const e2eMapDump = {
  BPMN_GUID: "14d42810-eced-11e4-0a66-001bc640cd9b",
  Type: "E2E-Map",
  domain_of: [
    {
      BPMN_GUID: "95c79df1-33d5-11eb-1d41-001bc6412ba9",
      scenario_of: [
        {
          BPMN_GUID: "e4a9b571-33d5-11eb-1d41-001bc6412ba9",
          Description:
            "This scenario covers the financial planning for P&L, Balance Sheet, and CAPEX reporting. It also includes the process for calculating standard price of a material during yearly planning.",
          _type: "Scenario",
          GUID: "449afa39-33d5-11eb-1d41-001bc6412ba9",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "449afa40-33d5-11eb-1d41-001bc6412ba9",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "L2 Process",
              _id: 2150,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "449afa3c-33d5-11eb-1d41-001bc6412ba9",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "L2 Process",
              _id: 2149,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "449afa3e-33d5-11eb-1d41-001bc6412ba9",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "L2 Process",
              _id: 2148,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "449afa42-33d5-11eb-1d41-001bc6412ba9",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "L2 Process",
              _id: 2147,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "Savola scenario",
          _id: 2146,
          Business_Rules: "",
          Prerequisite: "",
        },
      ],
      Description:
        "The Lead to Opportunity (L2O) domain describes the processes performed to generate new sales contracts with existing and new customers. Identified leads are addressed to reach the next stage of a specific opportunity.",
      _type: "Domain",
      GUID: "449afa32-33d5-11eb-1d41-001bc6412ba9",
      Advisory_Notes: "",
      Type: "E2E-Domain",
      Scope: "",
      Outcome: "",
      name: "SAVOLA",
      _id: 2145,
      Business_Rules: "",
      Prerequisite: "",
    },
    {
      BPMN_GUID: "4e388c11-67f4-11e8-2ddf-001bc640cd9b",
      scenario_of: [
        {
          BPMN_GUID: "574cd081-9f1d-11e8-2ddf-001bc640cd9b",
          Description:
            "This scenario describes the processes required to create and provide a quotation to a customer based on a specific inquiry for a non standard product. Non standard product means that the customer requirement doesnt fit a specification of existing products. Product development needs to evaluate the request and determine the feasibility, calculate a cost and estimate a timeline for possible delivery.  In case the feasability requires more intense research and prototyping a company may want to allocate the cost of these activities. In this case the scenario L2O Project based tender management should be applied. Depending on status of the business relation the business partner may need to be created. In this case credit management has to be involved to set payment rules. ",
          _type: "Scenario",
          GUID: "d26bbfb0-9b17-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "An inquiry including requirements which arent apparently covered by an existing standard product needs to be evaluated by product management. The result can be a reference to a standard product, a solution based on the adaption / configuration of an existing product or the solution based on a new product. In latter case the result needs to be further specified and developed.",
              _type: "Process",
              GUID: "5a61ffcf-9f1d-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The scope of the feasibility check varies and depends on the extend to which the request deviates from the standard products and the level of customization required.",
              Outcome: "Product or solution to customer inquiry",
              name: "Evaluate feasibility of request",
              _id: 275,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Capable to Promise (CTP) verifies whether a customers order can be fulfilled by production within a given time frame.   .  ",
              _type: "Process",
              GUID: "bf26ba8a-eaa4-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Depending on the product structure it must be decided how many production stages are considered during the CTP check and how stock levels of intermediates are factored in.    Even more complex rules can be required in case other intermediates can be used as substitutes.",
              Type: "Business Process",
              Scope:
                "After the customer order data is captured for a make to order production, it must be checked whether the order can be fulfilled. It is verified whether capacity is available to manufacture the finished product in the requested quantity and for the desired delivery date. In doing so, it must be ensured that the order can be placed and fits into the production plan. Components might be checked directly or their availability is considered as given based on the production plan",
              Outcome: "CTP check is performed.",
              name: "Check capability to promise",
              _id: 274,
              Business_Rules:
                "It must be defined what capacity is checked and reserved:   ***Capacity at local manufacturing unit     ***Capacity at all manufacturing units owned by the global organisation   ***Capacity of external contractors      It is necessary to define what consumes capacity and therefore reduces the available capacity.    The decision should be made whether capacity can be adjusted due to consumer demand. A production campaign for a certain type of product can be extended/increased.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Quotation is a binding commitment and can deal with significant product quantities and monetary values. Therefore, it must be ensured that information included into quotation is correct and corresponds to companys interests, which is ensured through an approval process.",
              _type: "Process",
              GUID: "f806160f-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After passing all checks related to the quotation, the commercial aspects of the quotation are approved and quotation is sent to the customer.",
              Outcome: "Quotation is sent to customer.",
              name: "Approve and send out quotation",
              _id: 213,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In order to quote a price and conditions to the customer, the quotation must be created and processed. Depending on the business model this may include collecting different information and processing various checks. Base for the creation of a quotation are customer details and information from the customer inquiry. ",
              _type: "Process",
              GUID: "f80615e2-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "For inquiries from and quotations for new potential customers, a dummy customer master might be used. Latest with the order entry, a real customer master is created and the sales order will be captured with reference to it.",
              Type: "Business Process",
              Scope:
                "A quotation document is prepared based on information captured in the inquiry. The sales price is calculated and conditions determined (e.g. rebates, shipping conditions, pre-payment requirements etc.). The requested delivery data is checked against availability.",
              Outcome: "Quotation is prepared and can be formally processed.",
              name: "Create quotation",
              _id: 273,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the confirmation is provided that the customer order can be fulfilled, the product price must be calculated (or extracted from the system) taking into account relevant conditions (e.g. rebates, shipping condition, customer price groups).",
              _type: "Process",
              GUID: "197ea3f9-eaa9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "In addition to the pricing itself, the workflows and required approvals have to be defined. Consider all types of sales (priced samples, free of charge samples etc.) and possible promotions and rebates.  In case a quotation has been placed, the conditions between both should be aligned or at least an interaction with the customer has to take place in case of any deviation.",
              Type: "Business Process",
              Scope:
                "Pricing takes into account all conditions related to the product and customer.",
              Outcome:
                "Pricing and conditions related to the order are generated, documented and agreed with customer.",
              name: "Determine product price and conditions",
              _id: 157,
              Business_Rules:
                "Pricing schemas are typically defined upfront.  It must be defined who (and with which limitations) has the rights to adjust prices and conditions within the sales process.   The price and trading conditions of the product must be based on a set of guidelines that take into account:   ***Cost of product   ***Market value of product   ***Customers perceived value of product    ***Relationship with customer (rebates etc.)   ***Defined profit margin expectations  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process includes the required activities to set and release the credit limit for a business partner.",
              _type: "Process",
              GUID: "ba2c9099-6a54-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Review credit limit for specific business partner, approve and release.",
              Outcome: "Released credit limit",
              name: "Approve and release credit limit",
              _id: 268,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process describes the initial capturing and checking of an inquiry. In comparison to a lead an inquiry contains an explicit request for a quotation. Receiving the customer inquiry and capturing it in a format necessary for further processing and initiating pre-sales business processes. ",
              _type: "Process",
              GUID: "f80615ee-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "For inquiries from and quotations for new potential customers, a dummy customer master might be used. Latest with the order entry, a real customer master gets created and the sales order will be captured with reference to it.",
              Type: "Business Process",
              Scope:
                "Once a customer inquires about a certain product, the data must be recorded, stored and forwarded for further processing. ",
              Outcome:
                "All relevant information regarding the customers inquiry is documented. The information captured provides the basis for preparing a quotation or reservation of goods.",
              name: "Receive and capture customer inquiry",
              _id: 171,
              Business_Rules:
                "Rules should determine in which cases inquiries have to be documented.   There are several aspects why inquiries should be captured in the system:   ***Avoidance of duplicated capturing of data   ***Considering the information in planning   ***Internal compliance and approval guidelines   ***Using the information for reporting and identifying reasons for lost sales  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade compliance ensures due diligence with trade regulatory programs and cross-border customs requirements. Global trade checks are required for all business operations.",
              _type: "Process",
              GUID: "1b684ec4-44de-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The check itself is typically done automatically by the ERP system. The actual process discussion should focus on the maintenance of the relevant GTS data (including the integration of external data sources) and the handling of sales orders failing to pass the checks.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both involved business partners and products being sold or related services are subject to checks.",
              Outcome:
                "The sales order complies with the applicable trade regulations and the product can be shipped.",
              name: "Perform global trade check",
              _id: 57,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists, dual use products) used for screening is comprehensive and up to date.   Customer data must be up to date.   Rules and procedures how to handle sales orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "L2O Inquiry to quotation non standard product",
          _id: 272,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "432df261-6a51-11e8-2ddf-001bc640cd9b",
          Description:
            "This scenario describes the processes required to setup or renew a customer contract. The main elements agreed upon are typically, special pricing discounts, payment terms and cash discounts, terms of delivery and volumes. ",
          _type: "Scenario",
          GUID: "5a1ed1d2-6a4f-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "This process reflects follow up activities that may be required in order to fulfill certain sales contracts. One example could be the creation of consignment warehouses adaption of stock levels in order to fulfill service levels.",
              _type: "Process",
              GUID: "1de237b9-6a51-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Trigger activities according to contract type",
              Outcome: "Contract follow-up activities defined and documented",
              name: "Perform contract follow-up activities",
              _id: 271,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the formalization of negotiation results within a sales contract. The actual sequence and amount of negotiations will vary according to the subject matter and business relation. This is not reflected in the process.",
              _type: "Process",
              GUID: "1de237ae-6a51-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Negotiate and maintain sales contract conditions",
              Outcome: "Sales contract with maintained conditions",
              name: "Negotiate and maintain sales and contract conditions",
              _id: 270,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process to reflect reporting requirements on monitoring sales contracts. This can be on volumes agreed upon or the realization of cash discounts. ",
              _type: "Process",
              GUID: "1de237c2-6a51-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Monitor fulfillment of contractual obligations ",
              Outcome: "Sales contract report",
              name: "Monitor sales contracts",
              _id: 269,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process includes the required activities to set and release the credit limit for a business partner.",
              _type: "Process",
              GUID: "ba2c9099-6a54-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Review credit limit for specific business partner, approve and release.",
              Outcome: "Released credit limit",
              name: "Approve and release credit limit",
              _id: 268,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the initial creation of a sales contract. Prerequisite is the existence of a business partner. Typically, if a contract already exists it may solely need a renewal or update.",
              _type: "Process",
              GUID: "1de237a4-6a51-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Creation of sales contract",
              Outcome: "Sales contract",
              name: "Create sales contract",
              _id: 267,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A simple approval of the sales contract is performed prior to sending out to the business partner.",
              _type: "Process",
              GUID: "1de237b6-6a51-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Request approval of sales contract and issue released sales contract to customer.",
              Outcome: "Released sales contract",
              name: "Approve and issue sales contract",
              _id: 266,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "L2O Sales contract management?",
          _id: 265,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "26a25c11-9f1e-11e8-2ddf-001bc640cd9b",
          Description:
            "This scenario describes how in the course of responding to a tender and creating a sales contract/quotation the activities and efforts are to be organized and allocated as a project.  This scenario contains similar processes as the Engineer to order (E2O) scenario but doesnt have a focus on developing new products or prototyping a specific solution rather combining standard products and services. The E2O scenario results in a quotation the tender results in a sales contract.",
          _type: "Scenario",
          GUID: "8c942b44-ef45-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "In order to ensure execution of the project in a timely manner and the controlling of costs, planning and scheduling of the project must be performed.      ",
              _type: "Process",
              GUID: "1cdd8084-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Scheduling is carried out according to project timelines, milestones and deliverables.  The cost of materials and planned labour comes from the project template. This information is incorporated into the project plan. ",
              Outcome:
                "Project plan is created and project activities are scheduled.",
              name: "Plan and schedule project",
              _id: 1280,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A simple approval of the sales contract is performed prior to sending out to the business partner.",
              _type: "Process",
              GUID: "1de237b6-6a51-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Request approval of sales contract and issue released sales contract to customer.",
              Outcome: "Released sales contract",
              name: "Approve and issue sales contract",
              _id: 266,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process to reflect reporting requirements on monitoring sales contracts. This can be on volumes agreed upon or the realization of cash discounts. ",
              _type: "Process",
              GUID: "1de237c2-6a51-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Monitor fulfillment of contractual obligations ",
              Outcome: "Sales contract report",
              name: "Monitor sales contracts",
              _id: 269,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Easy cost planning enables the planning of costs at WBS level based on quantities and characteristics. It is used to create quantity structures for the cost calculation, starting from the project structure.   ",
              _type: "Process",
              GUID: "135cff11-e998-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Easy cost planning is performed to create a first rough calculation of the project cost. ",
              Outcome: "Initial estimate of project cost is available",
              name: "Perform easy cost planning",
              _id: 204,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the formalization of negotiation results within a sales contract. The actual sequence and amount of negotiations will vary according to the subject matter and business relation. This is not reflected in the process.",
              _type: "Process",
              GUID: "1de237ae-6a51-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Negotiate and maintain sales contract conditions",
              Outcome: "Sales contract with maintained conditions",
              name: "Negotiate and maintain sales and contract conditions",
              _id: 270,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the initial creation of a sales contract. Prerequisite is the existence of a business partner. Typically, if a contract already exists it may solely need a renewal or update.",
              _type: "Process",
              GUID: "1de237a4-6a51-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Creation of sales contract",
              Outcome: "Sales contract",
              name: "Create sales contract",
              _id: 267,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Depending on the nature of a tender the activities required to be performed in order to reply sufficiently may vary strongly. These can include (non-exhaustive):   ***Product   ***Development/ technologies   ***Service levels Supply   ***Chain   ***Legal",
              _type: "Process",
              GUID: "3eda628e-9fd5-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Trigger definition of legal terms, provision of certifications and product specifications.",
              Outcome: "All documents required for tender",
              name: "Perform tender management activities",
              _id: 371,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process reflects follow up activities that may be required in order to fulfill certain sales contracts. One example could be the creation of consignment warehouses adaption of stock levels in order to fulfill service levels.",
              _type: "Process",
              GUID: "1de237b9-6a51-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Trigger activities according to contract type",
              Outcome: "Contract follow-up activities defined and documented",
              name: "Perform contract follow-up activities",
              _id: 271,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A project is created in order to add further details to the inquiry (for example, scheduling, payment processing). This ensures calculation of the cost as the basis for determining the gross price in the quotation.",
              _type: "Process",
              GUID: "c29e2dc6-e996-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The project is created with activities, components, and milestones in a complex structure.",
              Outcome:
                "Project is created, and timeline, costs, etc. can now be assigned.",
              name: "Create project",
              _id: 202,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When a prospective customer sends an request for a  project, the information must be captured and stored for further processing in form of an inquiry.     ",
              _type: "Process",
              GUID: "ab66382c-7e4e-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "An inquiry of a customer that would require a project for implementation is recorded. A respective project number is then assigned to the inquiry.",
              Outcome: "Customer inquiry for a  project is created.",
              name: "Create inquiry for customer project",
              _id: 199,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process includes the required activities to set and release the credit limit for a business partner.",
              _type: "Process",
              GUID: "ba2c9099-6a54-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Review credit limit for specific business partner, approve and release.",
              Outcome: "Released credit limit",
              name: "Approve and release credit limit",
              _id: 268,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "L2O Project based tender management",
          _id: 264,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "c6b9dbf0-6a4f-11e8-2ddf-001bc640cd9b",
          Description:
            "New lead creation describes the scenario of how an established lead is systematically evaluated and prepared for further processing. The main activities are capturing the data in the system, identifying if a corresponding business partner already exists or if a new business partner would be required, identify the responsible sales department/account manager and trigger the follow up actions. These can be a direct initiation of marketing material / samples or a hand over to further qualification by sales. ",
          _type: "Scenario",
          GUID: "5a1ed1d0-6a4f-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Qualify lead describes the activities required in order to qualify a lead initiated by a potential new customer for whom no prior business relationship existed and no corresponding business partner exists in the system.",
              _type: "Process",
              GUID: "5a1ed1e5-6a4f-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Typical activities are:***qualify lead  ***trigger business partner creation  ***initiate follow up activities",
              Outcome: "Qualified lead",
              name: "Qualify lead",
              _id: 263,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the activities in case a lead requirements can be fulfilled by sending standard marketing material or small samples. ",
              _type: "Process",
              GUID: "5a1ed1e8-6a4f-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After a selection of material has been made, it is sent out. In the system it is registered which material has been sent out to whom and when. ",
              Outcome:
                "Potential customer provided with marketing material and provision documented",
              name: "Send marketing material",
              _id: 262,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process covers the activities required to register a lead in a system and identify and trigger the responsibilities for follow up activities.",
              _type: "Process",
              GUID: "5a1ed1dc-6a4f-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Typical activities are:***register lead  ***evaluate existing  ***business relationship  ***identify and assign responsible sales department  ***trigger follow up activities",
              Outcome: "Registered lead",
              name: "Register and evaluate lead",
              _id: 261,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "L2O New lead creation",
          _id: 260,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "1ad3d851-9f19-11e8-2ddf-001bc640cd9b",
          Description:
            "This scenario describes the processes required to create and provide a quotation to a customer based on a specific inquiry for a standard product. Standard product means that the specification and price are defined. Depending on status of the business relation the business partner may need to be created. In this case credit management has to be involved to set payment rules. ",
          _type: "Scenario",
          GUID: "ba2c909f-6a54-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade compliance ensures due diligence with trade regulatory programs and cross-border customs requirements. Global trade checks are required for all business operations.",
              _type: "Process",
              GUID: "1b684ec4-44de-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The check itself is typically done automatically by the ERP system. The actual process discussion should focus on the maintenance of the relevant GTS data (including the integration of external data sources) and the handling of sales orders failing to pass the checks.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both involved business partners and products being sold or related services are subject to checks.",
              Outcome:
                "The sales order complies with the applicable trade regulations and the product can be shipped.",
              name: "Perform global trade check",
              _id: 57,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists, dual use products) used for screening is comprehensive and up to date.   Customer data must be up to date.   Rules and procedures how to handle sales orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process describes the initial capturing and checking of an inquiry. In comparison to a lead an inquiry contains an explicit request for a quotation. Receiving the customer inquiry and capturing it in a format necessary for further processing and initiating pre-sales business processes. ",
              _type: "Process",
              GUID: "f80615ee-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "For inquiries from and quotations for new potential customers, a dummy customer master might be used. Latest with the order entry, a real customer master gets created and the sales order will be captured with reference to it.",
              Type: "Business Process",
              Scope:
                "Once a customer inquires about a certain product, the data must be recorded, stored and forwarded for further processing. ",
              Outcome:
                "All relevant information regarding the customers inquiry is documented. The information captured provides the basis for preparing a quotation or reservation of goods.",
              name: "Receive and capture customer inquiry",
              _id: 171,
              Business_Rules:
                "Rules should determine in which cases inquiries have to be documented.   There are several aspects why inquiries should be captured in the system:   ***Avoidance of duplicated capturing of data   ***Considering the information in planning   ***Internal compliance and approval guidelines   ***Using the information for reporting and identifying reasons for lost sales  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The Available-to-Promise (ATP) check against stock verifies whether the required quantity of finished goods can be sold to the customer at the requested date. The check is carried out against actual or projected finished goods inventory.       ",
              _type: "Process",
              GUID: "eabe97ec-e8c8-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "It is necessary to define what happens after the availability is confirmed. Typically the requested product quantity is reserved (excluded from available stock). It should be defined how undelivered sales orders are handled and when a reservation for a sales order will be canceled.  Business rules that need to be defined are:   ***What are the main and alternative supply points for regions/customers (ship-to)   ***Which future goods receipts should be considered   ***Which future goods issues should be considered   ***Are allocations required to reserve quantities for specific customers, customer groups, markets/sales channels, regions    ***If allocations are used are those valid for the whole sales period or will those be deactivated after a certain time (example: monthly allocations are only valid until mid of the month any remaining quantities will be made generally available afterwards).    Sometimes other constraints like transportation capacity or handling capacity need to be integrated into the ATP check.",
              Type: "Business Process",
              Scope:
                "After the customer order data is captured, it must be checked if the order can be fulfilled (the requested products are available in the requested quantity and on the desired date). It is also necessary to determine the storage location the goods will be delivered from.",
              Outcome: "ATP check is performed.",
              name: "Check availability to promise at sales order entry",
              _id: 163,
              Business_Rules:
                "For setting-up the check it must be defined which sources, i.e. inventory, are to be considered.  Typical business cases are:   ***Check against plan or inventory    ***Inventory in local warehouse    ***Inventory in global organisation     ***Inventory in local warehouse + placed purchase orders/released production orders    Allocations might be used in short markets to manage the distribution of stock to particular markets, customer segments, or individual customers.  The workflow in case of different partial availability situations should be defined:   ***Proposal of alternate dates   ***Proposal of substitute products   ***Proposal of partial shipments   ***Backorder processing     ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the confirmation is provided that the customer order can be fulfilled, the product price must be calculated (or extracted from the system) taking into account relevant conditions (e.g. rebates, shipping condition, customer price groups).",
              _type: "Process",
              GUID: "197ea3f9-eaa9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "In addition to the pricing itself, the workflows and required approvals have to be defined. Consider all types of sales (priced samples, free of charge samples etc.) and possible promotions and rebates.  In case a quotation has been placed, the conditions between both should be aligned or at least an interaction with the customer has to take place in case of any deviation.",
              Type: "Business Process",
              Scope:
                "Pricing takes into account all conditions related to the product and customer.",
              Outcome:
                "Pricing and conditions related to the order are generated, documented and agreed with customer.",
              name: "Determine product price and conditions",
              _id: 157,
              Business_Rules:
                "Pricing schemas are typically defined upfront.  It must be defined who (and with which limitations) has the rights to adjust prices and conditions within the sales process.   The price and trading conditions of the product must be based on a set of guidelines that take into account:   ***Cost of product   ***Market value of product   ***Customers perceived value of product    ***Relationship with customer (rebates etc.)   ***Defined profit margin expectations  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Quotation is a binding commitment and can deal with significant product quantities and monetary values. Therefore, it must be ensured that information included into quotation is correct and corresponds to companys interests, which is ensured through an approval process.",
              _type: "Process",
              GUID: "f806160f-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After passing all checks related to the quotation, the commercial aspects of the quotation are approved and quotation is sent to the customer.",
              Outcome: "Quotation is sent to customer.",
              name: "Approve and send out quotation",
              _id: 213,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In order to quote a price and conditions to the customer, the quotation must be created and processed. Depending on the business model this may include collecting different information and processing various checks. Base for the creation of a quotation are customer details and information from the customer inquiry. ",
              _type: "Process",
              GUID: "f80615e2-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "For inquiries from and quotations for new potential customers, a dummy customer master might be used. Latest with the order entry, a real customer master is created and the sales order will be captured with reference to it.",
              Type: "Business Process",
              Scope:
                "A quotation document is prepared based on information captured in the inquiry. The sales price is calculated and conditions determined (e.g. rebates, shipping conditions, pre-payment requirements etc.). The requested delivery data is checked against availability.",
              Outcome: "Quotation is prepared and can be formally processed.",
              name: "Create quotation",
              _id: 273,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process includes the required activities to set and release the credit limit for a business partner.",
              _type: "Process",
              GUID: "ba2c9099-6a54-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Review credit limit for specific business partner, approve and release.",
              Outcome: "Released credit limit",
              name: "Approve and release credit limit",
              _id: 268,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "L2O Inquiry to quotation",
          _id: 259,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "486d9131-a053-11e8-2ddf-001bc640cd9b",
          Description:
            "Campaign to lead describes the processes required in order to plan, execute and close a marketing campaign. The overall objective is to strengthen the brand and directly promote sales by creating leads to potential new customers or additional sales to existing customers. ",
          _type: "Scenario",
          GUID: "5a1ed1d4-6a4f-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "After executing a marketing campaign activities the results of the campaign are evaluated in the process Close marketing campaign and documented in a campaign report. This includes checking if all activities were executed, budgets exceeded, services provided in time and an evaluation in how far the objectives were achieved (if tangible, i.e. amount of leads).",
              _type: "Process",
              GUID: "55508475-a053-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Evaluation of campaign and creation of campaign report",
              Outcome: "Campaign report",
              name: "Close marketing campaign",
              _id: 361,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Plan marketing campaign is a process which defines in detail the activities, required resources and budget for a marketing campaign. The main input of objective and target group is typically predefined in the annual marketing plan. ",
              _type: "Process",
              GUID: "55508471-a053-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Planning of the timely sequence and dependency of required marketing activities. Define required marketing material and services. ",
              Outcome: "Marketing campaign plan is executable.",
              name: "Plan marketing campaign",
              _id: 360,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Based on a marketing campaign plan the process execute marketing campaign requires different activities to be initiated and coordinated. Depending on the character of the marketing campaign (event, fair, email, advertising, telephone campaign) these activities can vary and involve the purchasing of services and material.",
              _type: "Process",
              GUID: "55508473-a053-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Execution and monitoring of defined marketing activities, initiate and participate in purchasing of marketing materials and services.",
              Outcome: "Marketing campaign plan is executed.",
              name: "Execute marketing campaign",
              _id: 362,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "L2O Campaign to lead",
          _id: 258,
          Business_Rules: "",
          Prerequisite: "",
        },
      ],
      Description:
        "The Lead to Opportunity (L2O) domain describes the processes performed to generate new sales contracts with existing and new customers. Identified leads are addressed to reach the next stage of a specific opportunity._",
      _type: "Domain",
      GUID: "58927696-ecef-11e4-0a66-001bc640cd9b",
      Advisory_Notes: "",
      Type: "E2E-Domain",
      Scope: "",
      Outcome: "",
      name: "Lead to Opportunity",
      _id: 257,
      Business_Rules: "",
      Prerequisite: "",
    },
    {
      BPMN_GUID: "94beadf1-ef1a-11e4-0a66-001bc640cd9b",
      scenario_of: [
        {
          BPMN_GUID: "1a7d2cd1-9ca8-11e8-2ddf-001bc640cd9b",
          Description:
            "This scenario covers the troubleshooting process involved with monitoring and adjusting IDOCS from the perspective of the shipping and the selling entities perspective.",
          _type: "Scenario",
          GUID: "e7fef675-5db5-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "After receiving the accounts payable open item, the person responsible for processing accounts payable must process the outgoing payment.",
              _type: "Process",
              GUID: "80843c13-9567-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once there are open items to be paid the Accounts receivable department ensures that the invoice has been applied to the correct reconciliation account. ",
              Outcome:
                "A task list is generated to be utilised during invoice verification. ",
              name: "Process open items accounts payable",
              _id: 517,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Required re-process the generation and transfer of intercompany invoices via EDI",
              _type: "Process",
              GUID: "fccd2e7c-9569-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After adjustments have been made a corrected IDOC is generated with an accompanying PDF file.",
              Outcome: "IC invoice transferred EDI.",
              name: "Re-process IDOCS",
              _id: 577,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of an intercompany invoice initiates the payment process for a transaction between two entities from the same corporate group.       ",
              _type: "Process",
              GUID: "53da3f54-e8c9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Typically there are special calculation rules to determine the profit margin in intercompany transactions.",
              Type: "Business Process",
              Scope:
                "The intercompany invoice, with which the supplier entity bills the selling or receiving entity, is created. In the case of a direct delivery to a customer, this happens automatically at the same time when the customer invoice is created. The required accounting entries are created using information from this invoice.",
              Outcome: "Intercompany invoice is created and issued. ",
              name: "Create intercompany invoice",
              _id: 1229,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "With this process, an analysis is done of all errors generated in the failed IDOC report.",
              _type: "Process",
              GUID: "fccd2e78-9569-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The causes of IDOC errors are identified at this point. All errors are then corrected and the segment type is adjusted. ",
              Outcome: "The IDOC segment type is adjusted.",
              name: "Analyse IDOC errors and adjust segment",
              _id: 582,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the adjusted IDOCS are generated, the system automatically posts the contra entry open item from the selling entitys perspective.",
              _type: "Process",
              GUID: "80843c1e-9567-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "This particularly useful for:    ***Intercompany Replenishment   ***Sales via Intercompany",
              Outcome:
                "There is the automatic change in the vendor line items or the amounts owed on the vendors account as a result of the incoming IDOC. ",
              name: "Post accounts payable open items automatically",
              _id: 523,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the failed IDOC invoices are identified, they must be compared with a PDF version of the invoice.",
              _type: "Process",
              GUID: "fccd2e76-9569-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "As a second quality check the accounts receivable clerk will compare the failed IDOCS against the automatically generated pdf file which was created at invoice creation. ",
              Outcome:
                "Comparison of incoming IDOC with PDF has been executed.",
              name: "Compare incoming IDOC's with PDF's",
              _id: 579,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process involves the tracking of failed IDOCS and the generation of reports for the failed IDOCs.  ",
              _type: "Process",
              GUID: "fccd2e74-9569-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Conduct timely checks to ensures that all failed Inter-company IDOC invoices are identified for analysis.",
              Outcome: "List of failed IDOC invoices are ready for analysis.",
              name: "Monitor IDOCS",
              _id: 583,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "A2R IDOC monitoring",
          _id: 256,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "e5442e51-7c8a-11e5-0a66-001bc640cd9b",
          Description:
            "A2R Period end closing describes the processes to close the books of a legal entity for the current accounting period on a monthly, quarterly, and yearly basis. Result of Period end closing is the published reporting for the legal entity in the consolidation reporting system. Period end closing results form the basis for profitability analysis.",
          _type: "Scenario",
          GUID: "a303a236-ef1a-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures that controlling relevant figures are ready for management reporting in a given accounting period.",
              _type: "Process",
              GUID: "2b3cd26c-9734-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Performance results analysis, calculation of work in progress (WIP), settlement of variances and subsequent execution to COPA.",
              Outcome: "Closing figures are ready for reporting. ",
              name: "Close profitability analysis",
              _id: 255,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process that covers activities required for closing of preventive maintenance and Corrective maintenance orders.",
              _type: "Process",
              GUID: "2b348219-d62b-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Plant maintenance orders are settled and closed to ensure correct and timely reporting.",
              Outcome: "Closing for maintenance orders completed",
              name: "Perform closing for maintenance orders",
              _id: 254,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Period end closing results are published, making them available for further analysis and consideration.",
              _type: "Process",
              GUID: "26c56e2c-7ca1-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After period end closing is completed reporting relevant figures (e.g. P&L, balance sheet) are submitted, validated and published in the reporting system.",
              Outcome: "Reporting figures are released.",
              name: "Report closing figures",
              _id: 253,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "To ensure an accurate period end closing, all sales related transactions must be recorded in the period within which they occur.",
              _type: "Process",
              GUID: "68f6e4e5-9732-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Complete and post all open sales documents so that they are reflected in the correct accounting period. ",
              Outcome: "Sales documents posted in correct accounting.",
              name: "Conduct period end closing sales/ distribution",
              _id: 252,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "To ensure an accurate period end closing, all production related activities must be recorded in the period within which they occur.",
              _type: "Process",
              GUID: "2b3cd26e-9734-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Covers the production related controlling activities which result in the technical completion and commercial settlement of all production orders and the subsequent calculation of work in progress (WIP) relevant for the accounting period. ",
              Outcome: "Closing figures are ready for reporting.",
              name: "Conduct closing in production",
              _id: 251,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "To ensure an accurate period end closing, all purchasing related transactions must be recorded in the period within which they occur.",
              _type: "Process",
              GUID: "68f6e4df-9732-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Complete and post all open purchasing documents so that they are reflected in the correct accounting period. ",
              Outcome:
                "Purchasing documents posted in correct accounting period.",
              name: "Conduct period end closing purchasing",
              _id: 250,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures that sales billing documents are released to accounts receivable accounting in a timely manner for period end closing.",
              _type: "Process",
              GUID: "68f6e4f1-9732-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Release all sales transactions with corresponding outbound delivery documents to accounting so that they are reflected in the correct to accounting period.",
              Outcome: "Sale billing documents released to accounting.",
              name: "Release billing to accounting",
              _id: 249,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process to ensure that closing operations are closed in payroll.",
              _type: "Process",
              GUID: "adc123f1-d629-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Review payroll results and wage type details, as well as reconcile payroll postings. When applicable, execute quarterly reports and year-end activities.",
              Outcome: "Closing in payroll complete",
              name: "Perform closing in payroll",
              _id: 248,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Closing of the general ledger is performed after closing and reconciliation of all subledgers.",
              _type: "Process",
              GUID: "68f6e4f9-9732-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Close general ledger involves reconciling the debit and credit balances of the posted documents with the debit and credit balances of the transactions figures in A/P, A/R and the general ledger, in order to check the consistency of the data. This is followed by execution of various closing activities including, foreign currency valuation of assets, accruals and deferrals, and clearing of accounts.",
              Outcome: "Accounts are closed for the closing period.",
              name: "Close general ledger",
              _id: 247,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process reflects the application of the depreciation policy to all fixed assets which fall within the companys asset register.  ",
              _type: "Process",
              GUID: "d4cc2764-6966-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Conduct periodic asset depreciation in accordance with the depreciation policy given in the applicable financial reporting standards (e.g. IFRS).  ",
              Outcome: "Perform periodic asset depreciation is complete.",
              name: "Perform periodic asset depreciation",
              _id: 246,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process to ensure that correct records of projects closure are reflected in management reports for a given period.",
              _type: "Process",
              GUID: "68f6e4ff-9732-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Reflects the settlement and subsequent allocation and distribution of costs, variances to various controlling objects and WBS controlling elements.",
              Outcome:
                "All projects for the given accounting period correctly closed and costs allocated.",
              name: "Conduct period end closing for projects",
              _id: 245,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "All invoices which have been flagged and subsequently blocked must be released before they can be considered for the accounting period.",
              _type: "Process",
              GUID: "68f6e4eb-9732-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Review and release blocked incoming invoices so that they can be applied to the appropriate accounting period in accordance with the matching concept. ",
              Outcome: "Invoices that had been blocked are released.",
              name: "Release blocked incoming invoices",
              _id: 244,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process to ensure that correct records of service orders closure are reflected in management reports for a given period.",
              _type: "Process",
              GUID: "9b283dd2-d60f-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Closing process for service orders, service sales orders and contracts related to the sales of services. ",
              Outcome:
                "All service orders for the given accounting period correctly closed and costs allocated.",
              name: "Perform closing for service cost objects",
              _id: 243,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "A2R Period end closing",
          _id: 242,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "646510e1-5dbc-11e8-2ddf-001bc640cd9b",
          Description:
            "This scenario deals with all transactions where an outgoing payment has been made for material, products or services rendered where a purchase order is required to trigger the upstream procurement process. ",
          _type: "Scenario",
          GUID: "22ea5986-5da9-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures that a payment to a vendor is captured, executed, and documented accordingly.       ",
              _type: "Process",
              GUID: "fb9de08d-7f05-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The methods of payment must be established taking into account country specific factors.",
              Type: "Business Process",
              Scope:
                "Manage outgoing payment involves making a payment to a vendor and posting the payment to the relevant vendor account. ",
              Outcome:
                "The outgoing payment is executed and the account vendor debited.",
              name: "Manage outgoing payment",
              _id: 1218,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This refers to activities which ensure that the customers cleared amounts are no longer reflected as an open item on their account.",
              _type: "Process",
              GUID: "e7fef68a-5db5-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "This involves the corresponding maintenance and adjustment of customer credit limits based on good repayment history.  ",
              Outcome:
                "The business partner details are adjusted in accordance with the customers payment history. ",
              name: "Perform account maintenance for AR",
              _id: 220,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After verification the invoiced amount must be posted accordingly.",
              _type: "Process",
              GUID: "981573d6-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Confirmation is given that the invoiced amounts correspond with the inbound delivery and has a corresponding goods receipt posting which also matches with the invoiced quantities and amounts.",
              Outcome: "Posting of invoice complete and correct.",
              name: "Post verified invoice",
              _id: 522,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Conduct clearing AP refers to the offsetting of outgoing vendor payments against outstanding amounts owed to creditors.  ",
              _type: "Process",
              GUID: "981573d8-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Conduct clearing AP process results in a decrease in the total accounts payables which will be reported in the balance as at that given point in time.",
              Outcome: "Vendor account is cleared.",
              name: "Conduct clearing AP",
              _id: 521,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "A2R Vendor invoice clearing (Purchase order based)",
          _id: 240,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "39fbbf11-9567-11e8-2ddf-001bc640cd9b",
          Description:
            "This refers to the cost center budgetary planning activities and subsequent allocation to cost centers or controlling objects where expenses can be accumulated over a given period of time.",
          _type: "Scenario",
          GUID: "22ea5994-5da9-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "This represents an allocation, distribution and application of settlement rules for production or project related costs which have been incurred for a given period to the correct production cost center.",
              _type: "Process",
              GUID: "c7c0ffd7-9565-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the budgetary planning has taken place, this must subsequently be allocated to the various cost centers within the company code or group organisational structure. ",
              Outcome:
                "Cost center planning figures allocation to cost centers complete and correct.",
              name: "Distribute and allocate costs to production related  cost centers",
              _id: 504,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In addition to the activity rate calculations, cost centers must also be budgeted.",
              _type: "Process",
              GUID: "c7c0ffd9-9565-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "This process involves the budgeting for estimated labour hours, machine hours or any other relevant activity type that will be a required resource for the achievement of periodic goals and targets (production targets etc. )",
              Outcome:
                "Capacity planning figures available for each production cost center.",
              name: "Perform capacity planning on the production cost center",
              _id: 507,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Cost center planning forms part of the overall business planning process. It enables to perform detailed planning below the cost element level.",
              _type: "Process",
              GUID: "b4b3673c-9562-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Cost center planning involves entering planned figures for costs, activities, prices or statistical key figures for a particular cost center and a particular planning period.",
              Outcome:
                "Cost center planning figure is available for planning period.",
              name: "Perform cost center planning",
              _id: 501,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "A2R Cost center planning and allocation",
          _id: 239,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "b04aa081-7c8a-11e5-0a66-001bc640cd9b",
          Description:
            "This scenario covers the financial planning for P&L, Balance Sheet, and CAPEX reporting. It also includes the process for calculating standard price of a material during yearly planning.",
          _type: "Scenario",
          GUID: "acb8fea0-1329-11e5-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "In this process, P&L planning figures are created according to financial reporting requirements.",
              _type: "Process",
              GUID: "b19f8466-7c99-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After business assumptions (e.g. Sales quantity, COGS) for P&L are received, planning guidelines are reviewed and updated where applicable.  The P&L is planned and sent for approval. Once approved it can be released.",
              Outcome: "P&L plan data is ready to be released.",
              name: "Conduct profitability planning",
              _id: 546,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When planning figures have been derived, they must be made available to concerned parties within the organization. ",
              _type: "Process",
              GUID: "b19f8484-7c99-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Release planning figures describes the submission, validation and publishing of all planning relevant reports.",
              Outcome: "Plan data is released.",
              name: "Release planning figures",
              _id: 562,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In order to provide comprehensive P&L planning figures, future planning figures for overhead costs must be derived.",
              _type: "Process",
              GUID: "b19f847e-7c99-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "In this process, future planning figures are calculated for indirect cost objects (e.g. cost centers, internal orders, projects/WBS elements).",
              Outcome:
                "Future planning figures for indirect cost objects are available.",
              name: "Conduct planning within overhead management",
              _id: 509,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Conduct balance sheet planning describes the generation of balance sheet planning figures according to financial reporting requirements.",
              _type: "Process",
              GUID: "b19f8481-7c99-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Planning guidelines are reviewed, planned depreciation calculated, and investment plan is derived. Once this has been done, the plan balance sheet data is ready for release.",
              Outcome:
                "Balance sheet planning figures are available and can be released.",
              name: "Conduct profit and loss and balance sheet planning",
              _id: 560,
              Business_Rules:
                "Planning guideline for the corresponding planning period will determine the rules for gathering, calculating and entering the plan information into the system.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Product cost planning affords the planning of costs for materials. It allows the setting of prices for materials.",
              _type: "Process",
              GUID: "b19f8499-7c99-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The process describes all steps to be considered for the product cost planning, starting from overhead production cost planning to the calculation of the standard price of a material.",
              Outcome:
                "Product cost planning is complete. All plan figures are derived.",
              name: "Conduct product cost planning",
              _id: 502,
              Business_Rules:
                "All materials need to have a released standard price before any movements or postings are created, usually at the 1st working day at every new fiscal period.",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "A2R Balance sheet and P&L planning",
          _id: 238,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "2b001a71-9566-11e8-2ddf-001bc640cd9b",
          Description:
            "Production controlling refers to the systematic planning, coordinating, and directing of all manufacturing activities and influences to ensure having goods made on time, of adequate quality, and at reasonable cost",
          _type: "Scenario",
          GUID: "22ea5992-5da9-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The production order is commercially closed when all the costs have been booked completely.",
              _type: "Process",
              GUID: "c7c0ffc4-9565-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The production order is set to status closed. With this - no more costs can be posted to the order, that is, confirmations and goods movements are no longer permitted for the order and the order can no longer be changed.",
              Outcome: "Production order is closed commercially.",
              name: "Close production order commercially",
              _id: 510,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The WIP calculation function evaluates the unfinished products (work in process) which have not been completed in an accounting period. ",
              _type: "Process",
              GUID: "c7c0ffb9-9565-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "In the Product Cost by Order component, the work in process is evaluated at actual cost. Work in progress is the difference between the debit and credit of a production or process order that has not been fully completed.    WIP can be calculated at actual costs for the following objects:     ***Production orders   ***Process orders",
              Outcome: "WIP values from production/ process orders are posted.",
              name: "Post work in progress (WIP) values",
              _id: 503,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the difference between planned and actual production/ process orders have been calculated, it is required that there is an accompanying settling of the differences which according to the allocation rules defined must be settled through a cost collector, controlling object or a cost center. ",
              _type: "Process",
              GUID: "c7c0ffc2-9565-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the difference between planned and actual production/ process orders have been calculated, it is required that there is an accompanying settling of the differences which according to the allocation rules defined must be settled through a cost collector, controlling object or a cost center.",
              Outcome: "All cost differences from production are settled.",
              name: "Perform and settle variances",
              _id: 511,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "A2R Production controlling",
          _id: 237,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "fb349781-956a-11e8-2ddf-001bc640cd9b",
          Description:
            "Covers processes to deal with intercompany charges and clearing ",
          _type: "Scenario",
          GUID: "22ea5998-5da9-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "When transactions occur between two related legal entities in an intercompany organization or between two groups in the same legal entity, the resulting balances from these transactions must be eliminated or appropriately adjusted during the preparation of the organizations consolidated financial statements. In such cases only the open balances are settled with actual payments. It must be ensured that open items in both legal entities are closed in the same way.      ",
              _type: "Process",
              GUID: "a99fac28-7e52-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Any open liabilities arising from intercompany transactions between two related legal entities are cleared and resulting open balances balances reconciled and settled by making actual payments.",
              Outcome:
                "Intercompany balances are cleared and recorded in accounting.",
              name: "Clear intercompany balance",
              _id: 574,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When entities from the same corporate group are involved in a business transaction (e.g. intercompany purchasing), intercompany billing is required.  ",
              _type: "Process",
              GUID: "837a78be-7eff-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The intercompany invoice must be captured and documented accordingly in the accounting system. The invoice is mapped to business transactions performed in purchasing.",
              Outcome:
                "Incoming intercompany invoice is recorded and forwarded for payment.",
              name: "Manage incoming intercompany invoice",
              _id: 1231,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "A2R IC Invoice clearing",
          _id: 236,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "54df5851-956c-11e8-2ddf-001bc640cd9b",
          Description:
            "This refers to all the reporting activities which are associated with the analysis, representation of variances and publishing of financial and management accounting reports.",
          _type: "Scenario",
          GUID: "e7fef671-5db5-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Process to assist management in understanding the qualitative reasoning behind variances so that corrective action can be triggered. ",
              _type: "Process",
              GUID: "fccd2e5b-9569-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Perform plan / actual variance analysis process evaluating the qualitative reasoning behind variances. This is often used as performance indicator in production, purchasing and overhead budgetary control. Based on the analysis corrective actions are triggered.",
              Outcome:
                "Variances between planned and actual order determined and reasons for variances captured.",
              name: "Perform plan / actual variance analysis",
              _id: 544,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This reflects the analysis, interpretation and evaluation of the financial performance of functional units, divisions or regions. This is commonly used by senior management as a control to ensure that operational targets at the business unit level are consistent with strategic goals. ",
              _type: "Process",
              GUID: "fccd2e5d-9569-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "To ensure accuracy of analysis, the following must be done:     ***Calculate work in process (WIP) of sales orders on the basis of planned and actual revenues and costs.    ***Generate report of WIP calculations for sales orders.    ***Settle sales orders to profitability analysis. This moves all revenues from the sales order to a controlling object for profitability analysis.    ***Review and complete (post) any outstanding goods issues.",
              Outcome: "Profitability analysis is closed.",
              name: "Perform profit and loss analysis by functional area and profit centers",
              _id: 547,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Controlling process to evaluate the cost of sales on line items level.",
              _type: "Process",
              GUID: "fccd2e59-9569-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Line items within the Trading, Profit and Loss account in addition to Balance sheet line items can be assessed, analysed and evaluated by management so that potential corrective action can be triggered if necessary. ",
              Outcome:
                "Cost of sales figures available for a specified period.",
              name: "Perform cost of sales analysis on line items",
              _id: 545,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "A2R Financial and management accounting reporting",
          _id: 235,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "10f6f381-5dba-11e8-2ddf-001bc640cd9b",
          Description:
            "This scenario covers standard clearing process for credit notes. When there are customer disputes and subsequent decision to honor a warranty claim, then there needs to be a credit note or refund which will be issued. ",
          _type: "Scenario",
          GUID: "22ea5984-5da9-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Once sales has aligned with Accounts Receivable, the release takes place where accounts receivable collects the costs of this warranty claim against the applicable cost center responsible for dealing with quality claims.",
              _type: "Process",
              GUID: "bb4dabe1-5dba-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The accounts receivable department approves the refund to be given to the customer in the form of a credit note or a reversal of the initial payment. The initial customer order should be connected as a reference to the credit note. ",
              Outcome: "Credit note is released",
              name: "Release credit note to sales",
              _id: 578,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This refers to the accompanying process step which is triggered by a warranty claim or a customer return which will be honored and refunded.",
              _type: "Process",
              GUID: "e7fef697-5db5-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the inspection lot is performed, the decision of whether or not a warranty claim is applicable is made. ",
              Outcome:
                "The warranty claim decision is made with the decision to issue a refund or credit note to the customer. ",
              name: "Manage outgoing customer payments and rebates",
              _id: 580,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Conduct clearing AR refers to the offsetting of incoming customer payments against outstanding amounts owed by debtors. This clearing process results in a decrease in the total accounts receivable which will be reported in the balance as at that given point in time.",
              _type: "Process",
              GUID: "e7fef685-5db5-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "This involves the clearing of outstanding open outstanding balances which are directly correlated to the payment.",
              Outcome:
                "The amounts owed are cleared with no differences outstanding against the initial customer order.",
              name: "Conduct clearing AR",
              _id: 219,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This refers to activities which ensure that the customers cleared amounts are no longer reflected as an open item on their account.",
              _type: "Process",
              GUID: "e7fef68a-5db5-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "This involves the corresponding maintenance and adjustment of customer credit limits based on good repayment history.  ",
              Outcome:
                "The business partner details are adjusted in accordance with the customers payment history. ",
              name: "Perform account maintenance for AR",
              _id: 220,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This reflects a communication flow between Accounts receivable and Sales/ party responsible for issuing the credit note. This is to ensure that the terms and conditions of the warranty have been met before the amounts can be released by accounts receivable.  ",
              _type: "Process",
              GUID: "e7fef69f-5db5-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "This process applies to all instances where there is a communication flow between sales and corresponding departments. ",
              Outcome: "All parties involved are informed and aligned. ",
              name: "Align with sales staff",
              _id: 576,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The credit note may be issued based on the defined terms of payment which will be defined in the customer business partner records. ",
              _type: "Process",
              GUID: "bb4d0f90-5dba-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The customer receives the credit note and provides confirmation of receipt either automatically via electronic fund transfers or manually via signed off receipt. ",
              Outcome:
                "The customer received the credit note and the dispute case is closed. ",
              name: "Issue credit note to customer",
              _id: 518,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "A2R Issuing credit notes",
          _id: 234,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "8b508871-9560-11e8-2ddf-001bc640cd9b",
          Description:
            "This scenario covers the standard asset management process including project system, plant maintenance and procurement. It reflects the subsequent activation of assets which have been procured to maintain the continuity, effectiveness and ability of the company to operate as a going concern. This is based on the requirement to maintain technologically relevant assets within a companys management.",
          _type: "Scenario",
          GUID: "22ea598c-5da9-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "When an asset can no longer be used, it is necessary to define further steps to finalize its phasing out.",
              _type: "Process",
              GUID: "21fda555-7ef0-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The maintenance manager evaluates the asset to get a view of the asset condition. In doing this, a decision is made on whether to sell, scrap or dispose the asset.",
              Outcome:
                "Decision is made whether to sell, scrap or dispose the asset.",
              name: "Analyze asset condition",
              _id: 589,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In handing over of physical possession of the asset to the buyer, it is necessary to define the means of transportation and who will cover the transportation cost, as well as record the sale.",
              _type: "Process",
              GUID: "feff4074-7ef0-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once sale consideration or the down payment (as per negotiated terms of payment approved has been received, the possession of the asset is handed over to the buyer. If a portion of sale consideration is deferred, i.e. payable over a span of time, the rightful title of the assets can not be transferred to the purchaser. However, the buyer will take possession of the asset on depositing down payment and may be required to pay interest on the deferred part of sale.",
              Outcome: "Asset is in possession of the buyer.",
              name: "Hand over asset to buyer",
              _id: 334,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This reflects the sale of an asset which has been approved by management or the cost center responsible for scrapping and/ or sale.  ",
              _type: "Process",
              GUID: "feff4098-7ef0-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The asset is sold upon negotiation of the selling price. There will be no sales order connected to this process and a manual invoice will be required. ",
              Outcome: "Asset sale is complete.",
              name: "Sell asset",
              _id: 567,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures receipt of the return copies of disposal documents within the set periods.",
              _type: "Process",
              GUID: "12bafa91-7ef1-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Generate list of the disposal documents whose return within period is soon to expire. For example, as soon as the disposer has sent the return copies and informed of the waste quantity disposed.   Adjust the waste quantity that can still be disposed of with the corresponding waste approval. Lock waste approvals which have reached their permitted quantity.",
              Outcome: "Waste disposal documents returned and up to date.",
              name: "Monitor disposal and document return",
              _id: 594,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Disposal is executed according to legal guidelines and waste management requirements.",
              _type: "Process",
              GUID: "ff0fe25a-7ef0-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Record the necessary external disposal operations and put together the legally required waste disposal documents such as waste manifests, dock receipts on the basis of the internal disposal documents. Execute the disposal and confirm completion.",
              Outcome: "Disposal of waste is confirmed.",
              name: "Execute waste disposal",
              _id: 592,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Depreciate asset process ensures that decrease in the value of an assets is reflected in accounting.",
              _type: "Process",
              GUID: "33c3d03a-9560-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Depreciation of the asset is calculated. The value of the asset is recorded to reflect the amount depreciated. The depreciation reflects the needs for internal, external and tax reporting requirements. Extraordinary depreciation can be done according to the policy in place and reconciled with the manager.",
              Outcome: "Depreciation of asset performed.",
              name: "Execute depreciation run",
              _id: 569,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process covers the creation of the master data required for waste management, including waste generators, points of generation, waste disposers, disposal facilities, waste transporters, authorities and waste.    In cases where waste disposal is to be executed by a service provided, preparation of waste disposal will trigger the procurement process for disposal services.",
              _type: "Process",
              GUID: "12bafa9a-7ef1-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "To describe the waste, waste materials can be created in the system with the logistic properties of the waste and waste specifications with the properties of ingredients, catalog numbers and process codes. The waste may be assigned to plant, cost centers, storage locations or the vendor.",
              Outcome:
                "Waste master data is created and the waste execution is triggered.",
              name: "Prepare waste disposal",
              _id: 593,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the decision has been taken to sell an asset, it is necessary to find a buyer and negotiate the terms of the sale.",
              _type: "Process",
              GUID: "feff4071-7ef0-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The remaining value of the asset is defined and based on that, negotiations are conducted with several potential buyers. The sale agreement is made with the buyer offering the best terms and conditions.",
              Outcome: "Buyer found and sale terms and conditions defined.",
              name: "Negotiate and determine buyer of asset",
              _id: 359,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Manage incoming payment process ensures that the payment from a customer is captured and documented appropriately.",
              _type: "Process",
              GUID: "f5f29ea1-e8f4-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Especially in global template projects different variants of payments have to be considered but their use should often be limited to a group of countries rather than being made available to all.",
              Type: "Business Process",
              Scope:
                "Manage incoming payment involves receiving a payment from a customer and entering the information in accounting. The incoming payment is mapped to the customer invoice and customer account.",
              Outcome:
                "Incoming payment is recorded and the customer account is credited.",
              name: "Manage incoming payment",
              _id: 1264,
              Business_Rules:
                "The methods of payment must be established taking into account country specific factors related to the business and customer. For instance: The bill of exchange (BoE) payment method is used in some countries only.   Typical methods of payment are:   ***Check   ***Direct debits   ***Credit cards   ***Bank transfers",
              Prerequisite:
                "Prerequisite: currency exchange and hedging processes",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In waste management, it is necessary to comply with and implement numerous national and international laws and regulations. This business process makes the classification of waste possible and the evaluation of waste management requirements.",
              _type: "Process",
              GUID: "12bafa97-7ef1-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Including the waste specifications, the requirements for handling, disposal, approval and documentation of waste is specified. This includes physical-chemical properties, safety and transport information and legal data for waste. ",
              Outcome:
                "Waste classification and requirements evaluation are complete.",
              name: "Classify waste and evaluate waste management requirements",
              _id: 591,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When an asset can no longer be used, it is necessary to define further steps to finalize its phasing out.",
              _type: "Process",
              GUID: "a92487cd-9561-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The maintenance manager evaluates the asset to get a view of the asset condition. In doing this, a decision is made on whether to sell, scrap or dispose the asset.",
              Outcome:
                "Decision is made on whether to sell, scrap or dispose the asset.",
              name: "Retire assets with no scrap value",
              _id: 564,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: " ",
          Outcome: "",
          name: "A2R Acquisition to retirement of assets",
          _id: 233,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "919fa271-955f-11e8-2ddf-001bc640cd9b",
          Description:
            "Covers the standard clearing process for vendor invoices which are not initially triggered by the creation of a purchase order and also includes the clearing of manually created invoices.",
          _type: "Scenario",
          GUID: "22ea5988-5da9-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Processing of an Expense Invoice from a vendor, in order to trigger the outgoing payment process. Such invoices have no reference to a Purchase Order.",
              _type: "Process",
              GUID: "be50c2f0-9556-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the FI invoice has been transferred (from the scanning tool), verification involves checking for formal compliance and whether it is consistent with goods delivered or services provided.",
              Outcome: "FI invoice is verified and ready for posting.",
              name: "Process incoming invoice without reference to PO",
              _id: 524,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process covers the scanning of a Purchase Order based invoice or an Expense Invoice (no PO reference).",
              _type: "Process",
              GUID: "981573d2-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the invoice is received, it is scanned and the data is captured. The data is then stored in a database for digital use and then transfered to for verification.",
              Outcome:
                "Received invoice information is transferred for verification.",
              name: "Scan incoming invoice with OCR software",
              _id: 1192,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures that a payment to a vendor is captured, executed, and documented accordingly.       ",
              _type: "Process",
              GUID: "fb9de08d-7f05-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The methods of payment must be established taking into account country specific factors.",
              Type: "Business Process",
              Scope:
                "Manage outgoing payment involves making a payment to a vendor and posting the payment to the relevant vendor account. ",
              Outcome:
                "The outgoing payment is executed and the account vendor debited.",
              name: "Manage outgoing payment",
              _id: 1218,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Conduct clearing AP refers to the offsetting of outgoing vendor payments against outstanding amounts owed to creditors.  ",
              _type: "Process",
              GUID: "981573d8-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Conduct clearing AP process results in a decrease in the total accounts payables which will be reported in the balance as at that given point in time.",
              Outcome: "Vendor account is cleared.",
              name: "Conduct clearing AP",
              _id: 521,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After verification the invoiced amount must be posted accordingly.",
              _type: "Process",
              GUID: "981573d6-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Confirmation is given that the invoiced amounts correspond with the inbound delivery and has a corresponding goods receipt posting which also matches with the invoiced quantities and amounts.",
              Outcome: "Posting of invoice complete and correct.",
              name: "Post verified invoice",
              _id: 522,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "A2R Vendor invoice clearing (FI based invoice)",
          _id: 232,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "c5069711-b79e-11e9-0cfc-001bc641ce4f",
          Description:
            "This scenario covers the processes for  combining financial statements of  several business entities within a corporate group for the purpose of deriving a consolidated balance sheet and a consolidated profit and loss statement.",
          _type: "Scenario",
          GUID: "4b138532-b2c6-11e9-0cfc-001bc641ce4f",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "c7087287-bd00-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Generate consolidated Profit & Loss statement",
              _id: 231,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "c7087283-bd00-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Generate consolidated balance sheet",
              _id: 230,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "c7087272-bd00-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Perform foreign currency translation",
              _id: 229,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "c7087261-bd00-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Capture financial  statements data of parent company for consolidation",
              _id: 228,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Parents and subsidiaries trade with each other very often.  However, when you look at both parent and subsidiary as at 1 company, which is the purpose of consolidation, then you find out that theres no transaction at all.  In other words, group has not performed any transaction from the view of some external user.  Therefore you need to eliminate all transactions happening within the group, between a parent and its subsidiaries.   You can use manual journal entries, recurring journals, and MassAllocations to create eliminating entries in a consolidation set of books. You can eliminate standard and/or average balances, but the respective eliminating entries will be independent of each other. For example, if you eliminate an accounts standard balance, the related average balance is not eliminated. Likewise, if you eliminate an average balance, there is no effect on the related standard balance. The effective date of eliminating entries is always the first day of the period.",
              _type: "Process",
              GUID: "18962e21-4be9-11ea-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Conduct intercompany matching and eliminations",
              _id: 227,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "c7087280-bd00-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Perform final verifications at capital group level",
              _id: 226,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "Hot topics: In transit stock for replenishment",
              _type: "Process",
              GUID: "db2aa62c-b79b-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Approve and import financial statements data for consolidation",
              _id: 225,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures that financial statements data of subsidiaries meet the requirements for group level consolidation. Typically, the parent company provides subsidiaries with a consolidation package for capturing the financial statements data used for consolidation. ",
              _type: "Process",
              GUID: "db2aa629-b79b-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Ensure that business transactions involving several companies within the group are correctly maintained and up to date. Reporting data from individual financial statements of subsidiary must be adapted so that it easily links to the consolidation system used by the parent company. ",
              Outcome:
                "Financial statements data of subsidiary is ready for approval by group controller",
              name: "Prepare financial statements data for consolidation",
              _id: 224,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Data mapping accuracy (who is responsible for harmonisation of structures) normalizing the consolidated data",
              _type: "Process",
              GUID: "18962e27-4be9-11ea-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Harmonize and aggregate data for consolidation",
              _id: 223,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "mapping general ledgers to a single chart of accounts, ",
              _type: "Process",
              GUID: "c7087264-bd00-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Conduct reporting data validation",
              _id: 222,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "A2R Financial consolidation",
          _id: 221,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "d077fc11-5db8-11e8-2ddf-001bc640cd9b",
          Description:
            "This scenario covers the standard clearing process for customer invoices. It reflects all transactions for clearing of incoming payments and subsequent reduction of amounts owed to the company. ",
          _type: "Scenario",
          GUID: "22ea5982-5da9-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "This refers to activities which ensure that the customers cleared amounts are no longer reflected as an open item on their account.",
              _type: "Process",
              GUID: "e7fef68a-5db5-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "This involves the corresponding maintenance and adjustment of customer credit limits based on good repayment history.  ",
              Outcome:
                "The business partner details are adjusted in accordance with the customers payment history. ",
              name: "Perform account maintenance for AR",
              _id: 220,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Conduct clearing AR refers to the offsetting of incoming customer payments against outstanding amounts owed by debtors. This clearing process results in a decrease in the total accounts receivable which will be reported in the balance as at that given point in time.",
              _type: "Process",
              GUID: "e7fef685-5db5-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "This involves the clearing of outstanding open outstanding balances which are directly correlated to the payment.",
              Outcome:
                "The amounts owed are cleared with no differences outstanding against the initial customer order.",
              name: "Conduct clearing AR",
              _id: 219,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Manage incoming payment process ensures that the payment from a customer is captured and documented appropriately.",
              _type: "Process",
              GUID: "f5f29ea1-e8f4-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Especially in global template projects different variants of payments have to be considered but their use should often be limited to a group of countries rather than being made available to all.",
              Type: "Business Process",
              Scope:
                "Manage incoming payment involves receiving a payment from a customer and entering the information in accounting. The incoming payment is mapped to the customer invoice and customer account.",
              Outcome:
                "Incoming payment is recorded and the customer account is credited.",
              name: "Manage incoming payment",
              _id: 1264,
              Business_Rules:
                "The methods of payment must be established taking into account country specific factors related to the business and customer. For instance: The bill of exchange (BoE) payment method is used in some countries only.   Typical methods of payment are:   ***Check   ***Direct debits   ***Credit cards   ***Bank transfers",
              Prerequisite:
                "Prerequisite: currency exchange and hedging processes",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "A2R Customer invoice clearing",
          _id: 218,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "a37ce661-9564-11e8-2ddf-001bc640cd9b",
          Description:
            "The scenario covers the allocation of product costs via cost objects to finished production items. Product Costing is used for planning costs and establishing material prices. It helps in estimating the Manufacturing costs and provides a valuation of stock in hand at a given point in time.",
          _type: "Scenario",
          GUID: "22ea5990-5da9-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Activity Rates define or rather calculate the cost of performing an activity type. ",
              _type: "Process",
              GUID: "b4b36743-9562-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Perform activity rate calculation in order to calculate plan activity rates for activities in each production cost center.",
              Outcome:
                "Plan activity rates are available for each activity in each cost center in a plant.",
              name: "Perform activity rate calculation",
              _id: 513,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The cost estimate with quantity structure enables you to calculate the non-order-related cost of goods manufactured and the cost of goods sold for products, based on the BOMs and routings (PP).",
              _type: "Process",
              GUID: "b4b36749-9562-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Quantity structure to be established on planned production orders with the relevant BOM and routing master data maintained.",
              Outcome:
                "The quantity structure is maintained and correctly connected to planned production orders.",
              name: "Establish quantity structure based on BOM and routing",
              _id: 498,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "During production, product cost collectors and manufacturing orders are debited with actual costs. Each time goods are received into inventory, ERP systems evaluate the goods receipt and credit it to the defined product cost collector or production order accordingly.",
              _type: "Process",
              GUID: "b4b36755-9562-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The actual costs posted to an order can be higher or lower than the value of the initial production order which was credited when the goods receipt was posted. This must be settled by the difference between the debit and credit of the order which is subsequently transferred to Financial Accounting.",
              Outcome: "All differences are settled.",
              name: "Settle differences via product cost collectors",
              _id: 506,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Variance calculation provides the difference between Actual Costs and Target Costs posted on order.",
              _type: "Process",
              GUID: "b4b36753-9562-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "This process covers the analysis of price variances stemming from the manufacturing process which can include:   ***Total Variance   ***Variance   ***Planning Variance  ",
              Outcome:
                "Product price variances determined and follow up actions initiated.",
              name: "Conduct variance analysis",
              _id: 505,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "WIP refers to the raw materials, labor, and overhead costs incurred for products that are at various stages of the production process. WIP is a component of the inventory asset account on the balance sheet. These costs are subsequently transferred to the finished goods account and eventually to cost of sales.   ",
              _type: "Process",
              GUID: "7d3f15f0-a206-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "When production orders have not been completed in the accounting time period when it was generated, there needs to be a calculation to accurately reflect the companys balance sheet position at that point in time. ",
              Outcome:
                "WIP calculations are reflected at the line item level of the balance sheet. ",
              name: "Calculate work in progress (WIP)",
              _id: 512,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Cost center planning forms part of the overall business planning process. It enables to perform detailed planning below the cost element level.",
              _type: "Process",
              GUID: "b4b3673c-9562-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Cost center planning involves entering planned figures for costs, activities, prices or statistical key figures for a particular cost center and a particular planning period.",
              Outcome:
                "Cost center planning figure is available for planning period.",
              name: "Perform cost center planning",
              _id: 501,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process involves the periodic costing of a sizeable number of products/ materials (for example all materials of one plant). ",
              _type: "Process",
              GUID: "b4b3674e-9562-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "With help of the costing run, the high-performing costing of a great number of materials per collective processing is possible (often at plant level).",
              Outcome: "Product costing run is complete.",
              name: "Execute costing run",
              _id: 508,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "A2R Product cost controlling",
          _id: 217,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "04e66990-4e54-11ea-0cfc-001bc641ce4f",
          Description:
            "The scenario covers the planning, collection, and settlement of costs related to internal jobs and tasks. During period end closing, internal orders are settled to fixed assets, cost centers, profits centers, and projects.  ",
          _type: "Scenario",
          GUID: "cc29fcd0-4e52-11ea-0cfc-001bc641ce4f",
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "A2R Internal order processing",
          _id: 241,
          Business_Rules: "",
          Prerequisite: "",
        },
      ],
      Description:
        "The Account to Report (A2R) domain covers general ledger, asset management, cost center controlling, product costing and profitability analysis, and period end closing activities. It also includes credit management, bank and tax accounting, dunning, accounts receivables and accounts payables processes.",
      _type: "Domain",
      GUID: "964b5c3c-642b-11e4-55cc-001bc640cd9b",
      Advisory_Notes: "",
      Type: "E2E-Domain",
      Scope: "",
      Outcome: "",
      name: "Account to Report",
      _id: 216,
      Business_Rules: "",
      Prerequisite: "",
    },
    {
      BPMN_GUID: "b1bd6ec1-ef0e-11e4-0a66-001bc640cd9b",
      scenario_of: [
        {
          BPMN_GUID: "4ae51ca1-82c7-11e5-0a66-001bc640cd9b",
          Description:
            "The sales of trading goods scenario is used for goods, which are purchased from a supplier directly triggered by a specific customer request. The purchasing process is initiated after placing of the final sales order. Nevertheless, delivery of the products by the vendor goes first to the organizations warehouse. The advantage of receiving trading goods in ones own warehouse in comparison to direct delivery from vendor to customer is the higher level of control over the supply chain. In this context, cross docking becomes more and more popular.  The scenario is usually applied by manufacturers for trading in products, which complement the own portfolio, or as a dedicated business model. In distribution and wholesaler businesses, the business model might be equally deployed beside trading via stock and direct sales.",
          _type: "Scenario",
          GUID: "7a693930-ef3c-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "After the customer inquiry or information regarding internal product request is received, technical feasibility to produce requested products must be assessed before a quotation can be issued  to the customer.   ",
              _type: "Process",
              GUID: "1cdd809c-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "In make to order scenarios, the customer inquiry may contain very specific requirements or even request a product that has never been produced before in the specific configuration. Technical feasibility to meet these requirements must be assessed in order to  prepare a quotation for the customer. Depending on complexity of the inquiry, the assessment may range from checking if existing products meet specified requirements and changes to product design to complete development of a new product prototype in a R&D project (engineer to order). During the assessment, the components and production steps required for manufacturing are defined, building a foundation for further pricing proposals.",
              Outcome:
                "Technical feasibility to meet requirements contained in customer inquiry is assessed. Manufacturing information for product pricing is available",
              name: "Gather and document product specifications",
              _id: 215,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of a customer invoice provides documentation of the financial obligation related to a customer order. The customer invoice is created from a sales order.",
              _type: "Process",
              GUID: "75ff0dfc-e8bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Circumstances such as required documents for customs clearance or advance payments might have an impact on the timing when an invoice needs to be created during the sales process.",
              Type: "Business Process",
              Scope:
                "After the customer order has been fulfilled, the invoice is created. It provides the customer with information required to settle the payment related to their order.",
              Outcome: "Invoice is created and sent to the customer.",
              name: "Create customer invoice",
              _id: 1363,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Country specific regulations state that, above a certain quantity of chemicals and other hazardous substances, it is required to register with the authorities the maximum quantities of these substances that is planned to be purchased, imported, produced, sold, or exported within a certain period. By comparing the recorded quantities with the limit values, the system signals that a limit value is close to be exceeded if a limit value is exceeded, the system can also block the respective business process.  ",
              _type: "Process",
              GUID: "96e72960-eaa6-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Identify required Checks   ***Check if Registration Status is positive or negative   ***Check quantity limit to import / produce   ***Block order and report issue   ***Permit Order  ",
              Outcome:
                "The product complies with the chemical compliance related requirements and sales order processing is permitted.",
              name: "Perform chemical compliance check",
              _id: 159,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of the sales order is given through the confirmation and represents a commitment to fulfil the order.",
              _type: "Process",
              GUID: "a98a286c-7e52-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The effectiveness of the approval-workflows often is overestimated. Sales managers will receive many approval requests daily. The data to be checked should be limited to the essentials. Everything that can be checked automatically by rules should be implemented in the system. The result of the automatic checks should be obvious to the reviewer.",
              Type: "Business Process",
              Scope:
                "After all checks related to the order have been performed the final decision is made regarding execution of the order. A commitment to the customer is made. This triggers the outbound logistics, production process or service process. ",
              Outcome:
                "A decision is made to fulfil the customers order. This triggers the outbound logistics/production process. The customer is informed about the decision.",
              name: "Save and approve sales order",
              _id: 1332,
              Business_Rules:
                "Rules must be established for allocating authorization for sales order approval to users. The format of the confirmation (electronic, paper) and communication channel must be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In order to quote a price and conditions to the customer, the quotation must be created and processed. Depending on the business model this may include collecting different information and processing various checks. Base for the creation of a quotation are customer details and information from the customer inquiry.",
              _type: "Process",
              GUID: "5fbf8d47-82c7-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "In case standard agreements exist, the check with the supplier might be replaced by an internal check against standard lead times documented in the respective master data.",
              Type: "Business Process",
              Scope:
                "A quotation document is prepared based on information captured in the inquiry. The sales price is calculated and conditions determined (e.g. rebates, shipping conditions, pre-payment requirements etc.). The availability, and potentially also conditions and price are checked with the supplier.",
              Outcome: "A quotation is prepared and can be formally processed.",
              name: "Create quotation for trading goods",
              _id: 214,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After capturing and confirming a sales order, the order fulfillment needs to be monitored. Changes in availability, confirmation dates and priorities have to be considered and reflected in the sales order. The customer needs to be informed accordingly.",
              _type: "Process",
              GUID: "397b5453-d3a1-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "From a time perspective, this process spans from the saving of the sales order to the creation, release of the delivery and invoicing.",
              Outcome:
                "Any changes are reflected in the sales order, communication and excalation procedures are triggered if necessary.",
              name: "Monitor order fulfillment",
              _id: 158,
              Business_Rules:
                "Clear guidelines need to be defined how to handle shortages, deviations from already given commitments to the customer, priority conflicts as well as rules need to be agreed on how and when, and under which sircumstances the customer can request changes to the order. ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the confirmation is provided that the customer order can be fulfilled, the product price must be calculated (or extracted from the system) taking into account relevant conditions (e.g. rebates, shipping condition, customer price groups).",
              _type: "Process",
              GUID: "197ea3f9-eaa9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "In addition to the pricing itself, the workflows and required approvals have to be defined. Consider all types of sales (priced samples, free of charge samples etc.) and possible promotions and rebates.  In case a quotation has been placed, the conditions between both should be aligned or at least an interaction with the customer has to take place in case of any deviation.",
              Type: "Business Process",
              Scope:
                "Pricing takes into account all conditions related to the product and customer.",
              Outcome:
                "Pricing and conditions related to the order are generated, documented and agreed with customer.",
              name: "Determine product price and conditions",
              _id: 157,
              Business_Rules:
                "Pricing schemas are typically defined upfront.  It must be defined who (and with which limitations) has the rights to adjust prices and conditions within the sales process.   The price and trading conditions of the product must be based on a set of guidelines that take into account:   ***Cost of product   ***Market value of product   ***Customers perceived value of product    ***Relationship with customer (rebates etc.)   ***Defined profit margin expectations  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Quotation is a binding commitment and can deal with significant product quantities and monetary values. Therefore, it must be ensured that information included into quotation is correct and corresponds to companys interests, which is ensured through an approval process.",
              _type: "Process",
              GUID: "f806160f-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After passing all checks related to the quotation, the commercial aspects of the quotation are approved and quotation is sent to the customer.",
              Outcome: "Quotation is sent to customer.",
              name: "Approve and send out quotation",
              _id: 213,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Credit management helps to control the companys exposure to credit risk. Credit management must be aligned taking into account the customers liquidity and payment history (credit limit/insurance) and outstanding receivables.",
              _type: "Process",
              GUID: "5aa42fcb-e8e2-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Many corporations start looking at credit management from a group perspective. This requires some collaboration across companies and business units, which might not be established. Hierarchical credit limits might help to hinder a single business unit from already consuming the entire credit limit of a customer.  Any kind of guarantees such as letter of credit or bank guarantees and advanced payments need to be considered in this process.  Credit management for consignment fill-ups - despite goods remaining in sellers property, it is common to perform credit check, since control over goods is lost and the goods issue is typically retrospective.",
              Type: "Business Process",
              Scope:
                "The customers ability to pay for the product or service is evaluated based on their liquidity and payment history and a decision is made on whether the sale is allowed or not.",
              Outcome:
                "The decision is made on whether to proceed with sale or not.",
              name: "Execute credit management",
              _id: 1334,
              Business_Rules:
                "It is necessary to define the information necessary to execute the credit management process.  A framework must be put in place for:   ***Calculating the rating value of customers    ***Determining Credit Limit   ***Setting rules for Credit Check    ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade compliance ensures due diligence with trade regulatory programs and cross-border customs requirements. Global trade checks are required for all business operations.",
              _type: "Process",
              GUID: "1b684ec4-44de-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The check itself is typically done automatically by the ERP system. The actual process discussion should focus on the maintenance of the relevant GTS data (including the integration of external data sources) and the handling of sales orders failing to pass the checks.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both involved business partners and products being sold or related services are subject to checks.",
              Outcome:
                "The sales order complies with the applicable trade regulations and the product can be shipped.",
              name: "Perform global trade check",
              _id: 57,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists, dual use products) used for screening is comprehensive and up to date.   Customer data must be up to date.   Rules and procedures how to handle sales orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process describes the initial capturing and checking of an inquiry. In comparison to a lead an inquiry contains an explicit request for a quotation. Receiving the customer inquiry and capturing it in a format necessary for further processing and initiating pre-sales business processes. ",
              _type: "Process",
              GUID: "f80615ee-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "For inquiries from and quotations for new potential customers, a dummy customer master might be used. Latest with the order entry, a real customer master gets created and the sales order will be captured with reference to it.",
              Type: "Business Process",
              Scope:
                "Once a customer inquires about a certain product, the data must be recorded, stored and forwarded for further processing. ",
              Outcome:
                "All relevant information regarding the customers inquiry is documented. The information captured provides the basis for preparing a quotation or reservation of goods.",
              name: "Receive and capture customer inquiry",
              _id: 171,
              Business_Rules:
                "Rules should determine in which cases inquiries have to be documented.   There are several aspects why inquiries should be captured in the system:   ***Avoidance of duplicated capturing of data   ***Considering the information in planning   ***Internal compliance and approval guidelines   ***Using the information for reporting and identifying reasons for lost sales  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "For customer orders related to a quotation, information from the quotation is transferred to the sales order when the customer order is received. This differs from sales processes where the source of incoming information is only the customer order itself.",
              _type: "Process",
              GUID: "7c55366c-7e54-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the customer order is placed, information from the quotation is transferred to the sales order, updated and enriched if necessary.",
              Outcome:
                "Sales order with reference to the quotation is created.",
              name: "Receive customer order and transfer quotation to sales order",
              _id: 212,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The process describes the creation of customer specific documentation that may be requested by our customers.",
              _type: "Process",
              GUID: "56165656-7169-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The documentation may be delivered together with the goods receipt or independently from it.    The documentation may be delivered as hard copy or as an electronic version.",
              Type: "Business Process",
              Scope:
                "After the request for creating customer specific documentation has been received, the documentation is created and prepared for a shipment to the customer.",
              Outcome:
                "The customer receives specific documentation as requested.",
              name: "Prepare customer specific documentation",
              _id: 160,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "A purchase requisition is directly generated from the sales order schedule line triggering the related purchasing scenario and linking both together.  Purchasing products directly for a sales order is used in a variety of business models. It can be a one time opportunity, a frequently applied model, or even a type of outsourced inventory in a JIT-like set-up. Therefore, the interaction between the sales department, the purchasing department, and the vendor in order to clarify availability and delivery dates might differ. In a opportunity sale, it might even be required to identify a source of supply before any commitment to the customer is given.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Sales of trading goods (Procure to order)",
          _id: 211,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "401ac301-7e4f-11e5-0a66-001bc640cd9b",
          Description:
            "Handling of returnable packaging refers to re-usable packaging units that are provided to customers in the course of product sales transactions. It is applied if packaging units are valuable and re-usable.  The deposit scenario covers the option, in which packaging units at customer disposal are tracked and the customer is charged a security deposit for them. The deposit is returned after return of the packaging units.",
          _type: "Scenario",
          GUID: "8c942b4a-ef45-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "A credit memo is issued by the seller of goods to the customer, reducing the amount that is owed to the seller under the terms of an earlier invoice. A credit memo may be issued because the goods were returned to the seller, or there may have been a pricing dispute or other reasons for which the customer will not pay the seller the full amount of the invoice.       ",
              _type: "Process",
              GUID: "e83072e4-e98c-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "The appropriate sales tax is also calculated along with any shipping charges that are being credited to the customer. ",
              Type: "Business Process",
              Scope:
                "Once the decision is made to compensate a customer with a credit memo, the document is created with details regarding reduction in the previous amount owed. The appropriate sales tax is also calculated along with any shipping charges that are being credited to the customer.",
              Outcome: "Credit memo is created and sent to the customer.",
              name: "Create credit memo",
              _id: 1368,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The assignment of returnable packaging to a sales order ensures that the cost and quantity of  the materials are mapped to the customer order. ",
              _type: "Process",
              GUID: "605f699d-7e4f-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Information about the quantity and value of the returnable packaging, as well as the plant to which the materials are to be returned is linked to the customer order and documented accordingly.",
              Outcome:
                "Returnable packaging information is recorded with the sales order data.",
              name: "Assign returnable packaging to sales order",
              _id: 379,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A delivery is the central object of the goods receipt process containing all the data required for triggering and monitoring it, starting from goods receipt in the yard and ending with transferral of the goods to the final putaway. In a customer return (as well as consignment pick-up) process, a return delivery document is used for this purpose.",
              _type: "Process",
              GUID: "3712628c-e9bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the return order (consignment pick-up order for consignment process) is created, a return delivery is created with reference to it.",
              Outcome:
                "Return delivery is created and goods receipt process can be initiated. ",
              name: "Create return delivery",
              _id: 1371,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "Returnable packaging can also be sold. In this case the price is either included in the products price or an additional line item for the packaging material is added to the sales order.  Nevertheless, there might be an agreement that the seller will buy back the provided packaging material if the customer asks for it.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Handling of returnable packaging (Deposit)",
          _id: 210,
          Business_Rules:
            "If the customer has to return the packaging material, it needs to be defined at which location. Internal processes to reconcile between two subsidiaries have to be in place if deposit and return can be made at different locations/legal entities.",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "a7774681-7e55-11e5-0a66-001bc640cd9b",
          Description:
            "The sales via intercompany is a collaborative scenario, whereby the goods are not kept in stock, but after customer order is placed, the order details are transferred to a manufacturing or distribution business unit of the same organization, which takes over the order fulfillment and ships goods directly to the customer.  Typically the scenario is used in organizations with dedicated sales business units without own warehouses, who carry out customer service and sales, and manufacturing sites or centralized distribution centers, who fulfill the placed sales orders. The scenario can be combined with any of the product sales scenarios and any production model.",
          _type: "Scenario",
          GUID: "8c942b24-ef45-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "For intercompany transactions, this process ensures that billing information is received by the delivering entity and the financial obligation related to the transaction is settled.      ",
              _type: "Process",
              GUID: "6166270a-7e56-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the goods have been delivered and invoice received, payment is made to the delivering entity and recording in accounting.",
              Outcome:
                "Amount in the intercompany invoice is paid and documented accordingly.",
              name: "Receive intercompany invoice",
              _id: 1232,
              Business_Rules:
                "It is necessary to define: - General payment terms and condition for intercompany invoicing, - Relations between the selling and shipping operating units in view of intercompany transaction flows.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Back order processing must be performed in case the ATP check did not provide a satisfying result, or an unplanned change to the supply situation requires a reconsideration/ recalculation of already confirmed quantities and dates. The process might affect other sales orders, stock transfer orders, and confirmed documents such as material reservations, production or repair orders, which compete with the respective sales documents for the available quantity of the requested material. The resolution of a shortage situation includes the alignment (and consequent adjustment) of the supply situation as well as a reallocation of already confirmed and allocated ATP quantities. All affected parties must be involved or informed accordingly.",
              _type: "Process",
              GUID: "3e124dd1-602a-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the ATP situation has been analysed, a solution is elaborated by e.g. rescheduling the order confirmation or evaluating other supplier options. Finally the solution is communicated with all relevant parties.",
              Outcome:
                "Aligned supply situation and communicated with all affected parties ",
              name: "Perform back order processing",
              _id: 177,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of a customer invoice provides documentation of the financial obligation related to a customer order. The customer invoice is created from a sales order.",
              _type: "Process",
              GUID: "75ff0dfc-e8bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Circumstances such as required documents for customs clearance or advance payments might have an impact on the timing when an invoice needs to be created during the sales process.",
              Type: "Business Process",
              Scope:
                "After the customer order has been fulfilled, the invoice is created. It provides the customer with information required to settle the payment related to their order.",
              Outcome: "Invoice is created and sent to the customer.",
              name: "Create customer invoice",
              _id: 1363,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The process describes the creation of customer specific documentation that may be requested by our customers.",
              _type: "Process",
              GUID: "56165656-7169-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The documentation may be delivered together with the goods receipt or independently from it.    The documentation may be delivered as hard copy or as an electronic version.",
              Type: "Business Process",
              Scope:
                "After the request for creating customer specific documentation has been received, the documentation is created and prepared for a shipment to the customer.",
              Outcome:
                "The customer receives specific documentation as requested.",
              name: "Prepare customer specific documentation",
              _id: 160,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Country specific regulations state that, above a certain quantity of chemicals and other hazardous substances, it is required to register with the authorities the maximum quantities of these substances that is planned to be purchased, imported, produced, sold, or exported within a certain period. By comparing the recorded quantities with the limit values, the system signals that a limit value is close to be exceeded if a limit value is exceeded, the system can also block the respective business process.  ",
              _type: "Process",
              GUID: "96e72960-eaa6-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Identify required Checks   ***Check if Registration Status is positive or negative   ***Check quantity limit to import / produce   ***Block order and report issue   ***Permit Order  ",
              Outcome:
                "The product complies with the chemical compliance related requirements and sales order processing is permitted.",
              name: "Perform chemical compliance check",
              _id: 159,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of an intercompany invoice initiates the payment process for a transaction between two entities from the same corporate group.       ",
              _type: "Process",
              GUID: "53da3f54-e8c9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Typically there are special calculation rules to determine the profit margin in intercompany transactions.",
              Type: "Business Process",
              Scope:
                "The intercompany invoice, with which the supplier entity bills the selling or receiving entity, is created. In the case of a direct delivery to a customer, this happens automatically at the same time when the customer invoice is created. The required accounting entries are created using information from this invoice.",
              Outcome: "Intercompany invoice is created and issued. ",
              name: "Create intercompany invoice",
              _id: 1229,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of the sales order is given through the confirmation and represents a commitment to fulfil the order.",
              _type: "Process",
              GUID: "a98a286c-7e52-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The effectiveness of the approval-workflows often is overestimated. Sales managers will receive many approval requests daily. The data to be checked should be limited to the essentials. Everything that can be checked automatically by rules should be implemented in the system. The result of the automatic checks should be obvious to the reviewer.",
              Type: "Business Process",
              Scope:
                "After all checks related to the order have been performed the final decision is made regarding execution of the order. A commitment to the customer is made. This triggers the outbound logistics, production process or service process. ",
              Outcome:
                "A decision is made to fulfil the customers order. This triggers the outbound logistics/production process. The customer is informed about the decision.",
              name: "Save and approve sales order",
              _id: 1332,
              Business_Rules:
                "Rules must be established for allocating authorization for sales order approval to users. The format of the confirmation (electronic, paper) and communication channel must be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Receiving the customer order and capturing it in a format necessary for further processing are the key first steps to all sales processes. ",
              _type: "Process",
              GUID: "4cb51061-7e56-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the customer order is placed, the data must be amended, stored and forwarded for further processing. This might include transferring or copying data from other documents such as quotations or frame contracts.",
              Outcome:
                "All relevant information regarding the customers order is documented. The information captured provides the basis for determining whether the order can be fulfilled.",
              name: "Receive customer order and capture sales order data",
              _id: 175,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The purpose of this process is to prevent shipping of dangerous goods which will harm dangerous goods regulation.",
              _type: "Process",
              GUID: "3124d4df-e98f-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The dangerous goods check verifies whether the shipment of dangerous goods contains transport regulatory data derived from UN-numbers, dangerous good classes, packaging codes etc. ",
              Outcome:
                "The product complies with the EH+S related requirements and the sales order is permitted by EH+S.",
              name: "Perform dangerous goods check",
              _id: 67,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The Available-to-Promise (ATP) check against stock verifies whether the required quantity of finished goods can be sold to the customer at the requested date. The check is carried out against actual or projected finished goods inventory.       ",
              _type: "Process",
              GUID: "eabe97ec-e8c8-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "It is necessary to define what happens after the availability is confirmed. Typically the requested product quantity is reserved (excluded from available stock). It should be defined how undelivered sales orders are handled and when a reservation for a sales order will be canceled.  Business rules that need to be defined are:   ***What are the main and alternative supply points for regions/customers (ship-to)   ***Which future goods receipts should be considered   ***Which future goods issues should be considered   ***Are allocations required to reserve quantities for specific customers, customer groups, markets/sales channels, regions    ***If allocations are used are those valid for the whole sales period or will those be deactivated after a certain time (example: monthly allocations are only valid until mid of the month any remaining quantities will be made generally available afterwards).    Sometimes other constraints like transportation capacity or handling capacity need to be integrated into the ATP check.",
              Type: "Business Process",
              Scope:
                "After the customer order data is captured, it must be checked if the order can be fulfilled (the requested products are available in the requested quantity and on the desired date). It is also necessary to determine the storage location the goods will be delivered from.",
              Outcome: "ATP check is performed.",
              name: "Check availability to promise at sales order entry",
              _id: 163,
              Business_Rules:
                "For setting-up the check it must be defined which sources, i.e. inventory, are to be considered.  Typical business cases are:   ***Check against plan or inventory    ***Inventory in local warehouse    ***Inventory in global organisation     ***Inventory in local warehouse + placed purchase orders/released production orders    Allocations might be used in short markets to manage the distribution of stock to particular markets, customer segments, or individual customers.  The workflow in case of different partial availability situations should be defined:   ***Proposal of alternate dates   ***Proposal of substitute products   ***Proposal of partial shipments   ***Backorder processing     ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade compliance ensures due diligence with trade regulatory programs and cross-border customs requirements. Global trade checks are required for all business operations.",
              _type: "Process",
              GUID: "1b684ec4-44de-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The check itself is typically done automatically by the ERP system. The actual process discussion should focus on the maintenance of the relevant GTS data (including the integration of external data sources) and the handling of sales orders failing to pass the checks.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both involved business partners and products being sold or related services are subject to checks.",
              Outcome:
                "The sales order complies with the applicable trade regulations and the product can be shipped.",
              name: "Perform global trade check",
              _id: 57,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists, dual use products) used for screening is comprehensive and up to date.   Customer data must be up to date.   Rules and procedures how to handle sales orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the confirmation is provided that the customer order can be fulfilled, the product price must be calculated (or extracted from the system) taking into account relevant conditions (e.g. rebates, shipping condition, customer price groups).",
              _type: "Process",
              GUID: "197ea3f9-eaa9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "In addition to the pricing itself, the workflows and required approvals have to be defined. Consider all types of sales (priced samples, free of charge samples etc.) and possible promotions and rebates.  In case a quotation has been placed, the conditions between both should be aligned or at least an interaction with the customer has to take place in case of any deviation.",
              Type: "Business Process",
              Scope:
                "Pricing takes into account all conditions related to the product and customer.",
              Outcome:
                "Pricing and conditions related to the order are generated, documented and agreed with customer.",
              name: "Determine product price and conditions",
              _id: 157,
              Business_Rules:
                "Pricing schemas are typically defined upfront.  It must be defined who (and with which limitations) has the rights to adjust prices and conditions within the sales process.   The price and trading conditions of the product must be based on a set of guidelines that take into account:   ***Cost of product   ***Market value of product   ***Customers perceived value of product    ***Relationship with customer (rebates etc.)   ***Defined profit margin expectations  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The results of the final ATP check need to be reviewed and the order confirmation to the customer is sent out. If the ATP check has not already been (re-)performed, this needs to be done now out of the individual sales document to consider the newly available ATP quantities and to adjust confirmation dates.",
              _type: "Process",
              GUID: "3e124dd3-602a-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After reviewing the results of the ATP, the customer needs to be informed via order confirmation or the supply situation must be clarified with the MRP planner.",
              Outcome: "Reviewed ATP and communicated order confirmation",
              name: "Review ATP and reconfirm order",
              _id: 176,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Credit management helps to control the companys exposure to credit risk. Credit management must be aligned taking into account the customers liquidity and payment history (credit limit/insurance) and outstanding receivables.",
              _type: "Process",
              GUID: "5aa42fcb-e8e2-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Many corporations start looking at credit management from a group perspective. This requires some collaboration across companies and business units, which might not be established. Hierarchical credit limits might help to hinder a single business unit from already consuming the entire credit limit of a customer.  Any kind of guarantees such as letter of credit or bank guarantees and advanced payments need to be considered in this process.  Credit management for consignment fill-ups - despite goods remaining in sellers property, it is common to perform credit check, since control over goods is lost and the goods issue is typically retrospective.",
              Type: "Business Process",
              Scope:
                "The customers ability to pay for the product or service is evaluated based on their liquidity and payment history and a decision is made on whether the sale is allowed or not.",
              Outcome:
                "The decision is made on whether to proceed with sale or not.",
              name: "Execute credit management",
              _id: 1334,
              Business_Rules:
                "It is necessary to define the information necessary to execute the credit management process.  A framework must be put in place for:   ***Calculating the rating value of customers    ***Determining Credit Limit   ***Setting rules for Credit Check    ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After capturing and confirming a sales order, the order fulfillment needs to be monitored. Changes in availability, confirmation dates and priorities have to be considered and reflected in the sales order. The customer needs to be informed accordingly.",
              _type: "Process",
              GUID: "397b5453-d3a1-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "From a time perspective, this process spans from the saving of the sales order to the creation, release of the delivery and invoicing.",
              Outcome:
                "Any changes are reflected in the sales order, communication and excalation procedures are triggered if necessary.",
              name: "Monitor order fulfillment",
              _id: 158,
              Business_Rules:
                "Clear guidelines need to be defined how to handle shortages, deviations from already given commitments to the customer, priority conflicts as well as rules need to be agreed on how and when, and under which sircumstances the customer can request changes to the order. ",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "In case returnable packaging is used in combination with this operating model, the collection and refund needs to be clarified.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Sales via intercompany",
          _id: 209,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "686be3a1-7e51-11e5-0a66-001bc640cd9b",
          Description:
            "Rebate management scenario covers process flow required to set-up, maintain and settle rebate agreements with customers. This also includes the calculation and payout of customer rebates.  Rebate agreement is concluded for a specific period of time. The basis of a rebate agreement is the customers commitment to purchase products or services in specific quantity or value. Fulfillment of customers commitment needs to be tracked. At the end of the rebate agreement period a settlement process needs to take place, where calculation of applied rebates and fulfillment of the customers obligations takes place. This determines if a credit or debit note needs to be issued to the customer.",
          _type: "Scenario",
          GUID: "8c942b3a-ef45-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "After rebate agreement terms have been negotiated with the customer, a rebate agreement is created in the system containing the agreement details. The agreement will be further used for tracking of customer commitment fulfillment.",
              _type: "Process",
              GUID: "7093bfe7-7e51-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "A rebate agreement is created in the system after general negotiation with customer. The agreement contains details necessary for tracking of customer commitment fulfillment and calculation of applied rebates during settlement - rebate validity period, value/volume of goods customer commits to, items, for which rebates are relevant, rebate amounts/percentages, payment methods etc.",
              Outcome:
                "Rebate agreement is created and applied rebates can be tracked.",
              name: "Capture rebate agreement",
              _id: 208,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A debit memo is issued by the seller of goods to the customer, increasing the amount that is owed to the seller under the terms of an earlier invoice. Typically a debit memo is issued, when the amount billed on the original invoice was too low. An example for such situation would be a debit note for the amount of a rebate, which was included into initial invoice, but for which the customer has not qualified.",
              _type: "Process",
              GUID: "1ea694f6-e995-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Many companies do not use debit memos, but instead rather re-issue the original invoice with an adjustment, or issue an invoice for the incremental amount.",
              Type: "Business Process",
              Scope:
                "Once it has been identified, that amount billed on the original invoice was too low, the debit memo document is created with or without reference to original invoice.",
              Outcome: "Debit memo is created and sent to the customer.",
              name: "Create debit memo",
              _id: 207,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "At the end of validity period of a rebate agreement the transactions under the terms of the agreement are evaluated and mutual liabilities arising form the agreement are settled. During the validity of the rebate agreement, partial settlements can take place. ",
              _type: "Process",
              GUID: "7093bfdb-7e51-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The customer invoices are evaluated and accrued. Rebates are calculated and a credit note request gets created. At the end of the rebate agreement, the final settlement is executed to close the agreement.",
              Outcome:
                "Rebates are calculated in accordance to the agreement and credit note requests are created.",
              name: "Settle rebate agreement",
              _id: 206,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A credit memo is issued by the seller of goods to the customer, reducing the amount that is owed to the seller under the terms of an earlier invoice. A credit memo may be issued because the goods were returned to the seller, or there may have been a pricing dispute or other reasons for which the customer will not pay the seller the full amount of the invoice.       ",
              _type: "Process",
              GUID: "e83072e4-e98c-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "The appropriate sales tax is also calculated along with any shipping charges that are being credited to the customer. ",
              Type: "Business Process",
              Scope:
                "Once the decision is made to compensate a customer with a credit memo, the document is created with details regarding reduction in the previous amount owed. The appropriate sales tax is also calculated along with any shipping charges that are being credited to the customer.",
              Outcome: "Credit memo is created and sent to the customer.",
              name: "Create credit memo",
              _id: 1368,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "After general negotiation with the customer a rebate agreement is created in the system in one sales area for a specific time period (with / without reference). The basis of rebate agreement is the value/volume of for the goods sold to the specific customer. In the rebate agreement, a condition is maintained that reflects the estimated quantity / amount to be granted.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Rebate management",
          _id: 205,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "a37152d1-7e4e-11e5-0a66-001bc640cd9b",
          Description:
            "This scenario describes the business process for managing inquiry and quotation for customer projects. Sales & Distribution (SD) and the Project System (PS) are used to control the complete process from the customer inquiry to the accepted quotation.",
          _type: "Scenario",
          GUID: "8c942b46-ef45-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Easy cost planning enables the planning of costs at WBS level based on quantities and characteristics. It is used to create quantity structures for the cost calculation, starting from the project structure.   ",
              _type: "Process",
              GUID: "135cff11-e998-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Easy cost planning is performed to create a first rough calculation of the project cost. ",
              Outcome: "Initial estimate of project cost is available",
              name: "Perform easy cost planning",
              _id: 204,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures the creation of a quotation based on the information in the inquiry. The quotation is subsequently sent to the prospective customer.",
              _type: "Process",
              GUID: "ab663832-7e4e-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The inquiry is first copied into the quotation. After maintaining all the details for the labour and materials used in the project, the pricing information is added to the quotation. Project milestones are transferred to the quotation. By means of a project version a snapshot of the project is created before sending out the quotation.",
              Outcome: "The quotation is forwarded to the customer",
              name: "Create quotation with ref. to customer inquiry",
              _id: 203,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A project is created in order to add further details to the inquiry (for example, scheduling, payment processing). This ensures calculation of the cost as the basis for determining the gross price in the quotation.",
              _type: "Process",
              GUID: "c29e2dc6-e996-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The project is created with activities, components, and milestones in a complex structure.",
              Outcome:
                "Project is created, and timeline, costs, etc. can now be assigned.",
              name: "Create project",
              _id: 202,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In order to ensure execution of the project in a timely manner and the controlling of costs, planning and scheduling of the project must be performed.      ",
              _type: "Process",
              GUID: "1cdd8084-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Scheduling is carried out according to project timelines, milestones and deliverables.  The cost of materials and planned labour comes from the project template. This information is incorporated into the project plan. ",
              Outcome:
                "Project plan is created and project activities are scheduled.",
              name: "Plan and schedule project",
              _id: 1280,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Advance procurement must be carried out at the very beginning of the project execution. In this process ProMan is used to control the activity. Sometimes long lead time procurement is triggered before the order is confirmed. Although whenever possible a supplier will avoid ordering project-specific materials beforehand, in some situations it is required.     ",
              _type: "Process",
              GUID: "ab66384a-7e4e-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The data for needed material (of long lead time material) is checked, and whether its planned demand will be met. With the release of this activity the demand for (long lead time) items are created for the MRP run.",
              Outcome:
                "A purchase order is created for the procurement of the required materials.",
              name: "Perform advance procurement",
              _id: 201,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The quotation is a binding commitment and can deal with significant product quantities and monetary values. Therefore, it must be ensured that the information included in the quotation is correct and corresponds to the companys interests, which is ensured through the approval process.",
              _type: "Process",
              GUID: "e22cbe01-e8c2-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the quotation is created, it needs to be send to customer and receive feedback. Based on customer response, a quotation is updated, rejected or accepted.",
              Outcome:
                "After passing all checks related to the quotation, the commercial aspects of the quotation are approved and the quotation is sent to the customer.",
              name: "Send quotation",
              _id: 200,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When a prospective customer sends an request for a  project, the information must be captured and stored for further processing in form of an inquiry.     ",
              _type: "Process",
              GUID: "ab66382c-7e4e-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "An inquiry of a customer that would require a project for implementation is recorded. A respective project number is then assigned to the inquiry.",
              Outcome: "Customer inquiry for a  project is created.",
              name: "Create inquiry for customer project",
              _id: 199,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The budget is the approved cost structure for a project. It is used by management to approve the expected development of order costs over a given timeframe. Availability control enables the control of costs actively by issuing warnings and error messages when costs are incurred.     ",
              _type: "Process",
              GUID: "ab66384d-7e4e-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The original budget is allocated to the WBS elements. After a specified point in time, the budget can only be corrected using budget updates.",
              Outcome: "The budget is allocated to the WBS elements.",
              name: "Perform budget planning",
              _id: 198,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Upon revision of the quotation by the customer, changes may be required. Given this, the data must be updated according to the new information.",
              _type: "Process",
              GUID: "e2365b03-e8c2-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Based on the requested changes of the customer, the quotation is populated with the new information and sent back to the customer.",
              Outcome: "The quotation is updated and sent to the customer",
              name: "Change quotation",
              _id: 197,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Engineer-to-order (Quotation)",
          _id: 196,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "09669111-7e48-11e5-0a66-001bc640cd9b",
          Description:
            "Consignment pick-up scenario covers the process flow required to physically return products from consignment stock at a customers premises back to the own warehouse.  The scenario is applied if the customer does not consume the product within an agreed timeframe. Depending on the consignment contract this may or may not include additional fees.",
          _type: "Scenario",
          GUID: "8c942b2c-ef45-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "With the creation of a consignment pick-up order, goods returned by the customer are recorded in the warehouse of the seller i.e. the company that actually owns the goods. This precedes the transportation of the goods from the customers storage location back to the supplying company.  ",
              _type: "Process",
              GUID: "5abd47b1-7e47-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "When the customer no longer requires goods given to them on consignment, the creation of a consignment pick-up order triggers a return delivery to the seller.",
              Outcome: "Order for consignment pick-up is created.",
              name: "Receive customer notification and create consignment pick-up order",
              _id: 195,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of consignment pickup order is required to ensure that customer request to return not consumed by the customer back to the warehouse in accordance with company rules.",
              _type: "Process",
              GUID: "6bcd18ca-624c-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "A consignment pickup allows a customer to return goods and materials, which were not consumed.   Once such a request is received and recorded in form of a consignment pickup order, its validity is checked. In case it is in accordance with company rules, the pickup is confirmed and can be processed. A consignment pickup allows a customer to return goods and materials, which were not consumed.",
              Outcome:
                "Once a pick-up request is received and recorded in form of a consignment pickup order, its validity is checked. In case it is in accordance with company rules, the pickup is confirmed and can be processed.",
              name: "Confirm consignment pick up order",
              _id: 194,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A delivery is the central object of the goods receipt process containing all the data required for triggering and monitoring it, starting from goods receipt in the yard and ending with transferral of the goods to the final putaway. In a customer return (as well as consignment pick-up) process, a return delivery document is used for this purpose.",
              _type: "Process",
              GUID: "3712628c-e9bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the return order (consignment pick-up order for consignment process) is created, a return delivery is created with reference to it.",
              Outcome:
                "Return delivery is created and goods receipt process can be initiated. ",
              name: "Create return delivery",
              _id: 1371,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "In case of inventory losses on consignment stock or the need to destroy consignment stock, a pick-up needs to be performed at least on (SAP) system level to perform the consecutive business processes.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Consignment pick-up",
          _id: 193,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "11935231-7eeb-11e5-0a66-001bc640cd9b",
          Description:
            "Sample handling describes provision of free-of-charge product samples to the customer.  The scenario is applied as part of sales support to give customers the possibility to get acquainted with a new product (including testing the suitability of product to customer requirements) before committing to actual purchase.",
          _type: "Scenario",
          GUID: "8c942b40-ef45-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Receiving the customer order and capturing it in a format necessary for further processing are the key first steps to all sales processes. ",
              _type: "Process",
              GUID: "4cb51061-7e56-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the customer order is placed, the data must be amended, stored and forwarded for further processing. This might include transferring or copying data from other documents such as quotations or frame contracts.",
              Outcome:
                "All relevant information regarding the customers order is documented. The information captured provides the basis for determining whether the order can be fulfilled.",
              name: "Receive customer order and capture sales order data",
              _id: 175,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade compliance ensures due diligence with trade regulatory programs and cross-border customs requirements. Global trade checks are required for all business operations.",
              _type: "Process",
              GUID: "1b684ec4-44de-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The check itself is typically done automatically by the ERP system. The actual process discussion should focus on the maintenance of the relevant GTS data (including the integration of external data sources) and the handling of sales orders failing to pass the checks.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both involved business partners and products being sold or related services are subject to checks.",
              Outcome:
                "The sales order complies with the applicable trade regulations and the product can be shipped.",
              name: "Perform global trade check",
              _id: 57,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists, dual use products) used for screening is comprehensive and up to date.   Customer data must be up to date.   Rules and procedures how to handle sales orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After capturing and confirming a sales order, the order fulfillment needs to be monitored. Changes in availability, confirmation dates and priorities have to be considered and reflected in the sales order. The customer needs to be informed accordingly.",
              _type: "Process",
              GUID: "397b5453-d3a1-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "From a time perspective, this process spans from the saving of the sales order to the creation, release of the delivery and invoicing.",
              Outcome:
                "Any changes are reflected in the sales order, communication and excalation procedures are triggered if necessary.",
              name: "Monitor order fulfillment",
              _id: 158,
              Business_Rules:
                "Clear guidelines need to be defined how to handle shortages, deviations from already given commitments to the customer, priority conflicts as well as rules need to be agreed on how and when, and under which sircumstances the customer can request changes to the order. ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of the sales order is given through the confirmation and represents a commitment to fulfil the order.",
              _type: "Process",
              GUID: "a98a286c-7e52-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The effectiveness of the approval-workflows often is overestimated. Sales managers will receive many approval requests daily. The data to be checked should be limited to the essentials. Everything that can be checked automatically by rules should be implemented in the system. The result of the automatic checks should be obvious to the reviewer.",
              Type: "Business Process",
              Scope:
                "After all checks related to the order have been performed the final decision is made regarding execution of the order. A commitment to the customer is made. This triggers the outbound logistics, production process or service process. ",
              Outcome:
                "A decision is made to fulfil the customers order. This triggers the outbound logistics/production process. The customer is informed about the decision.",
              name: "Save and approve sales order",
              _id: 1332,
              Business_Rules:
                "Rules must be established for allocating authorization for sales order approval to users. The format of the confirmation (electronic, paper) and communication channel must be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Country specific regulations state that, above a certain quantity of chemicals and other hazardous substances, it is required to register with the authorities the maximum quantities of these substances that is planned to be purchased, imported, produced, sold, or exported within a certain period. By comparing the recorded quantities with the limit values, the system signals that a limit value is close to be exceeded if a limit value is exceeded, the system can also block the respective business process.  ",
              _type: "Process",
              GUID: "96e72960-eaa6-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Identify required Checks   ***Check if Registration Status is positive or negative   ***Check quantity limit to import / produce   ***Block order and report issue   ***Permit Order  ",
              Outcome:
                "The product complies with the chemical compliance related requirements and sales order processing is permitted.",
              name: "Perform chemical compliance check",
              _id: 159,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Credit management helps to control the companys exposure to credit risk. Credit management must be aligned taking into account the customers liquidity and payment history (credit limit/insurance) and outstanding receivables.",
              _type: "Process",
              GUID: "5aa42fcb-e8e2-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Many corporations start looking at credit management from a group perspective. This requires some collaboration across companies and business units, which might not be established. Hierarchical credit limits might help to hinder a single business unit from already consuming the entire credit limit of a customer.  Any kind of guarantees such as letter of credit or bank guarantees and advanced payments need to be considered in this process.  Credit management for consignment fill-ups - despite goods remaining in sellers property, it is common to perform credit check, since control over goods is lost and the goods issue is typically retrospective.",
              Type: "Business Process",
              Scope:
                "The customers ability to pay for the product or service is evaluated based on their liquidity and payment history and a decision is made on whether the sale is allowed or not.",
              Outcome:
                "The decision is made on whether to proceed with sale or not.",
              name: "Execute credit management",
              _id: 1334,
              Business_Rules:
                "It is necessary to define the information necessary to execute the credit management process.  A framework must be put in place for:   ***Calculating the rating value of customers    ***Determining Credit Limit   ***Setting rules for Credit Check    ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The Available-to-Promise (ATP) check against stock verifies whether the required quantity of finished goods can be sold to the customer at the requested date. The check is carried out against actual or projected finished goods inventory.       ",
              _type: "Process",
              GUID: "eabe97ec-e8c8-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "It is necessary to define what happens after the availability is confirmed. Typically the requested product quantity is reserved (excluded from available stock). It should be defined how undelivered sales orders are handled and when a reservation for a sales order will be canceled.  Business rules that need to be defined are:   ***What are the main and alternative supply points for regions/customers (ship-to)   ***Which future goods receipts should be considered   ***Which future goods issues should be considered   ***Are allocations required to reserve quantities for specific customers, customer groups, markets/sales channels, regions    ***If allocations are used are those valid for the whole sales period or will those be deactivated after a certain time (example: monthly allocations are only valid until mid of the month any remaining quantities will be made generally available afterwards).    Sometimes other constraints like transportation capacity or handling capacity need to be integrated into the ATP check.",
              Type: "Business Process",
              Scope:
                "After the customer order data is captured, it must be checked if the order can be fulfilled (the requested products are available in the requested quantity and on the desired date). It is also necessary to determine the storage location the goods will be delivered from.",
              Outcome: "ATP check is performed.",
              name: "Check availability to promise at sales order entry",
              _id: 163,
              Business_Rules:
                "For setting-up the check it must be defined which sources, i.e. inventory, are to be considered.  Typical business cases are:   ***Check against plan or inventory    ***Inventory in local warehouse    ***Inventory in global organisation     ***Inventory in local warehouse + placed purchase orders/released production orders    Allocations might be used in short markets to manage the distribution of stock to particular markets, customer segments, or individual customers.  The workflow in case of different partial availability situations should be defined:   ***Proposal of alternate dates   ***Proposal of substitute products   ***Proposal of partial shipments   ***Backorder processing     ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The process describes the creation of customer specific documentation that may be requested by our customers.",
              _type: "Process",
              GUID: "56165656-7169-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The documentation may be delivered together with the goods receipt or independently from it.    The documentation may be delivered as hard copy or as an electronic version.",
              Type: "Business Process",
              Scope:
                "After the request for creating customer specific documentation has been received, the documentation is created and prepared for a shipment to the customer.",
              Outcome:
                "The customer receives specific documentation as requested.",
              name: "Prepare customer specific documentation",
              _id: 160,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Back order processing must be performed in case the ATP check did not provide a satisfying result, or an unplanned change to the supply situation requires a reconsideration/ recalculation of already confirmed quantities and dates. The process might affect other sales orders, stock transfer orders, and confirmed documents such as material reservations, production or repair orders, which compete with the respective sales documents for the available quantity of the requested material. The resolution of a shortage situation includes the alignment (and consequent adjustment) of the supply situation as well as a reallocation of already confirmed and allocated ATP quantities. All affected parties must be involved or informed accordingly.",
              _type: "Process",
              GUID: "3e124dd1-602a-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the ATP situation has been analysed, a solution is elaborated by e.g. rescheduling the order confirmation or evaluating other supplier options. Finally the solution is communicated with all relevant parties.",
              Outcome:
                "Aligned supply situation and communicated with all affected parties ",
              name: "Perform back order processing",
              _id: 177,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the confirmation is provided that the customer order can be fulfilled, the product price must be calculated (or extracted from the system) taking into account relevant conditions (e.g. rebates, shipping condition, customer price groups).",
              _type: "Process",
              GUID: "197ea3f9-eaa9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "In addition to the pricing itself, the workflows and required approvals have to be defined. Consider all types of sales (priced samples, free of charge samples etc.) and possible promotions and rebates.  In case a quotation has been placed, the conditions between both should be aligned or at least an interaction with the customer has to take place in case of any deviation.",
              Type: "Business Process",
              Scope:
                "Pricing takes into account all conditions related to the product and customer.",
              Outcome:
                "Pricing and conditions related to the order are generated, documented and agreed with customer.",
              name: "Determine product price and conditions",
              _id: 157,
              Business_Rules:
                "Pricing schemas are typically defined upfront.  It must be defined who (and with which limitations) has the rights to adjust prices and conditions within the sales process.   The price and trading conditions of the product must be based on a set of guidelines that take into account:   ***Cost of product   ***Market value of product   ***Customers perceived value of product    ***Relationship with customer (rebates etc.)   ***Defined profit margin expectations  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The results of the final ATP check need to be reviewed and the order confirmation to the customer is sent out. If the ATP check has not already been (re-)performed, this needs to be done now out of the individual sales document to consider the newly available ATP quantities and to adjust confirmation dates.",
              _type: "Process",
              GUID: "3e124dd3-602a-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After reviewing the results of the ATP, the customer needs to be informed via order confirmation or the supply situation must be clarified with the MRP planner.",
              Outcome: "Reviewed ATP and communicated order confirmation",
              name: "Review ATP and reconfirm order",
              _id: 176,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The purpose of this process is to prevent shipping of dangerous goods which will harm dangerous goods regulation.",
              _type: "Process",
              GUID: "3124d4df-e98f-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The dangerous goods check verifies whether the shipment of dangerous goods contains transport regulatory data derived from UN-numbers, dangerous good classes, packaging codes etc. ",
              Outcome:
                "The product complies with the EH+S related requirements and the sales order is permitted by EH+S.",
              name: "Perform dangerous goods check",
              _id: 67,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "Despite that the shipment is free of charge, all regulations for customs, EH&S, and trade restrictions apply.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Sample handling",
          _id: 192,
          Business_Rules:
            "Depending on the industry, free-of-charge shipments can vary in frequency and value of the shipped goods. Business rules should guide and control the usage of free-of-charge samples via value limits or/and approval workflows.",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "a0ef2381-7e48-11e5-0a66-001bc640cd9b",
          Description:
            "Consignment returns scenario is applied if the customer wishes to return products that have been issued but the customer has not actually consumed the products. However, the products remain at the customer location.  The scenario includes the cancellation of consignment issue, return of products to the consignment stock and issue of compensation to the customer. Within this scenario the goods ownership changes back from customer to the organization.",
          _type: "Scenario",
          GUID: "8c942b2a-ef45-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "A credit memo is issued by the seller of goods to the customer, reducing the amount that is owed to the seller under the terms of an earlier invoice. A credit memo may be issued because the goods were returned to the seller, or there may have been a pricing dispute or other reasons for which the customer will not pay the seller the full amount of the invoice.       ",
              _type: "Process",
              GUID: "e83072e4-e98c-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "The appropriate sales tax is also calculated along with any shipping charges that are being credited to the customer. ",
              Type: "Business Process",
              Scope:
                "Once the decision is made to compensate a customer with a credit memo, the document is created with details regarding reduction in the previous amount owed. The appropriate sales tax is also calculated along with any shipping charges that are being credited to the customer.",
              Outcome: "Credit memo is created and sent to the customer.",
              name: "Create credit memo",
              _id: 1368,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Non-physical goods receipt is required to record the change of ownership of goods from an external entity to the organization. Physically, the goods are still located at customer premises. Return delivery is required to record goods receipt into consignment stock.",
              _type: "Process",
              GUID: "1577b599-7e48-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the consignment return order has been created, the return delivery is created and non-physical goods receipt posted. This documents the fact that goods have been returned by the customer and are now owned by the organization. However, the goods are still at the customers location physically.",
              Outcome:
                "Non-physical goods receipt is recorded, goods become property of the organization and consignment stock has increased.",
              name: "Simulate return delivery and post goods receipt",
              _id: 191,
              Business_Rules:
                "Rules must be established regarding:   ***How to deal with consignment returns i.e. if they are added to regular customer consignment stock or tracked separately.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When the customer provides notification that goods sold through consignment issue are being returned to consignment stock, it is necessary to create a consignment return order to initiate the change of ownership of the goods.",
              _type: "Process",
              GUID: "aa8c61b1-7e48-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The return is usually posted with the same batch number the issue has been posted from except the company policies require issuing a new batch number in case of returns.  ",
              Type: "Business Process",
              Scope:
                "Once the customer provides notification to return consignment goods, a consignment return order is created. In this case the consignor must take back ownership of the goods.",
              Outcome:
                "The consignment return order is created, triggering the non-physical goods receipt for consignment returns process.",
              name: "Receive customer notification and create consignment return order",
              _id: 190,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A created credit memo can either be used to partly or fully clear an existing customer invoice or forms a base for making a payment to customer.    ",
              _type: "Process",
              GUID: "aa8c61b7-7e48-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once credit memo is created and approved, it must be checked if there are any open customer invoices, which can be cleared with it. If no open customer invoices exist, a direct payment to customer must be made to close the credit memo. Latter option is rarely used.",
              Outcome:
                "Credit memo is cleared and payment to customer made if required.",
              name: "Manage credit memo payment",
              _id: 1374,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of consignment return order is required to ensure that customer request to returned previously consumed goods/materials is in accordance with company rules.",
              _type: "Process",
              GUID: "aa8c61ab-7e48-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "There is no direct link between the different sales orders and stock movements throughout the consignment scenarios except for the fill-up and issue. Thus, it is possible to post a consignment return with higher quantities or for other batches than actually posted in the issue.",
              Type: "Business Process",
              Scope:
                "A consignment return allows customer to give company back goods/materials, which were previously reported as consumed and request refund of made payment (if applicable). Once such request is received and recorded in form of a consignment return order, its validity is checked and if request is considered justified and in accordance with company rules, the return is confirmed and can be processed. ",
              Outcome:
                "Consignment return order validity is checked and confirmed, order can be processed.",
              name: "Confirm consignment return order",
              _id: 189,
              Business_Rules:
                "Rules must be established for evaluating, when customer returns can be considered justified.",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Consignment returns",
          _id: 188,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "9dbaa0e1-7e52-11e5-0a66-001bc640cd9b",
          Description:
            "Sales for intercompany replenishment describes sales of products performed by a supplying entity in an intercompany relation in order to replenish stock of another legal entity from the same organization. Since the replenishment scenario is carried out between two entities from the same organization, it is characterized by pre-defined logistics routes (no GTS check required). Credit management also does not need to be performed. The special relationship between the two parties allows for a leaner process compared to other sales scenarios. However, it remains a business transaction between two legal entities.  Typically, the replenishment scenario is applied in complex organizations, where one entity internally supplies products to another entity, who sells to external customers or uses the supplied materials in its manufacturing process. In case both entities are supported by the same ERP system the scenario P2P Intercompany replenishment should be applied bypassing the actual sales process within the supplying entity.",
          _type: "Scenario",
          GUID: "7a693934-ef3c-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "After capturing and confirming a sales order, the order fulfillment needs to be monitored. Changes in availability, confirmation dates and priorities have to be considered and reflected in the sales order. The customer needs to be informed accordingly.",
              _type: "Process",
              GUID: "397b5453-d3a1-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "From a time perspective, this process spans from the saving of the sales order to the creation, release of the delivery and invoicing.",
              Outcome:
                "Any changes are reflected in the sales order, communication and excalation procedures are triggered if necessary.",
              name: "Monitor order fulfillment",
              _id: 158,
              Business_Rules:
                "Clear guidelines need to be defined how to handle shortages, deviations from already given commitments to the customer, priority conflicts as well as rules need to be agreed on how and when, and under which sircumstances the customer can request changes to the order. ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The process describes the creation of customer specific documentation that may be requested by our customers.",
              _type: "Process",
              GUID: "56165656-7169-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The documentation may be delivered together with the goods receipt or independently from it.    The documentation may be delivered as hard copy or as an electronic version.",
              Type: "Business Process",
              Scope:
                "After the request for creating customer specific documentation has been received, the documentation is created and prepared for a shipment to the customer.",
              Outcome:
                "The customer receives specific documentation as requested.",
              name: "Prepare customer specific documentation",
              _id: 160,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Receiving the customer order and capturing it in a format necessary for further processing are the key first steps to all sales processes. ",
              _type: "Process",
              GUID: "4cb51061-7e56-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the customer order is placed, the data must be amended, stored and forwarded for further processing. This might include transferring or copying data from other documents such as quotations or frame contracts.",
              Outcome:
                "All relevant information regarding the customers order is documented. The information captured provides the basis for determining whether the order can be fulfilled.",
              name: "Receive customer order and capture sales order data",
              _id: 175,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the confirmation is provided that the customer order can be fulfilled, the product price must be calculated (or extracted from the system) taking into account relevant conditions (e.g. rebates, shipping condition, customer price groups).",
              _type: "Process",
              GUID: "197ea3f9-eaa9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "In addition to the pricing itself, the workflows and required approvals have to be defined. Consider all types of sales (priced samples, free of charge samples etc.) and possible promotions and rebates.  In case a quotation has been placed, the conditions between both should be aligned or at least an interaction with the customer has to take place in case of any deviation.",
              Type: "Business Process",
              Scope:
                "Pricing takes into account all conditions related to the product and customer.",
              Outcome:
                "Pricing and conditions related to the order are generated, documented and agreed with customer.",
              name: "Determine product price and conditions",
              _id: 157,
              Business_Rules:
                "Pricing schemas are typically defined upfront.  It must be defined who (and with which limitations) has the rights to adjust prices and conditions within the sales process.   The price and trading conditions of the product must be based on a set of guidelines that take into account:   ***Cost of product   ***Market value of product   ***Customers perceived value of product    ***Relationship with customer (rebates etc.)   ***Defined profit margin expectations  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of the sales order is given through the confirmation and represents a commitment to fulfil the order.",
              _type: "Process",
              GUID: "a98a286c-7e52-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The effectiveness of the approval-workflows often is overestimated. Sales managers will receive many approval requests daily. The data to be checked should be limited to the essentials. Everything that can be checked automatically by rules should be implemented in the system. The result of the automatic checks should be obvious to the reviewer.",
              Type: "Business Process",
              Scope:
                "After all checks related to the order have been performed the final decision is made regarding execution of the order. A commitment to the customer is made. This triggers the outbound logistics, production process or service process. ",
              Outcome:
                "A decision is made to fulfil the customers order. This triggers the outbound logistics/production process. The customer is informed about the decision.",
              name: "Save and approve sales order",
              _id: 1332,
              Business_Rules:
                "Rules must be established for allocating authorization for sales order approval to users. The format of the confirmation (electronic, paper) and communication channel must be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Country specific regulations state that, above a certain quantity of chemicals and other hazardous substances, it is required to register with the authorities the maximum quantities of these substances that is planned to be purchased, imported, produced, sold, or exported within a certain period. By comparing the recorded quantities with the limit values, the system signals that a limit value is close to be exceeded if a limit value is exceeded, the system can also block the respective business process.  ",
              _type: "Process",
              GUID: "96e72960-eaa6-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Identify required Checks   ***Check if Registration Status is positive or negative   ***Check quantity limit to import / produce   ***Block order and report issue   ***Permit Order  ",
              Outcome:
                "The product complies with the chemical compliance related requirements and sales order processing is permitted.",
              name: "Perform chemical compliance check",
              _id: 159,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The Available-to-Promise (ATP) check against stock verifies whether the required quantity of finished goods can be sold to the customer at the requested date. The check is carried out against actual or projected finished goods inventory.       ",
              _type: "Process",
              GUID: "eabe97ec-e8c8-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "It is necessary to define what happens after the availability is confirmed. Typically the requested product quantity is reserved (excluded from available stock). It should be defined how undelivered sales orders are handled and when a reservation for a sales order will be canceled.  Business rules that need to be defined are:   ***What are the main and alternative supply points for regions/customers (ship-to)   ***Which future goods receipts should be considered   ***Which future goods issues should be considered   ***Are allocations required to reserve quantities for specific customers, customer groups, markets/sales channels, regions    ***If allocations are used are those valid for the whole sales period or will those be deactivated after a certain time (example: monthly allocations are only valid until mid of the month any remaining quantities will be made generally available afterwards).    Sometimes other constraints like transportation capacity or handling capacity need to be integrated into the ATP check.",
              Type: "Business Process",
              Scope:
                "After the customer order data is captured, it must be checked if the order can be fulfilled (the requested products are available in the requested quantity and on the desired date). It is also necessary to determine the storage location the goods will be delivered from.",
              Outcome: "ATP check is performed.",
              name: "Check availability to promise at sales order entry",
              _id: 163,
              Business_Rules:
                "For setting-up the check it must be defined which sources, i.e. inventory, are to be considered.  Typical business cases are:   ***Check against plan or inventory    ***Inventory in local warehouse    ***Inventory in global organisation     ***Inventory in local warehouse + placed purchase orders/released production orders    Allocations might be used in short markets to manage the distribution of stock to particular markets, customer segments, or individual customers.  The workflow in case of different partial availability situations should be defined:   ***Proposal of alternate dates   ***Proposal of substitute products   ***Proposal of partial shipments   ***Backorder processing     ",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Sales for intercompany replenishment",
          _id: 187,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "d24aa101-a6d2-11e9-0cfc-001bc641ce4f",
          Description:
            "This scenario represents the integration between a sales subsidiary and the headquarters. Latter taking over the fulfillment part of the sales order.  The document flow, representing the intercompany relationship, is a classical purchase order - sales order link between the two entities with the respective exchange of status documents such as order confirmations and ASNs.",
          _type: "Scenario",
          GUID: "1c4f0c1f-928c-11e9-0cfc-001bc641ce4f",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The IC supplier transfers an order confirmation, which is processed in the respective purchase order as well as the original sales order. Latter typically includes the creation of a respective order confirmation for the customer.",
              _type: "Process",
              GUID: "d39d38d2-a6d2-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Both documents, purchase order and sales order are updated accordingly based on the confirmation received by the IC supplier.",
              Outcome:
                "Order confirmation data from IC supplier reflected in purchase and sales order.",
              name: "Receive order confirmation IC",
              _id: 300,
              Business_Rules:
                "Rules need to be established how cases should be treated when confirmed dates and quantities to not match the original request.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The purpose of this process is to prevent shipping of dangerous goods which will harm dangerous goods regulation.",
              _type: "Process",
              GUID: "3124d4df-e98f-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The dangerous goods check verifies whether the shipment of dangerous goods contains transport regulatory data derived from UN-numbers, dangerous good classes, packaging codes etc. ",
              Outcome:
                "The product complies with the EH+S related requirements and the sales order is permitted by EH+S.",
              name: "Perform dangerous goods check",
              _id: 67,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of the sales order is given through the confirmation and represents a commitment to fulfil the order.",
              _type: "Process",
              GUID: "a98a286c-7e52-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The effectiveness of the approval-workflows often is overestimated. Sales managers will receive many approval requests daily. The data to be checked should be limited to the essentials. Everything that can be checked automatically by rules should be implemented in the system. The result of the automatic checks should be obvious to the reviewer.",
              Type: "Business Process",
              Scope:
                "After all checks related to the order have been performed the final decision is made regarding execution of the order. A commitment to the customer is made. This triggers the outbound logistics, production process or service process. ",
              Outcome:
                "A decision is made to fulfil the customers order. This triggers the outbound logistics/production process. The customer is informed about the decision.",
              name: "Save and approve sales order",
              _id: 1332,
              Business_Rules:
                "Rules must be established for allocating authorization for sales order approval to users. The format of the confirmation (electronic, paper) and communication channel must be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A dispatch advice is automatically transferred to the requesting IC entity. ",
              _type: "Process",
              GUID: "6f734268-9406-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "Dispatch advice created and transferred.",
              name: "Transfer dispatch advice",
              _id: 182,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After capturing and confirming a sales order, the order fulfillment needs to be monitored. Changes in availability, confirmation dates and priorities have to be considered and reflected in the sales order. The customer needs to be informed accordingly.",
              _type: "Process",
              GUID: "397b5453-d3a1-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "From a time perspective, this process spans from the saving of the sales order to the creation, release of the delivery and invoicing.",
              Outcome:
                "Any changes are reflected in the sales order, communication and excalation procedures are triggered if necessary.",
              name: "Monitor order fulfillment",
              _id: 158,
              Business_Rules:
                "Clear guidelines need to be defined how to handle shortages, deviations from already given commitments to the customer, priority conflicts as well as rules need to be agreed on how and when, and under which sircumstances the customer can request changes to the order. ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade compliance ensures due diligence with trade regulatory programs and cross-border customs requirements. Global trade checks are required for all business operations.",
              _type: "Process",
              GUID: "1b684ec4-44de-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The check itself is typically done automatically by the ERP system. The actual process discussion should focus on the maintenance of the relevant GTS data (including the integration of external data sources) and the handling of sales orders failing to pass the checks.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both involved business partners and products being sold or related services are subject to checks.",
              Outcome:
                "The sales order complies with the applicable trade regulations and the product can be shipped.",
              name: "Perform global trade check",
              _id: 57,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists, dual use products) used for screening is comprehensive and up to date.   Customer data must be up to date.   Rules and procedures how to handle sales orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In a third party sales scenario there is no physical inbound movement of goods or materials. Nevertheless it is necessary to acknowledge change of ownership of goods from supplier to selling entity to be able to further record the sale to the customer.      ",
              _type: "Process",
              GUID: "2bb46437-7f03-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once advanced shipping notification is received, a non-physical goods receipt is recorded, documenting assumption of the title of ownership for the goods or materials by the selling entity. The non-physical goods receipt does not initiate any changes in inventory levels.",
              Outcome: "Change of goods ownership is recorded.",
              name: "Perform non-physical goods receipt",
              _id: 1213,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A purchase requisition (PR)  is created after a sales order has been confirmed. Typically for an automated scenario, no specific interactions from the purchasing department are required. Therefore, the resulting purchase order can be generated automatically and is electronically submitted to the system of the supplying entity via interface.",
              _type: "Process",
              GUID: "d39d38c1-a6d2-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The scope of the process includes the generation of purchase requisition, the conversion of it to a purchase order, and the transfer of the automatically generated purchase order vie electronic interface.",
              Outcome:
                "The IC purchase order is created and transferred to the IC supplier.",
              name: "Generate purchase requisition and IC purchase order",
              _id: 297,
              Business_Rules:
                "Clear rules and procedures must ensure the proper set-up of master data to allow for an automated generation of all relevant purchasing documents (selling entity) and sales documents (supplying entity).",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of an intercompany invoice initiates the payment process for a transaction between two entities from the same corporate group.       ",
              _type: "Process",
              GUID: "53da3f54-e8c9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Typically there are special calculation rules to determine the profit margin in intercompany transactions.",
              Type: "Business Process",
              Scope:
                "The intercompany invoice, with which the supplier entity bills the selling or receiving entity, is created. In the case of a direct delivery to a customer, this happens automatically at the same time when the customer invoice is created. The required accounting entries are created using information from this invoice.",
              Outcome: "Intercompany invoice is created and issued. ",
              name: "Create intercompany invoice",
              _id: 1229,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "An order confirmation is created and submitted to the IC entity requesting the delivery automatically via interface.",
              _type: "Process",
              GUID: "d39d38d0-a6d2-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "All order items should be confirmed timely in terms of quantities and delivery dates.",
              Outcome: "Order confirmation transferred.",
              name: "Submit order confirmation IC",
              _id: 282,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "For intercompany transactions, this process ensures that billing information is received by the delivering entity and the financial obligation related to the transaction is settled.      ",
              _type: "Process",
              GUID: "6166270a-7e56-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the goods have been delivered and invoice received, payment is made to the delivering entity and recording in accounting.",
              Outcome:
                "Amount in the intercompany invoice is paid and documented accordingly.",
              name: "Receive intercompany invoice",
              _id: 1232,
              Business_Rules:
                "It is necessary to define: - General payment terms and condition for intercompany invoicing, - Relations between the selling and shipping operating units in view of intercompany transaction flows.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Based on the electronically transferred IC purchase order, a corresponding sales order is automatically generated.",
              _type: "Process",
              GUID: "d39d38c4-a6d2-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The sales order involves the requesting IC entity as sold-to and its customer as ship-to.",
              Outcome: "The sales order is created.",
              name: "Generate IC sales order",
              _id: 376,
              Business_Rules:
                "Clear rules and procedures must ensure the proper set-up of master data to allow for an automated generation of all relevant purchasing documents (selling entity) and sales documents (supplying entity).",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The dispatch advice from the IC supplier gets processed. This requires to update the purchase order with the ASN as well as to forward the dispatch advice to the customer respectively.",
              _type: "Process",
              GUID: "d39d38e1-a6d2-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "ASN processed.",
              name: "Receive advanced shipping notification IC",
              _id: 280,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Determine supply source and conditions aims at finding the external source from which a customer order will be fulfilled, as well as agreeing on the related conditions. The Determine supply source and conditions process is required for third party sales and sales via subcontracting, as well as in certain constellations of intercompany processes. In case of the latter, external source may also refer to other entities of the group.       ",
              _type: "Process",
              GUID: "5ac7e463-e8e2-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the customer order data is captured, the external source (external vendor) used to fulfil the order and related conditions must be determined. ",
              Outcome:
                "Source of supply and conditions related to the order are defined and documented.",
              name: "Determine supply source and conditions",
              _id: 180,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The Available-to-Promise (ATP) check against stock verifies whether the required quantity of finished goods can be sold to the customer at the requested date. The check is carried out against actual or projected finished goods inventory.       ",
              _type: "Process",
              GUID: "eabe97ec-e8c8-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "It is necessary to define what happens after the availability is confirmed. Typically the requested product quantity is reserved (excluded from available stock). It should be defined how undelivered sales orders are handled and when a reservation for a sales order will be canceled.  Business rules that need to be defined are:   ***What are the main and alternative supply points for regions/customers (ship-to)   ***Which future goods receipts should be considered   ***Which future goods issues should be considered   ***Are allocations required to reserve quantities for specific customers, customer groups, markets/sales channels, regions    ***If allocations are used are those valid for the whole sales period or will those be deactivated after a certain time (example: monthly allocations are only valid until mid of the month any remaining quantities will be made generally available afterwards).    Sometimes other constraints like transportation capacity or handling capacity need to be integrated into the ATP check.",
              Type: "Business Process",
              Scope:
                "After the customer order data is captured, it must be checked if the order can be fulfilled (the requested products are available in the requested quantity and on the desired date). It is also necessary to determine the storage location the goods will be delivered from.",
              Outcome: "ATP check is performed.",
              name: "Check availability to promise at sales order entry",
              _id: 163,
              Business_Rules:
                "For setting-up the check it must be defined which sources, i.e. inventory, are to be considered.  Typical business cases are:   ***Check against plan or inventory    ***Inventory in local warehouse    ***Inventory in global organisation     ***Inventory in local warehouse + placed purchase orders/released production orders    Allocations might be used in short markets to manage the distribution of stock to particular markets, customer segments, or individual customers.  The workflow in case of different partial availability situations should be defined:   ***Proposal of alternate dates   ***Proposal of substitute products   ***Proposal of partial shipments   ***Backorder processing     ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the confirmation is provided that the customer order can be fulfilled, the product price must be calculated (or extracted from the system) taking into account relevant conditions (e.g. rebates, shipping condition, customer price groups).",
              _type: "Process",
              GUID: "197ea3f9-eaa9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "In addition to the pricing itself, the workflows and required approvals have to be defined. Consider all types of sales (priced samples, free of charge samples etc.) and possible promotions and rebates.  In case a quotation has been placed, the conditions between both should be aligned or at least an interaction with the customer has to take place in case of any deviation.",
              Type: "Business Process",
              Scope:
                "Pricing takes into account all conditions related to the product and customer.",
              Outcome:
                "Pricing and conditions related to the order are generated, documented and agreed with customer.",
              name: "Determine product price and conditions",
              _id: 157,
              Business_Rules:
                "Pricing schemas are typically defined upfront.  It must be defined who (and with which limitations) has the rights to adjust prices and conditions within the sales process.   The price and trading conditions of the product must be based on a set of guidelines that take into account:   ***Cost of product   ***Market value of product   ***Customers perceived value of product    ***Relationship with customer (rebates etc.)   ***Defined profit margin expectations  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of a customer invoice provides documentation of the financial obligation related to a customer order. The customer invoice is created from a sales order.",
              _type: "Process",
              GUID: "75ff0dfc-e8bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Circumstances such as required documents for customs clearance or advance payments might have an impact on the timing when an invoice needs to be created during the sales process.",
              Type: "Business Process",
              Scope:
                "After the customer order has been fulfilled, the invoice is created. It provides the customer with information required to settle the payment related to their order.",
              Outcome: "Invoice is created and sent to the customer.",
              name: "Create customer invoice",
              _id: 1363,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Receiving the customer order and capturing it in a format necessary for further processing are the key first steps to all sales processes. ",
              _type: "Process",
              GUID: "4cb51061-7e56-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the customer order is placed, the data must be amended, stored and forwarded for further processing. This might include transferring or copying data from other documents such as quotations or frame contracts.",
              Outcome:
                "All relevant information regarding the customers order is documented. The information captured provides the basis for determining whether the order can be fulfilled.",
              name: "Receive customer order and capture sales order data",
              _id: 175,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In an intercompany situation, product price may vary from those offers to external customers. In such cases, it is necessary to determine the price offered to the IC buyer. Pricing will be performed, using SD-functionality.",
              _type: "Process",
              GUID: "80843c23-9567-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Transfer product price is determined based on corporate guidelines and corporate tax regulations.",
              Outcome: "Transfer product price is determined.",
              name: "Determine transfer product price for IC",
              _id: 178,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Credit management helps to control the companys exposure to credit risk. Credit management must be aligned taking into account the customers liquidity and payment history (credit limit/insurance) and outstanding receivables.",
              _type: "Process",
              GUID: "5aa42fcb-e8e2-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Many corporations start looking at credit management from a group perspective. This requires some collaboration across companies and business units, which might not be established. Hierarchical credit limits might help to hinder a single business unit from already consuming the entire credit limit of a customer.  Any kind of guarantees such as letter of credit or bank guarantees and advanced payments need to be considered in this process.  Credit management for consignment fill-ups - despite goods remaining in sellers property, it is common to perform credit check, since control over goods is lost and the goods issue is typically retrospective.",
              Type: "Business Process",
              Scope:
                "The customers ability to pay for the product or service is evaluated based on their liquidity and payment history and a decision is made on whether the sale is allowed or not.",
              Outcome:
                "The decision is made on whether to proceed with sale or not.",
              name: "Execute credit management",
              _id: 1334,
              Business_Rules:
                "It is necessary to define the information necessary to execute the credit management process.  A framework must be put in place for:   ***Calculating the rating value of customers    ***Determining Credit Limit   ***Setting rules for Credit Check    ",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "This scenario represents the plug and play design of an SAP S/4 HANA hybrid model with the sales entity on Cloud and the fulfilling entity on Premises. However, it might also applicable for non-SAP integration as alternative to the cross-company scenarios. It is only recommended in case there is a tight and fully automated integration between the two ERP systems used by the entities, though.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Plug and play solution",
          _id: 186,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "dddb8eb1-82c5-11e5-0a66-001bc640cd9b",
          Description:
            "The Sales of stock products scenario describes the sales process of products, which are held on stock. The products have been typically produced or purchased previously based on a supply plan (make-to-stock production model) or replenishment plan. This scenario usually applies to products, which can be sold to many different customers or a long term commitment from a single/small number of customers exists. Product availability check at sales order placement is performed either against goods physically on stock, against incoming transit or planned production / placed purchase orders, or defined replacement times.  In case of stock-outs, a backorder processing is applied to handle orders, which could not be confirmed.  Additional value-added-services such as labelling or packing (costly packaging materials), which are carried out in the warehouse might be part of the actual product sale and can be priced and included into SO as line items.",
          _type: "Scenario",
          GUID: "b6b20960-ef2f-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The Available-to-Promise (ATP) check against stock verifies whether the required quantity of finished goods can be sold to the customer at the requested date. The check is carried out against actual or projected finished goods inventory.       ",
              _type: "Process",
              GUID: "eabe97ec-e8c8-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "It is necessary to define what happens after the availability is confirmed. Typically the requested product quantity is reserved (excluded from available stock). It should be defined how undelivered sales orders are handled and when a reservation for a sales order will be canceled.  Business rules that need to be defined are:   ***What are the main and alternative supply points for regions/customers (ship-to)   ***Which future goods receipts should be considered   ***Which future goods issues should be considered   ***Are allocations required to reserve quantities for specific customers, customer groups, markets/sales channels, regions    ***If allocations are used are those valid for the whole sales period or will those be deactivated after a certain time (example: monthly allocations are only valid until mid of the month any remaining quantities will be made generally available afterwards).    Sometimes other constraints like transportation capacity or handling capacity need to be integrated into the ATP check.",
              Type: "Business Process",
              Scope:
                "After the customer order data is captured, it must be checked if the order can be fulfilled (the requested products are available in the requested quantity and on the desired date). It is also necessary to determine the storage location the goods will be delivered from.",
              Outcome: "ATP check is performed.",
              name: "Check availability to promise at sales order entry",
              _id: 163,
              Business_Rules:
                "For setting-up the check it must be defined which sources, i.e. inventory, are to be considered.  Typical business cases are:   ***Check against plan or inventory    ***Inventory in local warehouse    ***Inventory in global organisation     ***Inventory in local warehouse + placed purchase orders/released production orders    Allocations might be used in short markets to manage the distribution of stock to particular markets, customer segments, or individual customers.  The workflow in case of different partial availability situations should be defined:   ***Proposal of alternate dates   ***Proposal of substitute products   ***Proposal of partial shipments   ***Backorder processing     ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Country specific regulations state that, above a certain quantity of chemicals and other hazardous substances, it is required to register with the authorities the maximum quantities of these substances that is planned to be purchased, imported, produced, sold, or exported within a certain period. By comparing the recorded quantities with the limit values, the system signals that a limit value is close to be exceeded if a limit value is exceeded, the system can also block the respective business process.  ",
              _type: "Process",
              GUID: "96e72960-eaa6-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Identify required Checks   ***Check if Registration Status is positive or negative   ***Check quantity limit to import / produce   ***Block order and report issue   ***Permit Order  ",
              Outcome:
                "The product complies with the chemical compliance related requirements and sales order processing is permitted.",
              name: "Perform chemical compliance check",
              _id: 159,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The purpose of this process is to prevent shipping of dangerous goods which will harm dangerous goods regulation.",
              _type: "Process",
              GUID: "3124d4df-e98f-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The dangerous goods check verifies whether the shipment of dangerous goods contains transport regulatory data derived from UN-numbers, dangerous good classes, packaging codes etc. ",
              Outcome:
                "The product complies with the EH+S related requirements and the sales order is permitted by EH+S.",
              name: "Perform dangerous goods check",
              _id: 67,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Back order processing must be performed in case the ATP check did not provide a satisfying result, or an unplanned change to the supply situation requires a reconsideration/ recalculation of already confirmed quantities and dates. The process might affect other sales orders, stock transfer orders, and confirmed documents such as material reservations, production or repair orders, which compete with the respective sales documents for the available quantity of the requested material. The resolution of a shortage situation includes the alignment (and consequent adjustment) of the supply situation as well as a reallocation of already confirmed and allocated ATP quantities. All affected parties must be involved or informed accordingly.",
              _type: "Process",
              GUID: "3e124dd1-602a-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the ATP situation has been analysed, a solution is elaborated by e.g. rescheduling the order confirmation or evaluating other supplier options. Finally the solution is communicated with all relevant parties.",
              Outcome:
                "Aligned supply situation and communicated with all affected parties ",
              name: "Perform back order processing",
              _id: 177,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of the sales order is given through the confirmation and represents a commitment to fulfil the order.",
              _type: "Process",
              GUID: "a98a286c-7e52-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The effectiveness of the approval-workflows often is overestimated. Sales managers will receive many approval requests daily. The data to be checked should be limited to the essentials. Everything that can be checked automatically by rules should be implemented in the system. The result of the automatic checks should be obvious to the reviewer.",
              Type: "Business Process",
              Scope:
                "After all checks related to the order have been performed the final decision is made regarding execution of the order. A commitment to the customer is made. This triggers the outbound logistics, production process or service process. ",
              Outcome:
                "A decision is made to fulfil the customers order. This triggers the outbound logistics/production process. The customer is informed about the decision.",
              name: "Save and approve sales order",
              _id: 1332,
              Business_Rules:
                "Rules must be established for allocating authorization for sales order approval to users. The format of the confirmation (electronic, paper) and communication channel must be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Receiving the customer order and capturing it in a format necessary for further processing are the key first steps to all sales processes. ",
              _type: "Process",
              GUID: "4cb51061-7e56-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the customer order is placed, the data must be amended, stored and forwarded for further processing. This might include transferring or copying data from other documents such as quotations or frame contracts.",
              Outcome:
                "All relevant information regarding the customers order is documented. The information captured provides the basis for determining whether the order can be fulfilled.",
              name: "Receive customer order and capture sales order data",
              _id: 175,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Credit management helps to control the companys exposure to credit risk. Credit management must be aligned taking into account the customers liquidity and payment history (credit limit/insurance) and outstanding receivables.",
              _type: "Process",
              GUID: "5aa42fcb-e8e2-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Many corporations start looking at credit management from a group perspective. This requires some collaboration across companies and business units, which might not be established. Hierarchical credit limits might help to hinder a single business unit from already consuming the entire credit limit of a customer.  Any kind of guarantees such as letter of credit or bank guarantees and advanced payments need to be considered in this process.  Credit management for consignment fill-ups - despite goods remaining in sellers property, it is common to perform credit check, since control over goods is lost and the goods issue is typically retrospective.",
              Type: "Business Process",
              Scope:
                "The customers ability to pay for the product or service is evaluated based on their liquidity and payment history and a decision is made on whether the sale is allowed or not.",
              Outcome:
                "The decision is made on whether to proceed with sale or not.",
              name: "Execute credit management",
              _id: 1334,
              Business_Rules:
                "It is necessary to define the information necessary to execute the credit management process.  A framework must be put in place for:   ***Calculating the rating value of customers    ***Determining Credit Limit   ***Setting rules for Credit Check    ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the confirmation is provided that the customer order can be fulfilled, the product price must be calculated (or extracted from the system) taking into account relevant conditions (e.g. rebates, shipping condition, customer price groups).",
              _type: "Process",
              GUID: "197ea3f9-eaa9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "In addition to the pricing itself, the workflows and required approvals have to be defined. Consider all types of sales (priced samples, free of charge samples etc.) and possible promotions and rebates.  In case a quotation has been placed, the conditions between both should be aligned or at least an interaction with the customer has to take place in case of any deviation.",
              Type: "Business Process",
              Scope:
                "Pricing takes into account all conditions related to the product and customer.",
              Outcome:
                "Pricing and conditions related to the order are generated, documented and agreed with customer.",
              name: "Determine product price and conditions",
              _id: 157,
              Business_Rules:
                "Pricing schemas are typically defined upfront.  It must be defined who (and with which limitations) has the rights to adjust prices and conditions within the sales process.   The price and trading conditions of the product must be based on a set of guidelines that take into account:   ***Cost of product   ***Market value of product   ***Customers perceived value of product    ***Relationship with customer (rebates etc.)   ***Defined profit margin expectations  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After capturing and confirming a sales order, the order fulfillment needs to be monitored. Changes in availability, confirmation dates and priorities have to be considered and reflected in the sales order. The customer needs to be informed accordingly.",
              _type: "Process",
              GUID: "397b5453-d3a1-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "From a time perspective, this process spans from the saving of the sales order to the creation, release of the delivery and invoicing.",
              Outcome:
                "Any changes are reflected in the sales order, communication and excalation procedures are triggered if necessary.",
              name: "Monitor order fulfillment",
              _id: 158,
              Business_Rules:
                "Clear guidelines need to be defined how to handle shortages, deviations from already given commitments to the customer, priority conflicts as well as rules need to be agreed on how and when, and under which sircumstances the customer can request changes to the order. ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The results of the final ATP check need to be reviewed and the order confirmation to the customer is sent out. If the ATP check has not already been (re-)performed, this needs to be done now out of the individual sales document to consider the newly available ATP quantities and to adjust confirmation dates.",
              _type: "Process",
              GUID: "3e124dd3-602a-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After reviewing the results of the ATP, the customer needs to be informed via order confirmation or the supply situation must be clarified with the MRP planner.",
              Outcome: "Reviewed ATP and communicated order confirmation",
              name: "Review ATP and reconfirm order",
              _id: 176,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of a customer invoice provides documentation of the financial obligation related to a customer order. The customer invoice is created from a sales order.",
              _type: "Process",
              GUID: "75ff0dfc-e8bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Circumstances such as required documents for customs clearance or advance payments might have an impact on the timing when an invoice needs to be created during the sales process.",
              Type: "Business Process",
              Scope:
                "After the customer order has been fulfilled, the invoice is created. It provides the customer with information required to settle the payment related to their order.",
              Outcome: "Invoice is created and sent to the customer.",
              name: "Create customer invoice",
              _id: 1363,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade compliance ensures due diligence with trade regulatory programs and cross-border customs requirements. Global trade checks are required for all business operations.",
              _type: "Process",
              GUID: "1b684ec4-44de-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The check itself is typically done automatically by the ERP system. The actual process discussion should focus on the maintenance of the relevant GTS data (including the integration of external data sources) and the handling of sales orders failing to pass the checks.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both involved business partners and products being sold or related services are subject to checks.",
              Outcome:
                "The sales order complies with the applicable trade regulations and the product can be shipped.",
              name: "Perform global trade check",
              _id: 57,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists, dual use products) used for screening is comprehensive and up to date.   Customer data must be up to date.   Rules and procedures how to handle sales orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The process describes the creation of customer specific documentation that may be requested by our customers.",
              _type: "Process",
              GUID: "56165656-7169-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The documentation may be delivered together with the goods receipt or independently from it.    The documentation may be delivered as hard copy or as an electronic version.",
              Type: "Business Process",
              Scope:
                "After the request for creating customer specific documentation has been received, the documentation is created and prepared for a shipment to the customer.",
              Outcome:
                "The customer receives specific documentation as requested.",
              name: "Prepare customer specific documentation",
              _id: 160,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "The timing and especially the duration of the sales process can differ extremely depending on the industry and the operational models. Even with standard products, commercial aspects (letter of credit, bank guarantees) or necessary complex logistics arrangements can cause long lead times between order placement and actual order fulfillment. Often sales orders are entered in the system after the whole process is performed. This reduces transparency, leads to unnecessary additional efforts to keep track, and limits the possibilities to deploy proper planning processes.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Sales of stock products (Make to stock)",
          _id: 185,
          Business_Rules:
            "Depending on your supply chain set-up, logistics capabilities, and market strategies, the rules for ATP and backorder processing must be defined. Beside availability, allocation can be used to limit access to available goods and keep servcie levels for important customers or markets up.",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "1beda951-7eec-11e5-0a66-001bc640cd9b",
          Description:
            "Third-party sales scenario covers sales collaboration with an external vendor, whereby the goods are not kept in stock. Instead, after the customer order is placed, the order details are transferred to the vendor, who takes over the order fulfillment. Usually the vendor also ships goods directly to the customer and invoices the seller. However shipment of goods can also be coordinated by the organizations transportation department.  Typically the scenario is used for supplementary products, which are not the core business of the organization, or by distributors. Latter prefer to organize transportation and might require their own packaging/labeling to protect their role as intermediary. Advantages of direct shipment from vendor to the customer are shorter lead times and reduction of transport and handling costs.  The scenario can be combined with any of the product sales scenarios and any production model.",
          _type: "Scenario",
          GUID: "8c942b22-ef45-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Credit management helps to control the companys exposure to credit risk. Credit management must be aligned taking into account the customers liquidity and payment history (credit limit/insurance) and outstanding receivables.",
              _type: "Process",
              GUID: "5aa42fcb-e8e2-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Many corporations start looking at credit management from a group perspective. This requires some collaboration across companies and business units, which might not be established. Hierarchical credit limits might help to hinder a single business unit from already consuming the entire credit limit of a customer.  Any kind of guarantees such as letter of credit or bank guarantees and advanced payments need to be considered in this process.  Credit management for consignment fill-ups - despite goods remaining in sellers property, it is common to perform credit check, since control over goods is lost and the goods issue is typically retrospective.",
              Type: "Business Process",
              Scope:
                "The customers ability to pay for the product or service is evaluated based on their liquidity and payment history and a decision is made on whether the sale is allowed or not.",
              Outcome:
                "The decision is made on whether to proceed with sale or not.",
              name: "Execute credit management",
              _id: 1334,
              Business_Rules:
                "It is necessary to define the information necessary to execute the credit management process.  A framework must be put in place for:   ***Calculating the rating value of customers    ***Determining Credit Limit   ***Setting rules for Credit Check    ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of the sales order is given through the confirmation and represents a commitment to fulfil the order.",
              _type: "Process",
              GUID: "a98a286c-7e52-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The effectiveness of the approval-workflows often is overestimated. Sales managers will receive many approval requests daily. The data to be checked should be limited to the essentials. Everything that can be checked automatically by rules should be implemented in the system. The result of the automatic checks should be obvious to the reviewer.",
              Type: "Business Process",
              Scope:
                "After all checks related to the order have been performed the final decision is made regarding execution of the order. A commitment to the customer is made. This triggers the outbound logistics, production process or service process. ",
              Outcome:
                "A decision is made to fulfil the customers order. This triggers the outbound logistics/production process. The customer is informed about the decision.",
              name: "Save and approve sales order",
              _id: 1332,
              Business_Rules:
                "Rules must be established for allocating authorization for sales order approval to users. The format of the confirmation (electronic, paper) and communication channel must be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the confirmation is provided that the customer order can be fulfilled, the product price must be calculated (or extracted from the system) taking into account relevant conditions (e.g. rebates, shipping condition, customer price groups).",
              _type: "Process",
              GUID: "197ea3f9-eaa9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "In addition to the pricing itself, the workflows and required approvals have to be defined. Consider all types of sales (priced samples, free of charge samples etc.) and possible promotions and rebates.  In case a quotation has been placed, the conditions between both should be aligned or at least an interaction with the customer has to take place in case of any deviation.",
              Type: "Business Process",
              Scope:
                "Pricing takes into account all conditions related to the product and customer.",
              Outcome:
                "Pricing and conditions related to the order are generated, documented and agreed with customer.",
              name: "Determine product price and conditions",
              _id: 157,
              Business_Rules:
                "Pricing schemas are typically defined upfront.  It must be defined who (and with which limitations) has the rights to adjust prices and conditions within the sales process.   The price and trading conditions of the product must be based on a set of guidelines that take into account:   ***Cost of product   ***Market value of product   ***Customers perceived value of product    ***Relationship with customer (rebates etc.)   ***Defined profit margin expectations  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Determine supply source and conditions aims at finding the external source from which a customer order will be fulfilled, as well as agreeing on the related conditions. The Determine supply source and conditions process is required for third party sales and sales via subcontracting, as well as in certain constellations of intercompany processes. In case of the latter, external source may also refer to other entities of the group.       ",
              _type: "Process",
              GUID: "5ac7e463-e8e2-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the customer order data is captured, the external source (external vendor) used to fulfil the order and related conditions must be determined. ",
              Outcome:
                "Source of supply and conditions related to the order are defined and documented.",
              name: "Determine supply source and conditions",
              _id: 180,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Country specific regulations state that, above a certain quantity of chemicals and other hazardous substances, it is required to register with the authorities the maximum quantities of these substances that is planned to be purchased, imported, produced, sold, or exported within a certain period. By comparing the recorded quantities with the limit values, the system signals that a limit value is close to be exceeded if a limit value is exceeded, the system can also block the respective business process.  ",
              _type: "Process",
              GUID: "96e72960-eaa6-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Identify required Checks   ***Check if Registration Status is positive or negative   ***Check quantity limit to import / produce   ***Block order and report issue   ***Permit Order  ",
              Outcome:
                "The product complies with the chemical compliance related requirements and sales order processing is permitted.",
              name: "Perform chemical compliance check",
              _id: 159,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After capturing and confirming a sales order, the order fulfillment needs to be monitored. Changes in availability, confirmation dates and priorities have to be considered and reflected in the sales order. The customer needs to be informed accordingly.",
              _type: "Process",
              GUID: "397b5453-d3a1-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "From a time perspective, this process spans from the saving of the sales order to the creation, release of the delivery and invoicing.",
              Outcome:
                "Any changes are reflected in the sales order, communication and excalation procedures are triggered if necessary.",
              name: "Monitor order fulfillment",
              _id: 158,
              Business_Rules:
                "Clear guidelines need to be defined how to handle shortages, deviations from already given commitments to the customer, priority conflicts as well as rules need to be agreed on how and when, and under which sircumstances the customer can request changes to the order. ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The process describes the creation of customer specific documentation that may be requested by our customers.",
              _type: "Process",
              GUID: "56165656-7169-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The documentation may be delivered together with the goods receipt or independently from it.    The documentation may be delivered as hard copy or as an electronic version.",
              Type: "Business Process",
              Scope:
                "After the request for creating customer specific documentation has been received, the documentation is created and prepared for a shipment to the customer.",
              Outcome:
                "The customer receives specific documentation as requested.",
              name: "Prepare customer specific documentation",
              _id: 160,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Receiving the customer order and capturing it in a format necessary for further processing are the key first steps to all sales processes.        ",
              _type: "Process",
              GUID: "2a215fa6-7eec-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The design and the quality of this process is essential to avoid any changes to the sales order later in the sales and delivery process. All relevant and necessary data should be captured in order to allow an uninterrupted order processing.",
              Type: "Business Process",
              Scope:
                "Once the customer order is placed, the data must be amended, stored and forwarded for further processing. This might include transferring or copying data from other documents such as quotations or frame contracts.",
              Outcome:
                "All relevant information regarding the customers order is documented. The information captured provides the basis for determining whether the order can be fulfilled.",
              name: "Receive customer order and capture 3rd party sales order data",
              _id: 373,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade compliance ensures due diligence with trade regulatory programs and cross-border customs requirements. Global trade checks are required for all business operations.",
              _type: "Process",
              GUID: "1b684ec4-44de-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The check itself is typically done automatically by the ERP system. The actual process discussion should focus on the maintenance of the relevant GTS data (including the integration of external data sources) and the handling of sales orders failing to pass the checks.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both involved business partners and products being sold or related services are subject to checks.",
              Outcome:
                "The sales order complies with the applicable trade regulations and the product can be shipped.",
              name: "Perform global trade check",
              _id: 57,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists, dual use products) used for screening is comprehensive and up to date.   Customer data must be up to date.   Rules and procedures how to handle sales orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of a customer invoice provides documentation of the financial obligation related to a customer order. The customer invoice is created from a sales order.",
              _type: "Process",
              GUID: "75ff0dfc-e8bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Circumstances such as required documents for customs clearance or advance payments might have an impact on the timing when an invoice needs to be created during the sales process.",
              Type: "Business Process",
              Scope:
                "After the customer order has been fulfilled, the invoice is created. It provides the customer with information required to settle the payment related to their order.",
              Outcome: "Invoice is created and sent to the customer.",
              name: "Create customer invoice",
              _id: 1363,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The purpose of this process is to prevent shipping of dangerous goods which will harm dangerous goods regulation.",
              _type: "Process",
              GUID: "3124d4df-e98f-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The dangerous goods check verifies whether the shipment of dangerous goods contains transport regulatory data derived from UN-numbers, dangerous good classes, packaging codes etc. ",
              Outcome:
                "The product complies with the EH+S related requirements and the sales order is permitted by EH+S.",
              name: "Perform dangerous goods check",
              _id: 67,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Third party sales",
          _id: 184,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "39e152e1-7e5b-11e5-0a66-001bc640cd9b",
          Description:
            "In a scheduling agreement scenario an outline agreement with the customer containing delivery quantities and dates is negotiated. These are then entered as schedule lines in a delivery schedule either at creation of scheduling agreement or later.  Individual deliveries are triggered by the schedule lines of the agreement and do not require any additional request by the customer.",
          _type: "Scenario",
          GUID: "8c942b38-ef45-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "After an outline agreement with the customer regarding items, prices, delivery quantities and dates is negotiated, a scheduling agreement is created in the system containing the agreement details (individual deliveries form schedule lines) and serve as base for further performing of actual deliveries.",
              _type: "Process",
              GUID: "4021aa79-7e5b-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "A scheduling agreement is created in the system. Schedule lines for individual deliveries can be entered either at creation of the scheduling agreement or later. Similar to a standard sales order, dangerous goods, global trade, availability and credit management checks are performed, when the scheduling agreement is created. Because of the nature and often long lead times of such agreements, the result of an ATP check and credit check might only be for information purposes.",
              Outcome:
                "Scheduling agreement is created and individual deliveries can be carried out.",
              name: "Capture scheduling agreement",
              _id: 370,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of a customer invoice provides documentation of the financial obligation related to a customer order. The customer invoice is created from a sales order.",
              _type: "Process",
              GUID: "75ff0dfc-e8bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Circumstances such as required documents for customs clearance or advance payments might have an impact on the timing when an invoice needs to be created during the sales process.",
              Type: "Business Process",
              Scope:
                "After the customer order has been fulfilled, the invoice is created. It provides the customer with information required to settle the payment related to their order.",
              Outcome: "Invoice is created and sent to the customer.",
              name: "Create customer invoice",
              _id: 1363,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After capturing and confirming a sales order, the order fulfillment needs to be monitored. Changes in availability, confirmation dates and priorities have to be considered and reflected in the sales order. The customer needs to be informed accordingly.",
              _type: "Process",
              GUID: "397b5453-d3a1-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "From a time perspective, this process spans from the saving of the sales order to the creation, release of the delivery and invoicing.",
              Outcome:
                "Any changes are reflected in the sales order, communication and excalation procedures are triggered if necessary.",
              name: "Monitor order fulfillment",
              _id: 158,
              Business_Rules:
                "Clear guidelines need to be defined how to handle shortages, deviations from already given commitments to the customer, priority conflicts as well as rules need to be agreed on how and when, and under which sircumstances the customer can request changes to the order. ",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Scheduling agreement",
          _id: 183,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "65fd90c1-9403-11e9-0cfc-001bc641ce4f",
          Description:
            "A sales order is created at the selling entity. This order triggers a purchase order from the selling entity to the producing entity. This purchase order is transferred via EDI to the producing entity and creates a sales order with a drop shipment to the customer at the producing entity. The daily MRP run creates a planned order which is scheduled and converted to a production order. Based on availability on remaining quantity of components of an older version, an order split should be executed automatically. The table for order confirmation is maintained and sales order, purchase order, order split is reflected, and respective sales orders are confirmed and an order response to the customer is triggered. Production staging is triggered. Production is executed and a goods receipt from production is performed. Outbound delivery picking and goods issue is performed which automatically triggers the statistical goods receipt for the selling entitys purchase order and the connected sales order is triggering the creation of dispatch advice sent to the customer via EDI. The intercompany invoice is generated and processed. The selling entitys invoice is generated and submitted to the customer.",
          _type: "Scenario",
          GUID: "1c4f0c1d-928c-11e9-0cfc-001bc641ce4f",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "A purchase requisition (PR)  is created after a sales order has been confirmed. The purchasing department must check which vendor can supply the goods. The goods are delivered directly to the customer, therefore it is necessary to clarify the terms of delivery with the vendor.        ",
              _type: "Process",
              GUID: "78ced096-7f02-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Purchasing products directly for a sales order is used in a variety of business models. It can be a one time opportunity, a frequently applied model, or even a type of outsourced inventory in a JIT-like set-up. Therefore, the interaction between the sales department, the purchasing department, and the vendor in order to clarify availability and delivery dates might differ. In a opportunity sale, it might even be required to identify a source of supply before any commitment to the customer is given.",
              Type: "Business Process",
              Scope:
                "If not already specified by master data, the purchasing department checks vendors to determine which one can supply the products required to fulfil the order.",
              Outcome: "The PR is created.",
              name: "Process purchase requisition for sales orders",
              _id: 1188,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Credit management helps to control the companys exposure to credit risk. Credit management must be aligned taking into account the customers liquidity and payment history (credit limit/insurance) and outstanding receivables.",
              _type: "Process",
              GUID: "5aa42fcb-e8e2-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Many corporations start looking at credit management from a group perspective. This requires some collaboration across companies and business units, which might not be established. Hierarchical credit limits might help to hinder a single business unit from already consuming the entire credit limit of a customer.  Any kind of guarantees such as letter of credit or bank guarantees and advanced payments need to be considered in this process.  Credit management for consignment fill-ups - despite goods remaining in sellers property, it is common to perform credit check, since control over goods is lost and the goods issue is typically retrospective.",
              Type: "Business Process",
              Scope:
                "The customers ability to pay for the product or service is evaluated based on their liquidity and payment history and a decision is made on whether the sale is allowed or not.",
              Outcome:
                "The decision is made on whether to proceed with sale or not.",
              name: "Execute credit management",
              _id: 1334,
              Business_Rules:
                "It is necessary to define the information necessary to execute the credit management process.  A framework must be put in place for:   ***Calculating the rating value of customers    ***Determining Credit Limit   ***Setting rules for Credit Check    ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After capturing and confirming a sales order, the order fulfillment needs to be monitored. Changes in availability, confirmation dates and priorities have to be considered and reflected in the sales order. The customer needs to be informed accordingly.",
              _type: "Process",
              GUID: "397b5453-d3a1-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "From a time perspective, this process spans from the saving of the sales order to the creation, release of the delivery and invoicing.",
              Outcome:
                "Any changes are reflected in the sales order, communication and excalation procedures are triggered if necessary.",
              name: "Monitor order fulfillment",
              _id: 158,
              Business_Rules:
                "Clear guidelines need to be defined how to handle shortages, deviations from already given commitments to the customer, priority conflicts as well as rules need to be agreed on how and when, and under which sircumstances the customer can request changes to the order. ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of a customer invoice provides documentation of the financial obligation related to a customer order. The customer invoice is created from a sales order.",
              _type: "Process",
              GUID: "75ff0dfc-e8bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Circumstances such as required documents for customs clearance or advance payments might have an impact on the timing when an invoice needs to be created during the sales process.",
              Type: "Business Process",
              Scope:
                "After the customer order has been fulfilled, the invoice is created. It provides the customer with information required to settle the payment related to their order.",
              Outcome: "Invoice is created and sent to the customer.",
              name: "Create customer invoice",
              _id: 1363,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A dispatch advice is automatically transferred to the requesting IC entity. ",
              _type: "Process",
              GUID: "6f734268-9406-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "Dispatch advice created and transferred.",
              name: "Transfer dispatch advice",
              _id: 182,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Receiving the customer order and capturing it in a format necessary for further processing are the key first steps to all sales processes. ",
              _type: "Process",
              GUID: "4cb51061-7e56-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the customer order is placed, the data must be amended, stored and forwarded for further processing. This might include transferring or copying data from other documents such as quotations or frame contracts.",
              Outcome:
                "All relevant information regarding the customers order is documented. The information captured provides the basis for determining whether the order can be fulfilled.",
              name: "Receive customer order and capture sales order data",
              _id: 175,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the confirmation is provided that the customer order can be fulfilled, the product price must be calculated (or extracted from the system) taking into account relevant conditions (e.g. rebates, shipping condition, customer price groups).",
              _type: "Process",
              GUID: "197ea3f9-eaa9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "In addition to the pricing itself, the workflows and required approvals have to be defined. Consider all types of sales (priced samples, free of charge samples etc.) and possible promotions and rebates.  In case a quotation has been placed, the conditions between both should be aligned or at least an interaction with the customer has to take place in case of any deviation.",
              Type: "Business Process",
              Scope:
                "Pricing takes into account all conditions related to the product and customer.",
              Outcome:
                "Pricing and conditions related to the order are generated, documented and agreed with customer.",
              name: "Determine product price and conditions",
              _id: 157,
              Business_Rules:
                "Pricing schemas are typically defined upfront.  It must be defined who (and with which limitations) has the rights to adjust prices and conditions within the sales process.   The price and trading conditions of the product must be based on a set of guidelines that take into account:   ***Cost of product   ***Market value of product   ***Customers perceived value of product    ***Relationship with customer (rebates etc.)   ***Defined profit margin expectations  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "For intercompany transactions, this process ensures that billing information is received by the delivering entity and the financial obligation related to the transaction is settled.      ",
              _type: "Process",
              GUID: "6166270a-7e56-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the goods have been delivered and invoice received, payment is made to the delivering entity and recording in accounting.",
              Outcome:
                "Amount in the intercompany invoice is paid and documented accordingly.",
              name: "Receive intercompany invoice",
              _id: 1232,
              Business_Rules:
                "It is necessary to define: - General payment terms and condition for intercompany invoicing, - Relations between the selling and shipping operating units in view of intercompany transaction flows.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "05042ad3-9404-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Create sales order for IC purchase order",
              _id: 181,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In a third party sales scenario there is no physical inbound movement of goods or materials. Nevertheless it is necessary to acknowledge change of ownership of goods from supplier to selling entity to be able to further record the sale to the customer.      ",
              _type: "Process",
              GUID: "2bb46437-7f03-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once advanced shipping notification is received, a non-physical goods receipt is recorded, documenting assumption of the title of ownership for the goods or materials by the selling entity. The non-physical goods receipt does not initiate any changes in inventory levels.",
              Outcome: "Change of goods ownership is recorded.",
              name: "Perform non-physical goods receipt",
              _id: 1213,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Determine supply source and conditions aims at finding the external source from which a customer order will be fulfilled, as well as agreeing on the related conditions. The Determine supply source and conditions process is required for third party sales and sales via subcontracting, as well as in certain constellations of intercompany processes. In case of the latter, external source may also refer to other entities of the group.       ",
              _type: "Process",
              GUID: "5ac7e463-e8e2-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the customer order data is captured, the external source (external vendor) used to fulfil the order and related conditions must be determined. ",
              Outcome:
                "Source of supply and conditions related to the order are defined and documented.",
              name: "Determine supply source and conditions",
              _id: 180,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In an intercompany situation, product price may vary from those offers to external customers. In such cases, it is necessary to determine the price offered to the IC buyer. Pricing will be performed, using SD-functionality.",
              _type: "Process",
              GUID: "80843c23-9567-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Transfer product price is determined based on corporate guidelines and corporate tax regulations.",
              Outcome: "Transfer product price is determined.",
              name: "Determine transfer product price for IC",
              _id: 178,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once issued to vendor the purchase order represents a firm commitment. Therefore, it must be approved before the issue and then transferred to vendor.       ",
              _type: "Process",
              GUID: "de59c972-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Before committing to the actual purchase of materials or services, an authorised person does a final check if the purchase order is correct and approves it. The PO will then be sent to the vendor.",
              Outcome: "The purchase order is issued.",
              name: "Approve and issue purchase order",
              _id: 1189,
              Business_Rules: "Approval rules and limits have to be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of the sales order is given through the confirmation and represents a commitment to fulfil the order.",
              _type: "Process",
              GUID: "a98a286c-7e52-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The effectiveness of the approval-workflows often is overestimated. Sales managers will receive many approval requests daily. The data to be checked should be limited to the essentials. Everything that can be checked automatically by rules should be implemented in the system. The result of the automatic checks should be obvious to the reviewer.",
              Type: "Business Process",
              Scope:
                "After all checks related to the order have been performed the final decision is made regarding execution of the order. A commitment to the customer is made. This triggers the outbound logistics, production process or service process. ",
              Outcome:
                "A decision is made to fulfil the customers order. This triggers the outbound logistics/production process. The customer is informed about the decision.",
              name: "Save and approve sales order",
              _id: 1332,
              Business_Rules:
                "Rules must be established for allocating authorization for sales order approval to users. The format of the confirmation (electronic, paper) and communication channel must be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of an intercompany invoice initiates the payment process for a transaction between two entities from the same corporate group.       ",
              _type: "Process",
              GUID: "53da3f54-e8c9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Typically there are special calculation rules to determine the profit margin in intercompany transactions.",
              Type: "Business Process",
              Scope:
                "The intercompany invoice, with which the supplier entity bills the selling or receiving entity, is created. In the case of a direct delivery to a customer, this happens automatically at the same time when the customer invoice is created. The required accounting entries are created using information from this invoice.",
              Outcome: "Intercompany invoice is created and issued. ",
              name: "Create intercompany invoice",
              _id: 1229,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "An official purchase order (PO) has to be created from a purchase requisition (PR) to be able to order materials and services.       ",
              _type: "Process",
              GUID: "de59c987-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                " ***set-up of possible conversions must be defined. Conversion options are single, multiple or partial ***purchasing strategies for vendors need to be considered (e.g. fair share, contingents)  ***special agreements with vendors need to be considered (e.g. FTL/FCL only, min/max quantities, multiple products to be bundled) ",
              Type: "Business Process",
              Scope:
                "The PO is created with reference to a specific PR. Additional data not provided within the PR has to be maintained.",
              Outcome: "A PO is generated.",
              name: "Convert purchase requisition to purchase order",
              _id: 1193,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade compliance ensures due diligence with trade regulatory programs and cross-border customs requirements. Global trade checks are required for all business operations.",
              _type: "Process",
              GUID: "1b684ec4-44de-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The check itself is typically done automatically by the ERP system. The actual process discussion should focus on the maintenance of the relevant GTS data (including the integration of external data sources) and the handling of sales orders failing to pass the checks.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both involved business partners and products being sold or related services are subject to checks.",
              Outcome:
                "The sales order complies with the applicable trade regulations and the product can be shipped.",
              name: "Perform global trade check",
              _id: 57,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists, dual use products) used for screening is comprehensive and up to date.   Customer data must be up to date.   Rules and procedures how to handle sales orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The purpose of this process is to prevent shipping of dangerous goods which will harm dangerous goods regulation.",
              _type: "Process",
              GUID: "3124d4df-e98f-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The dangerous goods check verifies whether the shipment of dangerous goods contains transport regulatory data derived from UN-numbers, dangerous good classes, packaging codes etc. ",
              Outcome:
                "The product complies with the EH+S related requirements and the sales order is permitted by EH+S.",
              name: "Perform dangerous goods check",
              _id: 67,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Intercompany sales",
          _id: 179,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "b4c43c91-93f9-11e9-0cfc-001bc641ce4f",
          Description:
            "The sales via intercompany is a collaborative scenario, whereby the goods are not kept in stock at the selling entity, but after customer order is placed, the order details are transferred to a manufacturing or distribution business unit of the same organization, which takes over the order fulfillment and ships goods directly to the customer.  The scenario can be combined with any of the product sales scenarios and any production model.",
          _type: "Scenario",
          GUID: "1c4f0c1b-928c-11e9-0cfc-001bc641ce4f",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "For intercompany transactions, this process ensures that billing information is received by the delivering entity and the financial obligation related to the transaction is settled.      ",
              _type: "Process",
              GUID: "6166270a-7e56-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the goods have been delivered and invoice received, payment is made to the delivering entity and recording in accounting.",
              Outcome:
                "Amount in the intercompany invoice is paid and documented accordingly.",
              name: "Receive intercompany invoice",
              _id: 1232,
              Business_Rules:
                "It is necessary to define: - General payment terms and condition for intercompany invoicing, - Relations between the selling and shipping operating units in view of intercompany transaction flows.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of a customer invoice provides documentation of the financial obligation related to a customer order. The customer invoice is created from a sales order.",
              _type: "Process",
              GUID: "75ff0dfc-e8bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Circumstances such as required documents for customs clearance or advance payments might have an impact on the timing when an invoice needs to be created during the sales process.",
              Type: "Business Process",
              Scope:
                "After the customer order has been fulfilled, the invoice is created. It provides the customer with information required to settle the payment related to their order.",
              Outcome: "Invoice is created and sent to the customer.",
              name: "Create customer invoice",
              _id: 1363,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In an intercompany situation, product price may vary from those offers to external customers. In such cases, it is necessary to determine the price offered to the IC buyer. Pricing will be performed, using SD-functionality.",
              _type: "Process",
              GUID: "80843c23-9567-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Transfer product price is determined based on corporate guidelines and corporate tax regulations.",
              Outcome: "Transfer product price is determined.",
              name: "Determine transfer product price for IC",
              _id: 178,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After capturing and confirming a sales order, the order fulfillment needs to be monitored. Changes in availability, confirmation dates and priorities have to be considered and reflected in the sales order. The customer needs to be informed accordingly.",
              _type: "Process",
              GUID: "397b5453-d3a1-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "From a time perspective, this process spans from the saving of the sales order to the creation, release of the delivery and invoicing.",
              Outcome:
                "Any changes are reflected in the sales order, communication and excalation procedures are triggered if necessary.",
              name: "Monitor order fulfillment",
              _id: 158,
              Business_Rules:
                "Clear guidelines need to be defined how to handle shortages, deviations from already given commitments to the customer, priority conflicts as well as rules need to be agreed on how and when, and under which sircumstances the customer can request changes to the order. ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the confirmation is provided that the customer order can be fulfilled, the product price must be calculated (or extracted from the system) taking into account relevant conditions (e.g. rebates, shipping condition, customer price groups).",
              _type: "Process",
              GUID: "197ea3f9-eaa9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "In addition to the pricing itself, the workflows and required approvals have to be defined. Consider all types of sales (priced samples, free of charge samples etc.) and possible promotions and rebates.  In case a quotation has been placed, the conditions between both should be aligned or at least an interaction with the customer has to take place in case of any deviation.",
              Type: "Business Process",
              Scope:
                "Pricing takes into account all conditions related to the product and customer.",
              Outcome:
                "Pricing and conditions related to the order are generated, documented and agreed with customer.",
              name: "Determine product price and conditions",
              _id: 157,
              Business_Rules:
                "Pricing schemas are typically defined upfront.  It must be defined who (and with which limitations) has the rights to adjust prices and conditions within the sales process.   The price and trading conditions of the product must be based on a set of guidelines that take into account:   ***Cost of product   ***Market value of product   ***Customers perceived value of product    ***Relationship with customer (rebates etc.)   ***Defined profit margin expectations  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Back order processing must be performed in case the ATP check did not provide a satisfying result, or an unplanned change to the supply situation requires a reconsideration/ recalculation of already confirmed quantities and dates. The process might affect other sales orders, stock transfer orders, and confirmed documents such as material reservations, production or repair orders, which compete with the respective sales documents for the available quantity of the requested material. The resolution of a shortage situation includes the alignment (and consequent adjustment) of the supply situation as well as a reallocation of already confirmed and allocated ATP quantities. All affected parties must be involved or informed accordingly.",
              _type: "Process",
              GUID: "3e124dd1-602a-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the ATP situation has been analysed, a solution is elaborated by e.g. rescheduling the order confirmation or evaluating other supplier options. Finally the solution is communicated with all relevant parties.",
              Outcome:
                "Aligned supply situation and communicated with all affected parties ",
              name: "Perform back order processing",
              _id: 177,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The results of the final ATP check need to be reviewed and the order confirmation to the customer is sent out. If the ATP check has not already been (re-)performed, this needs to be done now out of the individual sales document to consider the newly available ATP quantities and to adjust confirmation dates.",
              _type: "Process",
              GUID: "3e124dd3-602a-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After reviewing the results of the ATP, the customer needs to be informed via order confirmation or the supply situation must be clarified with the MRP planner.",
              Outcome: "Reviewed ATP and communicated order confirmation",
              name: "Review ATP and reconfirm order",
              _id: 176,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Receiving the customer order and capturing it in a format necessary for further processing are the key first steps to all sales processes. ",
              _type: "Process",
              GUID: "4cb51061-7e56-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the customer order is placed, the data must be amended, stored and forwarded for further processing. This might include transferring or copying data from other documents such as quotations or frame contracts.",
              Outcome:
                "All relevant information regarding the customers order is documented. The information captured provides the basis for determining whether the order can be fulfilled.",
              name: "Receive customer order and capture sales order data",
              _id: 175,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade compliance ensures due diligence with trade regulatory programs and cross-border customs requirements. Global trade checks are required for all business operations.",
              _type: "Process",
              GUID: "1b684ec4-44de-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The check itself is typically done automatically by the ERP system. The actual process discussion should focus on the maintenance of the relevant GTS data (including the integration of external data sources) and the handling of sales orders failing to pass the checks.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both involved business partners and products being sold or related services are subject to checks.",
              Outcome:
                "The sales order complies with the applicable trade regulations and the product can be shipped.",
              name: "Perform global trade check",
              _id: 57,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists, dual use products) used for screening is comprehensive and up to date.   Customer data must be up to date.   Rules and procedures how to handle sales orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Credit management helps to control the companys exposure to credit risk. Credit management must be aligned taking into account the customers liquidity and payment history (credit limit/insurance) and outstanding receivables.",
              _type: "Process",
              GUID: "5aa42fcb-e8e2-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Many corporations start looking at credit management from a group perspective. This requires some collaboration across companies and business units, which might not be established. Hierarchical credit limits might help to hinder a single business unit from already consuming the entire credit limit of a customer.  Any kind of guarantees such as letter of credit or bank guarantees and advanced payments need to be considered in this process.  Credit management for consignment fill-ups - despite goods remaining in sellers property, it is common to perform credit check, since control over goods is lost and the goods issue is typically retrospective.",
              Type: "Business Process",
              Scope:
                "The customers ability to pay for the product or service is evaluated based on their liquidity and payment history and a decision is made on whether the sale is allowed or not.",
              Outcome:
                "The decision is made on whether to proceed with sale or not.",
              name: "Execute credit management",
              _id: 1334,
              Business_Rules:
                "It is necessary to define the information necessary to execute the credit management process.  A framework must be put in place for:   ***Calculating the rating value of customers    ***Determining Credit Limit   ***Setting rules for Credit Check    ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of an intercompany invoice initiates the payment process for a transaction between two entities from the same corporate group.       ",
              _type: "Process",
              GUID: "53da3f54-e8c9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Typically there are special calculation rules to determine the profit margin in intercompany transactions.",
              Type: "Business Process",
              Scope:
                "The intercompany invoice, with which the supplier entity bills the selling or receiving entity, is created. In the case of a direct delivery to a customer, this happens automatically at the same time when the customer invoice is created. The required accounting entries are created using information from this invoice.",
              Outcome: "Intercompany invoice is created and issued. ",
              name: "Create intercompany invoice",
              _id: 1229,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The Available-to-Promise (ATP) check against stock verifies whether the required quantity of finished goods can be sold to the customer at the requested date. The check is carried out against actual or projected finished goods inventory.       ",
              _type: "Process",
              GUID: "eabe97ec-e8c8-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "It is necessary to define what happens after the availability is confirmed. Typically the requested product quantity is reserved (excluded from available stock). It should be defined how undelivered sales orders are handled and when a reservation for a sales order will be canceled.  Business rules that need to be defined are:   ***What are the main and alternative supply points for regions/customers (ship-to)   ***Which future goods receipts should be considered   ***Which future goods issues should be considered   ***Are allocations required to reserve quantities for specific customers, customer groups, markets/sales channels, regions    ***If allocations are used are those valid for the whole sales period or will those be deactivated after a certain time (example: monthly allocations are only valid until mid of the month any remaining quantities will be made generally available afterwards).    Sometimes other constraints like transportation capacity or handling capacity need to be integrated into the ATP check.",
              Type: "Business Process",
              Scope:
                "After the customer order data is captured, it must be checked if the order can be fulfilled (the requested products are available in the requested quantity and on the desired date). It is also necessary to determine the storage location the goods will be delivered from.",
              Outcome: "ATP check is performed.",
              name: "Check availability to promise at sales order entry",
              _id: 163,
              Business_Rules:
                "For setting-up the check it must be defined which sources, i.e. inventory, are to be considered.  Typical business cases are:   ***Check against plan or inventory    ***Inventory in local warehouse    ***Inventory in global organisation     ***Inventory in local warehouse + placed purchase orders/released production orders    Allocations might be used in short markets to manage the distribution of stock to particular markets, customer segments, or individual customers.  The workflow in case of different partial availability situations should be defined:   ***Proposal of alternate dates   ***Proposal of substitute products   ***Proposal of partial shipments   ***Backorder processing     ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of the sales order is given through the confirmation and represents a commitment to fulfil the order.",
              _type: "Process",
              GUID: "a98a286c-7e52-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The effectiveness of the approval-workflows often is overestimated. Sales managers will receive many approval requests daily. The data to be checked should be limited to the essentials. Everything that can be checked automatically by rules should be implemented in the system. The result of the automatic checks should be obvious to the reviewer.",
              Type: "Business Process",
              Scope:
                "After all checks related to the order have been performed the final decision is made regarding execution of the order. A commitment to the customer is made. This triggers the outbound logistics, production process or service process. ",
              Outcome:
                "A decision is made to fulfil the customers order. This triggers the outbound logistics/production process. The customer is informed about the decision.",
              name: "Save and approve sales order",
              _id: 1332,
              Business_Rules:
                "Rules must be established for allocating authorization for sales order approval to users. The format of the confirmation (electronic, paper) and communication channel must be defined.",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Cross-company sales",
          _id: 174,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "550b9641-7e59-11e5-0a66-001bc640cd9b",
          Description:
            "In special chemicals and in high-tech industries it is often the case that customers have specific technical requirements and their own production process is very sensitive to any deviation in product characteristics. Therefore compliance of batches with the specification must be ensured. Often, by sending a sample to the customer to be analyzed or used in a test production. The batch needs to be reserved for the customer after his initial inquiry but prior to the placement of a final sales order. Sales with reservations scenario describes processes relevant to this situation.  The scenario is applied in situations when the customer wants to test a sample of the product prior to committing to the actual purchase. In this case exactly the same batch, from which the sample is drawn must be reserved for the customer. The sample may or may not be provided to the customer free-of-charge.",
          _type: "Scenario",
          GUID: "8c942b42-ef45-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Once customer inquiry is received, a sample order must be created to enable further processing of the customer request.",
              _type: "Process",
              GUID: "5acb9a51-7e59-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Data from customer inquiry is amended, stored and forwarded for further processing.",
              Outcome:
                "All relevant information regarding the customers inquiry is documented. The information captured provides the basis for determining batch, from which sample will be drawn and reserving goods in this sample.",
              name: "Create batch sample order",
              _id: 173,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The pro-forma invoice provides the customer with documentation regarding the goods delivered. As opposed to a customer invoice, the pro-forma invoice is not a request for payment. ",
              _type: "Process",
              GUID: "5acb9a33-7e59-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the samples have been delivered to the customer, a pro-forma invoice is create with information on the quantity (value of samples if required). This concludes the sample handling process.",
              Outcome: "Pro-forma invoice is created and sent to the customer.",
              name: "Create pro forma invoice",
              _id: 172,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process describes the initial capturing and checking of an inquiry. In comparison to a lead an inquiry contains an explicit request for a quotation. Receiving the customer inquiry and capturing it in a format necessary for further processing and initiating pre-sales business processes. ",
              _type: "Process",
              GUID: "f80615ee-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "For inquiries from and quotations for new potential customers, a dummy customer master might be used. Latest with the order entry, a real customer master gets created and the sales order will be captured with reference to it.",
              Type: "Business Process",
              Scope:
                "Once a customer inquires about a certain product, the data must be recorded, stored and forwarded for further processing. ",
              Outcome:
                "All relevant information regarding the customers inquiry is documented. The information captured provides the basis for preparing a quotation or reservation of goods.",
              name: "Receive and capture customer inquiry",
              _id: 171,
              Business_Rules:
                "Rules should determine in which cases inquiries have to be documented.   There are several aspects why inquiries should be captured in the system:   ***Avoidance of duplicated capturing of data   ***Considering the information in planning   ***Internal compliance and approval guidelines   ***Using the information for reporting and identifying reasons for lost sales  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Goods reservation ensures that products related to the customer inquiry will be available when the customer wants to buy them. ",
              _type: "Process",
              GUID: "5acb9a3c-7e59-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Based on the customer inquiry, a reservation is created for a specific batch of product. This information needs to be transferred to the warehouse in order to ensure that the reserved batch is not shipped out to fulfil another customer order.",
              Outcome: "A batch of goods is reserved. ",
              name: "Reserve goods on batch level",
              _id: 170,
              Business_Rules:
                "The duration of the reservation, means of securing that the batch is not shipped out, and the means of locating the batch and matching it to a sample must be established.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Country specific regulations state that, above a certain quantity of chemicals and other hazardous substances, it is required to register with the authorities the maximum quantities of these substances that is planned to be purchased, imported, produced, sold, or exported within a certain period. By comparing the recorded quantities with the limit values, the system signals that a limit value is close to be exceeded if a limit value is exceeded, the system can also block the respective business process.  ",
              _type: "Process",
              GUID: "96e72960-eaa6-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Identify required Checks   ***Check if Registration Status is positive or negative   ***Check quantity limit to import / produce   ***Block order and report issue   ***Permit Order  ",
              Outcome:
                "The product complies with the chemical compliance related requirements and sales order processing is permitted.",
              name: "Perform chemical compliance check",
              _id: 159,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The process describes the creation of customer specific documentation that may be requested by our customers.",
              _type: "Process",
              GUID: "56165656-7169-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The documentation may be delivered together with the goods receipt or independently from it.    The documentation may be delivered as hard copy or as an electronic version.",
              Type: "Business Process",
              Scope:
                "After the request for creating customer specific documentation has been received, the documentation is created and prepared for a shipment to the customer.",
              Outcome:
                "The customer receives specific documentation as requested.",
              name: "Prepare customer specific documentation",
              _id: 160,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After capturing and confirming a sales order, the order fulfillment needs to be monitored. Changes in availability, confirmation dates and priorities have to be considered and reflected in the sales order. The customer needs to be informed accordingly.",
              _type: "Process",
              GUID: "397b5453-d3a1-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "From a time perspective, this process spans from the saving of the sales order to the creation, release of the delivery and invoicing.",
              Outcome:
                "Any changes are reflected in the sales order, communication and excalation procedures are triggered if necessary.",
              name: "Monitor order fulfillment",
              _id: 158,
              Business_Rules:
                "Clear guidelines need to be defined how to handle shortages, deviations from already given commitments to the customer, priority conflicts as well as rules need to be agreed on how and when, and under which sircumstances the customer can request changes to the order. ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the confirmation is provided that the customer order can be fulfilled, the product price must be calculated (or extracted from the system) taking into account relevant conditions (e.g. rebates, shipping condition, customer price groups).",
              _type: "Process",
              GUID: "197ea3f9-eaa9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "In addition to the pricing itself, the workflows and required approvals have to be defined. Consider all types of sales (priced samples, free of charge samples etc.) and possible promotions and rebates.  In case a quotation has been placed, the conditions between both should be aligned or at least an interaction with the customer has to take place in case of any deviation.",
              Type: "Business Process",
              Scope:
                "Pricing takes into account all conditions related to the product and customer.",
              Outcome:
                "Pricing and conditions related to the order are generated, documented and agreed with customer.",
              name: "Determine product price and conditions",
              _id: 157,
              Business_Rules:
                "Pricing schemas are typically defined upfront.  It must be defined who (and with which limitations) has the rights to adjust prices and conditions within the sales process.   The price and trading conditions of the product must be based on a set of guidelines that take into account:   ***Cost of product   ***Market value of product   ***Customers perceived value of product    ***Relationship with customer (rebates etc.)   ***Defined profit margin expectations  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of the sample order is provided through the confirmation and represents a commitment to deliver the sample goods to the customer on the agreed date. ",
              _type: "Process",
              GUID: "5ae11e01-7e59-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After all checks related to the sample order have been performed the final decision is made regarding execution of the order. A commitment to the customer is made, triggering the outbound logistics process. ",
              Outcome: "A decision is made to deliver the samples to customer.",
              name: "Save and approve sample order",
              _id: 169,
              Business_Rules:
                "It is essential to define how sample order confirmation is linked to inventory management and production processes. Rules must be established for allocating authorization for sample order approval. The format of the confirmation (electronic, paper) and communication channel must be defined.",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "The sample might be sold or shipped free-of-charge. This can be a substantial volume for a test production. A separate sales order should be used in such cases.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Sales with reservation",
          _id: 168,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "6b7d7e81-7e53-11e5-0a66-001bc640cd9b",
          Description:
            "Sales from production (ATO) scenario covers sales of products, which are customized (assembled from components available in inventory) to customer specification after the sales order is placed. It triggers hence the assembly process in production (assemble-to-order production model).  The scenario is applied if customers require customization of standard products, which can be assembled from common components. The assembly is initiated after the customer order is placed. For confirmation that the customer order can be fulfilled, the ATP check is performed, which verifies if the components to be assembled are available and whether the finished product will be available in the requested quantity on the desired date.",
          _type: "Scenario",
          GUID: "b6b20964-ef2f-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of the sales order is given through the confirmation and represents a commitment to fulfil the order.",
              _type: "Process",
              GUID: "a98a286c-7e52-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The effectiveness of the approval-workflows often is overestimated. Sales managers will receive many approval requests daily. The data to be checked should be limited to the essentials. Everything that can be checked automatically by rules should be implemented in the system. The result of the automatic checks should be obvious to the reviewer.",
              Type: "Business Process",
              Scope:
                "After all checks related to the order have been performed the final decision is made regarding execution of the order. A commitment to the customer is made. This triggers the outbound logistics, production process or service process. ",
              Outcome:
                "A decision is made to fulfil the customers order. This triggers the outbound logistics/production process. The customer is informed about the decision.",
              name: "Save and approve sales order",
              _id: 1332,
              Business_Rules:
                "Rules must be established for allocating authorization for sales order approval to users. The format of the confirmation (electronic, paper) and communication channel must be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Receiving an assembly order and capturing it in a standard format necessary for further processing are the key first steps for the assembly sales scenario. ",
              _type: "Process",
              GUID: "7263da23-7e53-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the customer order is placed, the data must be amended, stored and forwarded for further processing. This might include transferring or copying data from other documents such as quotations or frame contracts.",
              Outcome:
                "All relevant information regarding the customers order is documented. The information captured provides the basis for determining whether the order can be fulfilled.",
              name: "Receive assembly order and capture sales order data",
              _id: 490,
              Business_Rules: "",
              Prerequisite:
                "Prerequisite: set-up of communication channels to be used.",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "An assembly is either done based on a simple sales BOM (bill of material) or on a more complex configuration logic. The outcome of this process serves as input for determining the price and conditions of the assembly order as well as for the actual assembly work.",
              _type: "Process",
              GUID: "97016803-eaa6-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "If assembly orders are used for final filling or packaging, typically sales BOMs are used to specify the components (product and packaging material).  Sometimes, assembly orders are used for processes like blending and mixing. In such cases, either a configuration logic is established or the BOM is specified for each order specifically.  Even more complex configurations are typically handled using configurable products.",
              Type: "Business Process",
              Scope:
                "Once the sales order data for assembly production has been captured, the next step is to define how the product will be assembled and what components will be used for production.",
              Outcome:
                "The product configuration and required components are defined based on the sales order. ",
              name: "Configure product (Assembly)",
              _id: 356,
              Business_Rules:
                "Depending on the product and type of assembly, rules to limit options might be required.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Credit management helps to control the companys exposure to credit risk. Credit management must be aligned taking into account the customers liquidity and payment history (credit limit/insurance) and outstanding receivables.",
              _type: "Process",
              GUID: "5aa42fcb-e8e2-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Many corporations start looking at credit management from a group perspective. This requires some collaboration across companies and business units, which might not be established. Hierarchical credit limits might help to hinder a single business unit from already consuming the entire credit limit of a customer.  Any kind of guarantees such as letter of credit or bank guarantees and advanced payments need to be considered in this process.  Credit management for consignment fill-ups - despite goods remaining in sellers property, it is common to perform credit check, since control over goods is lost and the goods issue is typically retrospective.",
              Type: "Business Process",
              Scope:
                "The customers ability to pay for the product or service is evaluated based on their liquidity and payment history and a decision is made on whether the sale is allowed or not.",
              Outcome:
                "The decision is made on whether to proceed with sale or not.",
              name: "Execute credit management",
              _id: 1334,
              Business_Rules:
                "It is necessary to define the information necessary to execute the credit management process.  A framework must be put in place for:   ***Calculating the rating value of customers    ***Determining Credit Limit   ***Setting rules for Credit Check    ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of a customer invoice provides documentation of the financial obligation related to a customer order. The customer invoice is created from a sales order.",
              _type: "Process",
              GUID: "75ff0dfc-e8bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Circumstances such as required documents for customs clearance or advance payments might have an impact on the timing when an invoice needs to be created during the sales process.",
              Type: "Business Process",
              Scope:
                "After the customer order has been fulfilled, the invoice is created. It provides the customer with information required to settle the payment related to their order.",
              Outcome: "Invoice is created and sent to the customer.",
              name: "Create customer invoice",
              _id: 1363,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The process describes the creation of customer specific documentation that may be requested by our customers.",
              _type: "Process",
              GUID: "56165656-7169-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The documentation may be delivered together with the goods receipt or independently from it.    The documentation may be delivered as hard copy or as an electronic version.",
              Type: "Business Process",
              Scope:
                "After the request for creating customer specific documentation has been received, the documentation is created and prepared for a shipment to the customer.",
              Outcome:
                "The customer receives specific documentation as requested.",
              name: "Prepare customer specific documentation",
              _id: 160,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The Available-to-Promise (ATP) check against stock verifies whether the required quantity of finished goods can be sold to the customer at the requested date. The check is carried out against actual or projected finished goods inventory.       ",
              _type: "Process",
              GUID: "eabe97ec-e8c8-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "It is necessary to define what happens after the availability is confirmed. Typically the requested product quantity is reserved (excluded from available stock). It should be defined how undelivered sales orders are handled and when a reservation for a sales order will be canceled.  Business rules that need to be defined are:   ***What are the main and alternative supply points for regions/customers (ship-to)   ***Which future goods receipts should be considered   ***Which future goods issues should be considered   ***Are allocations required to reserve quantities for specific customers, customer groups, markets/sales channels, regions    ***If allocations are used are those valid for the whole sales period or will those be deactivated after a certain time (example: monthly allocations are only valid until mid of the month any remaining quantities will be made generally available afterwards).    Sometimes other constraints like transportation capacity or handling capacity need to be integrated into the ATP check.",
              Type: "Business Process",
              Scope:
                "After the customer order data is captured, it must be checked if the order can be fulfilled (the requested products are available in the requested quantity and on the desired date). It is also necessary to determine the storage location the goods will be delivered from.",
              Outcome: "ATP check is performed.",
              name: "Check availability to promise at sales order entry",
              _id: 163,
              Business_Rules:
                "For setting-up the check it must be defined which sources, i.e. inventory, are to be considered.  Typical business cases are:   ***Check against plan or inventory    ***Inventory in local warehouse    ***Inventory in global organisation     ***Inventory in local warehouse + placed purchase orders/released production orders    Allocations might be used in short markets to manage the distribution of stock to particular markets, customer segments, or individual customers.  The workflow in case of different partial availability situations should be defined:   ***Proposal of alternate dates   ***Proposal of substitute products   ***Proposal of partial shipments   ***Backorder processing     ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After capturing and confirming a sales order, the order fulfillment needs to be monitored. Changes in availability, confirmation dates and priorities have to be considered and reflected in the sales order. The customer needs to be informed accordingly.",
              _type: "Process",
              GUID: "397b5453-d3a1-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "From a time perspective, this process spans from the saving of the sales order to the creation, release of the delivery and invoicing.",
              Outcome:
                "Any changes are reflected in the sales order, communication and excalation procedures are triggered if necessary.",
              name: "Monitor order fulfillment",
              _id: 158,
              Business_Rules:
                "Clear guidelines need to be defined how to handle shortages, deviations from already given commitments to the customer, priority conflicts as well as rules need to be agreed on how and when, and under which sircumstances the customer can request changes to the order. ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the confirmation is provided that the customer order can be fulfilled, the product price must be calculated (or extracted from the system) taking into account relevant conditions (e.g. rebates, shipping condition, customer price groups).",
              _type: "Process",
              GUID: "197ea3f9-eaa9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "In addition to the pricing itself, the workflows and required approvals have to be defined. Consider all types of sales (priced samples, free of charge samples etc.) and possible promotions and rebates.  In case a quotation has been placed, the conditions between both should be aligned or at least an interaction with the customer has to take place in case of any deviation.",
              Type: "Business Process",
              Scope:
                "Pricing takes into account all conditions related to the product and customer.",
              Outcome:
                "Pricing and conditions related to the order are generated, documented and agreed with customer.",
              name: "Determine product price and conditions",
              _id: 157,
              Business_Rules:
                "Pricing schemas are typically defined upfront.  It must be defined who (and with which limitations) has the rights to adjust prices and conditions within the sales process.   The price and trading conditions of the product must be based on a set of guidelines that take into account:   ***Cost of product   ***Market value of product   ***Customers perceived value of product    ***Relationship with customer (rebates etc.)   ***Defined profit margin expectations  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Country specific regulations state that, above a certain quantity of chemicals and other hazardous substances, it is required to register with the authorities the maximum quantities of these substances that is planned to be purchased, imported, produced, sold, or exported within a certain period. By comparing the recorded quantities with the limit values, the system signals that a limit value is close to be exceeded if a limit value is exceeded, the system can also block the respective business process.  ",
              _type: "Process",
              GUID: "96e72960-eaa6-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Identify required Checks   ***Check if Registration Status is positive or negative   ***Check quantity limit to import / produce   ***Block order and report issue   ***Permit Order  ",
              Outcome:
                "The product complies with the chemical compliance related requirements and sales order processing is permitted.",
              name: "Perform chemical compliance check",
              _id: 159,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "Assembly to order focuses more on the availability of the components than on any assembly capacities.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Sales from production (Assemble to order)",
          _id: 167,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "a730c041-7e58-11e5-0a66-001bc640cd9b",
          Description:
            "Sales with down payment can be applied in combination with other sales scenarios. The sales process includes down payments from the customer as a prerequisite for triggering any internal processes (production, purchase of goods or components, assembly) or a delivery.  In some regions, down payments are quite common. Otherwise, those are applied in case such as: low credit ranking of a customer, high costs or long production times in make-to-order scenarios, in cases where costly logistics processes are involved, the final goods are hardly to be sold or reused (MTO), or in engineer-to-order scenarios",
          _type: "Scenario",
          GUID: "7a693936-ef3c-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The customer balanced the down payment request. The amount now needs to be identified to the down payment request and posted in the system.  Both automatic and manual postings are possible. The down payment request gets cleared.        ",
              _type: "Process",
              GUID: "f5f054bc-e8f4-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Down payments have to be considered in the credit check.",
              Type: "Business Process",
              Scope: "Clear down payment request.",
              Outcome: "Down payment request cleared.",
              name: "Clear down payment request",
              _id: 581,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the steps after the sales order was confirmed. The customer is required to pay the down payment. In order to do that, the billing block of the sales order needs to be removed first and a down payment request sent to the customer.",
              _type: "Process",
              GUID: "ad546818-7e58-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Remove billing block, create down payment request",
              Outcome: "Down payment request created and sent to customer.",
              name: "Process down payment request",
              _id: 389,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After final invoice has been issued to the customer the down payment can be cleared with the invoice.       ",
              _type: "Process",
              GUID: "ad54682a-7e58-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "A customer pays an invoice for which a down payment was made. The down payment open item is clear to indicate the payment made.",
              Outcome: "Down payment cleared.",
              name: "Clear down payment",
              _id: 584,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Receiving the customer order and capturing it in a format necessary for further processing are the key first steps to all sales processes. A billing plan is maintained and the initial down payment to be paid by the customer captured.",
              _type: "Process",
              GUID: "ad54682d-7e58-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the customer order is placed, the data must be amended, stored and forwarded for further processing. This might include transferring or copying data from other documents such as quotations or frame contracts.",
              Outcome:
                "All relevant information regarding the customers order is documented. The information captured provides the basis for determining whether the order can be fulfilled.",
              name: "Create sales order with down payment",
              _id: 387,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After capturing and confirming a sales order, the order fulfillment needs to be monitored. Changes in availability, confirmation dates and priorities have to be considered and reflected in the sales order. The customer needs to be informed accordingly.",
              _type: "Process",
              GUID: "397b5453-d3a1-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "From a time perspective, this process spans from the saving of the sales order to the creation, release of the delivery and invoicing.",
              Outcome:
                "Any changes are reflected in the sales order, communication and excalation procedures are triggered if necessary.",
              name: "Monitor order fulfillment",
              _id: 158,
              Business_Rules:
                "Clear guidelines need to be defined how to handle shortages, deviations from already given commitments to the customer, priority conflicts as well as rules need to be agreed on how and when, and under which sircumstances the customer can request changes to the order. ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of a customer invoice provides documentation of the financial obligation related to a customer order. The customer invoice is created from a sales order.",
              _type: "Process",
              GUID: "75ff0dfc-e8bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Circumstances such as required documents for customs clearance or advance payments might have an impact on the timing when an invoice needs to be created during the sales process.",
              Type: "Business Process",
              Scope:
                "After the customer order has been fulfilled, the invoice is created. It provides the customer with information required to settle the payment related to their order.",
              Outcome: "Invoice is created and sent to the customer.",
              name: "Create customer invoice",
              _id: 1363,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Sales with down payment",
          _id: 166,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "e233faa1-7e57-11e5-0a66-001bc640cd9b",
          Description:
            "Sales via subcontracting is a collaborative scenario whereby sold products are toll-manufactured by a supplier using components from the selling entity. After the customer order is placed, the order details are transferred to a subcontractor, who manufactures the product.  The supply chain setup defines if the finished products will be shipped from the subcontractor directly to the customer or to the organizations warehouse. Alternatively the organizations own transportation department can coordinate transportation.  This scenario represents the combination of subcontracting/toll manufacturing with a make-to-order or assemble-to-order manufacturing set-up.",
          _type: "Scenario",
          GUID: "7a693932-ef3c-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of a customer invoice provides documentation of the financial obligation related to a customer order. The customer invoice is created from a sales order.",
              _type: "Process",
              GUID: "75ff0dfc-e8bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Circumstances such as required documents for customs clearance or advance payments might have an impact on the timing when an invoice needs to be created during the sales process.",
              Type: "Business Process",
              Scope:
                "After the customer order has been fulfilled, the invoice is created. It provides the customer with information required to settle the payment related to their order.",
              Outcome: "Invoice is created and sent to the customer.",
              name: "Create customer invoice",
              _id: 1363,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The purpose of this process is to prevent shipping of dangerous goods which will harm dangerous goods regulation.",
              _type: "Process",
              GUID: "3124d4df-e98f-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The dangerous goods check verifies whether the shipment of dangerous goods contains transport regulatory data derived from UN-numbers, dangerous good classes, packaging codes etc. ",
              Outcome:
                "The product complies with the EH+S related requirements and the sales order is permitted by EH+S.",
              name: "Perform dangerous goods check",
              _id: 67,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The process describes the creation of customer specific documentation that may be requested by our customers.",
              _type: "Process",
              GUID: "56165656-7169-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The documentation may be delivered together with the goods receipt or independently from it.    The documentation may be delivered as hard copy or as an electronic version.",
              Type: "Business Process",
              Scope:
                "After the request for creating customer specific documentation has been received, the documentation is created and prepared for a shipment to the customer.",
              Outcome:
                "The customer receives specific documentation as requested.",
              name: "Prepare customer specific documentation",
              _id: 160,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The Available-to-Promise (ATP) check against stock verifies whether the required quantity of finished goods can be sold to the customer at the requested date. The check is carried out against actual or projected finished goods inventory.       ",
              _type: "Process",
              GUID: "eabe97ec-e8c8-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "It is necessary to define what happens after the availability is confirmed. Typically the requested product quantity is reserved (excluded from available stock). It should be defined how undelivered sales orders are handled and when a reservation for a sales order will be canceled.  Business rules that need to be defined are:   ***What are the main and alternative supply points for regions/customers (ship-to)   ***Which future goods receipts should be considered   ***Which future goods issues should be considered   ***Are allocations required to reserve quantities for specific customers, customer groups, markets/sales channels, regions    ***If allocations are used are those valid for the whole sales period or will those be deactivated after a certain time (example: monthly allocations are only valid until mid of the month any remaining quantities will be made generally available afterwards).    Sometimes other constraints like transportation capacity or handling capacity need to be integrated into the ATP check.",
              Type: "Business Process",
              Scope:
                "After the customer order data is captured, it must be checked if the order can be fulfilled (the requested products are available in the requested quantity and on the desired date). It is also necessary to determine the storage location the goods will be delivered from.",
              Outcome: "ATP check is performed.",
              name: "Check availability to promise at sales order entry",
              _id: 163,
              Business_Rules:
                "For setting-up the check it must be defined which sources, i.e. inventory, are to be considered.  Typical business cases are:   ***Check against plan or inventory    ***Inventory in local warehouse    ***Inventory in global organisation     ***Inventory in local warehouse + placed purchase orders/released production orders    Allocations might be used in short markets to manage the distribution of stock to particular markets, customer segments, or individual customers.  The workflow in case of different partial availability situations should be defined:   ***Proposal of alternate dates   ***Proposal of substitute products   ***Proposal of partial shipments   ***Backorder processing     ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Credit management helps to control the companys exposure to credit risk. Credit management must be aligned taking into account the customers liquidity and payment history (credit limit/insurance) and outstanding receivables.",
              _type: "Process",
              GUID: "5aa42fcb-e8e2-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Many corporations start looking at credit management from a group perspective. This requires some collaboration across companies and business units, which might not be established. Hierarchical credit limits might help to hinder a single business unit from already consuming the entire credit limit of a customer.  Any kind of guarantees such as letter of credit or bank guarantees and advanced payments need to be considered in this process.  Credit management for consignment fill-ups - despite goods remaining in sellers property, it is common to perform credit check, since control over goods is lost and the goods issue is typically retrospective.",
              Type: "Business Process",
              Scope:
                "The customers ability to pay for the product or service is evaluated based on their liquidity and payment history and a decision is made on whether the sale is allowed or not.",
              Outcome:
                "The decision is made on whether to proceed with sale or not.",
              name: "Execute credit management",
              _id: 1334,
              Business_Rules:
                "It is necessary to define the information necessary to execute the credit management process.  A framework must be put in place for:   ***Calculating the rating value of customers    ***Determining Credit Limit   ***Setting rules for Credit Check    ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of the sales order is given through the confirmation and represents a commitment to fulfil the order.",
              _type: "Process",
              GUID: "a98a286c-7e52-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The effectiveness of the approval-workflows often is overestimated. Sales managers will receive many approval requests daily. The data to be checked should be limited to the essentials. Everything that can be checked automatically by rules should be implemented in the system. The result of the automatic checks should be obvious to the reviewer.",
              Type: "Business Process",
              Scope:
                "After all checks related to the order have been performed the final decision is made regarding execution of the order. A commitment to the customer is made. This triggers the outbound logistics, production process or service process. ",
              Outcome:
                "A decision is made to fulfil the customers order. This triggers the outbound logistics/production process. The customer is informed about the decision.",
              name: "Save and approve sales order",
              _id: 1332,
              Business_Rules:
                "Rules must be established for allocating authorization for sales order approval to users. The format of the confirmation (electronic, paper) and communication channel must be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the confirmation is provided that the customer order can be fulfilled, the product price must be calculated (or extracted from the system) taking into account relevant conditions (e.g. rebates, shipping condition, customer price groups).",
              _type: "Process",
              GUID: "197ea3f9-eaa9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "In addition to the pricing itself, the workflows and required approvals have to be defined. Consider all types of sales (priced samples, free of charge samples etc.) and possible promotions and rebates.  In case a quotation has been placed, the conditions between both should be aligned or at least an interaction with the customer has to take place in case of any deviation.",
              Type: "Business Process",
              Scope:
                "Pricing takes into account all conditions related to the product and customer.",
              Outcome:
                "Pricing and conditions related to the order are generated, documented and agreed with customer.",
              name: "Determine product price and conditions",
              _id: 157,
              Business_Rules:
                "Pricing schemas are typically defined upfront.  It must be defined who (and with which limitations) has the rights to adjust prices and conditions within the sales process.   The price and trading conditions of the product must be based on a set of guidelines that take into account:   ***Cost of product   ***Market value of product   ***Customers perceived value of product    ***Relationship with customer (rebates etc.)   ***Defined profit margin expectations  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After capturing and confirming a sales order, the order fulfillment needs to be monitored. Changes in availability, confirmation dates and priorities have to be considered and reflected in the sales order. The customer needs to be informed accordingly.",
              _type: "Process",
              GUID: "397b5453-d3a1-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "From a time perspective, this process spans from the saving of the sales order to the creation, release of the delivery and invoicing.",
              Outcome:
                "Any changes are reflected in the sales order, communication and excalation procedures are triggered if necessary.",
              name: "Monitor order fulfillment",
              _id: 158,
              Business_Rules:
                "Clear guidelines need to be defined how to handle shortages, deviations from already given commitments to the customer, priority conflicts as well as rules need to be agreed on how and when, and under which sircumstances the customer can request changes to the order. ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade compliance ensures due diligence with trade regulatory programs and cross-border customs requirements. Global trade checks are required for all business operations.",
              _type: "Process",
              GUID: "1b684ec4-44de-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The check itself is typically done automatically by the ERP system. The actual process discussion should focus on the maintenance of the relevant GTS data (including the integration of external data sources) and the handling of sales orders failing to pass the checks.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both involved business partners and products being sold or related services are subject to checks.",
              Outcome:
                "The sales order complies with the applicable trade regulations and the product can be shipped.",
              name: "Perform global trade check",
              _id: 57,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists, dual use products) used for screening is comprehensive and up to date.   Customer data must be up to date.   Rules and procedures how to handle sales orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In the sales via subcontracting scenario, once the selling entity has accepted a customer order, a purchase order is issued to the subcontractor. Receipt of this order and capturing it in a format necessary for further processing are the key first steps required for fulfillment of the subcontracting service.",
              _type: "Process",
              GUID: "e7ceea7f-7e57-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once a purchase order is received, its data must be amended, stored and forwarded for further processing.",
              Outcome:
                "All relevant information regarding the received purchase order are documented. The information captured provides the basis for determining whether the order can be fulfilled.",
              name: "Receive subcontracting order and capture sales order data",
              _id: 375,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Country specific regulations state that, above a certain quantity of chemicals and other hazardous substances, it is required to register with the authorities the maximum quantities of these substances that is planned to be purchased, imported, produced, sold, or exported within a certain period. By comparing the recorded quantities with the limit values, the system signals that a limit value is close to be exceeded if a limit value is exceeded, the system can also block the respective business process.  ",
              _type: "Process",
              GUID: "96e72960-eaa6-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Identify required Checks   ***Check if Registration Status is positive or negative   ***Check quantity limit to import / produce   ***Block order and report issue   ***Permit Order  ",
              Outcome:
                "The product complies with the chemical compliance related requirements and sales order processing is permitted.",
              name: "Perform chemical compliance check",
              _id: 159,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Determine supply source and conditions aims at finding the external source from which a customer order will be fulfilled, as well as agreeing on the related conditions. The Determine supply source and conditions process is required for third party sales and sales via subcontracting, as well as in certain constellations of intercompany processes. In case of the latter, external source may also refer to other entities of the group.       ",
              _type: "Process",
              GUID: "5ac7e463-e8e2-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the customer order data is captured, the external source (external vendor) used to fulfil the order and related conditions must be determined. ",
              Outcome:
                "Source of supply and conditions related to the order are defined and documented.",
              name: "Determine supply source and conditions",
              _id: 180,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Sales via subcontracting",
          _id: 165,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "ac4c09f1-9402-11e8-2ddf-001bc640cd9b",
          Description:
            "Handling of returnable packaging refers to re-usable packaging units that are provided to customers in the course of product sales transactions, and is applied if packaging units are valuable and re-usable.  The rental scenario covers the option, in which the customer pays a periodic rental fee for the packaging units at his disposal. Usually an initial packaging usage period is free of charge, after which the rent is calculated and FIFO method is applied for calculation of the units that have been provided. The rental is limited to a time period, after which the payed fees actually cover the value of the packaging material. After that period, the customer gets owner of the packaging material.",
          _type: "Scenario",
          GUID: "8c942b4c-ef45-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of a customer invoice provides documentation of the financial obligation related to a customer order. The customer invoice is created from a sales order.",
              _type: "Process",
              GUID: "75ff0dfc-e8bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Circumstances such as required documents for customs clearance or advance payments might have an impact on the timing when an invoice needs to be created during the sales process.",
              Type: "Business Process",
              Scope:
                "After the customer order has been fulfilled, the invoice is created. It provides the customer with information required to settle the payment related to their order.",
              Outcome: "Invoice is created and sent to the customer.",
              name: "Create customer invoice",
              _id: 1363,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The assignment of returnable packaging to a sales order ensures that the cost and quantity of  the materials are mapped to the customer order. ",
              _type: "Process",
              GUID: "605f699d-7e4f-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Information about the quantity and value of the returnable packaging, as well as the plant to which the materials are to be returned is linked to the customer order and documented accordingly.",
              Outcome:
                "Returnable packaging information is recorded with the sales order data.",
              name: "Assign returnable packaging to sales order",
              _id: 379,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A delivery is the central object of the goods receipt process containing all the data required for triggering and monitoring it, starting from goods receipt in the yard and ending with transferral of the goods to the final putaway. In a customer return (as well as consignment pick-up) process, a return delivery document is used for this purpose.",
              _type: "Process",
              GUID: "3712628c-e9bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the return order (consignment pick-up order for consignment process) is created, a return delivery is created with reference to it.",
              Outcome:
                "Return delivery is created and goods receipt process can be initiated. ",
              name: "Create return delivery",
              _id: 1371,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "Returnable packaging can also be sold. In this case the price is either included in the products price or an additional line item for the packaging material is added to the sales order.  Nevertheless, there might be an agreement that the seller will buy back the provided packaging material if the customer asks for it.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Handling of returnable packaging (Rental)",
          _id: 164,
          Business_Rules:
            "Rules have to define the period packaging material will be provided free-of-charge before the renting period starts. How long the maximum period is. In case of pick-up scenarios, when the renting period stops (typically with the announcement of the customer that the packaging material can be picked up).  If the customer has to return the packaging material, it needs to be defined at which location.",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "5d2c87e1-7e49-11e5-0a66-001bc640cd9b",
          Description:
            "Under a consignment agreement products are provided to the customer, and actual sales are recorded and invoice issued based on consumption information from customer. Consignment sales scenario describes this case and covers consignment fill-up (provision of products to customer) and issue (recording of product sales).  Ownership of consignment stock at the customer location stays with the organization and is transferred to the customer only when the products are consumed.  This scenario is typically used in combination with the make-to-stock production model. Inventory levels at the customer location can either be managed by the seller (active VMI) or the customer.",
          _type: "Scenario",
          GUID: "8c942b28-ef45-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The Available-to-Promise (ATP) check against stock verifies whether the required quantity of finished goods can be sold to the customer at the requested date. The check is carried out against actual or projected finished goods inventory.       ",
              _type: "Process",
              GUID: "eabe97ec-e8c8-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "It is necessary to define what happens after the availability is confirmed. Typically the requested product quantity is reserved (excluded from available stock). It should be defined how undelivered sales orders are handled and when a reservation for a sales order will be canceled.  Business rules that need to be defined are:   ***What are the main and alternative supply points for regions/customers (ship-to)   ***Which future goods receipts should be considered   ***Which future goods issues should be considered   ***Are allocations required to reserve quantities for specific customers, customer groups, markets/sales channels, regions    ***If allocations are used are those valid for the whole sales period or will those be deactivated after a certain time (example: monthly allocations are only valid until mid of the month any remaining quantities will be made generally available afterwards).    Sometimes other constraints like transportation capacity or handling capacity need to be integrated into the ATP check.",
              Type: "Business Process",
              Scope:
                "After the customer order data is captured, it must be checked if the order can be fulfilled (the requested products are available in the requested quantity and on the desired date). It is also necessary to determine the storage location the goods will be delivered from.",
              Outcome: "ATP check is performed.",
              name: "Check availability to promise at sales order entry",
              _id: 163,
              Business_Rules:
                "For setting-up the check it must be defined which sources, i.e. inventory, are to be considered.  Typical business cases are:   ***Check against plan or inventory    ***Inventory in local warehouse    ***Inventory in global organisation     ***Inventory in local warehouse + placed purchase orders/released production orders    Allocations might be used in short markets to manage the distribution of stock to particular markets, customer segments, or individual customers.  The workflow in case of different partial availability situations should be defined:   ***Proposal of alternate dates   ***Proposal of substitute products   ***Proposal of partial shipments   ***Backorder processing     ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Credit management helps to control the companys exposure to credit risk. Credit management must be aligned taking into account the customers liquidity and payment history (credit limit/insurance) and outstanding receivables.",
              _type: "Process",
              GUID: "5aa42fcb-e8e2-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Many corporations start looking at credit management from a group perspective. This requires some collaboration across companies and business units, which might not be established. Hierarchical credit limits might help to hinder a single business unit from already consuming the entire credit limit of a customer.  Any kind of guarantees such as letter of credit or bank guarantees and advanced payments need to be considered in this process.  Credit management for consignment fill-ups - despite goods remaining in sellers property, it is common to perform credit check, since control over goods is lost and the goods issue is typically retrospective.",
              Type: "Business Process",
              Scope:
                "The customers ability to pay for the product or service is evaluated based on their liquidity and payment history and a decision is made on whether the sale is allowed or not.",
              Outcome:
                "The decision is made on whether to proceed with sale or not.",
              name: "Execute credit management",
              _id: 1334,
              Business_Rules:
                "It is necessary to define the information necessary to execute the credit management process.  A framework must be put in place for:   ***Calculating the rating value of customers    ***Determining Credit Limit   ***Setting rules for Credit Check    ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process includes the customer notification that goods provided on consignment have been consumed captured by an consignment issue order. From the sellers perspective this happens when the goods are sold. ",
              _type: "Process",
              GUID: "7f93241f-7e49-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Most of the data will be copied from the consignment fill-up order including price. However, there might be scenarios where price determination is affected by the date of consumption and therefore price determination runs again.    Customer notification can be part of self invoicing. In this case payment will be settled with issuing the invoice.",
              Type: "Business Process",
              Scope:
                "Once the customer provides information that goods on consignment have been consumed, the data is amended, stored and forwarded for further processing.",
              Outcome: "A sales order for consignment issue is created.",
              name: "Capture and issue consignment consumption",
              _id: 162,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The consignment scenario is initiated with a fill-up order, which triggers the transfer of consignment goods to the customer. Depending on the agreement with the customer, the planning and respectively the request for a new fill-up can be either done by the customer or by the seller.",
              _type: "Process",
              GUID: "6581198b-7e49-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Even though, the consignment goods are still owned by the selling company, prices get determined at this stage and later copied to the consignment issue order.   The price will be necessary for any pro forma invoice as well as will be used in case of excise tax procedures apply.",
              Type: "Business Process",
              Scope:
                "Once the consignment order has been placed, the data must be amended, stored and forwarded for further processing.",
              Outcome:
                "All relevant information regarding the consignment order is documented. The information captured provides the basis for determining whether the consignment order can be fulfilled.",
              name: "Capture consignment fill-up order",
              _id: 161,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The process describes the creation of customer specific documentation that may be requested by our customers.",
              _type: "Process",
              GUID: "56165656-7169-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The documentation may be delivered together with the goods receipt or independently from it.    The documentation may be delivered as hard copy or as an electronic version.",
              Type: "Business Process",
              Scope:
                "After the request for creating customer specific documentation has been received, the documentation is created and prepared for a shipment to the customer.",
              Outcome:
                "The customer receives specific documentation as requested.",
              name: "Prepare customer specific documentation",
              _id: 160,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of a customer invoice provides documentation of the financial obligation related to a customer order. The customer invoice is created from a sales order.",
              _type: "Process",
              GUID: "75ff0dfc-e8bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Circumstances such as required documents for customs clearance or advance payments might have an impact on the timing when an invoice needs to be created during the sales process.",
              Type: "Business Process",
              Scope:
                "After the customer order has been fulfilled, the invoice is created. It provides the customer with information required to settle the payment related to their order.",
              Outcome: "Invoice is created and sent to the customer.",
              name: "Create customer invoice",
              _id: 1363,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Country specific regulations state that, above a certain quantity of chemicals and other hazardous substances, it is required to register with the authorities the maximum quantities of these substances that is planned to be purchased, imported, produced, sold, or exported within a certain period. By comparing the recorded quantities with the limit values, the system signals that a limit value is close to be exceeded if a limit value is exceeded, the system can also block the respective business process.  ",
              _type: "Process",
              GUID: "96e72960-eaa6-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Identify required Checks   ***Check if Registration Status is positive or negative   ***Check quantity limit to import / produce   ***Block order and report issue   ***Permit Order  ",
              Outcome:
                "The product complies with the chemical compliance related requirements and sales order processing is permitted.",
              name: "Perform chemical compliance check",
              _id: 159,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After capturing and confirming a sales order, the order fulfillment needs to be monitored. Changes in availability, confirmation dates and priorities have to be considered and reflected in the sales order. The customer needs to be informed accordingly.",
              _type: "Process",
              GUID: "397b5453-d3a1-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "From a time perspective, this process spans from the saving of the sales order to the creation, release of the delivery and invoicing.",
              Outcome:
                "Any changes are reflected in the sales order, communication and excalation procedures are triggered if necessary.",
              name: "Monitor order fulfillment",
              _id: 158,
              Business_Rules:
                "Clear guidelines need to be defined how to handle shortages, deviations from already given commitments to the customer, priority conflicts as well as rules need to be agreed on how and when, and under which sircumstances the customer can request changes to the order. ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of the sales order is given through the confirmation and represents a commitment to fulfil the order.",
              _type: "Process",
              GUID: "a98a286c-7e52-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The effectiveness of the approval-workflows often is overestimated. Sales managers will receive many approval requests daily. The data to be checked should be limited to the essentials. Everything that can be checked automatically by rules should be implemented in the system. The result of the automatic checks should be obvious to the reviewer.",
              Type: "Business Process",
              Scope:
                "After all checks related to the order have been performed the final decision is made regarding execution of the order. A commitment to the customer is made. This triggers the outbound logistics, production process or service process. ",
              Outcome:
                "A decision is made to fulfil the customers order. This triggers the outbound logistics/production process. The customer is informed about the decision.",
              name: "Save and approve sales order",
              _id: 1332,
              Business_Rules:
                "Rules must be established for allocating authorization for sales order approval to users. The format of the confirmation (electronic, paper) and communication channel must be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the confirmation is provided that the customer order can be fulfilled, the product price must be calculated (or extracted from the system) taking into account relevant conditions (e.g. rebates, shipping condition, customer price groups).",
              _type: "Process",
              GUID: "197ea3f9-eaa9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "In addition to the pricing itself, the workflows and required approvals have to be defined. Consider all types of sales (priced samples, free of charge samples etc.) and possible promotions and rebates.  In case a quotation has been placed, the conditions between both should be aligned or at least an interaction with the customer has to take place in case of any deviation.",
              Type: "Business Process",
              Scope:
                "Pricing takes into account all conditions related to the product and customer.",
              Outcome:
                "Pricing and conditions related to the order are generated, documented and agreed with customer.",
              name: "Determine product price and conditions",
              _id: 157,
              Business_Rules:
                "Pricing schemas are typically defined upfront.  It must be defined who (and with which limitations) has the rights to adjust prices and conditions within the sales process.   The price and trading conditions of the product must be based on a set of guidelines that take into account:   ***Cost of product   ***Market value of product   ***Customers perceived value of product    ***Relationship with customer (rebates etc.)   ***Defined profit margin expectations  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When the goods provided on consignment have been sold, the ownership of the goods must be transferred to the customer. Since the goods are already being stored at the customers location, the movement is non-physical and represents only a change of ownership. Nevertheless an outbound delivery needs to be created to record the goods issue from consignment stock.",
              _type: "Process",
              GUID: "7f932416-7e49-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the customer provides notification that the goods have been sold, the outbound delivery is created and goods issue posted, allocating the goods as a property of the customer. ",
              Outcome:
                "Goods provided on consignment become property of the customer. This triggers the invoicing process.",
              name: "Simulate outbound delivery and post goods issue",
              _id: 156,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "In some cases issuing a pro forma invoice at the time of delivery of the fill-up might be necessary. Later, the customer invoice will than be issued with a reference to the pro forma invoice.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Consignment sales",
          _id: 155,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "7399a571-7e54-11e5-0a66-001bc640cd9b",
          Description:
            "Sales from production (MTO) scenario describes a sales process flow, in which the customer order is accepted for a product, which will only be produced after order placement. The production will be planned and executed after the final sales order is placed (make-to-order production model).  The scenario is usually applied either for products that are produced specifically to customer requirements, so they cannot easily be resold to a different customer, or for slow turning standard products to avoid unnecessary high inventory levels. Shelf life can be another reason as well as high production costs. For accepting the customer order, it is necessary to perform a capability to promise check, which verifies that the manufacturing capacity for the finished product is available and reserves it. The confirmation of the customer order directly leads to scheduling of sales order demand in the production plan.",
          _type: "Scenario",
          GUID: "b6b20962-ef2f-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of a customer invoice provides documentation of the financial obligation related to a customer order. The customer invoice is created from a sales order.",
              _type: "Process",
              GUID: "75ff0dfc-e8bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Circumstances such as required documents for customs clearance or advance payments might have an impact on the timing when an invoice needs to be created during the sales process.",
              Type: "Business Process",
              Scope:
                "After the customer order has been fulfilled, the invoice is created. It provides the customer with information required to settle the payment related to their order.",
              Outcome: "Invoice is created and sent to the customer.",
              name: "Create customer invoice",
              _id: 1363,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade compliance ensures due diligence with trade regulatory programs and cross-border customs requirements. Global trade checks are required for all business operations.",
              _type: "Process",
              GUID: "1b684ec4-44de-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The check itself is typically done automatically by the ERP system. The actual process discussion should focus on the maintenance of the relevant GTS data (including the integration of external data sources) and the handling of sales orders failing to pass the checks.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both involved business partners and products being sold or related services are subject to checks.",
              Outcome:
                "The sales order complies with the applicable trade regulations and the product can be shipped.",
              name: "Perform global trade check",
              _id: 57,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists, dual use products) used for screening is comprehensive and up to date.   Customer data must be up to date.   Rules and procedures how to handle sales orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "For customer orders related to a quotation, information from the quotation is transferred to the sales order when the customer order is received. This differs from sales processes where the source of incoming information is only the customer order itself.",
              _type: "Process",
              GUID: "7c55366c-7e54-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the customer order is placed, information from the quotation is transferred to the sales order, updated and enriched if necessary.",
              Outcome:
                "Sales order with reference to the quotation is created.",
              name: "Receive customer order and transfer quotation to sales order",
              _id: 212,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After capturing and confirming a sales order, the order fulfillment needs to be monitored. Changes in availability, confirmation dates and priorities have to be considered and reflected in the sales order. The customer needs to be informed accordingly.",
              _type: "Process",
              GUID: "397b5453-d3a1-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "From a time perspective, this process spans from the saving of the sales order to the creation, release of the delivery and invoicing.",
              Outcome:
                "Any changes are reflected in the sales order, communication and excalation procedures are triggered if necessary.",
              name: "Monitor order fulfillment",
              _id: 158,
              Business_Rules:
                "Clear guidelines need to be defined how to handle shortages, deviations from already given commitments to the customer, priority conflicts as well as rules need to be agreed on how and when, and under which sircumstances the customer can request changes to the order. ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In order to quote a price and conditions to the customer, the quotation must be created and processed. Depending on the business model this may include collecting different information and processing various checks. Base for the creation of a quotation are customer details and information from the customer inquiry.",
              _type: "Process",
              GUID: "7c55365a-7e54-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "A quotation document is prepared based on information captured in the inquiry. The sales price is calculated and conditions determined (e.g. rebates, shipping conditions, pre-payment requirements etc.). The requested quantity and delivery data is checked against production capabilities and/or production plans.A quotation document is prepared based on information captured in the inquiry. A sales price is calculated and conditions determined (e.g. rebates, shipping conditions, pre-payment requirements etc.). The requested quantity and delivery data is checked against production capabilities and/or production plans.",
              Outcome: "A quotation is prepared and can be formally processed.",
              name: "Create quotation for MTO",
              _id: 383,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "ATP check for quotation verifies whether goods related to a quotation will be available at the indicated date. The check performed is dependent on the underlying sales scenario, i.e. stocked products, assembly to order, make to order.",
              _type: "Process",
              GUID: "c046c5f1-eaa3-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Based on the product and connected sales scenario, the check is performed against stock, production capability or component availability. ",
              Outcome: "ATP check is performed.",
              name: "Check capability to promise for quotation",
              _id: 382,
              Business_Rules:
                "It must be defined:   ***How the availability check will be done   ***What type of actual stock or planned changes are considered for the availability check   ***Whether and how to reserve material / capacity",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Capable to Promise (CTP) verifies whether a customers order can be fulfilled by production within a given time frame.   .  ",
              _type: "Process",
              GUID: "bf26ba8a-eaa4-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Depending on the product structure it must be decided how many production stages are considered during the CTP check and how stock levels of intermediates are factored in.    Even more complex rules can be required in case other intermediates can be used as substitutes.",
              Type: "Business Process",
              Scope:
                "After the customer order data is captured for a make to order production, it must be checked whether the order can be fulfilled. It is verified whether capacity is available to manufacture the finished product in the requested quantity and for the desired delivery date. In doing so, it must be ensured that the order can be placed and fits into the production plan. Components might be checked directly or their availability is considered as given based on the production plan",
              Outcome: "CTP check is performed.",
              name: "Check capability to promise",
              _id: 274,
              Business_Rules:
                "It must be defined what capacity is checked and reserved:   ***Capacity at local manufacturing unit     ***Capacity at all manufacturing units owned by the global organisation   ***Capacity of external contractors      It is necessary to define what consumes capacity and therefore reduces the available capacity.    The decision should be made whether capacity can be adjusted due to consumer demand. A production campaign for a certain type of product can be extended/increased.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process describes the initial capturing and checking of an inquiry. In comparison to a lead an inquiry contains an explicit request for a quotation. Receiving the customer inquiry and capturing it in a format necessary for further processing and initiating pre-sales business processes. ",
              _type: "Process",
              GUID: "f80615ee-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "For inquiries from and quotations for new potential customers, a dummy customer master might be used. Latest with the order entry, a real customer master gets created and the sales order will be captured with reference to it.",
              Type: "Business Process",
              Scope:
                "Once a customer inquires about a certain product, the data must be recorded, stored and forwarded for further processing. ",
              Outcome:
                "All relevant information regarding the customers inquiry is documented. The information captured provides the basis for preparing a quotation or reservation of goods.",
              name: "Receive and capture customer inquiry",
              _id: 171,
              Business_Rules:
                "Rules should determine in which cases inquiries have to be documented.   There are several aspects why inquiries should be captured in the system:   ***Avoidance of duplicated capturing of data   ***Considering the information in planning   ***Internal compliance and approval guidelines   ***Using the information for reporting and identifying reasons for lost sales  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Based on received customer order the configuration of the product to be manufactured is captured. The outcome of this process serves as input for the actual manufacturing work. ",
              _type: "Process",
              GUID: "7c553669-7e54-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "MTO can use either already finally specified material masters (including routing and BOM), or need to be configured. Latter is often done using special routings with criteria for determining whether a production step is required or not and Super BOMs.   In differentiation to this case by case configuration a material variant is a material that can be kept in stock and that arises from an individual configuration of a configurable product.",
              Type: "Business Process",
              Scope:
                "Once the sales order data has been captured, the next step is to define how the product will be configured, what components will be used for production and what production tasks must be carried out. In make to order scenario it is possible that no BOM (bill of material) or routing exist and must be created in this process.",
              Outcome:
                "The product configuration and required components are defined based on the sales order.",
              name: "Configure product (MTO)",
              _id: 377,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The process describes the creation of customer specific documentation that may be requested by our customers.",
              _type: "Process",
              GUID: "56165656-7169-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The documentation may be delivered together with the goods receipt or independently from it.    The documentation may be delivered as hard copy or as an electronic version.",
              Type: "Business Process",
              Scope:
                "After the request for creating customer specific documentation has been received, the documentation is created and prepared for a shipment to the customer.",
              Outcome:
                "The customer receives specific documentation as requested.",
              name: "Prepare customer specific documentation",
              _id: 160,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the confirmation is provided that the customer order can be fulfilled, the product price must be calculated (or extracted from the system) taking into account relevant conditions (e.g. rebates, shipping condition, customer price groups).",
              _type: "Process",
              GUID: "197ea3f9-eaa9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "In addition to the pricing itself, the workflows and required approvals have to be defined. Consider all types of sales (priced samples, free of charge samples etc.) and possible promotions and rebates.  In case a quotation has been placed, the conditions between both should be aligned or at least an interaction with the customer has to take place in case of any deviation.",
              Type: "Business Process",
              Scope:
                "Pricing takes into account all conditions related to the product and customer.",
              Outcome:
                "Pricing and conditions related to the order are generated, documented and agreed with customer.",
              name: "Determine product price and conditions",
              _id: 157,
              Business_Rules:
                "Pricing schemas are typically defined upfront.  It must be defined who (and with which limitations) has the rights to adjust prices and conditions within the sales process.   The price and trading conditions of the product must be based on a set of guidelines that take into account:   ***Cost of product   ***Market value of product   ***Customers perceived value of product    ***Relationship with customer (rebates etc.)   ***Defined profit margin expectations  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Credit management helps to control the companys exposure to credit risk. Credit management must be aligned taking into account the customers liquidity and payment history (credit limit/insurance) and outstanding receivables.",
              _type: "Process",
              GUID: "5aa42fcb-e8e2-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Many corporations start looking at credit management from a group perspective. This requires some collaboration across companies and business units, which might not be established. Hierarchical credit limits might help to hinder a single business unit from already consuming the entire credit limit of a customer.  Any kind of guarantees such as letter of credit or bank guarantees and advanced payments need to be considered in this process.  Credit management for consignment fill-ups - despite goods remaining in sellers property, it is common to perform credit check, since control over goods is lost and the goods issue is typically retrospective.",
              Type: "Business Process",
              Scope:
                "The customers ability to pay for the product or service is evaluated based on their liquidity and payment history and a decision is made on whether the sale is allowed or not.",
              Outcome:
                "The decision is made on whether to proceed with sale or not.",
              name: "Execute credit management",
              _id: 1334,
              Business_Rules:
                "It is necessary to define the information necessary to execute the credit management process.  A framework must be put in place for:   ***Calculating the rating value of customers    ***Determining Credit Limit   ***Setting rules for Credit Check    ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of the sales order is given through the confirmation and represents a commitment to fulfil the order.",
              _type: "Process",
              GUID: "a98a286c-7e52-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The effectiveness of the approval-workflows often is overestimated. Sales managers will receive many approval requests daily. The data to be checked should be limited to the essentials. Everything that can be checked automatically by rules should be implemented in the system. The result of the automatic checks should be obvious to the reviewer.",
              Type: "Business Process",
              Scope:
                "After all checks related to the order have been performed the final decision is made regarding execution of the order. A commitment to the customer is made. This triggers the outbound logistics, production process or service process. ",
              Outcome:
                "A decision is made to fulfil the customers order. This triggers the outbound logistics/production process. The customer is informed about the decision.",
              name: "Save and approve sales order",
              _id: 1332,
              Business_Rules:
                "Rules must be established for allocating authorization for sales order approval to users. The format of the confirmation (electronic, paper) and communication channel must be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Quotation is a binding commitment and can deal with significant product quantities and monetary values. Therefore, it must be ensured that information included into quotation is correct and corresponds to companys interests, which is ensured through an approval process.",
              _type: "Process",
              GUID: "f806160f-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After passing all checks related to the quotation, the commercial aspects of the quotation are approved and quotation is sent to the customer.",
              Outcome: "Quotation is sent to customer.",
              name: "Approve and send out quotation",
              _id: 213,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Country specific regulations state that, above a certain quantity of chemicals and other hazardous substances, it is required to register with the authorities the maximum quantities of these substances that is planned to be purchased, imported, produced, sold, or exported within a certain period. By comparing the recorded quantities with the limit values, the system signals that a limit value is close to be exceeded if a limit value is exceeded, the system can also block the respective business process.  ",
              _type: "Process",
              GUID: "96e72960-eaa6-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Identify required Checks   ***Check if Registration Status is positive or negative   ***Check quantity limit to import / produce   ***Block order and report issue   ***Permit Order  ",
              Outcome:
                "The product complies with the chemical compliance related requirements and sales order processing is permitted.",
              name: "Perform chemical compliance check",
              _id: 159,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "O2C Sales from production (Make to order)",
          _id: 154,
          Business_Rules: "",
          Prerequisite: "",
        },
      ],
      Description:
        "The Order to Cash (O2C) domain describes the process of receiving and processing customer sales which includes the initial decision to enter the order, the process of defining the price and checking the availability, the processing and shipment of the goods, and the transactions made for receiving payment. It includes all compliance processes required for order processing and shipment.",
      _type: "Domain",
      GUID: "05699f67-6410-11e4-55cc-001bc640cd9b",
      Advisory_Notes: "",
      Type: "E2E-Domain",
      Scope: "",
      Outcome: "",
      name: "Order to Cash",
      _id: 153,
      Business_Rules: "",
      Prerequisite: "",
    },
    {
      BPMN_GUID: "93ee61b1-f4c8-11e8-2ddf-001bc640cd9b",
      scenario_of: [
        {
          BPMN_GUID: "c27749e1-f570-11e8-2ddf-001bc640cd9b",
          Description:
            "Payroll involves tasks to ensure the accurate and timely completion of employee salary payments and personnel costs, payroll tax and record-keeping compliance.",
          _type: "Scenario",
          GUID: "070d897d-f4d1-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The payroll schedule determine how often employees are paid. This can be on a weekly, bi-weekly or Monthly bases.",
              _type: "Process",
              GUID: "2db0a710-6d94-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Define one or multiple payroll schedules e.g. a bi-weekly payroll every other Friday for some employees, and a monthly payroll on the first of each month for owners and/or managers.",
              Outcome:
                "The payroll schedule in created with a defined validity date.",
              name: "Create payroll schedule",
              _id: 460,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process to execute payroll based on the payroll schedule and data.",
              _type: "Process",
              GUID: "2db0a714-6d94-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Enter payroll information, deduct payroll and withholding taxes. Approve payroll and forward payroll payment to employees.",
              Outcome: "Payroll run completed successfully.",
              name: "Run Payroll",
              _id: 458,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Before running the payroll, it is necessary to gather and enter all relevant information in the payroll system.",
              _type: "Process",
              GUID: "2db0a712-6d94-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                " Enter payroll information in payroll software for calculations. Ensure that information is correct prior to calculation of payroll taxes.",
              Outcome: "Payroll information is ready for payroll run.",
              name: "Prepare payroll run",
              _id: 443,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures that all information from payroll results are reflected in accounting components.",
              _type: "Process",
              GUID: "2db0a718-6d94-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Group posting relevant information from payroll results together, create summarized documents, and perform the relevant postings in accounting components. ",
              Outcome: "Payroll results are reflected in accounting.",
              name: "Post payroll results to Accounting",
              _id: 431,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After running the payroll it is necessary to check the results for completeness and correctness. ",
              _type: "Process",
              GUID: "2db0a716-6d94-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the payroll calculation completes successfully, view results and balances. Confirm that results are correct via reports. At each validation stage make corrections to employee data where required. ",
              Outcome: "Validity of payroll results confirmed.",
              name: "Validate payroll results",
              _id: 422,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "H2R Payroll",
          _id: 152,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "7347fcc1-f570-11e8-2ddf-001bc640cd9b",
          Description:
            "Employee performance management scenario deals with processes for measuring workload, billable hours and employee productivity.",
          _type: "Scenario",
          GUID: "4ea47800-f4cb-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensues completeness and correctness of data on employee workload.",
              _type: "Process",
              GUID: "44f60dc4-442b-11ea-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Collect information of workload via email, data entry sheet, or ad-hoc meeting with employee. Verify correctness of data by aligning with employee, and their associated project manager (s) and supervisor.",
              Outcome: "Data on employee workload complete and correct.",
              name: "Collect data and verify employee's workload",
              _id: 151,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Define measures to give an employee with performance deficiencies the opportunity to succeed. It may be used to address failures to meet specific job goals or to ameliorate behavior-related concerns.",
              _type: "Process",
              GUID: "c8a1e937-b758-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Develop draft including specifics regarding performance and measurable objectives that are achievable. Involve employees in setting performance standards.",
              Outcome:
                "After the first 90 days, a review of employee performance, goal progress, and discussions for future training should be held.",
              name: "Define performance management follow-up actions",
              _id: 150,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Productivity of the employee is evaluated taking into account target and actual working hours, as well as deliverables and tasks completed.",
              _type: "Process",
              GUID: "44f60dc8-442b-11ea-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Check actual/billable working hours against planned/target working hours. Check working hours against deliverables and completed tasks. Compile results of assessment for use in employee performance review meeting.",
              Outcome: "Employee productivity report derived.",
              name: "Assess employee productivity",
              _id: 149,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "H2R Performance management",
          _id: 148,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "a69decb1-f570-11e8-2ddf-001bc640cd9b",
          Description:
            "Deals with the processes carried out by HR to prepare, support and aid employees throughout times of organizational change.",
          _type: "Scenario",
          GUID: "4ea47808-f4cb-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Since most change occurs to improve a process, a product, or an outcome, it is critical to identify the focus and to clarify goals. This also involves identifying the resources and individuals that will facilitate the process and lead the endeavor. Most change systems acknowledge that knowing what to improve creates a solid foundation for clarity, ease, and successful implementation.",
              _type: "Process",
              GUID: "81ed23d0-e10c-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Identify changes, include perspective of employees, identify goals",
              Outcome:
                "Identification of goals, individuals that will facilitate change and creation proposal.",
              name: "Identify change focus and goals",
              _id: 414,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The change impact analysis provides accurate understanding of the implications of a proposed change, which help the teams make informed business decisions about which proposals to approve.",
              _type: "Process",
              GUID: "81ef94d3-e10c-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Evaluate change implications, identify documents for modification, identify tasks for change implementation, estimate impact/benefit and estimate cost.",
              Outcome: "Change impact analysis document ready for reporting.",
              name: "Conduct change impact analysis",
              _id: 399,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After successful distribution and authorization of the change roadmap the real process of change can start by implementing changes step by step according to the roadmap.",
              _type: "Process",
              GUID: "81ef94d5-e10c-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Try to keep schedule, resolve roadblocks and reach milestones.",
              Outcome:
                "Successful implementation of changes across the organization.",
              name: "Implement changes",
              _id: 391,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "An after-action review is a post-project analysis of what worked and what did not. This analysis results in lessons-learned for the next project or change implementation.",
              _type: "Process",
              GUID: "81ef94d9-e10c-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Consider input from employees, customers and stakeholders impacted by the change, document lessons learned.",
              Outcome:
                "Lessons-learned and changes to the change management process for the next project.",
              name: "Conduct after action review",
              _id: 384,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This is the roadmap that identifies the beginning, the route to be taken, and the destination. You will also integrate resources to be leveraged, the scope or objective, and costs into the plan. A critical element of planning is providing a multi-step process rather than sudden, unplanned sweeping changes. This involves outlining the project with clear steps with measurable targets, incentives, measurements, and analysis. For example, a well-planed and controlled change management process for IT services will dramatically reduce the impact of IT infrastructure changes on the business. There is also a universal caution to practice patience throughout this process and avoid shortcuts.",
              _type: "Process",
              GUID: "81ef94d1-e10c-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Find fitting template from roadmap tool or design your own, insert vision, values, critical goals, strategies/tactics, milestones and potential roadblocks",
              Outcome:
                "Visual roadmap ready for communicating to all members of the company",
              name: "Develop change roadmap",
              _id: 381,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After conducting the change impact analysis, results are being reported to stakeholders who then have to approve or deny the change request. ",
              _type: "Process",
              GUID: "51da3420-b8ef-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Report the impact analysis results to all stakeholders so that they can use the information to help them decide whether to approve or reject the change request",
              Outcome: "Approval/Denial by Stakholders",
              name: "Align and approve change goals with steakholders",
              _id: 378,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This step helps identifying and celebrating successes on the project. Use these celebrations and public acknowledgement to reinforce the change. Constantly seek evidence of major milestones and identify early successes even if small.",
              _type: "Process",
              GUID: "81ef94d7-e10c-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Implement corrective action, celebrate successes and reinforce the change and transfer ownership of the change to operational managers.",
              Outcome: "Successful handover to operational managers.",
              name: "Recognize success and reinforce change",
              _id: 367,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "H2R Change management",
          _id: 147,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "c70ca310-b758-11e9-0cfc-001bc641ce4f",
          Description:
            "This scenario describes the processes required for storing HR relevant knowledge data (templates, onboarding documents, operational descriptions etc).They goal of knowledge management is to create an internal file storage for HR.",
          _type: "Scenario",
          GUID: "836ca66b-f4d4-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "This describes the identification stage of HR relevant material that should be integrated into the HR knowledge base.",
              _type: "Process",
              GUID: "c8a1e911-b758-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Identify sources of knowledge, increase the ability of individuals within the organization to share relevant with others.",
              Outcome:
                "Source of knowledge and responsible persons identified.",
              name: "Discover knowledge",
              _id: 324,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This describes the process by which new information from different sources are shared and eventually can drive the creation of new knowledge.",
              _type: "Process",
              GUID: "c8a1e927-b758-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Share knowledge via communities ,self learning or via IT systems.",
              Outcome: "Enabled learning process across HR",
              name: "Share knowledge",
              _id: 318,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the maintenance of knowledge data and availability.",
              _type: "Process",
              GUID: "c8a1e922-b758-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Integrate different data sources, create and administer information.",
              Outcome: "Information, file storage updated.",
              name: "Monitor and update knowledge database",
              _id: 313,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The process by which knowledge is converted from tacit to explicit forms.",
              _type: "Process",
              GUID: "c8a1e91d-b758-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Acquire tacit knowledge internally/externally, find right tool for storing and sharing knowledge (e.g. Sharepoint/Intranet)",
              Outcome: "Successful capture of needed knowledge.",
              name: "Capture knowledge",
              _id: 302,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "H2R  Knowledge management",
          _id: 146,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "654d57f1-f570-11e8-2ddf-001bc640cd9b",
          Description:
            "Onboarding, also known as organizational socialization, refers to the mechanism through which new employees acquire the necessary knowledge, skills, and behaviors in order to become effective organizational members and insiders. It is the process of integrating a new employee into the organization and its culture.",
          _type: "Scenario",
          GUID: "4ea477fe-f4cb-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Process to ensure that new employee details are captured with the organizations benefits scheme.",
              _type: "Process",
              GUID: "5dad993a-6cb1-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Where employee benefits are set up, there is the need to inform and get the necessary information necessary to facilitate the transfer or to ensure that the benefits are made available to the employee.",
              Outcome: "Employee benefits set up completed.",
              name: "Conduct employee benefits set up",
              _id: 351,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures that the employee can access the companys electronic resources, and premises.",
              _type: "Process",
              GUID: "5dad993c-6cb1-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Set up access to the email server, and handover  hardware. Also give employee access to company premises.",
              Outcome:
                "Employee has been given access the companys electronic resources, and premises.",
              name: "Set-up and handover equipment to employee",
              _id: 350,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process ensures that the employee onboarding is condcuted according to onboarding plan.",
              _type: "Process",
              GUID: "5dad9940-6cb1-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Stick to the onboarding training plan and make the onboarding a memorable, engaging employee experience, in order to have employees who are highly committed to the organization.",
              Outcome:
                "Employee onboarding executed according to onboarding plan.",
              name: "Execute employee onboarding trainings",
              _id: 345,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process for setting the scope and schedule for employee onboadring.",
              _type: "Process",
              GUID: "5dad993e-6cb1-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "This process set expectations, outline skills and establish a clear company culture/code of conduct for the new hire. Onboarding plans can vary but setting concrete goals is essential.",
              Outcome: "Employee has been allocated an onboarding trainings.",
              name: "Plan employee onboarding trainings",
              _id: 342,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures the collection and storage of employee information in the human resources central database.",
              _type: "Process",
              GUID: "5dad9936-6cb1-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "This process covers collection of all contact,legal, statutory and tax related information about the employee. Once the information has been collected, it must be validated and stored accordingly.",
              Outcome:
                "Employee information data is stored in the human resources central database.",
              name: "Perform employee information data capture",
              _id: 340,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process to ensure that new employee details are captured in payroll.",
              _type: "Process",
              GUID: "5dad9938-6cb1-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "In this process, all the banking institutional data is maintained to ensure that the employes wages and salaries can be transferred when they are due.",
              Outcome:
                "Wages of employee can be transferred when due for payment.",
              name: "Conduct employee payroll setup",
              _id: 336,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "H2R Employee onboarding",
          _id: 145,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "e9b3d821-f570-11e8-2ddf-001bc640cd9b",
          Description:
            "Employee transfer describes the horizontal movement, temporary or permanent, within the company.",
          _type: "Scenario",
          GUID: "070d8987-f4d1-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "When an employee transfers to another location or entity, this must be managed centrally within the organisational hierarchy to ensure that the employees wages will be booked against the correct cost center for future payroll cycles.    Update employee handbook and payroll, Solicit feedback from key managers, communicate planning progress across the organization and   roll out chang  Communicate transfer across organization and updated payroll and handbooks",
              _type: "Process",
              GUID: "44f60dde-442b-11ea-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Inform stakeholders about transfer",
              _id: 144,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "44f60de0-442b-11ea-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Update employee master data",
              _id: 143,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When an employee changes his or her role within an organisation, this requires an update centrally within the organisations hierachial structure. ",
              _type: "Process",
              GUID: "5dad994b-6cb1-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Update employee documents and contracts, Solicit feedback from key managers, communicate planning progress across the organization and   roll out change",
              Outcome: "Rollout of new structure and updated employee handbook",
              name: "Update contracts",
              _id: 142,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "Either from organization or employee",
              _type: "Process",
              GUID: "44f60dd7-442b-11ea-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Inform employee about transfer",
              _id: 141,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "44f60dd9-442b-11ea-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Negotiate employee transfer conditions",
              _id: 140,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "H2R Employee transfers",
          _id: 139,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "a0c0e480-f568-11e8-2ddf-001bc640cd9b",
          Description:
            "This scenario comprises the processes for finding, evaluating, and establishing a working relationship with future employees.",
          _type: "Scenario",
          GUID: "070d8977-f4d1-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "An employment contract is an agreement between the employer and employee setting out the employees employment rights, responsibilities and duties. It forms the legal relationship between the employer and employee.",
              _type: "Process",
              GUID: "98840da3-c4d5-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Add personal info, clauses, salary and legal texts.",
              Outcome: "Contract ready for signing",
              name: "Create and send employee contract",
              _id: 138,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the prospective employee accepts the position, he or she has to undergo an orientation process.",
              _type: "Process",
              GUID: "53fa79c4-f56b-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Copy signed contract and store. ",
              Outcome: "Signed contract received from new hire.",
              name: "Receive signed contract and initiate onboarding",
              _id: 137,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Candidates must undergo interviews to determine if the candidate fits the profile which is intended for the job as per job description.",
              _type: "Process",
              GUID: "53fa79c0-f56b-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Prepare questions,assess potential, ask for solutions and make candidates comfortable.",
              Outcome: "Job offer for fitting candidate.",
              name: "Conduct job interviews",
              _id: 136,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A process of recruitment where the preferred method and medium of recruitments and selection is determined.",
              _type: "Process",
              GUID: "639863b9-f56a-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Analyze HR strategy, collect data, analyze data, setup recruitment process.",
              Outcome: "Development of suitable HR Strategy.",
              name: "Define and determine recruitment process",
              _id: 135,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process descries the search, identifying and contact of potential hires.",
              _type: "Process",
              GUID: "b8af5675-f569-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Collect candidate information, pre-screen candidates, contact and inform candidates about open positions.",
              Outcome:
                "Successful pre-screening and relationship building with candidates.",
              name: "Source candidates",
              _id: 134,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once the candidate has been selected, a job offer is made with further negotiation if necessary.",
              _type: "Process",
              GUID: "53fa79c2-f56b-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The job offer is made with the necessary salary and fringe benefits. Discussions are conducted with the potential new hire to agree on salary and benefits. ",
              Outcome: "The job is offered and salary negotiations complete.",
              name: "Offer job and negotiate salary",
              _id: 133,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Candidates are shortlisted based on predetermined criteria and a profile which must fit the job description.",
              _type: "Process",
              GUID: "639863c6-f56a-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Screen resumes based on minimum qualifications, screen resumes based on preferred qualifications and create shortlist.",
              Outcome: "Shortlist of candidates ready for interview.",
              name: "Screen and select candidates",
              _id: 132,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The definition of the job itself, often a formal job description rendered on paper, an important aspect of which is determination of the compensation to be paid.",
              _type: "Process",
              GUID: "639863b7-f56a-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Create proper job description format including title, job summary, task and responsibilities, compensation. ",
              Outcome: "Job description ready for review/approval.",
              name: "Create formal job description",
              _id: 131,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures that permission is given by the works council for hiring an employee. ",
              _type: "Process",
              GUID: "b8af5678-f569-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "During the hiring process the works council must be informed, consulted or approve certain steps as provided for by law.",
              Outcome: "Works council approves or rejects new employee hire.",
              name: "Conduct works council approval",
              _id: 130,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval process for all hiring requests created by HR.",
              _type: "Process",
              GUID: "c4b8d258-f56c-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Forward job request to management. Review by management, confirm completeness and ensure applicable requirements are met.",
              Outcome: "Job description reviewed and approved by management.",
              name: "Create and approve hiring request",
              _id: 129,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "H2R Employee hiring",
          _id: 128,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "1b1264e1-f571-11e8-2ddf-001bc640cd9b",
          Description:
            "This Scenario deals with processes for the efficient management and maintenance of growing data volumes of alumni and professional network. It also includes maintaining contact and communication with former interns and employees of all kinds.",
          _type: "Scenario",
          GUID: "070d898b-f4d1-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The label alumni program in my experience signals an internally focused calendar of activities targeting former employees. The most advanced organisations invest in alumni networks that are run by alumni relations teams who build engagement with their alumni communities through two-way communication that doesnt start on the last day in the office but is fully integrated with communications throughout the employee lifecycle starting with recruitment and induction. It may seem at odds to talk about alumni with new hires but sharing examples of successful alumni and the history of the organisation can reaffirm their decision to join.",
              _type: "Process",
              GUID: "46ac2b7e-ec09-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Create value, offer incentives and communicate",
              Outcome: "Alumni network with high engagement by its members",
              name: "Build engagement with alumni communities",
              _id: 127,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process helps you to see how successful your alumni community is.",
              _type: "Process",
              GUID: "46ac2b80-ec09-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Check alumni retention rate in online community, check attendance rate of in person event and number of incentives given and support alumni for further career development",
              Outcome:
                "Enduring relationships with employees after they left the company",
              name: "Measure impact of alumni network",
              _id: 126,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Go where your alumni are, for example LinkedIn, and administer the community regularly. Keep communication consistent and provide value.",
              _type: "Process",
              GUID: "46ac2b7a-ec09-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Approve member requests and monitor community stats.",
              Outcome: "Alumni community that is regularly updated",
              name: "Monitor alumni network",
              _id: 125,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Host in person alumni events and mixers as well as career workshops and other learning and development opportunities. Its a small investment to make in a valued former employee who may take advantage of training programs to improve their skills, because when they boomerang, it could be to return in a higher-level position than the one they left. ",
              _type: "Process",
              GUID: "46ac2b82-ec09-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Plan event, host event and ask executives to attend alumni events to create a continuation of commitment",
              Outcome:
                "In Person or online alumni events that add value in different ways",
              name: "Plan and execute alumni events",
              _id: 124,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Alumni want to stay connected to individuals and teams currently at your organisations not just between themselves. More often than not alumni networks are set up without a mechanism for alumni to reconnect with their peers still at the organisation particularly if they are arent partners or senior executives. Your current employees also want to build their own professional networks and alumni are a great audience to tap into. The easiest way to improve alumni network registration rates is to subscribe your current employees and to manage an opt out process for leavers. Raising awareness and interest in your alumni network in the 4+ weeks after the employee has resigned is a tough ask even with several prompters during the exiting process. The priorities and mindset of leavers is not always conducive to joining an alumni community. Six months after leaving however is a different story but its critical to record their preferred contacts details in the meantime",
              _type: "Process",
              GUID: "46ac2b7c-ec09-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Establish online alumni community and electronic newsletter",
              Outcome:
                "Online alumni community created (e.g.LinkedIn, Facebook)",
              name: "Establish alumni network database",
              _id: 123,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "H2R Alumni management",
          _id: 122,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "85da0401-f570-11e8-2ddf-001bc640cd9b",
          Description:
            "This scenario includes the processes to promote the professional development of the employee and ensure that staff qualification requirements are met through continuous and collaborative learning. It also deals with incentive programs, evaluation and goal management (professional and personal)",
          _type: "Scenario",
          GUID: "4ea47804-f4cb-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the handling of career development information towards the employee. ",
              _type: "Process",
              GUID: "f60b6a33-c31a-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Inform employee about possible career paths and training programs,",
              Outcome: "Find fitting career path and apply.",
              name: "Evaluate career options with employee",
              _id: 526,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the design of career paths for employees. It provides workplace flexibility, engagement  inspiration to improve  skills and employee self-development. It also  helps companies to discover and use their top talent.",
              _type: "Process",
              GUID: "51da3436-b8ef-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Get up to date and detailed picture of current workforce, establish career advancement process. Offer dual career ladders/upgrade path and communicate plan.",
              Outcome:
                "Communicate designed career paths internally and advertise them.",
              name: "Design career paths",
              _id: 514,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the training is completed it is time to evaluate and review the training process.",
              _type: "Process",
              GUID: "04cded2e-baa7-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Have touch base with employees, enter successful trainings into the system and evaluate",
              Outcome:
                "Possible adjustments to existing training programs, development of new training programs.",
              name: "Evaluate career fulfilment",
              _id: 500,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures that training programs required for HR management are designed in line with the various career paths. The processes also includes design of a mentoring framework. ",
              _type: "Process",
              GUID: "51da343c-b8ef-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Design training programs according to career path plans.",
              Outcome:
                "Detailed training programs for each designed career path.",
              name: "Design training programs",
              _id: 497,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the deployment of new training material to employees according to their career development plan.",
              _type: "Process",
              GUID: "04cded2a-baa7-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Choose the right software or other training programs, create engaging learning experiences and deliver at the right time.",
              Outcome: "On-time roll-out of training material.",
              name: "Deploy training programs",
              _id: 491,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "H2R Employee development",
          _id: 121,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "db299a51-f56c-11e8-2ddf-001bc640cd9b",
          Description:
            "This scenario covers processes to establish an employee valued corporate identity. It comprises marketing, branding, and communication measures to put in place an Employer Value Proposition (EVP)",
          _type: "Scenario",
          GUID: "070d8973-f4d1-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "This process enables the  organisation to assess its branding needs in order to derive strategies that improve its reputation internally and externally. ",
              _type: "Process",
              GUID: "c4b8d26b-f56c-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Conduct critical analysis of the organizations strengths and weaknesses. Evaluate target groups for employer branding initiatives. ",
              Outcome: "Employer branding needs analysis complete.",
              name: "Analyse internal/external employer branding",
              _id: 554,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Based on the branding needs and employee value proposition, a branding strategy is developed.",
              _type: "Process",
              GUID: "7d720701-f56f-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Develop the organizations brand mission, brand vision, and brand story, taking into account the all target groups.",
              Outcome:
                "Branding strategy is detailed and specifing of marketing activities can begin.",
              name: "Develop branding strategy",
              _id: 550,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The process for detailing an employee value proposition that will be used for branding strategy. ",
              _type: "Process",
              GUID: "c4b8d26d-f56c-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Evaluate existing perception of the organization, and determine the key selling points. Derive EVP and test it with a group of existing employees. Then test EVP on a sample group of externals. Make adjustments where required and finalise the EVP. ",
              Outcome: "Employee value proposition is derived.",
              name: "Develop employee value proposition (EVP)",
              _id: 549,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The marketing activities are defined based on the developed branding strategy.",
              _type: "Process",
              GUID: "f783a632-d579-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Process detailing required marketing activities, including developing of marketing/branding materials.",
              Outcome:
                "All marketing activities specified. All required marketing/branding materials developed.",
              name: "Detail marketing activities",
              _id: 590,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The process for detailing an employee value proposition to fit specific target groups.",
              _type: "Process",
              GUID: "c4b8d26f-f56c-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Localize EVP in order to improve candidate experience.Detail the EVP taking into account factors specific to  talent segments and markets where the organization operates.",
              Outcome: "Localised employee value proposition is derived.",
              name: "Localize employee value proposition and core messages",
              _id: 551,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "H2R Employer branding",
          _id: 120,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "f14df341-f570-11e8-2ddf-001bc640cd9b",
          Description:
            "Succession planning is the process for providing a strategic framework regarding the replacement of key employees due to position changes, retirement, exit.",
          _type: "Scenario",
          GUID: "070d8985-f4d1-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the task to identify which roles have the greatest impact on your companys performance, and what roles are also the most difficult to replace.",
              _type: "Process",
              GUID: "51da3432-b8ef-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Identify critical roles, document tasks, and define job profiles for succession planning.",
              Outcome:
                "key positions list updated and ready for succession plan preparation.",
              name: "Manage key positions list",
              _id: 482,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Prepare succession plan process is ensure that an organization is equipped for  job transition. Succession planning is helpful when a position change occurs or when new roles within the organization become available.",
              _type: "Process",
              GUID: "51da342e-b8ef-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Build talent and successors within the company, conserve knowledge, Identify needed skills for vacant position. Determine whether positions can be filled with existing staff or whether a new hire is needed.",
              Outcome: "Employee succession plan in place.",
              name: "Prepare succession plan",
              _id: 478,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures that all stakeholder are informed about the emplyee succession plan and required follow-up actions are triggered.",
              _type: "Process",
              GUID: "51da3430-b8ef-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Communicate on time, establish living framework - who needs to know what and when, Convey fair and transparent selection process, review succession plan",
              Outcome:
                "Organization is prepared for smooth and timely transition.",
              name: "Communicate succession plan",
              _id: 461,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "H2R Succession planning",
          _id: 119,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "4eb3a620-b8f7-11e9-0cfc-001bc641ce4f",
          Description:
            " This process covers processes for employee time data recording and evaluation. The relevant data is forwarded to Payroll (case of longer abscence or sickness)",
          _type: "Scenario",
          GUID: "836ca669-f4d4-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the evaluation and payment of the employee working time.",
              _type: "Process",
              GUID: "46ac2b6a-ec09-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Calculate planned times, calculate over time, update time quotes and form wages",
              Outcome: "Determined over time wages and payment",
              name: "Calculate employee working time and pay",
              _id: 2202,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The employee must request for HR planning an application for sick leave.",
              _type: "Process",
              GUID: "8cc35ea6-6d86-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Submit date of leave of absent request, categorize request, enter reason and request end date.",
              Outcome: "Absence request routed to appropriate manager",
              name: "Request employee absence",
              _id: 2201,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the recording of working times. Where applicable, working times are assigned to projects and orders.",
              _type: "Process",
              GUID: "51da3442-b8ef-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Setup timesheet based on employee profiles. Record working times on a defined bases (e.g. daily, weekly, monthly)",
              Outcome:
                "Working times recorded and filled timesheet can be generated.",
              name: "Record working time",
              _id: 615,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The request for absence is processed according to requirements of the undertaking e.g. sickness, vacation, and other absences. For instance, in case of a sick leave, a doctors note must subsequently be submitted to the health insurance companies.",
              _type: "Process",
              GUID: "8cc35eaa-6d86-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Check status of leave of absence request, check submitted documents and approve/reject absence request",
              Outcome: "Absence request approved/rejected/confirmed (sickness)",
              name: "Process employee absence",
              _id: 607,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the change of a working schedule ensuring that the system can determine the employees personal planned working time. ",
              _type: "Process",
              GUID: "51da3440-b8ef-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Specify work schedule including working days per week, and set minimum/maximum working hours per day.",
              Outcome: "Work schedule data maintained.",
              name: "Change working schedule",
              _id: 603,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Employee absences are maintained in the HR records to reflect the planned period of absence for the employee.",
              _type: "Process",
              GUID: "8cc35e9c-6d86-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Update  date of leave of absent request, update  request category, update reason and request end date.",
              Outcome: "",
              name: "Maintain absence in employee HR record",
              _id: 596,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "H2R Time & attendance management",
          _id: 118,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "12ba29e1-f571-11e8-2ddf-001bc640cd9b",
          Description:
            "Employee Termination scenario is used for an employees departure from a job. Termination may be voluntary on the employees part, or it may be at the hands of the employer, often in the form of dismissal (firing), layoff or retirement.",
          _type: "Scenario",
          GUID: "070d8989-f4d1-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "In cases where termination was made due to an infringement by the employee, it is common practice to have the employee emails and electronic correspondence archived to ensure that a clear audit trail exists when it is deemed necessary. ",
              _type: "Process",
              GUID: "5dad992e-6cb1-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Backup data and save data",
              Outcome: "Backup of employees data on company server",
              name: "Archive employee electronic correspondence",
              _id: 117,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This represents a retroactive control to ensure that all of the companys assets have been returned together with the processing of all statutory/ social / tax related contributions are processed for the exiting employee",
              _type: "Process",
              GUID: "5dad992a-6cb1-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Check completeness of returned items and forms",
              Outcome: "Termination form completed",
              name: "Process employee termination forms and related documentation",
              _id: 116,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The official termination request is made to have the employee information and data removed from the companys servers and ERP systems.",
              _type: "Process",
              GUID: "5dad992c-6cb1-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Confirm termination of employees online accounts",
              Outcome: "Accounts disabled",
              name: "Prepare Termination file and remove employee from file or register",
              _id: 115,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This interview represents an open discussion between the employees and their direct superior where both the employee and the direct superior provide retroactive insights as well as feedback on the way forward on both sides of their employment relationship.",
              _type: "Process",
              GUID: "5dad9924-6cb1-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Conduct exit interview discussing reasons for exit. Get input from employee on exit and future career aspirations.",
              Outcome: "Agreement on exit terms",
              name: "Conduct exit interview with employee",
              _id: 114,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This is necessary to promote succession planning and the transition of work related tasks which will require a hand-over. In cases of behaviour related exits an official letter is drafted highlighting the documented infringements committed by the employee, usually based on a warning system.",
              _type: "Process",
              GUID: "5dad9920-6cb1-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Schedule appointment",
              Outcome: "Meeting in calendar",
              name: "Meet with employee to manage transition",
              _id: 113,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This is done to ensure that the communication flow and channels are not disrupted as a result of the departure of the employee.",
              _type: "Process",
              GUID: "5dad9926-6cb1-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Create note for departments and distribute via appropriate channels",
              Outcome: "Employee Exit Note",
              name: "Notify all existing departments of termination",
              _id: 112,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "All administrative forms associated with the determination need to be completed together with a due diligence checklist which ensures that all material and assets which belong to the company is returned.",
              _type: "Process",
              GUID: "5dad9928-6cb1-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Notify employee about duty to return items, maintain confidentiality of passwords/trade secrets and return items",
              Outcome: "Company property returned",
              name: "Distribute termination forms and return company property",
              _id: 111,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "H2R Employee exit",
          _id: 110,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "64418850-baa4-11e9-0cfc-001bc641ce4f",
          Description:
            "This process includes the complete and integrated administration of travel expenses. As well as the integration into payroll accounting.",
          _type: "Scenario",
          GUID: "6fff3970-4a2a-11e9-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "After a trip has been done, the traveler has to complete a travel expense report.",
              _type: "Process",
              GUID: "393bd880-ba89-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Complete travel expense report including all necessary data and documents, check travel expense report and receipts and forward report to superior.",
              Outcome: "Travel expense report ready for approval.",
              name: "Create travel expense report",
              _id: 557,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "On the basis of the trip provisions set for the relevant traveler, the system determines the travel expense results, especially the amount for reimbursement. To determine the reimbursement amount, you can choose between per diem/flat rate reimbursement and reimbursement according to individual receipts for meals, accommodations and travel costs for all other categories, reimbursement on the basis of individual receipts must be used.",
              _type: "Process",
              GUID: "393bd890-ba89-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Prepare travel expense results to suit mehtod of payment chosen, reimburse traveler, create travel expense statement and send to traveler.",
              Outcome: "Reimbursed traveler plus travel expense statement",
              name: "Reimburse travel expense",
              _id: 555,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The approval of an employee trip represents the connection between trip facts entry and Travel Expenses. The approval of an employee trip is the requirement for Travel Expenses.",
              _type: "Process",
              GUID: "393bd88a-ba89-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Choose trip, check documents and receipts, approve/reject travel expenses and communicate to person who entered the trip.",
              Outcome: "Travel expense ready for settlement.",
              name: "Evaluate and approve travel expense",
              _id: 548,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the planning and booking of a business trip.",
              _type: "Process",
              GUID: "393bd872-ba89-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Plan trip, enter destination and trip time and book flight/hotel room/car rental via external reservation system.",
              Outcome: "Travel request ready for approval.",
              name: "Plan travel",
              _id: 543,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "Travel request have to be approved by superior. ",
              _type: "Process",
              GUID: "393bd876-ba89-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Make travel request and travel request approved/rejected",
              Outcome: "Approved/Rejected travel request",
              name: "Approve travel",
              _id: 538,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The settlement of trips is situated between trip approval and the transfer to Accounting, Payroll.",
              _type: "Process",
              GUID: "393bd88d-ba89-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Check approval status of trip, calculate reimbursement amount for a trip for a certain payroll period and adjust settlement settlement status.",
              Outcome: "Approved and settled trip.",
              name: "Post travel expense",
              _id: 535,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "H2R Travel cost management",
          _id: 109,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "c8b72c31-f570-11e8-2ddf-001bc640cd9b",
          Description:
            "This scenario covers the processes for providing custom benefits to employees (such as pensions, work life balance additional health insurance) The benefits processing is highly integrated with Payroll activities.",
          _type: "Scenario",
          GUID: "070d8981-f4d1-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Manage mandatory or optional benefits for employees",
              _type: "Process",
              GUID: "44f60dcf-442b-11ea-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Create employee benefits catalogue",
              _id: 586,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "44f60dd1-442b-11ea-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Ensure benefits activation",
              _id: 573,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "44f60dcd-442b-11ea-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Evaluate benefit options",
              _id: 572,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "44f60dd3-442b-11ea-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Determine benefits allocation for employees",
              _id: 563,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "H2R Benefits processing",
          _id: 108,
          Business_Rules: "",
          Prerequisite: "",
        },
      ],
      Description:
        "The Hire to Retire (H2R) domain covers processes for employee sourcing and selection, employee onboarding, and employee development.  It also comprises processes for employee compensation and exit.",
      _type: "Domain",
      GUID: "fe5a9a7c-f4c7-11e8-2ddf-001bc640cd9b",
      Advisory_Notes: "",
      Type: "E2E-Domain",
      Scope: "",
      Outcome: "",
      name: "Hire to Retire",
      _id: 107,
      Business_Rules: "",
      Prerequisite: "",
    },
    {
      BPMN_GUID: "01369fb1-ef1b-11e4-0a66-001bc640cd9b",
      scenario_of: [
        {
          BPMN_GUID: "52f6ffd1-5f8c-11e9-2ddf-001bc640cd9b",
          Description:
            "Mid-term Production Planning scenario describes the process flow of Production Planning as part of the Sales & Operations Planning alignment cycle coordinated via Master Planning.  It focusses on tactical capacity planning and plant specific resolution of capacity shortages, on escalating issues back to Master Planning as well as on preparing an initial production plan to be passed on to short-term production planning.   Material availability is less important in this scenario since Master Planning is taking care of the alignment with Procurement Planning and the availability of own produced materials is considered to be a capacity topic within this mid-term planning horizon.",
          _type: "Scenario",
          GUID: "51bfc6f4-1f23-11e9-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to align available and needed production capacities.",
              _type: "Process",
              GUID: "43d8c3bc-5f81-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After receiving production requirements from Master Planning these need to be aligned with actual available capacities within the plant. Discrepancies need to be identified for further processing.",
              Outcome:
                "Needed and available capacities have been aligned and discrepancies have been identified.",
              name: "Evaluate and align mid-term capacities",
              _id: 429,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to create an initial plant specific production plan.",
              _type: "Process",
              GUID: "3d2f2522-5f90-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "Detail level and horizon of the production plan depends on the duration of production process and volatility of business in general. In non-volatile and long-running production environments it might be sufficient to set up a production plan with monthly quantities. Other environments might need weekly or even daily quantities. Also the granularity might differ from production areas/lines down to single resources (e.g. bottleneck machines)",
              Type: "Business Process",
              Scope:
                "Transform production requirements into a comprehensive production plan for all plant specific production resources.",
              Outcome: "Plant specific production plan is created.",
              name: "Create initial mid-term plant specific production plan",
              _id: 426,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to identify available production capacities in a mid-term horizon.",
              _type: "Process",
              GUID: "7a091b4b-6053-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "Depending on the used planning software, available capacities also need to be maintained in system.",
              Type: "Business Process",
              Scope:
                "Planned available capacities of different parts of operations need to be gathered, structured and aligned. This includes but is not limited to personnel and machine resources in production operations, quality control, warehouses, logistics as well as planned maintenance activities with impact on availability of resources.",
              Outcome:
                "Planned available capacities are gathered from and aligned with different operations departments.",
              name: "Determine planned available capacities",
              _id: 430,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to analyze and brake down production requirements to the plant specific structures.",
              _type: "Process",
              GUID: "e9dd474e-60de-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                " ***It is necessary to align with Master Planning on the structure and format of the production requirements provided to Production Planning. If possible the structure used in master Planning is already usable for production planning but more often Master Planning is run on a less detailed granularity level in order to reduce complexity.  ***The needed structure of data depends on production setup, production stages, product portfolio, planning horizons and many more aspects. Sometimes it might be plant specific.",
              Type: "Business Process",
              Scope:
                "After receiving production requirements from Master Planning these need to be broken down to the actual production structures. ",
              Outcome:
                "Production requirements from Master Planning have been structured in order to prepare mid-term production planning.",
              name: "Analyze production requirements",
              _id: 428,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to adjust the initial production plan according to the results/decisions coming from Master Planning as a result of the S&OP alignment meetings.",
              _type: "Process",
              GUID: "3d2f252c-5f90-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After receiving input from Master Planning the production plan needs to be adjusted accordingly and issue resolution needs to be incorporated.",
              Outcome:
                "Production plan is aligned with mutually agreed on S&OP plan.",
              name: "Adjust mid-term plant specific production plan to S&OP alignment",
              _id: 427,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to make the most actual production plan available for MRP and capacity planning.",
              _type: "Process",
              GUID: "3d2f2530-5f90-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                " ***Short-term production plan should already be available as planned production orders in the system and should not be impacted by changes to the PIR.  ***The usage of planned independent requirements to document the production plan has the advantage to be able to use MRP logic for the BOM brake down to different production stages and even raw material requirements. Depending on the planning strategies used it might not be possible to use planned independent requirements.  ***Using planned independent requirements implies the necessity to define suitable consumption rules for incoming orders/requirements. If these rules are not defined well or forecast accuracy is poor the consumption logic will in most cases lead to bad planning results.",
              Type: "Business Process",
              Scope:
                "Most actual information is evaluated and adjustment needs are determined. Existing production requirements are checked (e.g. planned independent requirements). Also the planned production orders from short-term production plan are considered to determine the actual necessary adjustments to the mid-term plan. Production requirements are either adjusted or maintained in order to represent the aligned production plan.",
              Outcome:
                "Adjusted production plan is available as independent demands in the system.",
              name: "Maintain production plan",
              _id: 98,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to escalate production requirements back to Master Planning for which plant specific production capacity is not sufficient.",
              _type: "Process",
              GUID: "3d2f2526-5f90-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "Some plant specific issue resolutions might have an impact on other planning disciplines as well (e.g. pre-ponement of production will lead to higher demand of warehouse capacities). Whether this kind of solutions can be aligned locally or need to be escalated via Master Planning and S&OP alignment meetings needs to be defined upfront.",
              Type: "Business Process",
              Scope:
                "A summary of all capacity issues is provided to Master Planning. Partially this is meant as information on already resolved issues. More importantly the not yet resolved issues need to be escalated in order to be aligned with the other planning disciplines during Master Planning.",
              Outcome:
                "Capacity issues that need to be resolved mutually with other planning disciplines are escalated to Master Planning.",
              name: "Escalate infeasible production requirements to Master Planning",
              _id: 424,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to resolve production capacity shortages by plant specific means.",
              _type: "Process",
              GUID: "43d8c3c0-5f81-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                " ***The alignment of Production Planning and Procurement Planning during preparation of Master Planning and S&OP alignment is quite common. Especially if raw material availability is a mentionable restriction and/or subcontracting is a standard solution to resolve internal capacity issues.  ***If interdependencies are strong it might make sense to combine Production Planning and Procurement Planning and sometimes also Distribution Planning to one central Supply Planning.",
              Type: "Business Process",
              Scope:
                "For each identified capacity issue a suitable solution needs to be defined and documented. In order to resolve issues different operations departments but also other planning disciplines (e.g. Procurement Planning) might need to be involved.",
              Outcome:
                "Capacity issues have been resolved by plant specific means as far as possible.",
              name: "Resolve capacity issues with plant specific means",
              _id: 425,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to make the needed capacities available to operations departments (e.g. production, quality control, on-site logistics, maintenance) in order for them to plan/organize resources accordingly.",
              _type: "Process",
              GUID: "7a091b50-6053-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "***The capacity requirement information from mid-term production planning is most often used to trigger vacation planning and temporary workforce contracts.",
              Type: "Business Process",
              Scope:
                "Needed capacities for the different operations departments are extracted from the adjusted production plan and communicated. This includes information on decisions taken during Master Planning in order to resolve issues. ",
              Outcome:
                "Needed capacities are known by the related departments.",
              name: "Provide capacity requirements to operations",
              _id: 423,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "If interdependencies are strong it might make sense to combine Production Planning and Procurement Planning and sometimes also Distribution Planning to one central Supply Planning. ",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "F2Pl Mid-term Production Planning",
          _id: 106,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "aa131b71-2632-11e9-2ddf-001bc640cd9b",
          Description:
            "Manual sales forecast scenario describes the flow in case the demand planning is conducted by manual sales forecast for a specific business unit.",
          _type: "Scenario",
          GUID: "51bfc707-1f23-11e9-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of the clarification of Supply Chain assumptions is to be able to consider important restrictions in order to reduce later adjustment efforts.",
              _type: "Process",
              GUID: "4d8735e4-2640-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "***Even if the final consolidated forecast will be input to Master Planning it is recommended to already consider information from Supply Chain in order to adjust assumptions and restrictions before starting to work on the Sales forecast itself. ***Master planning (and subsequent all other planning disciplines) is often involved in order to provide this information (e.g. major restrictions of capacities for a certain product range).",
              Type: "Business Process",
              Scope:
                "Already known restrictions within the supply chain are retrieved and prepared as guidance for the later forecast conduction.",
              Outcome:
                "Major restrictions coming from Supply Chain are known and can be considered during forecasting.",
              name: "Clarify supply chain assumptions",
              _id: 413,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of the alignment with Research & Development (R&D) is to consider impact of running or upcoming technological and product developments on the sales figures within the forecasting horizon.",
              _type: "Process",
              GUID: "ab363ed0-2632-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "R&D impacts might be related to new product development (phase-in / phase-out), changes to existing products (incl. components, intermediates or raw materials) as well as major changes in production technology.",
              Type: "Business Process",
              Scope:
                "The derived Sales forecast is presented and explained to R&D. R&D presents running or upcoming activities in order to identify potential impacts. Identified impacts are quantified together. The forecast is adjusted accordingly and reasons are documented.",
              Outcome:
                "Impact of R&D activities has been considered in forecast.",
              name: "Align forecast with Research & Development",
              _id: 455,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to adjust the sales forecast according to insights from S&OP alignment meetings.",
              _type: "Process",
              GUID: "629eacbd-5f71-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The approved forecast is being adjusted according to decisions from mutual S&OP alignment meetings. The adjusted forecast is communicated to all related stakeholders.",
              Outcome:
                "The sales forecast has been adjusted to fit the overall and mutually aligned Sales & Operations Plan.",
              name: "Adjust sales forecast according to S&OP alignment",
              _id: 449,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to finalize the forecast and approve it for further usage in master planning.",
              _type: "Process",
              GUID: "ab363eb7-2632-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The previously aligned figures receive a last quality check. The approval process for sales forecast is run. After approval the forecast is provided to master planning.",
              Outcome:
                "The sales forecast has been approved and is available for master planning.",
              name: "Approve sales forecast",
              _id: 450,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of the alignment with the Financial Planning is to identify deviation between forecast and budget and to be able to provide early feedback on budget fulfillment.",
              _type: "Process",
              GUID: "4d8735ea-2640-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "***Some of the follow-up activities might be tasks for other planning disciplines and would then be considered again during master planning. Other identified deviations might lead to new sales, project, marketing, R&D or service activities. These should then also consider additional information from Master planning, since master planning might lead to adjusted forecast figures.   ***The comparison of budget and forecast needs to be conducted with care. Deviation can not be avoided and the extend highly depends on the process how the budget is derived. It is strongly recommended to not misuse budget figures as forecast neglecting other more actual information sources. When forecast consists of budget data only you should rather not setup any demand planning processes at all.",
              Type: "Business Process",
              Scope:
                "The derived Sales forecast is compared to budget. In case of major deviations (especially but not limited to shortfalls) main drivers are identified. The documented assumptions of the forecast might be re-evaluated or follow-up activities might be defined in order to keep up with budget. Potentially the forecast data is adjusted to cover the impact of defined countermeasures to specific budget shortfalls.",
              Outcome:
                "Deviation of forecast to budget has been identified. Potentially countermeasures have been defined or initiatives have been started to do so.",
              name: "Align forecast with financial planning",
              _id: 451,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of the alignment with projects is to consider impact of running or upcoming projects on the sales figures within the forecasting horizon.",
              _type: "Process",
              GUID: "ab363ed9-2632-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "Consideration of M&A activities could also be part of this process.",
              Type: "Business Process",
              Scope:
                "The derived Sales forecast is presented and explained to the different Project Managements or the Project Portfolio Management in order to identify potential impacts. Identified impacts are quantified together. The forecast is adjusted accordingly and reasons are documented.",
              Outcome: "Impact of projects has been considered in forecast.",
              name: "Align forecast with projects",
              _id: 453,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of the alignment with Marketing is to consider impact of running or upcoming marketing activities such campaigns on the sales figures within the forecasting horizon.",
              _type: "Process",
              GUID: "ab363eca-2632-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The derived Sales forecast is presented and explained to Marketing. Marketing presents running or upcoming activities in order to identify potential impacts. Identified impacts are quantified together. The forecast is adjusted accordingly and reasons are documented.",
              Outcome:
                "Impact of Marketing activities has been considered in forecast.",
              name: "Align forecast with marketing",
              _id: 454,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of the forecast consolidation for a specific business unit is to provide the overview on aggregated level and to prepare forecast information for the upcoming alignments.",
              _type: "Process",
              GUID: "4d8735f4-2640-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "***The actual consolidation logic depends on the granularity level the forecast is being derived in and how it is going to be used during master planning.   ***The aggregation and consolidation rules and also the planning horizons need to be aligned with other planning disciplines. This task and the orchestration of the different planning disciplines is often considered as Sales & Operations Planning.",
              Type: "Business Process",
              Scope:
                "***Single forecast inputs are gathered and a first quality check is conducted. The validated inputs are combined in order to derive the consolidated overall forecast on business unit level.  ***If needed documentation on assumptions is completed.",
              Outcome:
                "All forecast data for the respective business unit has been consolidated to one central business unit sales forecast.",
              name: "Consolidate sales forecast for business unit",
              _id: 452,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of the alignment with the Service Organization is to consider impact of running or upcoming service and after sales activities on the sales figures within the forecasting horizon.",
              _type: "Process",
              GUID: "ab363ed4-2632-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The derived Sales forecast is presented and explained to the Service Organization. The Service Organization presents running or upcoming activities in order to identify potential impacts. Identified impacts are quantified together. The forecast is adjusted accordingly and reasons are documented.",
              Outcome:
                "Impact of Service and After Sales activities has been considered in forecast",
              name: "Align forecast with service organization",
              _id: 456,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of the manual Sales forecasting is to derive and maintain the actual forecast figures on the defined aggregation level.",
              _type: "Process",
              GUID: "ab363ebb-2632-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "***It is important to document assumptions made in order to make use of this information during root-cause analyses within the review process.   ***Also for manual forecast the aggregation/calculation logic needs to be carefully defined upfront in order to avoid blind spots or double counting during later consolidation of the individual forecast values.    ***The aggregation level needs to be defined with care in order to allow for meaningful sales forecast without overly extensive efforts. Often sales forecasts are derived as monthly or quarterly figures on product type or group level per market or channel.   ***The aggregation and consolidation rules and also the planning horizons need to be aligned with other planning disciplines. This task and the orchestration of the different planning disciplines is often considered as Sales & Operations Planning.",
              Type: "Business Process",
              Scope:
                "Based on available information (e.g. market intelligence, internal sources, specific customer information) and own experience the expected Sales figures are derived, validated Sales internally and maintained within the demand planning tool.",
              Outcome:
                "Sales forecast has been derived, validated and provided to the demand planning.",
              name: "Derive manual sales forecast",
              _id: 448,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of Initiate and monitor forecasting is to trigger and monitor the forecasting activities of the actual forecast cycle.",
              _type: "Process",
              GUID: "ab363eb3-2632-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "For manual forecasting it can be helpful to provide a statistical forecast based on historic data as a starting point. Sales department can use this as basis to adjust with information from further sources (e.g. knowledge about upcoming customer agreements or ending contracts). ",
              Type: "Business Process",
              Scope:
                "***After running necessary preparations the conduction of the actual forecast cycle can be triggered by informing and instructing the different involved parties. ***The timely performance of forecasting activities as well as the provision of results needs to be closely monitored.",
              Outcome: "outcome",
              name: "Initiate and monitor forecasting",
              _id: 445,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of reviewing the last forecast is to verify taken assumptions as well as information sources and to continuously improve the forecast accuracy.  ",
              _type: "Process",
              GUID: "ab363ebf-2632-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "Insights from former forecasts need to be discussed and shared to ensure consideration in the next forecast cycle. This is especially important in case of manual forecasting.",
              Type: "Business Process",
              Scope:
                "Former forecasts are compared to actual figures. Depending on extend of deviation (forecast accuracy) root cause analyses might be conducted in order to optimize assumptions and inputs for the upcoming forecast cycles.",
              Outcome:
                "Insights from former forecast cycles have been derived and shared.",
              name: "Review former forecast cycles",
              _id: 447,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "***Aggregation levels might differ depending on business need. Instead of product groups the aggregation level might also be single products and instead of markets it might be regions, countries or single customers.   ***The aggregation and consolidation rules and also the planning horizons need to be aligned with other planning disciplines. This task and the orchestration of the different planning disciplines is often considered as Sales & Operations Planning.    *** As external information sources direct knowledge from customers or general market information might be considered. As internal information sources information from Lead-to-Opportunity, Design-to-Deploy or from After Sales & Services could be considered.   ***It is highly recommended to also address the impact of poor forecast accuracy along the supply chain and in financial terms.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "F2Pl Demand Planning with manual sales forecast",
          _id: 105,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "b011d611-65ac-11e9-2ddf-001bc640cd9b",
          Description:
            "Distribution Planning in fixed distribution network scenario shows the process flow of planning of warehouse and transport requirements based on input from Master Planning. In addition information on special stock requirements from Production Planning and decisions on sources of supply from Procurement Planning need to be considered. After analyzing the requirements a suitable distribution setup is determined and optimized within the boundaries of the existing distribution network.  The capacities of warehouses and transportation are aligned and infeasible requirements are escalated back to Master Planning. In this scenario potentially necessary network adjustments (e.g. additional warehouse locations) are not in scope of Distribution Planning but Strategic Network Planning needs to be involved via the Master Planning escalation. The taken decisions during Master Planning are incorporated into both warehouse and transport requirements. Needed guidelines are documented, relevant data is maintained and plans are provided to the Transport Management and Warehouse Management  in order to facilitate compliance with the overall distribution plan. ",
          _type: "Scenario",
          GUID: "51bfc6f6-1f23-11e9-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to align planned and existing warehouse capacities.",
              _type: "Process",
              GUID: "1cabcf58-764a-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                " ***in many industries distribution capacities are considered as infinite in this stage of planning and are resolved by operational functions during later execution.",
              Type: "Business Process",
              Scope:
                "Based on the planned distribution setup the implications on stock levels and warehouse operations (e.g. pick& pack, cross docking) are determined. These planned warehouse requirements are compared to existing capacities. Most commonly the focus lies on expected issues regarding customer service level violations.",
              Outcome:
                "Warehouse requirements and capacities are aligned and most critical issues have been identified.",
              name: "Align warehouse requirements with capacities",
              _id: 442,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to document guidelines for transport management and execution processes. This is needed in order to facilitate later compliance with the derived transport plan.  ",
              _type: "Process",
              GUID: "1cabcf62-764a-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                " ***the amount of documentation highly depends on the standardization of transport services and on the importance of transport for the company/business unit success. In environments where transport is not considered crucial part of customer service or has a very small impact on total cost, companies might rely on flexible execution processes instead of ensuring compliance to the transport plan.",
              Type: "Business Process",
              Scope:
                "Decisions taken and assumptions made during creation of the transport plan need to be documented for each transport route. This information will on the one hand be used for carrier negotiations but also during transport planning and carrier selection. Necessary service levels (e.g. number of departures per week, lead time) and carrier selection criteria could be part of these guidelines.",
              Outcome:
                "Guidelines are documented and available for Transport Management and execution processes.",
              name: "Document guidelines for transport management and execution processes",
              _id: 325,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to hand over the planning results to Warehouse Management.",
              _type: "Process",
              GUID: "e46c4389-765c-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The stock allocation plan is provided to Warehouse Management and critical topics are clarified. Focus lies on information needed to later coordinate needed warehousing resources (e.g. for pick&pack activities) or to organize interim warehouse capacities (e.g. at external warehouses to cover peaks).  But there could also be insights from Planning alignments to be transferred to Warehouse Management (e.g. mid-term increase of full pallet movement).",
              Outcome:
                "The requirements and plan have been provided and explained to Warehouse Management.",
              name: "Provide planned warehouse requirements to Warehouse Management",
              _id: 438,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to document guidelines for execution processes. This is needed in order to facilitate later compliance with the derived distribution plan.",
              _type: "Process",
              GUID: "e46c4390-765c-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Decisions taken and assumptions made during creation of the distribution plan need to be documented. Of special importance in this field is the planned allocation of products, customers and warehouses (e.g. standard delivering plant) to facilitate the compliance with planned material flows.",
              Outcome:
                "Critical decisions are documented in order to be considered during execution processes. ",
              name: "Document guidelines for distribution execution processes",
              _id: 321,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to determine a first distribution setup considering the planned distribution requirements.",
              _type: "Process",
              GUID: "1cabcf3c-764a-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                " ***the determination of distribution setup needs to rely on results and guidelines provide by Strategic Network Planning. This includes for example distribution concepts such as local, regional or global hub-and-spoke systems and maybe fixed allocation of certain markets to certain distribution centers.  ***in many industries logistics capacities are considered as infinite in this stage of planning. The contracting of additional capacities is often carried out by operative functions during logistics execution processes.   ***additional data on customer requirements (e.g.expected lead times), supplier service conditions (e.g. only full trucks as direct shipments) and product specifics (e.g. thermo transport) need to be available in order to determine feasible distribution setups.  ***it needs to be considered that decisions on stock allocation have an effect on the transport requirements due to related replenishments.  ***in the definition of transport routes several parameters need to be considered. These are for example transport mode (e.g. road, sea, air, rail), transport service type (e.g. parcel, express, groupage, LTL, FTL, milk run), truck types (e.g. cooled or heated) and other influencing factors.",
              Type: "Business Process",
              Scope:
                "The already structured distribution requirements are matched to existing distribution resources. It is decided which warehouses and storage location should be used for which products/customers. In this way the planned warehouse requirements are specified. In addition first decisions are taken on the material flows through the distribution networks. Especially direct shipments, multi-stop and cross-docking options are considered.  As a last step the resulting transport requirements are specified per transport route.",
              Outcome:
                "A first distribution setup is determined and can be used for further distribution planning.",
              name: "Determine initial distribution setup",
              _id: 434,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to optimize the distribution setup for planned distribution requirements.",
              _type: "Process",
              GUID: "1cabcf40-764a-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                " ***Distribution Planning needs to have clear targets in order to be able to optimize the planned distribution setup. These targets need to reflect the overall strategy of the company or related business unit to allow resolution of conflicts between cost and service aspects.  ***It needs to be defined to which extend Distribution Planning is allowed to adjust the distribution network. For example, if it is a valid option to plan an additional warehouse location in a certain market. This might be considered as strategic decision which should be taken in Strategic Network Planning with alignment further business functions.",
              Type: "Business Process",
              Scope:
                "The initial distribution plan is taken as a basis in order to compile different optimization options. Most commonly decisions on storage location versus transport lead time and costs (which warehouse to use) as well as transport lead time vs. cost (express freight or groupage) are reconsidered to improve overall setup. Each option is evaluated regarding different targets (e.g. customer service/lead time, transport cost, warehousing cost). Then an optimized distribution plan is derived.",
              Outcome:
                "Distribution plan has been optimized with regards to various optimization targets.",
              name: "Optimize distribution setup",
              _id: 436,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to provide Transport Management with the derived transport plan.",
              _type: "Process",
              GUID: "e46c4382-765c-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Transport Management is provided with the transport plan and critical requirements and changes to the current setup are clarified. This also includes the documented guidelines to ensure compliance to the plan.",
              Outcome:
                "Transport plan has been provided to Transport Management as basis for transport sourcing and execution processes.",
              name: "Provide transport plan to Transport Management",
              _id: 441,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to analyze distribution requirements and brake these down to different warehouse locations and transportation routes.",
              _type: "Process",
              GUID: "54233eb9-6591-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                " ***It is necessary to align with Master Planning on the structure and format of the distribution requirements provided to Distribution Planning.",
              Type: "Business Process",
              Scope:
                "After receiving distribution requirements from Master Planning these are analyzed and structured according warehouse locations and transportation routes. In addition the warehousing requirements from Production Planning especially for semi- and finished goods (e.g. inventory development due to campaign production) need to be considered as input.",
              Outcome:
                "Distribution requirements from Master Planning have been structured in order to prepare distribution planning.",
              name: "Analyze distribution requirements",
              _id: 432,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to align planned and existing transport capacities.",
              _type: "Process",
              GUID: "1cabcf44-764a-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                " ***in many industries distribution capacities are considered as infinite in this stage of planning and are resolved by operational functions during later execution.",
              Type: "Business Process",
              Scope:
                "Based on planned distribution setup the implications on transport routes are determined. These planned transport requirements are compared to existing capacities. Most commonly the focus lies on expected transport cost increases (e.g. express freigt) and on customer service level violations (e.g. lead time requirements).",
              Outcome:
                "Transport requirements are aligned with capacities and most critical issues have been identified.",
              name: "Align transport requirements with capacities",
              _id: 439,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to adjust warehouse requirements and setup a stock allocation plan according to the results/decisions coming from Master Planning as a result of the S&OP alignment meetings.",
              _type: "Process",
              GUID: "1cabcf50-764a-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After receiving input from Master Planning the warehouse requirements need to be adjusted accordingly and issue resolution needs to be incorporated. Based on this the stock allocation including projected stock levels are determined.",
              Outcome:
                "Warehouse requirements including stock allocation are determined and aligned aligned with mutually agreed on S&OP plan.",
              name: "Adjust warehouse requirements and setup stock allocation plan",
              _id: 437,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to adjust the transport requirement according to the results/decisions coming from Master Planning as a result of the S&OP alignment meetings.",
              _type: "Process",
              GUID: "1cabcf54-764a-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After receiving input from Master Planning the transport requirements need to be adjusted accordingly and issue resolution needs to be incorporated. Based on these adjusted requirements a transport plan for each transport route is determined.",
              Outcome:
                "Procurement plan is aligned with mutually agreed on S&OP plan.",
              name: "Adjust transport requirements and setup transport  plan",
              _id: 433,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to transfer the distribution plan into the data needed for automated planning functionalities (esp. material requirements planning).",
              _type: "Process",
              GUID: "e46c438c-765c-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Stock parameters (such as target, minimum and maximum stock, as well as reorder levels and replenishment leadtimes) are determined for each material and storage location. Typically the parameters are maintained in material master data in order to facilitate material requirements planning functionalities.",
              Outcome:
                "Stock parameters of related materials are up to date and reflect the aligned distribution plan.",
              name: "Maintain stock parameters in material master",
              _id: 435,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to escalate distribution requirements back to Master Planning for which distribution planning cant provide a suitable solution.",
              _type: "Process",
              GUID: "1cabcf4c-764a-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "***the scope of issue solving in Distribution Planning is most commonly restricted, since some important decisions (e.g. on new warehouses) typically do not fall under the responsibility of Distribution Planning but rather are considered as part of Strategic Network Planning (SNP). SNP is mostly involved after escalation to Master Planning and in alignment with other Supply Chain Planning functions and business functions like Sales and Corporate Strategy.",
              Type: "Business Process",
              Scope:
                "A summary of critical distribution issues is provided to Master Planning. Partially this is meant as information on already resolved issues. More importantly the not yet resolved issues (e.g. customer lead time expectations can not be met) need to be escalated in order to be aligned with the other planning disciplines during Master Planning.",
              Outcome:
                "Distribution issues that need to be resolved mutually with other planning disciplines are escalated to Master Planning.",
              name: "Escalate infeasible distribution requirements to Master Planning",
              _id: 440,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "F2Pl Distribution Planning in fixed distribution network",
          _id: 104,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "baefa391-6053-11e9-2ddf-001bc640cd9b",
          Description:
            "Short-term Production Planning scenario describes the flow of processes regarding the operational production planning level. Based on a tactical (mid-term) production plan actual demands and material availability  (MRP) and actual capacities are considered to define a short-term production plan which provides the basis for detailed scheduling.  In short-term production planning the alignment with operations and other planning disciplines to resolve issues is important to consider.  Also providing feedback to Master Planning in order to inform about operational impact on mid- and long-term planning is part of this scenario. ",
          _type: "Scenario",
          GUID: "7a091b42-6053-11e9-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to evaluate and align impact of short-term changes to the production plan with impacted operations and related planning disciplines.",
              _type: "Process",
              GUID: "22a192d2-605d-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Changes to the production plan are evaluated with regards to potential impact on operations areas (e.g. production operations, procurement, warehouse operations, transport management, on-site logistics, maintenance). Changes and impact are aligned together and agreements are made in order to resolve potential issues. In case of need the related short-term to mid-term planning disciplines (e.g. procurement planning, distribution planning) are involved in order to check the impact on their plan.",
              Outcome:
                "Impact of adjustments is evaluated and solutions have been aligned.",
              name: "Align adjustment needs with related planning disciplines and operations",
              _id: 103,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to make (planned) production orders available to scheduling and declare the planning as finalized.",
              _type: "Process",
              GUID: "22a192cc-605d-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                " ***The logic and rules for handover of planned production orders to scheduling/production needs to be defined depending on the scheduling requirements and overall planning procedure.   ***Often fixation or a certain frozen horizon is used to determine those planned elements ready for scheduling. Frozen horizon is many times related to the creation of production orders from planned orders.   ***When defining the handover procedure from planning to scheduling one should also define the handover from scheduling to production. Also here a frozen horizon might make sense.",
              Type: "Business Process",
              Scope:
                "The planned production orders updated during MRP and capacity planning need to be released to scheduling. ",
              Outcome:
                "Planned production orders are available for detailed scheduling and are no longer in the responsibility of planning.",
              name: "Hand-over production orders to scheduling",
              _id: 102,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Effective short term production planning must be based on the most accurate data available, this can be ensured by regularly revising and updating the independent demands from both sales forecasts as well as actual demands from customer orders.       ",
              _type: "Process",
              GUID: "eb3c00f1-7f1f-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The basis for demand calculation must be defined. Typical setups are based on demand forecasts, actual demand, or a combination of both.    ",
              Type: "Business Process",
              Scope:
                "Demand information from sales and operations planning, which is taken as initial base for detailed production scheduling is usually based on sales forecast and historical sales data. The demand for finished products must be revised at this stage, the actual demand (firm customer orders) considered and a final demand provided as input to enable analysis of material requirements and generation of detailed production schedules.",
              Outcome:
                "Actual demand for finished products is considered and information for creation of detailed production schedules is updated.  ",
              name: "Revise and update independent demands",
              _id: 101,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to update existing and new planned production orders according to most actual MRP and capacity information. ",
              _type: "Process",
              GUID: "3d2f2549-5f90-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                " *** Production Planning and Production Operations need to define clear rules on frozen horizons within which production orders are no longer subject to adjustments. Common practice is to use the creation of production orders from planned orders as cut-off point. From this point in time, planning is considered to be finalized and there should be no further changes to the production orders.",
              Type: "Business Process",
              Scope:
                "The planned production orders are updated with regards to for example quantity, date or production version.",
              Outcome: "Planned production orders are up to date.",
              name: "Adjust planned production orders based on MRP and capacity planning",
              _id: 100,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Material requirements planning (MRP) helps to ensure the availability of all materials (raw materials, semifinished goods) required for production or other use in the right quantity and on time.",
              _type: "Process",
              GUID: "817029ee-7eff-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Material requirements planning (MRP) requires bills of materials and material lead times to be defined and correctly maintained. The MRP schedule must be defined regularly.   There are many different MRP strategies available for planning driven and consumption driven material approaches.   The identified materials requirement can be the triggering event for this process. Other triggering events can be: ***Production order created ***Independent demand revised and updated ***Rework production order created ***Refilling/Re-packaging process order created ***Campaign scheduling completed ***Dependent demand revised and updated",
              Type: "Business Process",
              Scope:
                "In stepwise production scheduling procedure after defining finished product demand for the planning period, material requirements planning must be performed to compare demand with current stocks and planned manufacturing, identify final products to be manufactured, analyze, what materials, in what quantity and when are required for the manufacturing and propose production and purchasing schedule (material requirements planning assumes infinite production capacity).",
              Outcome:
                "As a result of material requirements planning, the recommended production schedule is created together with planned orders. In parallel, a recommended purchasing schedule for materials required for production but not available on stock is needed.",
              name: "Perform and evaluate material requirements planning",
              _id: 1228,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Material requirements planning assumes infinite production capacity, therefore its outcome - recommended production schedule - is often unrealistic. Actual production capacity must be evaluated, to identify if the required capacity does not exceed work centers defined capacity limits in a given time period. ",
              _type: "Process",
              GUID: "712673d6-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Production capacity is often checked for bottleneck work centers or key work centers only.   It should also be defined on which granularity capacity should be leveled.  In less time sensitive environments, it might be sufficient to look at the weekly load not considering individual days of overload.",
              Type: "Business Process",
              Scope:
                "Recommended production schedule from MRP must be combined with information from routing sheets about work centers and working hours required to meet production plan, by taking into account also setup times. This allows to accurately determine the required capacity at each work center during each time period and to identify problem areas - overcommitment of resources.",
              Outcome:
                "Recommended production schedule revised by taking into account actual capacity constraints, bottlenecks and overcommitment of resources identified.  ",
              name: "Evaluate and align capacity",
              _id: 1347,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to obtain an overview of actually available capacities and to maintain these as basis for capacity leveling.",
              _type: "Process",
              GUID: "22a192b1-605d-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                " ***The quality of data on actually available capacities is a key driver for overall planning and scheduling accuracy. Especially when using advanced planning solutions the automatic planning functions and alert mechanisms are depending on this data.  ***The granularity level of capacity evaluation highly depends on the time sensitivity and on the utilization of production.  ***Within environments with clear bottlenecks, focussing on these areas is a common way to reduce complexity of planning.",
              Type: "Business Process",
              Scope:
                "Available capacity for all relevant resources need to be clarified, aligned and maintained. This include production lines/ machines, special equipment but also personnel resources from different operations areas (e.g. production, quality control, warehouses, logistics).",
              Outcome:
                "Actual available capacities are known to Production Planning and are maintained for capacity planning.",
              name: "Determine actual available capacities",
              _id: 99,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to make the most actual production plan available for MRP and capacity planning.",
              _type: "Process",
              GUID: "3d2f2530-5f90-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                " ***Short-term production plan should already be available as planned production orders in the system and should not be impacted by changes to the PIR.  ***The usage of planned independent requirements to document the production plan has the advantage to be able to use MRP logic for the BOM brake down to different production stages and even raw material requirements. Depending on the planning strategies used it might not be possible to use planned independent requirements.  ***Using planned independent requirements implies the necessity to define suitable consumption rules for incoming orders/requirements. If these rules are not defined well or forecast accuracy is poor the consumption logic will in most cases lead to bad planning results.",
              Type: "Business Process",
              Scope:
                "Most actual information is evaluated and adjustment needs are determined. Existing production requirements are checked (e.g. planned independent requirements). Also the planned production orders from short-term production plan are considered to determine the actual necessary adjustments to the mid-term plan. Production requirements are either adjusted or maintained in order to represent the aligned production plan.",
              Outcome:
                "Adjusted production plan is available as independent demands in the system.",
              name: "Maintain production plan",
              _id: 98,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "F2Pl Short-term Production Planning",
          _id: 97,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "1cb40411-5f76-11e9-2ddf-001bc640cd9b",
          Description:
            "Master Planning (forecast driven) scenario describes the process flow of master planning based on Demand Plans in case only one plant needs to be considered. The scenario considers production and procurement rather as limitation than distribution. Therefore production and procurement plans are first aligned based on the demand plan before distribution planning is involved. Master planning also includes the conduction of Sales & Operations Planning alignment meetings and the distribution of the mutually agreed on plan.",
          _type: "Scenario",
          GUID: "51bfc6f0-1f23-11e9-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to provide production requirements from sales forecast to Production Planning.",
              _type: "Process",
              GUID: "73a8306b-5f77-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Requirements data is provided to the Production Planning and clarification needs are resolved to facilitate planning.",
              Outcome:
                "Production capacity requirements are known to Production Planing and available for further planning.",
              name: "Provide and explain requirements to Production Planning",
              _id: 401,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is provide requirements data to distribution planning.",
              _type: "Process",
              GUID: "73a83089-5f77-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "*** The brake down logic from sales forecast to distribution requirements depends on the actual setup of  production facilities (own production, sub contractors) on the distribution network setup (location of plants, warehouses, suppliers and customers) and special requirements either customer or product related (e.g. temperature based transport, storage of hazardous material) . *** The detail-level of distribution requirements should correspond to the detail-level of distribution planning. Both with regards to special requirements as well as accumulation level on a timeline (e.g. yearly, quarterly, monthly or weekly requirements) *** Necessity to de-consolidate depends on the overall distribution situation. For some customers a detailed procurement plan might not be necessary (e.g. EXW contracts). Details need to be aligned together with Distribution Planning.",
              Type: "Business Process",
              Scope:
                "Forecast data is broken down according to warehousing and transportation structures into requirements for distribution. In addition information about make or buy decisions (e.g. own production vs. subcontracting) is being included.",
              Outcome:
                "Distribution requirements are available for further planning.",
              name: "Brake down demand plan and information from make or buy cases into distribution requirements",
              _id: 400,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to provide requirements from sales forecast to Distribution Planning.",
              _type: "Process",
              GUID: "73a83086-5f77-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Requirements data is provided to the Distribution Planning and clarification needs are resolved to facilitate planning.",
              Outcome:
                "Distribution requirements are known to Distribution Planning and available for further planning.",
              name: "Provide and explain requirements to Distribution Planning",
              _id: 408,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is de-consolidate the forecast and prepare it for production planning.",
              _type: "Process",
              GUID: "73a83067-5f77-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "*** The brake down logic from sales forecast to capacity requirement depends on the actual structure of products, the production setup of the plant and of the different production lines/areas. *** The detail-level of capacity requirements should correspond to the detail-level of production planning. Both with regards to usage of resources and equipments including availability of details in master data (e.g. from work plans / recipes) as well as accumulation level on a timeline (e.g. yearly, quarterly, monthly or weekly capacities) *** Necessity to de-consolidate depends on the overall capacity utilization. In some cases it might be sufficient to focus on bottleneck areas only. This needs to be decided together with production planning.",
              Type: "Business Process",
              Scope:
                "Forecast data is broken down according to the structure of the products and the product specific production process in order to determine the capacity requirements.",
              Outcome:
                "Production capacity requirements are available for further planning.",
              name: "Brake down demand plan into production requirements",
              _id: 403,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to provide procurement requirements from sales forecast to Procurement Planning.",
              _type: "Process",
              GUID: "fa5b7803-5f7d-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Procurement requirements data is provided to the Procurement Planning and clarification needs are resolved to facilitate Procurement Planning.",
              Outcome:
                "Procurement requirements are known to Procurement Planning and available for further planning.",
              name: "Evaluate and decide on make or buy cases with Production and Procurement Planning",
              _id: 405,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to receive feedback from Distribution Planning with regards to feasibility of forecasted requirements.",
              _type: "Process",
              GUID: "43d8c39c-5f81-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "A typical critical aspect which distribution planning could escalate towards master planning is a insufficient space in a certain warehouse.",
              Type: "Business Process",
              Scope:
                "Distribution Planning provides feedback and planning details back to Master Planning with a special focus on critical aspects and/or impact on other planning disciplines.",
              Outcome:
                "Distribution plan and critical aspects are known to Master Planning.",
              name: "Receive feedback from distribution planning",
              _id: 410,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is de-consolidate the forecast and prepare it for procurement planning.",
              _type: "Process",
              GUID: "73a8307c-5f77-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "*** The brake down logic from sales forecast to procurement requirement depends on the actual structure of products (e.g. bill of material, potential substitution). *** The detail-level of procurement requirements should correspond to the detail-level of procurement planning. Both with regards to raw material structures (e.g. raw material classification) as well as accumulation level on a timeline (e.g. yearly, quarterly, monthly or weekly requirements) *** Necessity to de-consolidate depends on the overall procurement situation. For some materials a detailed procurement plan is not necessary (e.g. piped water). Details need to be aligned together with Procurement Planning.",
              Type: "Business Process",
              Scope:
                "Forecast data is broken down according to the structure of the products into requirements of procured material (e.g. raw materials).",
              Outcome:
                "Procurement requirements are available for further planning.",
              name: "Brake down demand plan into procurement requirements",
              _id: 412,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to prepare the Sales & Operations Planning alignment meetings.",
              _type: "Process",
              GUID: "fa5b781c-5f7d-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "*** Depending on the complexity of the Supply Chain and the amount and nature of issues mentioned by the different planning disciplines it might be necessary to run further cycles of alignment between Production, Procurement and Distribution before entering the alignment meetings. Sometimes it might even be necessary to involve more strategic planning areas (e.g. strategic network planning) in order to prepare solutions to critical aspects within the different plans.",
              Type: "Business Process",
              Scope:
                "In order to prepare Sales & Operations Planning alignment meetings the plans of Sales, Production, Procurement and Distribution need to be consolidated. Furthermore invitations need to be prepared and participation of the different stakeholders need to be ensured. Decision points need to be prepared and shared upfront in order to facilitate decision making during the S&OP meetings.",
              Outcome: "S&OP alignment meetings have been prepared.",
              name: "Prepare Sales & Operations Planning alignment meetings",
              _id: 421,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to provide procurement requirements from sales forecast to Procurement Planning.",
              _type: "Process",
              GUID: "73a83076-5f77-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Requirements data is provided to the Procurement Planning and clarification needs are resolved to facilitate planning.",
              Outcome:
                "Procurement requirements are known to Procurement Planning and available for further planning.",
              name: "Provide and explain requirements to Procurement Planning",
              _id: 407,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to receive feedback from Production Planning with regards to feasibility of forecasted requirements.",
              _type: "Process",
              GUID: "fa5b7815-5f7d-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "A typical critical aspect which production planning could escalate towards master planning is insufficient production capacity within specific production areas / concerning specific product groups (either personnel or equipment based).",
              Type: "Business Process",
              Scope:
                "Production Planning provides feedback and planning details back to Master Planning with a special focus on critical aspects and/or impact on other planning disciplines.",
              Outcome:
                "Production plan and critical aspects are known to Master Planning.",
              name: "Receive feedback from production planning",
              _id: 402,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to receive and understand sales forecasts of different business units.",
              _type: "Process",
              GUID: "73a83063-5f77-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "*** The consolidation of different sales forecasts of different business units is especially relevant in case of mutually used resources either in sourcing (same raw material or suppliers), in production (same production lines) or in distribution (same warehouses or transportation means).",
              Type: "Business Process",
              Scope:
                "Receiving the approved sales forecasts from all relevant business units some of the data might need clarification in order to be interpreted the right way. Only after understanding the forecast data this can be used for master planning.",
              Outcome:
                "Business specific sales forecasts have been received and clarification needs have been resolved.",
              name: "Review demand plan of different business units",
              _id: 446,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to provide procurement requirements from sales forecast to Procurement Planning.",
              _type: "Process",
              GUID: "fa5b7807-5f7d-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Requirements data is provided to the Procurement Planning and clarification needs are resolved to facilitate planning.",
              Outcome:
                "Procurement requirements are known to Procurement Planning and available for further planning.",
              name: "Consolidate production plan and procurement plan",
              _id: 411,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to conduct different Sales & Operations Planning alignment meetings.",
              _type: "Process",
              GUID: "c4955b22-5f6c-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "*** The detailed sequence of alignment and the actual constitution of meetings highly depends on the business structures and supply chain setups. It is not possible to show a best practice as reference. It might be necessary to run cascaded meetings from global, regional to local level or vice-a-versa and maybe consider different meetings for different business units as well. *** In some cases it might even be necessary to review and adjust certain plans in between the alignment meetings and then align again afterwards.",
              Type: "Business Process",
              Scope:
                "In order to create sound Sales & Operations Planning results different Supply Chain Planning disciplines need to come together, align and make adjustments to the different single plans in order to achieve an overall feasible mutual Sales & Operations Plan.",
              Outcome:
                "Mutually agreed on and feasible Sales & Operations Plan has been defined and single Supply Chain discipline plans have been adjusted accordingly.",
              name: "Conduct Sales & Operations Planning alignment meetings",
              _id: 419,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is consolidate sales forecasts of different business units into one sales forecast for the specific plant.",
              _type: "Process",
              GUID: "629eacc5-5f71-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "*** The consolidation of different sales forecasts of different business units is especially relevant in case of mutually used resources either in sourcing (same raw material or suppliers), in production (same production lines) or in distribution (same warehouses or transportation means).",
              Type: "Business Process",
              Scope:
                "After receiving the approved sales forecasts from all relevant business units the data needs to be consolidated in order to create one mutual sales forecast for the relevant plant.",
              Outcome:
                "One consolidated business unit overarching sales forecast for the relevant plant has been set up.",
              name: "Consolidate demand plans of different business units",
              _id: 444,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to receive feedback from Procurement Planning with regards to feasibility of forecasted requirements.",
              _type: "Process",
              GUID: "43d8c396-5f81-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "A typical critical aspect which procurement planning could escalate towards master planning is a insufficient source of supply for certain raw materials.",
              Type: "Business Process",
              Scope:
                "Procurement Planning provides feedback and planning details back to Master Planning with a special focus on critical aspects and/or impact on other planning disciplines.",
              Outcome:
                "Procurement plan and critical aspects are known to Master Planning.",
              name: "Receive feedback from procurement planning",
              _id: 409,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is summarize and distribute the aligned plan after decision taken during S&OP alignment meetings.",
              _type: "Process",
              GUID: "fa5b7820-5f7d-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The detailed sequence of alignment and the actual constitution of meetings highly depends on the business structures and supply chain setups. It is not possible to show a best practice as reference.",
              Type: "Business Process",
              Scope:
                "Different taken decisions need to be summarized including the impact on different planning disciplines. The mutual plan needs to be adjusted according to these decisions and then distributed to all planing disciplines as basis for operationalization.",
              Outcome:
                "Mutual plan is distributed and available for all planning disciplines.",
              name: "Distribute mutual plan to different planning disciplines",
              _id: 404,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "F2Pl Master Planning (forecast driven)",
          _id: 96,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "9d52d111-61eb-11e9-2ddf-001bc640cd9b",
          Description:
            "Procurement Planning scenario shows the process flow of mid-term procurement planning based on the procurement requirements of a specific plant derived during Master Planning. After analyzing the requirements supplier capabilities to deliver the necessary materials need to be ensured. Issues need to be escalated back to Master Planning.  Typically Production Planning is the most closely related supply chain planning discipline. Alignment with Production Planning needs to be ensured especially when escalating issues to Master Planning and whenever adjusting procurement plans. Procurement planning also includes the definition of rules for selection of source of supply as a guidance for operational procurement. ",
          _type: "Scenario",
          GUID: "51bfc6f2-1f23-11e9-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to transfer the distribution plan into the data needed for automated planning functionalities (esp. material requirements planning).",
              _type: "Process",
              GUID: "e46c438c-765c-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Stock parameters (such as target, minimum and maximum stock, as well as reorder levels and replenishment leadtimes) are determined for each material and storage location. Typically the parameters are maintained in material master data in order to facilitate material requirements planning functionalities.",
              Outcome:
                "Stock parameters of related materials are up to date and reflect the aligned distribution plan.",
              name: "Maintain stock parameters in material master",
              _id: 435,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to align available and needed supply capacities.",
              _type: "Process",
              GUID: "1afd612a-61ec-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After receiving requirements from Master Planning these need to be aligned with actual available capacities of source of supplies. Discrepancies need to be identified for further processing.",
              Outcome:
                "Needed and available supply capacities have been aligned and discrepancies have been identified.",
              name: "Evaluate and align capacities of supply sources",
              _id: 394,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to define needed rules on how to choose the source of supply during actual procurement activities.",
              _type: "Process",
              GUID: "1afd6134-61ec-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "* in a multi-plant setup it needs to be determined which plant is allowed to order raw materials at a supplier and which should order raw materials via intercompany replenishment setups.",
              Type: "Business Process",
              Scope:
                "For all cases with multiple possible suppliers the rules for choosing source of supply are defined. This includes consideration of existing contracts with suppliers, alignment with Purchasing on impacts to new contracts and results into source of supply settings in the system (e.g. favorite SoS, fair-share rules or certain quotas per supplier). In addition intercompany supply needs to be considered as possible option. Sometimes even externally sourced products might be supplied internally via intercompany in order to improve external supply set up by bundling the sourcing from a certain supplier to one of the plants.",
              Outcome: "Determination rules for source of supply are defined.",
              name: "Determine rules for source of supply decisions",
              _id: 307,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to create an initial procurement plan.",
              _type: "Process",
              GUID: "1afd6124-61ec-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "Detail level and horizon of the procurement plan depend on the procurement lead times and the utilization level of storage facilities. In case of very tight storage capacities, the planning of inventories needs to be paid more attention and detail level might need to consider weekly or even daily buckets. ",
              Type: "Business Process",
              Scope:
                "Transform procurement requirements into a comprehensive procurement plan showing when to procure which quantity from which source of supply. This includes the definition of rules in case of multiple source of supplies for the same material.",
              Outcome: "Initial procurement plan is set up.",
              name: "Create initial procurement plan",
              _id: 397,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to make the planned procurement activities known to the operative Procurement team.",
              _type: "Process",
              GUID: "1afd6127-61ec-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Different responsible Procurement teams are informed about the planned procurement activities with focus on important upcoming changes (e.g. certain new rules for source of supply determination) and most critical situation in the mid-term horizon (e.g. special peak demands that need tight monitoring).",
              Outcome:
                "Procurement requirements and plan are known to Procurement.",
              name: "Provide procurement plan to Procurement",
              _id: 392,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to adjust the initial procurement plan according to the results/decisions coming from Master Planning as a result of the S&OP alignment meetings.",
              _type: "Process",
              GUID: "e7888671-61e5-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After receiving input from Master Planning the procurement plan needs to be adjusted accordingly and issue resolution needs to be incorporated. The resulting Production Planning after S&OP alignment should be considered as input for procurement planning since it will provide additional details on required raw material, components and subcontracted materials.  ",
              Outcome:
                "Procurement plan is aligned with mutually agreed on S&OP plan.",
              name: "Adjust procurement plan to S&OP alignment",
              _id: 396,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to analyze procurement requirements and brake these down to certain categories and suppliers.",
              _type: "Process",
              GUID: "e788866b-61e5-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                " ***It is necessary to align with Master Planning on the structure and format of the procurement requirements provided to Procurement Planning.",
              Type: "Business Process",
              Scope:
                "After receiving procurement requirements from Master Planning these are analyzed and structured according to categories and suppliers. ",
              Outcome:
                "Procurement requirements from Master Planning have been structured in order to prepare procurement planning.",
              name: "Analyze procurement requirements",
              _id: 395,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to escalate procurement requirements back to Master Planning for which procurement planning cant provide a suitable supply.",
              _type: "Process",
              GUID: "e788866e-61e5-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "A summary of all procurement issues is provided to Master Planning. Partially this is meant as information on already resolved issues (e.g. additional storage location to cover certain peaks). More importantly the not yet resolved issues (e.g. suppliers cant delivery sufficient material) need to be escalated in order to be aligned with the other planning disciplines during Master Planning. Typically Production Planning is the most closely related supply chain planning discipline. Alignment with Production Planning needs to be ensured especially when escalating issues to Master Planning and when adjusting procurement plans.",
              Outcome:
                "Procurement issues that need to be resolved mutually with other planning disciplines are escalated to Master Planning.",
              name: "Escalate infeasible procurement requirements to Master Planning",
              _id: 398,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to identify the most suitable source of supply for each procurement requirement.",
              _type: "Process",
              GUID: "1afd612e-61ec-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "***At this point in time there can be more then one source of supply for each procurement requirement. The selection of the source of supply will typically be done during actual Procurement activity based on rules, that need to be defined in a later stage of Procurement Planning scenario.",
              Type: "Business Process",
              Scope:
                "Structured procurement requirements are matched with known sources of supply. Missing sources of supply are identified and escalated to Purchasing. ",
              Outcome:
                "Procurement requirements are matched with sources of supply.",
              name: "Match requirements with sources of supply",
              _id: 393,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is to resolve production capacity shortages by plant specific means.",
              _type: "Process",
              GUID: "e7888668-61e5-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                " ***The alignment of Production Planning and Procurement Planning during preparation of Master Planning and S&OP alignment is quite common. Especially if raw material availability is a mentionable restriction and/or subcontracting is a standard solution to resolve internal capacity issues.  ***If interdependencies are strong it might make sense to combine Production Planning and Procurement Planning and sometimes also Distribution Planning to one central Supply Planning.",
              Type: "Business Process",
              Scope:
                "For each identified capacity issue a suitable solution needs to be defined and documented. In order to resolve issues different suppliers but also other planning disciplines (e.g. Production Planning) might need to be involved.",
              Outcome: "Supply issues have been resolved.",
              name: "Clarify capacity issues with suppliers",
              _id: 306,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "F2Pl Procurement Planning",
          _id: 95,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "NULL",
          Description:
            "Statistical sales forecast scenario describes the flow in case the demand planning is conducted by running statistical algorithms to generate sales forecast data for a specific business unit. This generated data then needs to be validated and aligned in order to adjust the forecast to input parameters not reflected in the calculations models.",
          _type: "Scenario",
          GUID: "c670cb32-28a0-11e9-2ddf-001bc640cd9b",
          Advisory_Notes:
            "***Aggregation levels might differ depending on business need. Instead of product groups the aggregation level might also be single products and instead of markets it might be regions, countries or single customers.   ***The aggregation and consolidation rules and also the planning horizons need to be aligned with other planning disciplines. This task and the orchestration of the different planning disciplines is often considered as Sales & Operations Planning.    *** As external information sources direct knowledge from customers or general market information might be considered. As internal information sources information from Lead-to-Opportunity, Design-to-Deploy or from After Sales & Services could be considered.   ***It is highly recommended to also address the impact of poor forecast accuracy along the supply chain and in financial terms.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "F2Pl Demand Planning with statistical sales forecast",
          _id: 94,
          Business_Rules: "",
          Prerequisite: "",
        },
      ],
      Description:
        "The Forecast to Plan (F2Pl) domain describes processes required for forecasting and planning customer demands and the respective material supply. The focus of the domain lies on the manufacturing industry and on the interaction of different planning disciplines. F2Pl domain is based on a planning reference landscape consisting of demand, procurement, production and distribution planning as well as the bridging element of master planning. The orchestration of these planning disciplines is handled by the sales & operations planning function.",
      _type: "Domain",
      GUID: "964b5c38-642b-11e4-55cc-001bc640cd9b",
      Advisory_Notes: "",
      Type: "E2E-Domain",
      Scope: "",
      Outcome: "",
      name: "Forecast to Plan",
      _id: 93,
      Business_Rules: "",
      Prerequisite: "",
    },
    {
      BPMN_GUID: "8e90a1c1-ef21-11e4-0a66-001bc640cd9b",
      scenario_of: [
        {
          BPMN_GUID: "84136161-7e0f-11e5-0a66-001bc640cd9b",
          Description:
            "Staging for production directly from vendor represents the process flow when raw materials and semi-finished products required for production are directly placed into a staging area for consumption at the time the materials are received from the supplier. The scenario hence bypasses any storage in the organizations warehouse. Typically this scenario is applied in just-in-time production models, in other integrated logistics concepts, or where handling via a warehouse is not possible/reasonable. Such optimized material flows often include that quality inspections have already taken place at the suppliers location or are done by the supplier based on the specifications and commercial agreements.",
          _type: "Scenario",
          GUID: "04fce3a2-ef28-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "During unloading, a first verification of goods is supported by label scanners or radio frequency scanners. Labels are agreed between the supplier and the receiving party before shipment. A paper-based variant of the process must be possible for exceptional cases.",
              _type: "Process",
              GUID: "889f619b-e803-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Goods are unloaded and compared against the shipping documents. A first visual check is performed.",
              Outcome: "Goods are unloaded and available for goods receipt.",
              name: "Unload goods",
              _id: 85,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In this process a truck about to enter the site and its driver are checked for suitability, e.g. purpose for entering the site, state of the vehicle. This includes the registering procedure (e.g. capturing drivers name and license plate).",
              _type: "Process",
              GUID: "057b285c-7caa-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Alignment of transportation planning and actual vehicle movements in addition to site entry controls for trucks.",
              Outcome:
                "Vehicle and persons entering the site have been registered and considered suitable to fulfill their pick-up or delivery task. Driving route and unloading/pick-up location have been communicated and the recipient at the (un-) loading location has been informed.",
              name: "Check-in truck",
              _id: 59,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The process describes the maintenance of the forecast delivery schedule containing requirements concerning delivery quantities and dates for regularly purchased material from a vendor. The forecast is transmitted to the vendor for incorporation into their planning.",
              _type: "Process",
              GUID: "59938f35-7e0f-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The forecast delivery schedule must be submitted to the vendor in regular intervals defined by a scheduling agreement for specific components.    The following questions need to be answered: ***Who is the recipient for the forecast information? ***How are the documents submitted (EDI, Email etc.)? ***What information is required? ***Who communicates with the vendor?",
              Type: "Business Process",
              Scope:
                "Create forecast delivery schedule and transmit to vendor.",
              Outcome:
                "The current forecast delivery schedule is submitted to the vendor.",
              name: "Create forecast delivery schedule and provide to vendor",
              _id: 92,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process contains the planning of inbound warehouse activities related to either vendor deliveries or customer returns. ",
              _type: "Process",
              GUID: "8710390a-7caa-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The inbound receipt schedule includes information on shipment of goods and additional information related to the shipment, such as order information, product description, physical characteristics, type of packaging, markings, carrier information, and configuration of goods within the transportation equipment.",
              Outcome: "Inbound receipt schedule is current and comprehensive.",
              name: "Update inbound receipt schedule",
              _id: 88,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In this process the truck about to leave the site and its driver are checked. This includes the de-registering procedure (e.g. capturing drivers name and license plate, check of loading documents, load securing and seals, or if truck must be empty).",
              _type: "Process",
              GUID: "8b5b772a-7caa-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "It must be defined which checks and additional tasks (e.g. cleaning) shall be performed for which kind of vehicles and goods, and what data shall be recorded.",
              Type: "Business Process",
              Scope:
                "Check of driver and vehicle identity against transport documentation.",
              Outcome:
                "Vehicle and persons leaving the site have been de-registered. Authorisation for moving goods off the site has been checked.",
              name: "Check-out delivery truck",
              _id: 86,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The vendor provided goods are delivered directly to the staging area without prior warehousing. Goods receipt is posted against a production storage location or directly against a production order.   Unloading and transfer to staging may be facilitated by carrier or warehouse staff and may involve quality management (QM) procedures. Typically, QM will have been performed by the supplier in this integrated scenario.",
              _type: "Process",
              GUID: "8df4fb9e-7e0f-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Transfer of unloaded goods to production staging, goods receipt and goods issue.",
              Outcome: "Material is available for production.",
              name: "Execute production staging directly from vendor",
              _id: 91,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The advanced shipping notification (ASN) issued by the vendor provides information about the carrier, the amount of material, the mode of transport, and the company which executes the shipping. It also provides information about the delivery date. Most importantly it allows better material availability planning and hence more reliable confirmation to customers.",
              _type: "Process",
              GUID: "871038f2-7caa-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The following questions need to be answered:  ***Who receives the shipping information?  ***How are the documents received (EDI, Email etc.)?  ***What information is required?  ***Who communicates with the vendor?  ***Who must be made aware of the processed ASN internally?",
              Type: "Business Process",
              Scope:
                "The shipping notification is received from the vendor and forwarded to all business units involved in goods receipt e.g. warehouse management and quality management.    The ASN includes information on shipment of goods and additional information related to the shipment, such as order information, product description, physical characteristics, type of packaging, markings, carrier information, and configuration of goods within the transportation equipment.",
              Outcome:
                "Advanced shipping notification is received and distributed to involved business units and inbound delivery has been created.",
              name: "Receive and process advanced shipping notification",
              _id: 1212,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When a request for materials is received from production, relevant information must be forwarded to a designated vendor. This ensures that the required material is available in the stated quantity and on the specified date. ",
              _type: "Process",
              GUID: "8df4fb95-7e0f-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The supply demand references a specific scheduling agreement for specific components.    The following questions need to be answered: ***Who is the recipient for the demand information? ***How are the documents submitted (EDI, Email etc.)? ***What information is required? ***Who communicates with the vendor?",
              Type: "Business Process",
              Scope:
                "Material is requested from a vendor with specified quantities and dates and reference to a scheduling agreement.",
              Outcome: "The supply demand is received by the vendor.",
              name: "Receive production supply demand and provide to vendor",
              _id: 90,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "The actual production progress is monitored.",
              _type: "Process",
              GUID: "0f289faf-974c-11e9-0cfc-001bc641ce4f",
              Advisory_Notes:
                " ***it needs to be defined which events will trigger the adjustment of schedule or even feedback to production planning.",
              Type: "Business Process",
              Scope:
                "After orders have been released to production the actual progress needs to be monitored. In case of any special events or deviations follow-up activities as well as counter-measures need to be triggered.  Most important is the update of the production schedule and information/feedback to production planning in case of need.",
              Outcome:
                "Actual production progress is monitored and appropriate reactions are triggered.",
              name: "Monitor production progress",
              _id: 1326,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2O Staging for production directly from vendor",
          _id: 89,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "80045401-7caa-11e5-0a66-001bc640cd9b",
          Description:
            "Inbound logistics cover the processing of incoming materials from suppliers delivered to the organization till they are stocked in the warehouse. Depending on the supply chain set-up and incoterms of the individual purchase order, transportation of the materials can be managed by the supplier or by the organizations transportation department. The Inbound logistics scenario is typically initiated by receipt of the advanced shipping notification from the supplier (if supplier organizes transportation) or information about an incoming shipment from the organizations own transportation department. The scenario is applied in combination with all procurement scenarios, which involve stock materials.",
          _type: "Scenario",
          GUID: "04fce392-ef28-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The putaway process includes putting goods away in storage bins in the warehouse. There are putaway strategies in the Warehouse Management (WM) system that simplify the search for appropriate storage bins.",
              _type: "Process",
              GUID: "1c4d66ca-7ca9-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Based on an goods receipt for an inbound delivery a transfer order is created to guide the putaway of goods within the actual warehouse.",
              Outcome:
                "Goods are stored in the warehouse and storage location has been confirmed.",
              name: "Perform putaway",
              _id: 49,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process contains the planning of inbound warehouse activities related to either vendor deliveries or customer returns. ",
              _type: "Process",
              GUID: "8710390a-7caa-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The inbound receipt schedule includes information on shipment of goods and additional information related to the shipment, such as order information, product description, physical characteristics, type of packaging, markings, carrier information, and configuration of goods within the transportation equipment.",
              Outcome: "Inbound receipt schedule is current and comprehensive.",
              name: "Update inbound receipt schedule",
              _id: 88,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In this process goods are checked to ensure quantity, quality, and items match. After checking goods, the goods receipt posting is performed thus triggering an update in inventory levels and accounts payable postings. Finally, the goods are stored in an interim storage location and final putaway is triggered. ",
              _type: "Process",
              GUID: "871038f8-7caa-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Procedures for the visual check of received goods must be established including guidelines for exception handling of damaged or missing items or excess items.   Verification of goods for goods receipt is supported by label scanners or radio frequency scanners. Labels must be agreed between the supplier and the receiving party before shipment. A paper-based variant of the process must be possible for exceptional cases.",
              Type: "Business Process",
              Scope:
                "Goods receipt for received goods is posted and paper documentation is created as required.",
              Outcome:
                "Goods receipt material document created, as required in addition goods receipt slip.",
              name: "Perform goods receipt of stock items",
              _id: 87,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In this process the truck about to leave the site and its driver are checked. This includes the de-registering procedure (e.g. capturing drivers name and license plate, check of loading documents, load securing and seals, or if truck must be empty).",
              _type: "Process",
              GUID: "8b5b772a-7caa-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "It must be defined which checks and additional tasks (e.g. cleaning) shall be performed for which kind of vehicles and goods, and what data shall be recorded.",
              Type: "Business Process",
              Scope:
                "Check of driver and vehicle identity against transport documentation.",
              Outcome:
                "Vehicle and persons leaving the site have been de-registered. Authorisation for moving goods off the site has been checked.",
              name: "Check-out delivery truck",
              _id: 86,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In this process a truck about to enter the site and its driver are checked for suitability, e.g. purpose for entering the site, state of the vehicle. This includes the registering procedure (e.g. capturing drivers name and license plate).",
              _type: "Process",
              GUID: "057b285c-7caa-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Alignment of transportation planning and actual vehicle movements in addition to site entry controls for trucks.",
              Outcome:
                "Vehicle and persons entering the site have been registered and considered suitable to fulfill their pick-up or delivery task. Driving route and unloading/pick-up location have been communicated and the recipient at the (un-) loading location has been informed.",
              name: "Check-in truck",
              _id: 59,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The advanced shipping notification (ASN) issued by the vendor provides information about the carrier, the amount of material, the mode of transport, and the company which executes the shipping. It also provides information about the delivery date. Most importantly it allows better material availability planning and hence more reliable confirmation to customers.",
              _type: "Process",
              GUID: "871038f2-7caa-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The following questions need to be answered:  ***Who receives the shipping information?  ***How are the documents received (EDI, Email etc.)?  ***What information is required?  ***Who communicates with the vendor?  ***Who must be made aware of the processed ASN internally?",
              Type: "Business Process",
              Scope:
                "The shipping notification is received from the vendor and forwarded to all business units involved in goods receipt e.g. warehouse management and quality management.    The ASN includes information on shipment of goods and additional information related to the shipment, such as order information, product description, physical characteristics, type of packaging, markings, carrier information, and configuration of goods within the transportation equipment.",
              Outcome:
                "Advanced shipping notification is received and distributed to involved business units and inbound delivery has been created.",
              name: "Receive and process advanced shipping notification",
              _id: 1212,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "During unloading, a first verification of goods is supported by label scanners or radio frequency scanners. Labels are agreed between the supplier and the receiving party before shipment. A paper-based variant of the process must be possible for exceptional cases.",
              _type: "Process",
              GUID: "889f619b-e803-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Goods are unloaded and compared against the shipping documents. A first visual check is performed.",
              Outcome: "Goods are unloaded and available for goods receipt.",
              name: "Unload goods",
              _id: 85,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2O Inbound logistics",
          _id: 84,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "2a38a501-7e10-11e5-0a66-001bc640cd9b",
          Description:
            "The scenario includes processes where products are delivered directly from the sales organizations supplier to the customer. Transportation is organized by the selling entity but the deliveries bypass their warehouse. Drop shipment logistics scenarios are usually applied in combination with third party sales or sales via subcontracting scenarios. Drop shipments are also common in intercompany business where the selling and the supplying entity belong to the same group. However, in such cases logistics is typically organized by the supplying entity. The actual transportation planning does not differ from the transportation management inhouse scenario and transportation demands of both scenarios might be handled in the same planning run.",
          _type: "Scenario",
          GUID: "04fce3ba-ef28-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The advanced shipping notification (ASN) issued by the vendor provides information about the carrier, the amount of material, the mode of transport, and the company which executes the shipping. It also provides information about the delivery date. Most importantly it allows better material availability planning and hence more reliable confirmation to customers.",
              _type: "Process",
              GUID: "871038f2-7caa-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The following questions need to be answered:  ***Who receives the shipping information?  ***How are the documents received (EDI, Email etc.)?  ***What information is required?  ***Who communicates with the vendor?  ***Who must be made aware of the processed ASN internally?",
              Type: "Business Process",
              Scope:
                "The shipping notification is received from the vendor and forwarded to all business units involved in goods receipt e.g. warehouse management and quality management.    The ASN includes information on shipment of goods and additional information related to the shipment, such as order information, product description, physical characteristics, type of packaging, markings, carrier information, and configuration of goods within the transportation equipment.",
              Outcome:
                "Advanced shipping notification is received and distributed to involved business units and inbound delivery has been created.",
              name: "Receive and process advanced shipping notification",
              _id: 1212,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process consolidates demands for drop shipments based on sales- and stock transfer orders, into shipments and freight orders for subsequently tendering carriers.",
              _type: "Process",
              GUID: "106a8142-7e10-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Creation of freight units and subsequent load optimization for definition of shipments and freight orders.",
              Outcome: "Freight orders created.",
              name: "Receive and process drop shipment transportation demand",
              _id: 330,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process covers the assignment of transportation tasks to a suitable carrier and freight orders or shipments under consideration of case-specific constraints and costs.",
              _type: "Process",
              GUID: "348c88f8-7e10-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Rules must be defined guiding the selection of carriers. These may consider load size, destination, route and means of transportation, transportation time, transport conditions (e.g. cold chain), compatibility of goods. Existing framework contracts may also be a criterion.",
              Type: "Business Process",
              Scope:
                "Selection and assignment of carriers based on a set of rules. ",
              Outcome: "Carrier is selected and assigned.",
              name: "Select carrier",
              _id: 328,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the monitoring of transportation of goods to the recipient and initiation of a response in case of deviations.",
              _type: "Process",
              GUID: "8a80f575-7e0d-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Rules must be defined which means of tracking (GPS, regular update calls, stage related postings, etc.) are applied to which kind of transport (value based, customer based, product class based, etc.).",
              Type: "Business Process",
              Scope:
                "Monitoring of transportation status updates compared to plan. Issuing and tracking of corrective actions in case of deviations, and recording of updates.",
              Outcome: "Current transport status is recorded in the system.",
              name: "Monitor transportation",
              _id: 66,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process is required for the actual booking of a transport and recording of the confirmation by the carrier.",
              _type: "Process",
              GUID: "106a8148-7e10-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Shipment order needs to be sent directly to the carrier in order for freight booking and confirmation must be received.   The following questions need to be answered:  ***Who receives the order information on shipper and carrier side?  ***How are the documents received (EDI, Email etc.)?  ***What information is required?  ***Who communicates with the carrier?",
              Type: "Business Process",
              Scope:
                "This process includes the booking of a transport with required information like pick-up location and time and receiving the booking confirmation from the carrier.",
              Outcome: "Booking of carrier and receipt of confirmation.",
              name: "Book and confirm carrier",
              _id: 326,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Pre-booking of freight space at a carrier is done based on freight bookings. This is important for complex transports, e.g. involving sea freight or time critical transports.  The booking must be confirmed at a later point in any case.",
              _type: "Process",
              GUID: "106a8136-7e10-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Reserve transportation capacity (freight space) with carrier.",
              Outcome: "Carrier freight space assured.",
              name: "Perform carrier pre-booking",
              _id: 327,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2O Transportation management for drop shipment",
          _id: 83,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "e2db6101-7e11-11e5-0a66-001bc640cd9b",
          Description:
            "The fulfillment of the organizations transportation needs is ensured by performing sourcing activities on a regular basis, whereby transportation routes and volumes are optimized and related contracts awarded to the most suited suppliers. The transportation sourcing scenario describes processes required for this. Typically transportation sourcing is carried out annually/bi-annually and requires planning information about the organizations transportation needs. An alternative transportation procurement strategy not covered within this scenario is ad-hoc purchasing of transportation services from the lowest bidder. This strategy requires setting-up a platform for receiving bids and a system for evaluating them and awarding lanes or signing up to such.",
          _type: "Scenario",
          GUID: "04fce3b4-ef28-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The shipping schedule outlines the overall expected quantity of the material(s) to be shipped over a specific period of time. It is used to plan activities in the warehouse and as a reference point for site access controls. ",
              _type: "Process",
              GUID: "ec357bc8-7e11-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The shipping schedule specifies the carriers and associated lanes with the expected transportation volumes and shipping days, pick-up window, laycan, etc.",
              Outcome: "Shipping schedules updated.",
              name: "Update shipping schedules",
              _id: 82,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Based on the available information (e.g. proposal, past performance, market intelligence) and binding price quote from several carriers a preliminary assignment of suppliers to specific lanes is made and optimized. Individual carrier may only be awarded particular subset of lanes covered within a bidding and selection process. Subsequent negotiations are based on these prices and lane assignments.",
              _type: "Process",
              GUID: "abfff400-7e11-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Analyze current proposals and quotes against past performance and provisionally assign transportation lanes.",
              Outcome: "Carrier proposed for negotiations.",
              name: "Evaluate carrier responses",
              _id: 81,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Receiving information about a supplier contract and capturing it for further processing are key first steps in purchasing processes which are based on the contractual agreement with a supplier.        ",
              _type: "Process",
              GUID: "ec357bcb-7e11-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Not all vendor contracts need to be captured in SAP. Often, only details such as prices or rebates will be reflected in the purchasing master data.   Only if special treatment of contracts within SAP is required, the contracts have to be captured as such in SAP. This is basically the case for scheduling agreements and for more complex rebate agreements.",
              Type: "Business Process",
              Scope:
                "Details regarding contracts with a supplier are  recorded, stored and forwarded for further processing. The information can include the type of products, the quantity and the agreed price, as well as other terms and condition related the purchase. ",
              Outcome:
                "All relevant information regarding the contract with the supplier is stored.",
              name: "Capture vendor contract",
              _id: 1203,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Transportation requirements are deduced from different orders in the ERP system (e.g. sales orders, purchase orders, and stock transport orders, as well as the corresponding returns orders for each order type). Depending on the time scale considered either actual, planned or projected transportation requirements can be formulated.    Data summarized include: materials, volumes, dates, pick-up locations and recipients, transport routes and conditions, etc.",
              _type: "Process",
              GUID: "ec357baa-7e11-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "This process includes the assessment of orders and translation into transportation requirements.",
              Outcome: "Transportation requirements defined.",
              name: "Gather transportation requirements",
              _id: 80,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Requests For Quotation (RFQ) is sent to potential transportation suppliers, i.e. carriers. It contains a description of all relevant parameters of the required transportation services, such as: ***Transportation lanes   ***Quantities/Volumes  ***Delivery requirements (e.g. cold chain, hazardous goods)  ***Other value added requirements or terms  ***Term (duration) of contract  ***Terms and conditions",
              _type: "Process",
              GUID: "ec357bc2-7e11-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "The RFQ is created and submitted to potential vendors.",
              Outcome: "Defined requirement submitted to vendors.",
              name: "Request quote for transport sourcing",
              _id: 79,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Before purchasing goods under a contractual agreement with the supplier, it is necessary to define the conditions and set the terms under which the goods will be provided. The purchasing department must understand exactly what products (e.g. goods or services) need to be purchased and in what quantity, as well as select the supplier and prepare the contracting details with the supplier.      ",
              _type: "Process",
              GUID: "ec357bb3-7e11-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Typically at the end of the negotiations the  vendor master data and other master data is initiated if  required.",
              Type: "Business Process",
              Scope:
                "Based on the products and quantity that needs to be purchased, a suitable supplier is selected. Specific terms and conditions related to the purchase are negotiated and a contract document prepared.",
              Outcome: "The contract with the supplier is approved.",
              name: "Perform contracting",
              _id: 1206,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In this process supplier and customer negotiate and agree the terms and conditions of their anticipated relationship.  The negotiation can be based on the previous exchange of RFP/RFQ and the related responses.",
              _type: "Process",
              GUID: "ec357bad-7e11-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Align and agree scope of services, negotiate and agree contract terms.",
              Outcome: "Agreement ready for contracting.",
              name: "Perform vendor negotiations",
              _id: 1205,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Transportation lanes are used for planning distribution and procurement between different locations. This simplifies transportation planning of recurring complex or high volume transportation requirements. Awarding lanes complements the remaining vendor negotiations.",
              _type: "Process",
              GUID: "ec357bb0-7e11-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the carrier and method of transportation have been documented, transportation lanes are awarded to selected carriers. Subsequently, the rates and conditions of transportation are recorded.",
              Outcome: "Transportation lane awarded to carrier.",
              name: "Award lanes",
              _id: 78,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2O Transportation sourcing",
          _id: 77,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "d7f06df1-8e56-11e8-2ddf-001bc640cd9b",
          Description:
            "Stock adjustments are used to clear inventory differences resulting from an inventory stock take. A stock adjustment is used to adjust stock for any number of reasons such as write-offs, stock-takes, donations and scrapping of materials or finished goods. ",
          _type: "Scenario",
          GUID: "f86b2a94-8e54-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "This process refers to the operational adjustment of the differences in physical inventory as compared to what has been previously recorded by Inventory Management. This reflects a manual adjustment which triggers postings to the inventory differences account which will be received by Controlling. ",
              _type: "Process",
              GUID: "f86b2aaf-8e54-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The process includes clearance of all the differences in physical inventory and results in an update of the storage location of the inventory.",
              Outcome:
                "The storage location for physical inventory is updated and differences are cleared.",
              name: "Clear differences in physical inventory",
              _id: 314,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purpose of this process is the commercial adjustment of stock postings in order to reflect differences in physical inventory.",
              _type: "Process",
              GUID: "f86b2ab1-8e54-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the inventory differences has been adjusted by the Warehouse management, there needs to be an accompanying settlement of this difference commercially. This commercial settlement is reflected by the settlement to the inventory differences clearing account which will subsequently be written off as an expense within the Trading, Profit and Loss account to the value of the amount settled. ",
              Outcome:
                "Stock is adjusted commercially to reflect actual inventory.",
              name: "Adjust stock postings commercially",
              _id: 499,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "A Segregation of Duties is essential to separate the clearing and writing off processes within inventory adjustments. ",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2O Stock adjustments",
          _id: 76,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "a2e7a2f1-94ae-11e8-2ddf-001bc640cd9b",
          Description:
            "Transportation costs need to be captured and settled logistics providers have to be paid and the costs have to be distributed and assigned to the appropriate cost objects in order to include them into profitability analyses and the calculation of cost of goods sold (COGS). This service can also be outsourced. The scenario Transportation costing outsourced describes the relevant processes in such cases. Freight cost settlement services are procured on a mid- to long-term basis as a standard service. The scenario is used especially in countries or set-ups where freight costing is quite complex.",
          _type: "Scenario",
          GUID: "04fce3b0-ef28-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The external service provider conducts freight settlement services and forwards information about distribution of transportation costs. Freight cost settlement allows the assignment and forwarding of the shipment costs to FI and cost accounting.",
              _type: "Process",
              GUID: "a703ec87-94af-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The freight costs are calculated based on freight agreements with predefined rates and tariffs and scales for inhouse calculation. Furthermore G/L account determination takes place during the cost determination and the transfer to FICO will be triggered by a transfer procedure with Service PO and service entry sheet creation for each creditor which will be included in the freight charge document on item level. ",
              Outcome:
                "Service provider provides freight cost distribution data.",
              name: "Conduct freight settlement services",
              _id: 75,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Proof of delivery (POD) is the confirmation sent by the Ship to party upon the receipt of goods. The ship-to party transfers the proof of delivery in the System via IDoc. This way, quantities are confirmed once for the entire delivery.",
              _type: "Process",
              GUID: "f4301854-7e0f-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Proof of delivery is exclusively an instrument for confirmation of external customers deliveries.",
              Type: "Business Process",
              Scope:
                "Receipt of POD from ship-to party, processing of discrepancies as required, confirmation of POD to goods recipient.",
              Outcome: "POD confirmed.",
              name: "Receive and process proof of delivery",
              _id: 73,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "Brasil is a typical example for a legislation that introduces such complexity to the process.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2O Transportation costing outsourced",
          _id: 74,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "ec6d1851-7e0f-11e5-0a66-001bc640cd9b",
          Description:
            "Transportation costs need to be captured and settled, logistics providers have to be paid and the costs have to be distributed and assigned to the appropriate cost objects in order to include them into profitability analyses and the calculation of cost of goods sold (COGS). The inhouse transportation costing scenario describes the freight cost calculation for external transportation services received. The calculation is based on predefined rates, tariffs and scales and the execution of the scenario depends on freight agreements, which specify the rates. The scenario is used in situations when transportation is outsourced, to capture the transport service cost, or if transportation is internally organized, but the transportation service is charged to the requestor for financial reporting purposes.",
          _type: "Scenario",
          GUID: "04fce3ae-ef28-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Proof of delivery (POD) is the confirmation sent by the Ship to party upon the receipt of goods. The ship-to party transfers the proof of delivery in the System via IDoc. This way, quantities are confirmed once for the entire delivery.",
              _type: "Process",
              GUID: "f4301854-7e0f-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Proof of delivery is exclusively an instrument for confirmation of external customers deliveries.",
              Type: "Business Process",
              Scope:
                "Receipt of POD from ship-to party, processing of discrepancies as required, confirmation of POD to goods recipient.",
              Outcome: "POD confirmed.",
              name: "Receive and process proof of delivery",
              _id: 73,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In this process the shipment costs will be captured based on incoming carrier-provided information and subject to proof of delivery. G/L account determination takes place during the cost determination and transfer to FICO is triggered by a transfer procedure with Service PO and service entry sheet creation for each creditor which will be included in the shipment cost document on item level.     ",
              _type: "Process",
              GUID: "3cd87de3-e831-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "This scenario does not apply when Transportation Management is used.",
              Type: "Business Process",
              Scope:
                "Creation of shipment cost document, cost calculation and allocation.",
              Outcome: "Shipment cost document has been updated.",
              name: "Settle freight cost",
              _id: 72,
              Business_Rules: "Cost allocation rules must be maintained.",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "Ad-hoc purchasing of transportation services also leads toa freight agreement, which has to be documented in the system.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2O Transportation costing inhouse",
          _id: 71,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "714610c1-7e0d-11e5-0a66-001bc640cd9b",
          Description:
            "Outbound logistics describes warehousing processes required for issuing products from inventory and making them ready to be transported to customers, other sites or subsidiaries, or other business partners. The scenario is initiated by an outbound delivery request. Depending on the incoterms used in the underlying sales transaction, transportation of products to the customer can be organized by the customer (pick up) or by the organizations transportation department. In the latter case the Transportation management scenario is performed in parallel with outbound logistics.",
          _type: "Scenario",
          GUID: "04fce39c-ef28-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The transfer order is a document used in the warehouse management (WM) system that contains all the information needed to carry out the physical movement of material into the warehouse, out of the warehouse or from one storage place to another within the warehouse. Transfer can also occur to a production staging area or loading bay. Confirmation can happen manually, automatically, or by scanning.",
              _type: "Process",
              GUID: "d9267281-e82f-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Verification of materials at storage location, confirmation of transfer order in system.",
              Outcome:
                "Transfer order has been confirmed. Material is available at the recorded storage location.",
              name: "Save and confirm transfer order",
              _id: 70,
              Business_Rules:
                "It must be defined which stock movements shall require confirmation.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the transport execution from leaving the enterprise grounds to receiving  the eventual proof of delivery signed by the receiver which acts as service confirmation between sender and carrier.  ",
              _type: "Process",
              GUID: "8a80f581-7e0d-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The requirement and channel for ASN must be specified per recipient.",
              Type: "Business Process",
              Scope:
                "Dispatching the shipment and delivery of goods to recipient. After associating the vehicle details with the delivery an Advance Shipping Notice is sent to the recipient.",
              Outcome:
                "Recipient has been provided with Advance Shipping Note. Forwarder has received proof of delivery from recipient.",
              name: "Execute shipment",
              _id: 69,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Provision of the Material Safety Data Sheet is a legal requirement in the context of risk communication for hazardous material. The distributor of hazardous material is obliged to inform the customer about the safety related data of a product. Carriers will require provision of a MSDS for transporting hazardous goods. The documents can be provided either as paper, e.g. as part of the shipment, or as an internet download.    ",
              _type: "Process",
              GUID: "8a80f57e-7e0d-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The channel for providing the MSDS ist not legally defined. Best practice is to make MSDS available for download though a customer portal.",
              Type: "Business Process",
              Scope:
                "Determine country-language specific safety data sheet and check availability. Send safety data sheet to customer.",
              Outcome:
                "Material safety data sheet has been provided to customer.",
              name: "Provide material safety data sheet (MSDS)",
              _id: 68,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The purpose of this process is to prevent shipping of dangerous goods which will harm dangerous goods regulation.",
              _type: "Process",
              GUID: "3124d4df-e98f-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The dangerous goods check verifies whether the shipment of dangerous goods contains transport regulatory data derived from UN-numbers, dangerous good classes, packaging codes etc. ",
              Outcome:
                "The product complies with the EH+S related requirements and the sales order is permitted by EH+S.",
              name: "Perform dangerous goods check",
              _id: 67,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the monitoring of transportation of goods to the recipient and initiation of a response in case of deviations.",
              _type: "Process",
              GUID: "8a80f575-7e0d-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Rules must be defined which means of tracking (GPS, regular update calls, stage related postings, etc.) are applied to which kind of transport (value based, customer based, product class based, etc.).",
              Type: "Business Process",
              Scope:
                "Monitoring of transportation status updates compared to plan. Issuing and tracking of corrective actions in case of deviations, and recording of updates.",
              Outcome: "Current transport status is recorded in the system.",
              name: "Monitor transportation",
              _id: 66,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Availability to promise check (ATP check) for delivery verifies whether goods included in the outbound delivery document are available on stock on the delivery date (or necessary ship-out date) and can be delivered.",
              _type: "Process",
              GUID: "44d43b72-e8bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "An availability check for delivery generation is recommended to determine whether the material situation has changed since the availability check was made for the sales order.",
              Type: "Business Process",
              Scope:
                "Before sending the outbound delivery to warehouse for picking and initiating transportation it must be checked whether goods included in this outbound delivery are available on stock at picking date. If there are not enough goods, delivery is not sent to warehouse for fulfillment.  Unlike other ATP checks, the check for delivery is typically performed only against physical stock on hand.",
              Outcome:
                "Products required for delivery are available and outbound logistics can be initiated.",
              name: "Check availability to promise for delivery",
              _id: 65,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The process describes picking of finished goods from a warehouse for delivery to a customer or intercompany.    ",
              _type: "Process",
              GUID: "e50fe5ce-6e30-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "A picking list which is created in this process is enriched with additional information, e.g. the ID of the storage bin, quantity, etc. and will be transfered to delivery. ",
              Outcome: "Material is picked and ready for delivery.",
              name: "Perform pick for outbound logistics",
              _id: 64,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "An outbound delivery is usually created with reference to another document (sales order, purchase order, stock transport order). Outbound deliveries can only be created for orders, which are due to delivery (material availability date or the transportation scheduling date is reached) - e.g. delivery is created 3 days before planned ship-out. Deliveries can not be created for orders, which are blocked e.g. sales order blocked due to exceeded credit limit.",
              _type: "Process",
              GUID: "e9f51001-e9bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Dealing with delivery creation the legal requirements in the country of operations must be considered - some countries do not permit a sales order to be broken up into more than one delivery, and likewise they may not permit more than one sales document to be combined into one delivery.",
              Type: "Business Process",
              Scope:
                "An outbound delivery is the central object of the goods issue process - all shipping activities including picking, packing, transportation and goods issue are initiated based on the outbound delivery.",
              Outcome:
                "Outbound delivery document is created and shipping activities can be initiated.",
              name: "Create outbound delivery",
              _id: 63,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The process describes the loading procedure for a shipment to ensure that all packages of a delivery are shipped to the Customer. This process also can be supported with RF technology.",
              _type: "Process",
              GUID: "7bf5a968-7e0d-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The Shipment loading process is optional and can be executed paper based or with a RF Scenario",
              Type: "Business Process",
              Scope: "Loading of vehicle and loading confirmation.",
              Outcome:
                "Goods are loaded onto a shipment and are ready for goods issue.",
              name: "Load goods",
              _id: 62,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In this process the shipment documents are prepared and the goods issue gets posted. In some cases shipment documents may have to be printed in advance to be included in the packaging.",
              _type: "Process",
              GUID: "7e8a0fce-7e0d-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The goods issue posting does not necessarily require prior creation of shipment and loading.",
              Type: "Business Process",
              Scope:
                "Goods issue posting and printing of transport documents are invovled in this process.",
              Outcome: "Goods issue posted and shipment ready for dispatch.",
              name: "Perform goods issue from stock",
              _id: 61,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In this process the truck about to leave the site and its driver are checked. This includes the de-registering procedure (e.g. capturing driver name license plate, check of loading documents, loading security and seals).",
              _type: "Process",
              GUID: "3cd60ced-e831-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "It must be defined which checks and additional tasks (e.g. cleaning) shall be performed for which kind of vehicles and goods, and what data shall be recorded.",
              Type: "Business Process",
              Scope:
                "Check of driver and vehicle identity against transport documentation. Company grounds exit control.",
              Outcome:
                "Vehicle and persons leaving the site have been de-registered. Authorisation for moving goods off the site has been checked.",
              name: "Check-out truck",
              _id: 60,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In this process a truck about to enter the site and its driver are checked for suitability, e.g. purpose for entering the site, state of the vehicle. This includes the registering procedure (e.g. capturing drivers name and license plate).",
              _type: "Process",
              GUID: "057b285c-7caa-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Alignment of transportation planning and actual vehicle movements in addition to site entry controls for trucks.",
              Outcome:
                "Vehicle and persons entering the site have been registered and considered suitable to fulfill their pick-up or delivery task. Driving route and unloading/pick-up location have been communicated and the recipient at the (un-) loading location has been informed.",
              name: "Check-in truck",
              _id: 59,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Materials together with packing materials are packed into handling units suitable for loading and transport. Handling units can be nested (e.g. carton, pallet, container).",
              _type: "Process",
              GUID: "7bf5a959-7e0d-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "It is possible to cover pick and pack combined in an automated procedure.",
              Type: "Business Process",
              Scope:
                "In this process the physical packing of materials, creation of handling units and labelling of the packages is invovled. ",
              Outcome: "Goods ready to be loaded.",
              name: "Perform pack",
              _id: 58,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade compliance ensures due diligence with trade regulatory programs and cross-border customs requirements. Global trade checks are required for all business operations.",
              _type: "Process",
              GUID: "1b684ec4-44de-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The check itself is typically done automatically by the ERP system. The actual process discussion should focus on the maintenance of the relevant GTS data (including the integration of external data sources) and the handling of sales orders failing to pass the checks.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both involved business partners and products being sold or related services are subject to checks.",
              Outcome:
                "The sales order complies with the applicable trade regulations and the product can be shipped.",
              name: "Perform global trade check",
              _id: 57,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists, dual use products) used for screening is comprehensive and up to date.   Customer data must be up to date.   Rules and procedures how to handle sales orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2O Outbound logistics",
          _id: 56,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "a40d0a51-7e11-11e5-0a66-001bc640cd9b",
          Description:
            "The scenario transportation management outsourced is applied when transportation management is outsourced to a fourth party logistics provider (4PL) taking over responsibility for managing the whole supply chain process. The organizations involvement in transportation management in this scenario is limited to ensuring communication flow with 4PL, own warehouse and suppliers.",
          _type: "Scenario",
          GUID: "04fce3aa-ef28-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Receive consolidated and planned outbound shipment message from 4PL to trigger internal shipment creation.",
              _type: "Process",
              GUID: "f123cd4c-7e10-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Order information needs to be received directly from the 4PL.   The following questions need to be answered: ***Who receives the shipping information? ***How are the documents transmitted (EDI, Email etc.)? ***What information is required? ***Who communicates with the 4PL?",
              Type: "Business Process",
              Scope:
                "Process shipment information from 4PL and update deliveries in own system.",
              Outcome: "Deliveries updated.",
              name: "Receive transportation information from 4PL",
              _id: 55,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process assures that the warehouse receives the delivery and pickup information (e.g. times, carrier, transportation requirements) provided by the 4PL.",
              _type: "Process",
              GUID: "abe34419-7e11-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Transport information needs to be exchanged directly with the warehouse.    The following questions need to be answered: ***Who receives the transport information? ***How are the documents transmitted (system workflow, EDI, Email etc.)? ***What information is required? ***Who communicates with the warehouse?",
              Type: "Business Process",
              Scope:
                "Provide transportation information to warehouse and confirm receipt.",
              Outcome: "Transportation information communicated to warehouse.",
              name: "Communicate transportation information to warehouse",
              _id: 54,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Firm planning and booking transportation capacities and services by a 4PL is based on actual orders or deliveries provided by the shipper, as would be the case for internal operations.",
              _type: "Process",
              GUID: "abe3442e-7e11-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Order information needs to be sent directly to the 4PL.    The following questions need to be answered: ***Who receives the order information? ***How are the documents transmitted (EDI, Email etc.)? ***What information is required? ***Who communicates with the 4PL?",
              Type: "Business Process",
              Scope:
                "Transmission of firm transportation demands (e.g. deliveries from O2C) to 4PL for actual booking.",
              Outcome:
                "Definite orders (sales order, purchase order, transfer order)  or deliveries transmitted to 4PL for processing.",
              name: "Send transportation demands to 4PL",
              _id: 53,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In case of outsourced transportation planning the 4PL need information about transportation requirements as early as possible to update their planning. The preliminary plans will be updated later when more solid information becomes available.",
              _type: "Process",
              GUID: "abe34416-7e11-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Send transportation request information, e.g. sales order and stock transfer order, to 4PL Transport Management System (TMS) to enable the 4PL TMS to perform transportation planning.",
              Outcome:
                "Preliminary orders (sales order, purchase order, transfer order) or deliveries transmitted to 4PL for processing.",
              name: "Provide transportation outlook to 4PL",
              _id: 52,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "Note that in this scenario, the warehousing is still done by inhouse. In case all logistics services are outsourced, typically only goods receipt and goods issues are transferred from the logistics service providers system for stock, and the delivery information is exchanged for the transport.   Transportation sourcing is a prerequisite to this scenario.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2O Transportation management outsourced",
          _id: 51,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "51cb10e1-7e0f-11e5-0a66-001bc640cd9b",
          Description:
            "Raw materials and semi-finished products need to be provided from the warehouse to production in the right quantity and at the right time to ensure an uninterrupted manufacturing process. The scenario production supply covers this staging of input materials and components for production from inventory to the point where they are ready to be consumed by the manufacturing process. This scenario typically applies to all production environments and for all materials except those that are provided either directly by a vendor or in a setup of continuous flows such as KANBAN or via pipeline. Typically staging is done within the same premises and no sophisticated transportation or packaging is needed.",
          _type: "Scenario",
          GUID: "04fce3a0-ef28-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Production staging makes warehouse managed materials available within a supply area close to the consuming production workstation. This happens with reference to a production order. Goods issue posting to the process order typically is done when the materials are taken from the staging area to be consumed during production. In cases when the consumed quantity is known only after production goods issue posting is possible after confirming the process order.",
              _type: "Process",
              GUID: "05d0f3bb-7e0e-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Creation of transfer requirement based on production order(s), transformation into transfer order, movement of materials from warehouse to staging area.",
              Outcome: "Transfer order for picking is created.",
              name: "Initiate production staging and create transfer order",
              _id: 343,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The process describes picking of goods from a warehouse for delivery to a customer or intercompany.   ",
              _type: "Process",
              GUID: "7e8a0fc2-7e0d-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Picking items can be sorted to optimize the picking distance / resources Deviations from picking quantities require adaptations in the delivery item. It is possible to cover pick and pack combined in an automated procedure.",
              Type: "Business Process",
              Scope:
                "The process includes the creation of transfer order, picking and confirmation of picked items.",
              Outcome: "Items for delivery have been picked.",
              name: "Perform pick for production staging",
              _id: 319,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The transfer order is a document used in the warehouse management (WM) system that contains all the information needed to carry out the physical movement of material into the warehouse, out of the warehouse or from one storage place to another within the warehouse. Transfer can also occur to a production staging area or loading bay. Confirmation can happen manually, automatically, or by scanning.",
              _type: "Process",
              GUID: "d9267281-e82f-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Verification of materials at storage location, confirmation of transfer order in system.",
              Outcome:
                "Transfer order has been confirmed. Material is available at the recorded storage location.",
              name: "Save and confirm transfer order",
              _id: 70,
              Business_Rules:
                "It must be defined which stock movements shall require confirmation.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Goods issue for materials and components used within the production process have to be posted after delivery and when they are moved from the warehouse for further processing. ",
              _type: "Process",
              GUID: "baf08434-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The segregation of staging for production and actual posting of the GI of the components can differ depending on the physical and organizational set-up as well as on the required transparency on the material flow.",
              Type: "Business Process",
              Scope:
                "Goods issues are performed for materials and components retrieved from stock used in the respective production step. Some stock materials might be exempt and later be posted in the cause of a backflushing process.",
              Outcome: "Goods issue is posted.",
              name: "Perform goods issue of components for production",
              _id: 1328,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "In case transportation between the location of production and warehouse is required, a goods receipt followed by a stock transfer from one site to another is used.  In rare cases some kind of transportation management is required because of the difficulties to move materials (special equipment required) makes it necessary.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2O Production supply",
          _id: 50,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "fcc4a091-7ca9-11e5-0a66-001bc640cd9b",
          Description:
            "Manufactured products are moved to the local warehouse and processed further. In particular this may involve initiating required QM inspections and putaway. The inbound from production scenario describes the flow from the production hall until the products are stocked in the warehouse. The main distinction from the inbound logistics of materials provided from suppliers is that intermediates and finished products from production are moved without extensive packaging and that the contents are already specified and quality inspected. Inspection results, however, may still be pending. The scenario can be used in combination with all production scenarios, which involve the local stocking of produced goods. However direct supply from production to customers or to a subsequent production stage without stocking is not covered by this scenario.",
          _type: "Scenario",
          GUID: "04fce398-ef28-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The putaway process includes putting goods away in storage bins in the warehouse. There are putaway strategies in the Warehouse Management (WM) system that simplify the search for appropriate storage bins.",
              _type: "Process",
              GUID: "1c4d66ca-7ca9-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Based on an goods receipt for an inbound delivery a transfer order is created to guide the putaway of goods within the actual warehouse.",
              Outcome:
                "Goods are stored in the warehouse and storage location has been confirmed.",
              name: "Perform putaway",
              _id: 49,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the goods receipt process for products and by-products manufactured in production. After goods receipt, the system increases the stock of the goods at the relevant storage location.      ",
              _type: "Process",
              GUID: "1c4d66cd-7ca9-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Goods or semi-finished goods that have been produced have to be posted on stock with a goods receipt.",
              Outcome:
                "Goods receipt posted (in many cases in a special stock as long as quality inspection is still ongoing).",
              name: "Perform goods receipt from production",
              _id: 1357,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "In case transportation between the location of prodcution and warehouse is required, elements of the general inbound logistics scenario might be required. Either a lean process, which fulfills the minimum requirements in terms of documentation is applied, or a goods receipt followed by a stock transfer from one site to another is used.  In rare cases some kind of transportation management is required due to difficulties to move materials (e.g. special equipment required).",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2O Inbound from production",
          _id: 48,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "bf643560-8e55-11e8-2ddf-001bc640cd9b",
          Description:
            "Inventory counting (also known as stock take) process helps to control and track inventory levels. During an inventory count, every material is counted and recorded. Counting can be done either via Full inventorying take or Cycle count/perpetual inventory take.",
          _type: "Scenario",
          GUID: "f86b2a92-8e54-11e8-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Following the physical count, this process describes maintaining the count in the system. In the case of a mismatch, a re-count is triggered  and the inventory is adjusted.",
              _type: "Process",
              GUID: "f86b2a9d-8e54-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "This maintenance includes the documentation of the count in the system and identification of count differences.",
              Outcome: "Inventory count maintained in the system.",
              name: "Maintain count in system",
              _id: 316,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the physical count of the goods against the count document. The purpose ist to determine exactly the inventory quantities and to identify differences. The physical inventory, system and physical stock levels should be aligned. ",
              _type: "Process",
              GUID: "f86b2a9b-8e54-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "This count includes all items included in the created count list.",
              Outcome: "Physical inventory is determined. ",
              name: "Count goods physically",
              _id: 317,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the first requirement of generating and printing an inventory count document. The document describes what should be counted and at what locations the items can be found. ",
              _type: "Process",
              GUID: "f86b2a99-8e54-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The count document includes materials for inventory count and the storage bins/locations where the items can be found.",
              Outcome: "Count document generated and printed.",
              name: "Create count document",
              _id: 315,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2O Inventory counting",
          _id: 47,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "87f77431-9ee9-11e8-2ddf-001bc640cd9b",
          Description:
            "Cross-docking is a logistics procedure where products from a supplier or manufacturing plant are distributed directly to a customer or retail chain with marginal to no handling or storage time. Cross-docking takes place in a distribution docking terminal usually consisting of trucks and dock doors on two (inbound and outbound) sides with minimal storage space. The name cross-docking explains the process of receiving products through an inbound dock and then transferring them across the dock to the outbound transportation dock.",
          _type: "Scenario",
          GUID: "04fce394-ef28-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the goods receipt from inbound deliveries needing to be directly processed via cross-docking to outbound deliveries.",
              _type: "Process",
              GUID: "7eaea9b3-9ee7-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Materials, goods or finished goods that are arriving at an inbound dock and directly needing to be shipped outbound.",
              Outcome:
                "Goods receipt is performed and transfer order can be created. ",
              name: "Perform goods receipt to inbound delivery for cross-docking",
              _id: 338,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes issuing the goods to an outbound delivery for cross-docking. In some cases shipment documents may have to be printed in advance to be included in the packaging.",
              _type: "Process",
              GUID: "e5a63124-9eea-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The goods issue posting is performed including printing of transport documents.",
              Outcome: "Goods issue for cross-docking posted. ",
              name: "Perform goods issue for cross-docking",
              _id: 341,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The cross-docking picking process involves taking goods for cross docking staging at the right quantity.",
              _type: "Process",
              GUID: "7eaea9c0-9ee7-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "For cross-docking transfer of materials, it is necessary to specify which materials to pick and the storage location where to find the materials.",
              Outcome: "Goods picked from inbound picking location.",
              name: "Pick goods for cross-docking",
              _id: 323,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A transfer order is used as an instruction to move materials from a source storage location to a destination storage location at a specified time. The transfer order contains information on the quantity of the material to be moved and requirements throughout a warehouse.",
              _type: "Process",
              GUID: "109ebff1-e804-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The transfer order contains all the information required to execute the physical transfer of materials into the warehouse, out of the warehouse, or from one storage bin to another storage bin within the warehouse. ",
              Outcome: "Transfer order created.",
              name: "Create transfer order",
              _id: 320,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the planning of cross-docking elements including planning of incoming shipments and outgoing shipping requirements. This procedure can reduce material handling costs, labour and time. Furthermore this process enables the warehouse to map inbound delivery documents to outbound deliveries which results in the reduction of storing in the warehouse.",
              _type: "Process",
              GUID: "7eaea9a9-9ee7-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "For cross-docking logistics, it is required to plan and align incoming supply with outgoing demand requirements.",
              Outcome:
                "Incoming and outgoing transfers and deliveries planned. ",
              name: "Plan cross-docking",
              _id: 331,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The advanced shipping notification (ASN) issued by the vendor provides information about the carrier, the amount of material, the mode of transport, and the company which executes the shipping. It also provides information about the delivery date. Most importantly it allows better material availability planning and hence more reliable confirmation to customers.",
              _type: "Process",
              GUID: "871038f2-7caa-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The following questions need to be answered:  ***Who receives the shipping information?  ***How are the documents received (EDI, Email etc.)?  ***What information is required?  ***Who communicates with the vendor?  ***Who must be made aware of the processed ASN internally?",
              Type: "Business Process",
              Scope:
                "The shipping notification is received from the vendor and forwarded to all business units involved in goods receipt e.g. warehouse management and quality management.    The ASN includes information on shipment of goods and additional information related to the shipment, such as order information, product description, physical characteristics, type of packaging, markings, carrier information, and configuration of goods within the transportation equipment.",
              Outcome:
                "Advanced shipping notification is received and distributed to involved business units and inbound delivery has been created.",
              name: "Receive and process advanced shipping notification",
              _id: 1212,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2O Cross-docking",
          _id: 46,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "e3b2f1c1-7e10-11e5-0a66-001bc640cd9b",
          Description:
            "Transportation management inhouse scenario describes the process flow required to plan, organize and execute the transportation of materials, intermediates, and finished products from warehouse to customer, from vendor to warehouse, or between warehouses as well as in the reversed direction in case of returns. The scenario is initiated by a transportation demand (typically a sales order, purchase order, or stock transfer order). Transportation demands from different above mentioned business cases might be combined and optimized together.",
          _type: "Scenario",
          GUID: "04fce3a8-ef28-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "This process covers the assignment of transportation tasks to a suitable carrier and freight orders or shipments under consideration of case-specific constraints and costs.",
              _type: "Process",
              GUID: "348c88f8-7e10-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Rules must be defined guiding the selection of carriers. These may consider load size, destination, route and means of transportation, transportation time, transport conditions (e.g. cold chain), compatibility of goods. Existing framework contracts may also be a criterion.",
              Type: "Business Process",
              Scope:
                "Selection and assignment of carriers based on a set of rules. ",
              Outcome: "Carrier is selected and assigned.",
              name: "Select carrier",
              _id: 328,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process consolidates demands for transportation, sales- and stock transfer orders, into shipments and freight orders, or freight bookings for subsequently tendering carriers. Freight orders capture all information required for transportation planning by the shipper (sender) and transportation execution.They are a combination of shipments, which can be assigned to specific legs of the transport and/or carriers. The combination is based on transportation planning or transportation charges calculation. Freight orders can be created directly or as part of transportation order based or delivery based planning. Freight bookings, in contrast, are used to book freight space in advance, for example, with a shipping company. Transportation execution can then happen on the same documents. Freight orders and freight bookings also form the basis for track & trace activities, event management and reporting.",
              _type: "Process",
              GUID: "94126c64-7e10-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Creation of freight units and subsequent load optimization for definition of shipments and freight orders/freight bookings.",
              Outcome: "Freight order/freight booking created.",
              name: "Receive and process transportation demand",
              _id: 329,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Pre-booking of freight space at a carrier is done based on freight bookings. This is important for complex transports, e.g. involving sea freight or time critical transports.  The booking must be confirmed at a later point in any case.",
              _type: "Process",
              GUID: "106a8136-7e10-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Reserve transportation capacity (freight space) with carrier.",
              Outcome: "Carrier freight space assured.",
              name: "Perform carrier pre-booking",
              _id: 327,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process is required for the actual booking of a transport and recording of the confirmation by the carrier.",
              _type: "Process",
              GUID: "106a8148-7e10-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Shipment order needs to be sent directly to the carrier in order for freight booking and confirmation must be received.   The following questions need to be answered:  ***Who receives the order information on shipper and carrier side?  ***How are the documents received (EDI, Email etc.)?  ***What information is required?  ***Who communicates with the carrier?",
              Type: "Business Process",
              Scope:
                "This process includes the booking of a transport with required information like pick-up location and time and receiving the booking confirmation from the carrier.",
              Outcome: "Booking of carrier and receipt of confirmation.",
              name: "Book and confirm carrier",
              _id: 326,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the handling of shipping documents and related customs interactions in case of international trade.",
              _type: "Process",
              GUID: "94126c6a-7e10-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Minimum Shipping documentation:  ***Truck: Bill of Lading (BOL), Master Bill of Lading (MBOL) ***Air: Airway Bill (AWB), House Way Bill (HWB)  ***Sea: Bill of Lading (BOL) ***Parcel: Carrier compliant parcel labels",
              Type: "Business Process",
              Scope:
                "Alignment of shipping documents with carrier, submission to customs for clearance.",
              Outcome: "Shipment is customs cleared and ready for pickup.",
              name: "Prepare and communicate transportation documents",
              _id: 335,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "Optimization might also include the combination of returns (products or returnable packaging/containers) in order to better utilize transportation resources.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2O Transportation management inhouse",
          _id: 44,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "NULL",
          Description:
            "Kanban concept maintains inventory that is very close to the production machines. A signal is sent to deliver a new shipment as material is consumed. Such a signal can be as simple as returning the empty box to be refilled. In such scenarios Kanban is often combined with a milk-run system for the internal transport. Kanban is either used to ensure availability of components of the same kind used by many different production orders in a simple way, or to provide a continuous flow of order specific components to a number of flexible work centers to insure high utilization of the resources.",
          _type: "Scenario",
          GUID: "04fce3a4-ef28-11e4-0a66-001bc640cd9b",
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2O Production supply (Kanban)",
          _id: 45,
          Business_Rules: "",
          Prerequisite: "",
        },
      ],
      Description:
        "The Inbound to Outbound (I2O) domain describes the processes necessary to handle incoming deliveries from suppliers, vendor and customer returns, as well as final delivery of products to customers, subcontractors and other warehouses. It also encompasses processes for warehousing, staging of materials and receiving semi-finished and finished products from production.",
      _type: "Domain",
      GUID: "964b5c36-642b-11e4-55cc-001bc640cd9b",
      Advisory_Notes: "",
      Type: "E2E-Domain",
      Scope: "",
      Outcome: "",
      name: "Inbound to Outbound",
      _id: 43,
      Business_Rules: "",
      Prerequisite: "",
    },
    {
      BPMN_GUID: "85afbd81-ef1b-11e4-0a66-001bc640cd9b",
      scenario_of: [
        {
          BPMN_GUID: "b3060eb1-7e45-11e5-0a66-001bc640cd9b",
          Description:
            "I2Q In process inspection with shop-floor integration covers the process flow to support the verification against goods specification on production lines without intermediate goods and without technical retrofit of the production line itself. The inspection with shop-floor integration takes place during production. The inspection may be a visual quality inspections based on predefined quality characteristics, a continuous observation of certain parameters during the production process, or a periodically performed assessment of such.",
          _type: "Scenario",
          GUID: "a303a242-ef1a-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description: "Quality parameters from MES are received.",
              _type: "Process",
              GUID: "76d66f00-6750-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The quality parameters are received from the MES and save to the inspection lot. The capturing of data from the MES can be done for multiple different parameters at different stages of production. It might be done multiple times during the production or by receiving a summary of parameters from the MES at the end of production.The inspection lot is closed once all parameters have been received and saved to the inspection lot.",
              Outcome:
                "Quality parameters from MES are saved to inspection lot.",
              name: "Receive quality parameters from manufacturing execution system",
              _id: 42,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Based on the documented results of the quality inspection, a decision on usage and final quality is made by an authorized and qualified person. It specifies whether the goods in the inspection lot have been accepted for use or rejected.",
              _type: "Process",
              GUID: "f072b296-7e45-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The usage decision for an inspection lot confirms that all physical samples have been evaluated and the inspection has been completed.  Usage decisions:    ***unrestricted usage sale/production   ***destruction of goods   ***recycling     ***re-work   ***return   ***restricted usage   (sale/production under certain circumstances - lower quality)   Approval requirements for usage decisions must be defined. The matrix between quality properties and actions should be defined to always ensure the same usage of goods.   Even in case of purchased goods, a new quality certificate might be generated if the goods are intended for sale.   If Laboratory Information Management System (LIMS) is used, the basis of the usage decision can be the recommendation transferred from the LIMS to the ERP.",
              Type: "Business Process",
              Scope:
                "The results of the quality inspection get reviewed and the completeness of the quality report is checked. Usage decisions can be made with the help of a predefined catalogue which includes all allowed codes for usage decisions. After the usage decision is made, the stock posting of material for stock-relevant inspection lots is carried out. The usage decision is communicated and documented, as well as a certificate of quality is generated and signed.",
              Outcome:
                "The decision on usage of goods is evaluated, documented and communicated. A quality certificate is generated if required.",
              name: "Make usage decision",
              _id: 1369,
              Business_Rules:
                "In order to make usage decision, the following conditions must be met: ***The Inspection Lot is released ***Expiration date has been assigned (if required ) ***Inspection results have been recorded for required characteristics, they are valuated and closed.    In case that an interface from SAP to LIMS and from LIMS to SAP (results transferring) are in place, this process takes place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Quality inspections are processes on the basis of inspection lots. If a specific quantity of a material is inspected, an inspection lot must be created in the system. ",
              _type: "Process",
              GUID: "17fae614-e864-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "1",
              Type: "Business Process",
              Scope:
                "Triggered by the event that an inspection is required an inspection plan has to be assigned. Inspection plan together with information derived from the triggering business object (production order, purchase order) and material master basically specify the content of the inspection lot: ***what shall be inspected?   ***by whom?   ***when?    ***in what way?   ***how often?     Once the inspection lot is defined, the source of the lot needs to be noted within the quality system.   All necessary information for an inspection is stored in the inspection lot. When creating the inspection lot, information from the corresponding material master, inspection plan and sampling procedure is evaluated.",
              Outcome:
                "The inspection lot is created and the underlying inspection plan is defined.",
              name: "Create inspection lot",
              _id: 1373,
              Business_Rules:
                "Whenever an inspection has to be carried out, an Inspection lot must be created.   The specific LIMS integration needs to be checked. It is possible to transmit created inspection lots from SAP to LIMS, to perform the sampling calculation there.",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "Rarely used as such inspections are most likely part of the actual production step or at least integrated into the routing as ordinary production step.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2Q In process inspection with shop-floor integration",
          _id: 41,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "890c3fc1-7e46-11e5-0a66-001bc640cd9b",
          Description:
            "I2Q Post-production inspection is used to assess and document quality and conformity with specification of produced goods.  In comparison to in-process inspections, the post-production inspection focuses on the classification of goods and the final usage decision. Samples or all produced goods undergo quality inspections based on predefined quality properties and methods.",
          _type: "Scenario",
          GUID: "a303a244-ef1a-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Quality inspections are processes on the basis of inspection lots. If a specific quantity of a material is inspected, an inspection lot must be created in the system. ",
              _type: "Process",
              GUID: "17fae614-e864-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "1",
              Type: "Business Process",
              Scope:
                "Triggered by the event that an inspection is required an inspection plan has to be assigned. Inspection plan together with information derived from the triggering business object (production order, purchase order) and material master basically specify the content of the inspection lot: ***what shall be inspected?   ***by whom?   ***when?    ***in what way?   ***how often?     Once the inspection lot is defined, the source of the lot needs to be noted within the quality system.   All necessary information for an inspection is stored in the inspection lot. When creating the inspection lot, information from the corresponding material master, inspection plan and sampling procedure is evaluated.",
              Outcome:
                "The inspection lot is created and the underlying inspection plan is defined.",
              name: "Create inspection lot",
              _id: 1373,
              Business_Rules:
                "Whenever an inspection has to be carried out, an Inspection lot must be created.   The specific LIMS integration needs to be checked. It is possible to transmit created inspection lots from SAP to LIMS, to perform the sampling calculation there.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Handle samples process provides information on the collection and extraction of samples.",
              _type: "Process",
              GUID: "07ddae9c-7e45-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The storage of the samples, the amount of samples needed and sampling techniques need to be defined. Sample handling might not be necessary in case a 100% control is performed. In this case, the sample comprises of the total quantity.",
              Type: "Business Process",
              Scope:
                "Once the inspection lot is generated, the samples can be extracted in the correct way, correct amount and with a dedicated sampling technique. The storage conditions shall not have any influence on the quality of the sample.",
              Outcome: "The samples are ready for the inspection.",
              name: "Handle samples",
              _id: 19,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Samples (sample may refer also to a 100% inspection) get inspected for each inspection characteristic. The results are recorded. The recorded inspection results document the quality of the inspected products and provide the basis for taking usage decisions and creating quality certificates.",
              _type: "Process",
              GUID: "72b8f001-59dc-11e8-2ddf-001bc640cd9b",
              Advisory_Notes:
                "Inspections follow a clear and predefined inspection plan. The inspection characteristics define what has to be inspected. The inspection method states how the characteristic has to be assessed. The quality parameters define for the inspected product/good the values range within the result are considered as within specification.",
              Type: "Business Process",
              Scope:
                "After the samples have been extracted, the defined inspection takes place. The inspection encompasses quality inspections based on predefined quality characteristics. The inspection can also include measurements done directly on the product without taking a specific sample for the inspection, or can be done directly by using the integrated measurement devices of the production line.",
              Outcome:
                "Quality characteristics have been assessed and documented.",
              name: "Perform inspection and record results for finished goods",
              _id: 465,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Based on the documented results of the quality inspection, a decision on usage and final quality is made by an authorized and qualified person. It specifies whether the goods in the inspection lot have been accepted for use or rejected.",
              _type: "Process",
              GUID: "f072b296-7e45-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The usage decision for an inspection lot confirms that all physical samples have been evaluated and the inspection has been completed.  Usage decisions:    ***unrestricted usage sale/production   ***destruction of goods   ***recycling     ***re-work   ***return   ***restricted usage   (sale/production under certain circumstances - lower quality)   Approval requirements for usage decisions must be defined. The matrix between quality properties and actions should be defined to always ensure the same usage of goods.   Even in case of purchased goods, a new quality certificate might be generated if the goods are intended for sale.   If Laboratory Information Management System (LIMS) is used, the basis of the usage decision can be the recommendation transferred from the LIMS to the ERP.",
              Type: "Business Process",
              Scope:
                "The results of the quality inspection get reviewed and the completeness of the quality report is checked. Usage decisions can be made with the help of a predefined catalogue which includes all allowed codes for usage decisions. After the usage decision is made, the stock posting of material for stock-relevant inspection lots is carried out. The usage decision is communicated and documented, as well as a certificate of quality is generated and signed.",
              Outcome:
                "The decision on usage of goods is evaluated, documented and communicated. A quality certificate is generated if required.",
              name: "Make usage decision",
              _id: 1369,
              Business_Rules:
                "In order to make usage decision, the following conditions must be met: ***The Inspection Lot is released ***Expiration date has been assigned (if required ) ***Inspection results have been recorded for required characteristics, they are valuated and closed.    In case that an interface from SAP to LIMS and from LIMS to SAP (results transferring) are in place, this process takes place.",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "The quality inspections of samples of produced goods may take longer. In such cases, the goods are already moved to the warehouse and might even be stocked already. Nevertheless, the inventory remains in the status in quality inspection and cannot be further used until the results of the inspections lead to a respective usage decision.  It can be necessary to put such stock into special quarantine areas or red zones, or mark them, in order to avoid unintended use. Blocking movements only via the system might not suffice to comply with regulatory requirements.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2Q Post-production inspection",
          _id: 40,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "a28ea951-7551-11e9-2ddf-001bc640cd9b",
          Description:
            "I2Q In process inspection with inspection points covers the process flow to support the quality inspections in parallel to production without stock relevance.  The quality inspections with inspection points take place during production and can either be valuated manually by the operators or automatically by using sensor data of interfaces test equipment. Specialty of inspection points is that it is possible to define multiple inspection points within one inspection lot. In this way it is possible to observe certain parameters during the production process, or a periodically performed assessment of such. Capturing of valuation results could for example be done within PI sheets or directly within the shop floor integration systems.  It is important to understand that production is not blocked by any results from inspections but is continued even if certain inspection points receive negative valuation. In order to make use of inspection valuations the results need to be reviewed from time to time and corrective measures or further ad-hoc inspections can be triggered.",
          _type: "Scenario",
          GUID: "e4e8df86-5f50-11e9-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Inspection point valuations are reviewed and follow up actions are triggered.",
              _type: "Process",
              GUID: "1c7ed402-7553-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "***When using sophisticated shop floor integration there might be cases where an ad-hoc adjustment of process parameters (e.g. temperature, machine speed) is possible based on automatically measured and captured inspection points. However this would then need to be considered rather a automated process control instead of quality inspection. ***It is possible that inspection points are dynamically created based on the results of the valuation of the current inspection point. However, such logic is more likely provided by specific expert systems. In such cases, the interface from those systems to ERP triggers the creation of a new inspection point.",
              Type: "Business Process",
              Scope:
                "On a recurring basis or ad-hoc the valuation of inspection points are reviewed. Valuations are checked for repeating deviations or trends, might be combined with post-production inspection results and even put into relation to customer complaint cases. Based on this review or analysis corrective measure could be triggered (e.g. re-adjustment of certain machine settings or processing times in the recipe). In severe cases even an ad-hoc quality inspection for certain batches might be initiated in order to block the stock and conduct detailed quality inspections.",
              Outcome: "",
              name: "Review results of inspection point valuation",
              _id: 475,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The inspection point is valuated and the results are captured.",
              _type: "Process",
              GUID: "27e79566-7551-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "***There can be multiple inspection points for one inspection lot. ***Production does not stop during this inspection and there is no sample drawn. ***Capturing of results is typically done by using PI sheets or directly reading data from test equipment (e.g. sensor data), which is interfaced either to the shop floor integration systems or the ERP system.",
              Type: "Business Process",
              Scope:
                "Once production reaches the predefined criteria the valuation of instruction point is triggered and conducted. The valuation results is captured for later review.",
              Outcome: "Inspection is conducted and result is captured.",
              name: "Valuate inspection point",
              _id: 463,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            " ***Typically this scenario is used in process industry in combination with using PI sheets in production.  ***It might make sense to combine the inspection point methodology with a post production quality control in a way that the valuation of inspection points gets reviewed before the product is released for further use. ***In many production processes, a direct intervention by fine-tuning certain parameters of the process or adding components to influence measured characteristics of the product is done by the production operator independent from the inspection lot. It is hence sometimes tricky to separate quality control from the production process as well as quality parameters and batch characteristics, as the measurements and parameters might overlap.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2Q In process inspection with inspection points",
          _id: 39,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "752db0c1-7e45-11e5-0a66-001bc640cd9b",
          Description:
            "I2Q In process inspections scenario describes the verification of goods against specification during the production process. It supports an early detection and determination of potential defects. Inspections during production aims at reducing the amount of damaged goods.  Within this scenario samples are inspected. In process inspections might also be applied as a 100% inspection, though. QM In process inspections are typically applied in complex production environments or as part of set-up and adjustment work during a production process. The inspection via samples takes place before or during performing a production step. Inspection lots undergo quality inspections based on predefined quality properties and methods.",
          _type: "Scenario",
          GUID: "a303a240-ef1a-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Samples (sample may refer also to a 100% inspection) get inspected for each inspection characteristic. The results are recorded. The recorded inspection results document the quality of the inspected products and provide the basis for taking usage decisions and creating quality certificates.",
              _type: "Process",
              GUID: "09bfdc2e-7e45-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Inspections follow a clear and predefined inspection plan. The inspection characteristics define what has to be inspected. The inspection method states how the characteristic has to be assessed. The quality parameters define for the inspected product/good the values range within the result are considered as within specification.",
              Type: "Business Process",
              Scope:
                "After the samples have been extracted, the defined inspection takes place. The inspection encompasses quality inspections based on predefined quality characteristics. The inspection can also include measurements done directly on the product without taking a specific sample for the inspection, or can be done directly by using the integrated measurement devices of the production line.",
              Outcome:
                "Quality characteristics have been assessed and documented.",
              name: "Perform inspection and record results for goods in production",
              _id: 462,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Quality inspections are processes on the basis of inspection lots. If a specific quantity of a material is inspected, an inspection lot must be created in the system. ",
              _type: "Process",
              GUID: "17fae614-e864-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "1",
              Type: "Business Process",
              Scope:
                "Triggered by the event that an inspection is required an inspection plan has to be assigned. Inspection plan together with information derived from the triggering business object (production order, purchase order) and material master basically specify the content of the inspection lot: ***what shall be inspected?   ***by whom?   ***when?    ***in what way?   ***how often?     Once the inspection lot is defined, the source of the lot needs to be noted within the quality system.   All necessary information for an inspection is stored in the inspection lot. When creating the inspection lot, information from the corresponding material master, inspection plan and sampling procedure is evaluated.",
              Outcome:
                "The inspection lot is created and the underlying inspection plan is defined.",
              name: "Create inspection lot",
              _id: 1373,
              Business_Rules:
                "Whenever an inspection has to be carried out, an Inspection lot must be created.   The specific LIMS integration needs to be checked. It is possible to transmit created inspection lots from SAP to LIMS, to perform the sampling calculation there.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Based on the documented results of the quality inspection, a decision on usage and final quality is made by an authorized and qualified person. It specifies whether the goods in the inspection lot have been accepted for use or rejected.",
              _type: "Process",
              GUID: "f072b296-7e45-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The usage decision for an inspection lot confirms that all physical samples have been evaluated and the inspection has been completed.  Usage decisions:    ***unrestricted usage sale/production   ***destruction of goods   ***recycling     ***re-work   ***return   ***restricted usage   (sale/production under certain circumstances - lower quality)   Approval requirements for usage decisions must be defined. The matrix between quality properties and actions should be defined to always ensure the same usage of goods.   Even in case of purchased goods, a new quality certificate might be generated if the goods are intended for sale.   If Laboratory Information Management System (LIMS) is used, the basis of the usage decision can be the recommendation transferred from the LIMS to the ERP.",
              Type: "Business Process",
              Scope:
                "The results of the quality inspection get reviewed and the completeness of the quality report is checked. Usage decisions can be made with the help of a predefined catalogue which includes all allowed codes for usage decisions. After the usage decision is made, the stock posting of material for stock-relevant inspection lots is carried out. The usage decision is communicated and documented, as well as a certificate of quality is generated and signed.",
              Outcome:
                "The decision on usage of goods is evaluated, documented and communicated. A quality certificate is generated if required.",
              name: "Make usage decision",
              _id: 1369,
              Business_Rules:
                "In order to make usage decision, the following conditions must be met: ***The Inspection Lot is released ***Expiration date has been assigned (if required ) ***Inspection results have been recorded for required characteristics, they are valuated and closed.    In case that an interface from SAP to LIMS and from LIMS to SAP (results transferring) are in place, this process takes place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Handle samples process provides information on the collection and extraction of samples.",
              _type: "Process",
              GUID: "07ddae9c-7e45-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The storage of the samples, the amount of samples needed and sampling techniques need to be defined. Sample handling might not be necessary in case a 100% control is performed. In this case, the sample comprises of the total quantity.",
              Type: "Business Process",
              Scope:
                "Once the inspection lot is generated, the samples can be extracted in the correct way, correct amount and with a dedicated sampling technique. The storage conditions shall not have any influence on the quality of the sample.",
              Outcome: "The samples are ready for the inspection.",
              name: "Handle samples",
              _id: 19,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "In reality, in process inspections are often implemented as dedicated production steps rather than using QM for it. However, the benefit of QM inspection lots is that results are documented and the work of QM personnel can be planned better, if it is not anyway a continuous workload.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2Q In process inspection",
          _id: 38,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "ff8b37b1-601e-11e9-2ddf-001bc640cd9b",
          Description:
            "I2Q Quality management with quality notification scenario shows the process flow in order to conduct detailed root cause analyses on quality issues, align either internal or external follow up activities and trigger necessary follow-up activities. In order to do the accompanying documentation quality notifications are used. The scenario is typically triggered by other quality inspection when serious issues have been identified. As a result of the quality management scenario either further ad-hoc inspections or the return process to the supplier could be triggered. The shown scenario covers the case, that inspection during inbound processes identify quality issues and quality management shall determine in more detail how to proceed with the blocked material and whether a return to the supplier needs to be done.",
          _type: "Scenario",
          GUID: "27e79546-7551-11e9-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Conduction of investigation and implementation of corrective actions are monitored.",
              _type: "Process",
              GUID: "bdf94770-6761-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Each defined investigation task and corrective action is monitored with regards to timely performance and result. Deviations from planned timelines can be followed up on. The quality notification is closed once all defined activities have been conducted.",
              Outcome:
                "Actual status of activities is known and quality notification is closed after conduction of defined activities.",
              name: "Monitor investigations and corrective actions",
              _id: 476,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "For all materials related to the quality issue the decision on further usage is taken.",
              _type: "Process",
              GUID: "c38779e9-659c-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                " ***All related materials need to be considered. This includes finished products that might have already been produced using the same raw materials/components. In case products have already been delivered to customer the customer return process also needs to be triggered from within this process.  ***In chemical industry it is a common case that material with quality issues is not returned to the vendor but used in a different way (e.g. concentration) to adjust to the quality deviation. The re-imbursement is then handled independently from the vendor return process. ",
              Type: "Business Process",
              Scope:
                "Based on results of investigations and corrective measures it is determined if the material can be released, released only with a certain restriction on usage, should be reworked, scrapped or returned to the vendor.",
              Outcome: "Decision is taken for each related material.",
              name: "Take decision on further use of material(s)",
              _id: 469,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Suitable corrective actions are defined and triggered.",
              _type: "Process",
              GUID: "1c7ed417-7553-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "***It needs to be determined whether corrective actions need to taken also for other products/plants ***Corrective actions will vary depending on the specific case and are therefore not specified in more detail. One could think of a wide range from adjusting the quality control mechanisms or certain parameters in production process, over rework of product or adjusted usage of the material, down to stop buying materials from the vendor.",
              Type: "Business Process",
              Scope:
                "Based on the investigation results suitable corrective measures are identified. An action plan is set up including determination of responsible people and clear timelines.",
              Outcome:
                "Corrective actions are defined and implementation is triggered.",
              name: "Define and trigger corrective actions",
              _id: 470,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Investigations are conducted in cooperation with the vendor to evaluate the quality issue.",
              _type: "Process",
              GUID: "1c7ed415-7553-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The exact procedure of reporting complaints need to be defined together with the vendor and should be part of contract negotiation. This could also include determination who runs the quality measurements/controls in case of complaints.",
              Type: "Business Process",
              Scope:
                "Based on the information from the quality inspection further suitable investigations are defined and conducted. Typically at least the extent of the quality issue and potential root causes are assessed. Sometimes more detailed quality analyses are conducted in order to support this investigation. The activities are done either in cooperation with the vendor or by the vendor.",
              Outcome:
                "Extent and external root cause of quality issue has been determined.",
              name: "Perform investigation with vendor",
              _id: 468,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Internal investigations are conducted to evaluate the quality issue.",
              _type: "Process",
              GUID: "1c7ed413-7553-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Based on the information from the quality inspection further suitable investigations are defined and conducted. Typically at least the extent of the quality issue and potential root causes are assessed. Sometimes more detailed quality analyses are conducted in order to support this investigation.",
              Outcome:
                "Extent and internal root cause of quality issue has been determined.",
              name: "Perform internal investigation",
              _id: 467,
              Business_Rules:
                "***when using quality notification the investigative activities can be managed with workflows and also monitored regarding status and results. ***depending on the relationship with the vendor the internal results might be shared with the vendor in order to support the investigations conducted by the vendor. ***The exact procedure of reporting complaints need to be defined together with the vendor and should be part of contract negotiation. This could also include determination who runs the quality measurements/controls in case of complaints.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The quality notification is created in order to document the investigation and the definition and implementation of corrective actions as well as further follow-up activities.",
              _type: "Process",
              GUID: "00bed5b1-601f-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Based on a certain inspection lot the quality notification is created. The problem is described, affected objects are identified (e.g. material, batch, equipment, supplier), involved people are named and workflow settings can be maintained.",
              Outcome:
                "The quality notification has been created in is ready to use for managing the quality issue.",
              name: "Create quality notification",
              _id: 473,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2Q Quality management with quality notification",
          _id: 37,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "f1837bb1-7e44-11e5-0a66-001bc640cd9b",
          Description:
            "I2Q Ad-hoc quality inspection scenario covers the process flow to support the control of samples from vendors or customers, retention samples from production, which have to be inspected outside of the regular and planned inspections as part of the material flow along the supply chain.  The final test scope and methods to be used often need to be defined during the inspection process. The quality checks focus on the reason for the inspection such as a specific complaint by a customer, or irregularities during the storage or the production process.",
          _type: "Scenario",
          GUID: "a303a252-ef1a-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Based on the quality inspection information, a decision on usage and quality is made. It specifies whether the goods in the inspection lot have been accepted for use or rejected.",
              _type: "Process",
              GUID: "07ddae81-7e45-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Decisions can be made during inspection lot completion with the help of a predefined catalogue, which includes all allowed codes for  usage decisions. After the usage decision is made, the stock posting of material for stock-relevant inspection lots is carried out. The usage decision as well as the quality degree are communicated and documented.",
              Outcome:
                "The decisions on usage and quality degree of goods are evaluated, documented and communicated. ",
              name: "Make usage decision for ad-hoc inspected materials / goods",
              _id: 36,
              Business_Rules:
                "The usage decision for an inspection lot confirms that all samples have been evaluated and the inspection has been completed.    The usage of already produced goods and intermediate goods should be defined:   ***approval for sale   ***destruction of goods    ***recycling     ***re-work   ***sale (lower quality)      Approval requirements for usage decisions must be defined. The matrix between quality properties and actions should be defined to ensure always the same usage of goods.   Communication channels for the usage decision need to be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Handle samples process provides information on the collection and extraction of samples.",
              _type: "Process",
              GUID: "07ddae9c-7e45-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The storage of the samples, the amount of samples needed and sampling techniques need to be defined. Sample handling might not be necessary in case a 100% control is performed. In this case, the sample comprises of the total quantity.",
              Type: "Business Process",
              Scope:
                "Once the inspection lot is generated, the samples can be extracted in the correct way, correct amount and with a dedicated sampling technique. The storage conditions shall not have any influence on the quality of the sample.",
              Outcome: "The samples are ready for the inspection.",
              name: "Handle samples",
              _id: 19,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Quality inspections are processes on the basis of inspection lots. If a specific quantity of a material is inspected, an inspection lot must be created in the system.",
              _type: "Process",
              GUID: "03110b7d-7e45-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The ad-hoc process is not planned and scheduled by quality management (QM). It must be triggered by an external department. In case of a trigger event, the respective department must inform QM which takes the decision if an ad-hoc inspection must be triggered. The inspection plan for the relevant inspection trigger can differ from the standard inspection plan of the relevant material. Ad-hoc inspection plans include at least the information by whom the inspection will be done and the inspection characteristics. Once the relevant inspection lot is defined, the source of the inspection lot needs to be noted within the quality system. All necessary information for an inspection is stored in the inspection lot. When creating the inspection lot, information from the corresponding material master, standard inspection plan and sampling procedure is evaluated. The inspection itself typically is minimized for the respective inspection trigger.",
              Outcome:
                "The inspection lot and the inspection plan are defined and set up.",
              name: "Create inspection lot for ad-hoc inspection",
              _id: 35,
              Business_Rules:
                "The trigger for the ad-hoc inspection needs to be defined:   ***customer (return consignment)   ***vendor audit    ***production (retention samples)   ***storage control   ***after relocation of goods    ***after adverse events (e.g. non-cooling, water, high temperatures)   ***before repackaging     The quantity control should be defined:   ***single inspection lots    ***full  volume     In case of an inspection of all products, no handling of samples is needed.    ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "If an ad-hoc inspection is required, the material/goods need to be blocked until the end of the inspection. In case the material for an ad-hoc inspection could influence the quality of other goods, the batch has to be flagged and physically separated.",
              _type: "Process",
              GUID: "07ddae90-7e45-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The batch needs to be flagged. In addition, in case of influencing the quality of other goods, it needs to be physically separated. This decision needs to be communicated.",
              Outcome:
                "The relevant batch is flagged and cannot be sold or used for production before a usage decision has been made",
              name: "Block material for usage for ad-hoc inspection",
              _id: 34,
              Business_Rules:
                "It must be defined per material:   ***quarantine requirement (yes, no)   ***marking conditions (specific signs)   ***storage conditions (cooling, humidity)  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Samples (sample may refer also to a 100% inspection) get inspected for each inspection characteristic. The results are recorded.   Depending on the trigger for the ad-hoc inspection results document the quality of the inspected product and provide the basis for taking usage decisions and updating or revoking quality certificates OR provides the basis for decisions on corrective actions and follow-up activities.",
              _type: "Process",
              GUID: "03110b80-7e45-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the inspection lot was extracted, the defined inspection takes place. The inspection encompasses quality inspections based on predefined quality characteristics, as well as additional characteristics which will be added during the inspection as necessary. ",
              Outcome:
                "Quality characteristics have been assessed and documented.",
              name: "Inspect and record results of ad-hoc inspection",
              _id: 33,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2Q Ad-hoc quality inspections",
          _id: 32,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "d906a511-7e46-11e5-0a66-001bc640cd9b",
          Description:
            "I2Q Shelf life management scenario covers the process flow of monitoring during the shelf life of manufactured goods, raw materials and semifinished materials, and initiates related follow up actions.  The shelf life itself is typically defined and documented during the manufacturing process for goods that have a limited storage time before becoming unfit for use or consumption. In many cases the handling of shelf life products is subject to regulatory and legal requirements.",
          _type: "Scenario",
          GUID: "a303a24e-ef1a-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Samples (sample may refer also to a 100% inspection) get inspected for each inspection characteristic. The results are recorded.   The inspection plan for end-of-shelf-life batches can differ from the original inspection plan used at the time of receiving the product from production or an external vendor.",
              _type: "Process",
              GUID: "f38ca755-7e46-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Inspections follow a clear and predefined inspection plan. The inspection characteristics define what has to be inspected. The inspection method states how the characteristic has to be assessed. The quality parameters define for the inspected product/good the values range within the result are considered as within specification.",
              Type: "Business Process",
              Scope:
                "Once the inspection lot was extracted, the defined inspection takes place. The inspection comprises quality inspections based on predefined quality characteristics.",
              Outcome:
                "Quality characteristics have been assessed and documented.",
              name: "Inspect and record results for end-of-shelf-life batches",
              _id: 31,
              Business_Rules:
                "Clear guidelines and procedures have to be established to comply with any regulatory requirement for extending shelf-life, if allowed at all.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Expired material is posted to the quality inspection stock and blocked against usage.",
              _type: "Process",
              GUID: "f38ca743-7e46-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Material is posted to the quality stock.  In case the batch could influence the quality of other goods in the stock, the batch has to be flagged and physically separated.",
              Outcome: "Material is blocked against usage.",
              name: "Block material for usage",
              _id: 30,
              Business_Rules:
                "It must be defined per material:   ***quarantine requirement (yes, no)   ***marking conditions (specific signs)   ***storage conditions (cooling, humidity)  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The identification of end-of-shelf-life material batches process covers monitoring of manufactured goods, raw and semifinished materials ,and its shelf-life information to ensure product quality.",
              _type: "Process",
              GUID: "f38ca74f-7e46-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The process is triggered by the end-of-shelf life of products or materials with limited storage time.",
              Outcome:
                "The relevant batches for the quality check are defined.",
              name: "Identify end-of-shelf-life material batches",
              _id: 29,
              Business_Rules:
                "The inspection is triggered within a specified automated or manual report before the batch expiry date. This period needs to be defined per material and monitored per batch.   It must be defined per material:   ***if an extension is allowed   ***quality properties and allowed ranges under which an extension is possible   ***if a physical separation is required        ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Handle samples process provides information on the collection and extraction of samples.",
              _type: "Process",
              GUID: "07ddae9c-7e45-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The storage of the samples, the amount of samples needed and sampling techniques need to be defined. Sample handling might not be necessary in case a 100% control is performed. In this case, the sample comprises of the total quantity.",
              Type: "Business Process",
              Scope:
                "Once the inspection lot is generated, the samples can be extracted in the correct way, correct amount and with a dedicated sampling technique. The storage conditions shall not have any influence on the quality of the sample.",
              Outcome: "The samples are ready for the inspection.",
              name: "Handle samples",
              _id: 19,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Based on the quality inspection information, a decision on usage and quality is made.  Based on the inspection result, a new shelf-life date can be determined.",
              _type: "Process",
              GUID: "f38ca758-7e46-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Decisions can be made during the inspection lot completion with the help of a predefined catalogue which includes all allowed codes for usage decisions. After the usage decision is made, the stock posting of material for stock-relevant inspection lots is carried out and a new shelf-life date can be set. The usage decision is communicated and documented as well as a certificate of quality is generated and signed.",
              Outcome:
                "The decision on usage of goods is evaluated, documented and communicated. If the shelf-life of the batch will be extended, a new shelf-life date is set and communicated. ",
              name: "Make usage decision for end-of-shelf-life batches",
              _id: 28,
              Business_Rules:
                "The usage decision for an inspection lot confirms that all physical samples have been evaluated and the inspection has been completed.    The usage of already produced goods and intermediate goods should be defined:    ***approval for sale   ***destruction of goods    ***recycling     ***re-work   ***sale (lower quality)      Approval requirements for usage decisions must be defined. The matrix between quality properties and actions should be defined to always ensure the same usage of goods.   Communication channels for the usage decision need to be defined.   New shelf-life date",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Quality inspections are processes on the basis of inspection lots. If a specific quantity of a material is inspected, an inspection lot must be created in the system. ",
              _type: "Process",
              GUID: "17fae614-e864-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "1",
              Type: "Business Process",
              Scope:
                "Triggered by the event that an inspection is required an inspection plan has to be assigned. Inspection plan together with information derived from the triggering business object (production order, purchase order) and material master basically specify the content of the inspection lot: ***what shall be inspected?   ***by whom?   ***when?    ***in what way?   ***how often?     Once the inspection lot is defined, the source of the lot needs to be noted within the quality system.   All necessary information for an inspection is stored in the inspection lot. When creating the inspection lot, information from the corresponding material master, inspection plan and sampling procedure is evaluated.",
              Outcome:
                "The inspection lot is created and the underlying inspection plan is defined.",
              name: "Create inspection lot",
              _id: 1373,
              Business_Rules:
                "Whenever an inspection has to be carried out, an Inspection lot must be created.   The specific LIMS integration needs to be checked. It is possible to transmit created inspection lots from SAP to LIMS, to perform the sampling calculation there.",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2Q Shelf life management",
          _id: 27,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "43da2b11-7e46-11e5-0a66-001bc640cd9b",
          Description:
            "I2Q Lean inbound inspection process covers the process flow for either not performing a standard quality inspection, or for minimizing the inspection effort itself. In this scenario, only material/goods documentation provided by the vendor (including quality certificate) and the shipment documentation are checked against the internal specifications. No actual inspection of the material is performed. This scenario is typically only applied for incoming materials/goods.    Before choosing this QM inspection strategy, it is recommended to evaluate the risk that some products of lower quality could be used in production or sold to customers. Therefore, it is strongly recommended to audit the vendor quality inspection processes on a regular basis. A necessary prerequisite for a lean quality inspection are inspections at the vendor before shipping materials and goods. The handed over materials and goods quality certificates - together with the shipment documentation and the specifications - are the basis for the lean inspection. An additional necessary prerequisite is the flawless and unaltered condition of the goods. This must be checked at the good receipt.",
          _type: "Scenario",
          GUID: "a303a24a-ef1a-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The Inspect and record results of lean inspection process describes the inspection and the results record for each inspection characteristic of an inspection plan which is assigned to the inspection lot. Basis for the inspection are the vendor goods quality certificates as well as goods specifications, the internal goods specification and the shipment documentation. The recorded inspection results document the quality of the inspected product and provide the basis for taking usage decision.",
              _type: "Process",
              GUID: "4c0e8a6b-7e46-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the inspection lot was created, the defined inspection takes place. The inspection encompasses quality inspections based on predefined quality characteristics.",
              Outcome:
                "Based on the quality inspection information, a decision on usage and quality can take place.",
              name: "Inspect and record results of lean inbound inspection",
              _id: 474,
              Business_Rules:
                "The inspection method (master data of inspection plan) of goods and the shipment needs to be defined.   The quality parameters (master data of inspection plan) and the allowed ranges should be defined for the specific production phase and the intermediate goods:   ***weight    ***temperatures   ***color, etc.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The create inspection lot for lean inbound inspection process covers the creation of the inspection lot and the collation of handed over quality certificates, as well as shipment documentations.",
              _type: "Process",
              GUID: "4c0e8a71-7e46-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The process is triggered by the inspection plan that includes:   ***What shall be inspected?   ***By whom?    ***When?    ***In what way?   ***How often?     Once the inspection lot is defined, the source of the lot needs to be noted within the quality system. All necessary information for an inspection is stored in the inspection lot. When creating the inspection lot, information from the corresponding material master and inspection plan is evaluated.",
              Outcome:
                "The inspection lot and the inspection plan are defined and set up.",
              name: "Create inspection lot for lean inbound inspection",
              _id: 466,
              Business_Rules:
                "The required documents need to be defined:  ***quality certificates of goods / materials ***specification (vendor) ***specification (internal) ***shipment documentation    In some cases the inspection lot might only consist of checking a quality certificate. For defined vendor and materials/goods, a lean inspection is allowed for.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Based on the quality inspection information, a decision on usage and quality is. It specifies whether the goods in the inspection lot have been accepted for use or rejected.",
              _type: "Process",
              GUID: "f200ccc1-7e45-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Decisions can be made during the inspection lot completion with the help of a predefined catalogue which includes all allowed codes for usage decisions. After the usage decision is made, the stock posting of material for stock-relevant inspection lots is carried out. The usage decision as well as the quality degree are communicated and documented.",
              Outcome:
                "The decisions on usage and quality degree of goods are evaluated, documented and communicated. ",
              name: "Make lean usage decision for purchased materials / goods",
              _id: 471,
              Business_Rules:
                "The usage decision for an inspection lot confirms that all relevant quality certificates, specifications and shipment documents have been evaluated and the inspection has been completed.    The usage of already produced goods and intermediate goods should be defined:   ***approval for sale/use    ***return to vendor   ***sale (lower quality)     Approval requirements for usage decisions must be defined. The matrix between quality properties and actions should be defined to always ensure the same usage of goods.   Communication channels for the usage decision need to be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After quality results of all inbound goods are defined and tracked, the information regarding the vendor shall be updated to ensure a constant quality for the delivered products or goods.",
              _type: "Process",
              GUID: "fabfdc69-e86b-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The process is triggered by the final decision of the usage of the delivered goods.  The result shall have an influence on sourcing considerations and any further negotiations with the supplier, as well as should be used to commonly further develop the vendors quality management system.",
              Outcome:
                "A track record on quality related data and KPIs is established.",
              name: "Update quality information in vendor record",
              _id: 21,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2Q Lean inbound inspection",
          _id: 26,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "18e3e701-7624-11e9-2ddf-001bc640cd9b",
          Description:
            "I2Q In process inspection with Laboratory Information Management System (LIMS) integration scenario describes the process flow of in process quality inspections supported by LIMS. After an inspection lot has been created and samples have been drawn, the actual inspection is conducted and recorded in the LIMS. Often this is done with direct integration to the laboratory equipment to transfer analytic data directly to the LIMS.  After assessing the inspection data, a usage recommendation is documented in LIMS and then transferred to ERP as basis for the actual usage decision. As an optional process the management of retention samples within the LIMS is represented in this scenario.",
          _type: "Scenario",
          GUID: "27e79542-7551-11e9-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Samples get inspected for each inspection characteristic and the results are recorded in LIMS.",
              _type: "Process",
              GUID: "a25729e1-38dd-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "Inspections follow a clear and predefined inspection plan. The inspection characteristics define what has to be inspected. The inspection method states how the characteristic has to be assessed. The quality parameters define for the inspected product/good the values range within the result are considered as within specification.   The inspection data transferred from LIMS to ERP depends on the specific use case.",
              Type: "Business Process",
              Scope:
                "After the samples have been distributed to labs, the defined inspection is initiated. Typically the results are captured in LIMS often by using automated interfacing to laboratory equipment. In addition the efforts might be captured. Finally, inspection data is maintained in LIMS and transferred to ERP.",
              Outcome:
                "Inspection results have been recorded in LIMS and inspection data has been sent to ERP.",
              name: "Inspect and record results in LIMS",
              _id: 25,
              Business_Rules:
                "An interface from LIMS to SAP (results transferring) takes place as the usage decision is made in SAP.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Handle samples process provides information on the collection and extraction of samples.",
              _type: "Process",
              GUID: "07ddae9c-7e45-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The storage of the samples, the amount of samples needed and sampling techniques need to be defined. Sample handling might not be necessary in case a 100% control is performed. In this case, the sample comprises of the total quantity.",
              Type: "Business Process",
              Scope:
                "Once the inspection lot is generated, the samples can be extracted in the correct way, correct amount and with a dedicated sampling technique. The storage conditions shall not have any influence on the quality of the sample.",
              Outcome: "The samples are ready for the inspection.",
              name: "Handle samples",
              _id: 19,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Based on the inspection data documented in LIMS the usage decision is prepared by documenting a recommendation. ",
              _type: "Process",
              GUID: "64e5d47a-8055-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: " ",
              Type: "Business Process",
              Scope:
                "The results of the quality inspection get reviewed and the completeness of the quality report is checked. Usage recommendation can be made with the help of a predefined catalogue which includes all allowed codes for usage decisions. After the usage recommendation is made in LIMS, the information is sent to ERP. ",
              Outcome:
                "A recommendation for the actual usage decision has been documented in LIMS and transferred to ERP.",
              name: "Document usage recommendation in LIMS",
              _id: 24,
              Business_Rules: " ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process reflects the lifecycle of the retention sample including additional analyses and later scrapping.",
              _type: "Process",
              GUID: "6e792144-99a0-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the samples are taken, rentention sample is created, analysed and stored.",
              Outcome: "Retention sample is kept on stock.",
              name: "Manage retention samples in LIMS",
              _id: 23,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Quality inspections are processes on the basis of inspection lots. If a specific quantity of a material is inspected, an inspection lot must be created in the system. ",
              _type: "Process",
              GUID: "17fae614-e864-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "1",
              Type: "Business Process",
              Scope:
                "Triggered by the event that an inspection is required an inspection plan has to be assigned. Inspection plan together with information derived from the triggering business object (production order, purchase order) and material master basically specify the content of the inspection lot: ***what shall be inspected?   ***by whom?   ***when?    ***in what way?   ***how often?     Once the inspection lot is defined, the source of the lot needs to be noted within the quality system.   All necessary information for an inspection is stored in the inspection lot. When creating the inspection lot, information from the corresponding material master, inspection plan and sampling procedure is evaluated.",
              Outcome:
                "The inspection lot is created and the underlying inspection plan is defined.",
              name: "Create inspection lot",
              _id: 1373,
              Business_Rules:
                "Whenever an inspection has to be carried out, an Inspection lot must be created.   The specific LIMS integration needs to be checked. It is possible to transmit created inspection lots from SAP to LIMS, to perform the sampling calculation there.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Based on the documented results of the quality inspection, a decision on usage and final quality is made by an authorized and qualified person. It specifies whether the goods in the inspection lot have been accepted for use or rejected.",
              _type: "Process",
              GUID: "f072b296-7e45-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The usage decision for an inspection lot confirms that all physical samples have been evaluated and the inspection has been completed.  Usage decisions:    ***unrestricted usage sale/production   ***destruction of goods   ***recycling     ***re-work   ***return   ***restricted usage   (sale/production under certain circumstances - lower quality)   Approval requirements for usage decisions must be defined. The matrix between quality properties and actions should be defined to always ensure the same usage of goods.   Even in case of purchased goods, a new quality certificate might be generated if the goods are intended for sale.   If Laboratory Information Management System (LIMS) is used, the basis of the usage decision can be the recommendation transferred from the LIMS to the ERP.",
              Type: "Business Process",
              Scope:
                "The results of the quality inspection get reviewed and the completeness of the quality report is checked. Usage decisions can be made with the help of a predefined catalogue which includes all allowed codes for usage decisions. After the usage decision is made, the stock posting of material for stock-relevant inspection lots is carried out. The usage decision is communicated and documented, as well as a certificate of quality is generated and signed.",
              Outcome:
                "The decision on usage of goods is evaluated, documented and communicated. A quality certificate is generated if required.",
              name: "Make usage decision",
              _id: 1369,
              Business_Rules:
                "In order to make usage decision, the following conditions must be met: ***The Inspection Lot is released ***Expiration date has been assigned (if required ) ***Inspection results have been recorded for required characteristics, they are valuated and closed.    In case that an interface from SAP to LIMS and from LIMS to SAP (results transferring) are in place, this process takes place.",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "This scenario shows one of various options on how a LIMS integration could be done. Three aspects need to be considered, when discussing LIMS integration. 1) integration during inspection lot creation (determination of inspections, number of samples, sample labels, etc. 2) integration into laboratory equipment regarding automatic data exchange or even execution of certain analyses 3) Integration during usage decision (recommendation vs. decision and extend of data exchange",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2Q In process inspection with LIMS integration",
          _id: 22,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "6aef4e90-65a8-11e9-2ddf-001bc640cd9b",
          Description:
            "I2Q Inbound inspection scenario covers the process flow to control the quality of incoming goods and materials before further processing. The control ensures that the delivered good or material comply with the specification agreed with the supplier. The process can also cover only inspection of required certificates etc. - not inspection of goods themselves. (e.g. in drop shipment scenarios).",
          _type: "Scenario",
          GUID: "a303a248-ef1a-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Quality inspections are processes on the basis of inspection lots. If a specific quantity of a material is inspected, an inspection lot must be created in the system. ",
              _type: "Process",
              GUID: "17fae614-e864-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "1",
              Type: "Business Process",
              Scope:
                "Triggered by the event that an inspection is required an inspection plan has to be assigned. Inspection plan together with information derived from the triggering business object (production order, purchase order) and material master basically specify the content of the inspection lot: ***what shall be inspected?   ***by whom?   ***when?    ***in what way?   ***how often?     Once the inspection lot is defined, the source of the lot needs to be noted within the quality system.   All necessary information for an inspection is stored in the inspection lot. When creating the inspection lot, information from the corresponding material master, inspection plan and sampling procedure is evaluated.",
              Outcome:
                "The inspection lot is created and the underlying inspection plan is defined.",
              name: "Create inspection lot",
              _id: 1373,
              Business_Rules:
                "Whenever an inspection has to be carried out, an Inspection lot must be created.   The specific LIMS integration needs to be checked. It is possible to transmit created inspection lots from SAP to LIMS, to perform the sampling calculation there.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After quality results of all inbound goods are defined and tracked, the information regarding the vendor shall be updated to ensure a constant quality for the delivered products or goods.",
              _type: "Process",
              GUID: "fabfdc69-e86b-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The process is triggered by the final decision of the usage of the delivered goods.  The result shall have an influence on sourcing considerations and any further negotiations with the supplier, as well as should be used to commonly further develop the vendors quality management system.",
              Outcome:
                "A track record on quality related data and KPIs is established.",
              name: "Update quality information in vendor record",
              _id: 21,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Based on the documented results of the quality inspection, a decision on usage and final quality is made by an authorized and qualified person. It specifies whether the goods in the inspection lot have been accepted for use or rejected.",
              _type: "Process",
              GUID: "f072b296-7e45-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The usage decision for an inspection lot confirms that all physical samples have been evaluated and the inspection has been completed.  Usage decisions:    ***unrestricted usage sale/production   ***destruction of goods   ***recycling     ***re-work   ***return   ***restricted usage   (sale/production under certain circumstances - lower quality)   Approval requirements for usage decisions must be defined. The matrix between quality properties and actions should be defined to always ensure the same usage of goods.   Even in case of purchased goods, a new quality certificate might be generated if the goods are intended for sale.   If Laboratory Information Management System (LIMS) is used, the basis of the usage decision can be the recommendation transferred from the LIMS to the ERP.",
              Type: "Business Process",
              Scope:
                "The results of the quality inspection get reviewed and the completeness of the quality report is checked. Usage decisions can be made with the help of a predefined catalogue which includes all allowed codes for usage decisions. After the usage decision is made, the stock posting of material for stock-relevant inspection lots is carried out. The usage decision is communicated and documented, as well as a certificate of quality is generated and signed.",
              Outcome:
                "The decision on usage of goods is evaluated, documented and communicated. A quality certificate is generated if required.",
              name: "Make usage decision",
              _id: 1369,
              Business_Rules:
                "In order to make usage decision, the following conditions must be met: ***The Inspection Lot is released ***Expiration date has been assigned (if required ) ***Inspection results have been recorded for required characteristics, they are valuated and closed.    In case that an interface from SAP to LIMS and from LIMS to SAP (results transferring) are in place, this process takes place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Samples (sample may refer also to a 100% inspection) get inspected for each inspection characteristic. The results are recorded.   Basis for the inspection are the internal goods specification and the vendor goods specification. The recorded inspection results document the quality of the inspected product, which might include quality related documents and certificates provided by the vendor. ",
              _type: "Process",
              GUID: "f072b287-7e45-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Inspections follow a clear and predefined inspection plan. The inspection characteristics define what has to be inspected. The inspection method states how the characteristic has to be assessed. The quality parameters define for the inspected product/good the values range within the result are considered as within specification.",
              Type: "Business Process",
              Scope:
                "Once the inspection lot was extracted, the defined inspection takes place. The inspection comprises quality inspections based on predefined quality characteristics. The inspection can also include measurements done directly on the product, without taking a specific sample for the inspection.",
              Outcome:
                " Quality characteristics have been assessed and documented. Any required documents and certificates have been checked.",
              name: "Inspect and record results for purchased materials/ goods",
              _id: 20,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Handle samples process provides information on the collection and extraction of samples.",
              _type: "Process",
              GUID: "07ddae9c-7e45-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The storage of the samples, the amount of samples needed and sampling techniques need to be defined. Sample handling might not be necessary in case a 100% control is performed. In this case, the sample comprises of the total quantity.",
              Type: "Business Process",
              Scope:
                "Once the inspection lot is generated, the samples can be extracted in the correct way, correct amount and with a dedicated sampling technique. The storage conditions shall not have any influence on the quality of the sample.",
              Outcome: "The samples are ready for the inspection.",
              name: "Handle samples",
              _id: 19,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "I2Q Inbound inspection",
          _id: 18,
          Business_Rules: "",
          Prerequisite: "",
        },
      ],
      Description:
        "The Inspect to Quality (I2Q) domain describes processes required for quality assurance and quality management. It includes quality assurance activities for purchased and returned goods, and in-process and end-control of manufactured products. ",
      _type: "Domain",
      GUID: "964b5c34-642b-11e4-55cc-001bc640cd9b",
      trial: "true",
      Advisory_Notes: "",
      Type: "E2E-Domain",
      Scope: "",
      Outcome: "",
      name: "Inspect to Quality",
      _id: 17,
      Business_Rules: "",
      Prerequisite: "",
    },
    {
      BPMN_GUID: "86fd0cc1-6f14-11e8-2ddf-001bc640cd9b",
      scenario_of: [
        {
          BPMN_GUID: "60393961-7e4e-11e5-0a66-001bc640cd9b",
          Description:
            "Customer complaints without returns scenario covers handling of sales related disputes with customers, whereby the complaint is resolved without physical return of products by the customer.  Typically such complaints regard pricing, delivery dates/conditions etc., but may also arise from products not satisfying customer requirements. In the latter case the scenario is mostly used, if the return of products is not economically reasonable and the products are scrapped at the customers location or can still be used but with a price reduction.",
          _type: "Scenario",
          GUID: "8c942b32-ef45-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "A created credit memo can either be used to partly or fully clear an existing customer invoice or forms a base for making a payment to customer.    ",
              _type: "Process",
              GUID: "aa8c61b7-7e48-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once credit memo is created and approved, it must be checked if there are any open customer invoices, which can be cleared with it. If no open customer invoices exist, a direct payment to customer must be made to close the credit memo. Latter option is rarely used.",
              Outcome:
                "Credit memo is cleared and payment to customer made if required.",
              name: "Manage credit memo payment",
              _id: 1374,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Receiving the customer complaint and capturing it in a format necessary for further processing helps to ensure the effective and efficient handling of customer disputes.",
              _type: "Process",
              GUID: "1f6c491c-7e4d-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the customer places a complaint, the data is recorded, stored and forwarded for further processing.",
              Outcome:
                "All relevant information regarding the customers complaint is documented.",
              name: "Document and assess customer complaint",
              _id: 1370,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Closing customer complaint is the final step in the customer dispute management process and occurs when all matters related to the dispute have been settled.         .",
              _type: "Process",
              GUID: "a3824c8c-e992-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the issuing of a credit memo or replacement, or a return by the customer has occurred, all information related to the dispute settlement is recorded, stored and sent to the customer. This marks the end of the customer dispute.",
              Outcome: "Customer complaint is closed",
              name: "Close customer complaint",
              _id: 1372,
              Business_Rules:
                "It is important to decide:   ***Who is responsible for closing what customer complaint   ***Whether and how confirmation of the closure needs to be confirmed by the customer?    ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A credit memo is issued by the seller of goods to the customer, reducing the amount that is owed to the seller under the terms of an earlier invoice. A credit memo may be issued because the goods were returned to the seller, or there may have been a pricing dispute or other reasons for which the customer will not pay the seller the full amount of the invoice.       ",
              _type: "Process",
              GUID: "e83072e4-e98c-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "The appropriate sales tax is also calculated along with any shipping charges that are being credited to the customer. ",
              Type: "Business Process",
              Scope:
                "Once the decision is made to compensate a customer with a credit memo, the document is created with details regarding reduction in the previous amount owed. The appropriate sales tax is also calculated along with any shipping charges that are being credited to the customer.",
              Outcome: "Credit memo is created and sent to the customer.",
              name: "Create credit memo",
              _id: 1368,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "ASS Customer complaints without returns",
          _id: 16,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "cec148a1-7e5d-11e5-0a66-001bc640cd9b",
          Description:
            "This scenario describes the sales of services and billing with SAP CS. The service department receives a problem notification about an installed equipment at a customers site. The example depicted here shows both options of performing the repair service free of charge (goodwill) and billable.  ",
          _type: "Scenario",
          GUID: "7a693942-ef3c-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the planning of the service execution. Based on the description of the service order this can include the planned working hours and the required material/spare parts used for the repair process. A first repair cost calculation is calculated. ",
              _type: "Process",
              GUID: "35d8dd2f-7eea-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Capture estimates on work hours and required material/spare parts, and calculate the costs for the repair.",
              Outcome: "Costs are calculated for the service order.",
              name: "Process service order",
              _id: 483,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the receipt of a service request of a customer for an equipment. From a service notification, a service order is directly created.",
              _type: "Process",
              GUID: "35d8dd17-7eea-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "A service notification with reference to an equipment master record is captured. The related service order is generated automatically.",
              Outcome: "Service notification and service order created.",
              name: "Create service notification and service order",
              _id: 485,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The service department decides to perform the repair service free of charge (goodwill).    ",
              _type: "Process",
              GUID: "31be9a19-7eea-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Maintain repair service as free of charge and confirm.",
              Outcome: "Service order confirmed and ready for execution.",
              name: "Confirm service order for service execution (with goodwill)",
              _id: 489,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of a customer invoice provides documentation of the financial obligation related to a customer order. The customer invoice is created from a sales order.",
              _type: "Process",
              GUID: "75ff0dfc-e8bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Circumstances such as required documents for customs clearance or advance payments might have an impact on the timing when an invoice needs to be created during the sales process.",
              Type: "Business Process",
              Scope:
                "After the customer order has been fulfilled, the invoice is created. It provides the customer with information required to settle the payment related to their order.",
              Outcome: "Invoice is created and sent to the customer.",
              name: "Create customer invoice",
              _id: 1363,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once all service order activities are complete and completion confirmations are posted, the status of the service order can be set to technically complete.",
              _type: "Process",
              GUID: "49b377d1-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The status of the service order is set to technically complete.",
              Outcome: "Service is technically complete.",
              name: "Technically complete service order",
              _id: 2,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Spare parts have been reserved from the service order in the stock for the repair. Spare part consumption takes place during the service process and must be recorded. Stock level in the system must be lowered accordingly.",
              _type: "Process",
              GUID: "499e1b3d-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Confirmation of material consumption, goods issue adjusts inventory and the spare parts are accounted to the service order as costs.",
              Outcome: "Material consumption captured and goods issue posted.",
              name: "Confirm consumption of spare parts",
              _id: 3,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Employees working on projects or services have to record the hours spend for it. This can be done using Cross-Application Time Sheet (CATS). CATS is a tool for recording working times and tasks. ",
              _type: "Process",
              GUID: "1f40c4e3-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Maintenance of working hours, approval of working hours by the manager, transfer of working hours to controlling.",
              Outcome: "Working hours are recorded.",
              name: "Record and approve working hours",
              _id: 1261,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the service execution the billing request needs to be created. Due to the previous decision that the customer will not be invoiced due to action of goodwill the pricing within the billing request needs to be corrected to 0. Once the billing has been adjusted and saved the system automatically blocks the billing request, which needs to be removed from it.",
              _type: "Process",
              GUID: "35d8dd0b-7eea-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Correct price for service 0, unblock billing request.",
              Outcome: "Billing request created.",
              name: "Create billing request (with goodwill)",
              _id: 386,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "With the commercial completion of the service, no more costs can be allocated to the service. The service order is completed from an accounting/controlling perspective. This process describes the settling of the service order, which is the posting of all costs and revenues related to the service order and its transfer to the profitability analysis.",
              _type: "Process",
              GUID: "499e1b10-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Post costs and revenues related to the service order and transfer to the profitability analysis via settlement, complete service order.",
              Outcome:
                "All costs and revenues settled to service order and service order is closed from a business perspective.",
              name: "Settle and complete service order",
              _id: 484,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The process describes materials/spare parts/working hours used for the execution of the service and its confirmation with reference to the service order.",
              _type: "Process",
              GUID: "f56c62e3-7e51-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Capturing of resource-related expenses.",
              Outcome: "Billing request created.",
              name: "Create billing request",
              _id: 385,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The service must be executed according to the specifications provided in the service order. ",
              _type: "Process",
              GUID: "49b377d4-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the service has been dispatched, required activities are carried out to perform the service. After service execution, it is required to document the provided service.",
              Outcome: "Service operations are fulfilled.",
              name: "Perform service",
              _id: 1366,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "ASS Service order and billing",
          _id: 15,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "df84c7e1-7e51-11e5-0a66-001bc640cd9b",
          Description:
            "The service department receives a repair request from a customer. A quotation is created based on the repair request and send out to the customer. Only if the customer accepts the quotation, the service is further processed. The customer delivers the damaged item to a repair center, for which the customer does not have a valid warranty. After the service execution working times are maintained and approved within a time recording system (e.g.CATS). It is possible that spare parts were used in the repair process. The costs for the repair (e.g. spare parts, working hours) are invoiced to the customer.   ",
          _type: "Scenario",
          GUID: "7a69393c-ef3c-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The service must be executed according to the specifications provided in the service order. ",
              _type: "Process",
              GUID: "49b377d4-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the service has been dispatched, required activities are carried out to perform the service. After service execution, it is required to document the provided service.",
              Outcome: "Service operations are fulfilled.",
              name: "Perform service",
              _id: 1366,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Based on the equipment number, the service employee can perform a warranty check. If the  equipment has a valid warranty which covers the kind of damage a sales order free of charge (potentially with returns delivery) is created. If the warranty does not apply, the customer is invoiced for the repair.",
              _type: "Process",
              GUID: "499e1b34-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Check customer warranty.",
              Outcome: "Warranty status determined.",
              name: "Determine warranty status",
              _id: 14,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the quotation acceptance of  the customer the release of the service order is triggered. Furthermore, spare parts that are required to execute the service are reserved.",
              _type: "Process",
              GUID: "bc205e7b-e8da-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Release service order and reserve spare parts.",
              Outcome: "Service order released and spare parts reserved.",
              name: "Release service order",
              _id: 13,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A delivery is the central object of the goods receipt process containing all the data required for triggering and monitoring it, starting from goods receipt in the yard and ending with transferral of the goods to the final putaway. In a customer return (as well as consignment pick-up) process, a return delivery document is used for this purpose.",
              _type: "Process",
              GUID: "3712628c-e9bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the return order (consignment pick-up order for consignment process) is created, a return delivery is created with reference to it.",
              Outcome:
                "Return delivery is created and goods receipt process can be initiated. ",
              name: "Create return delivery",
              _id: 1371,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In this process goods receipt posting is performed thus triggering an update in inventory levels. As the material remains property of the customer no postings and accounting are required.",
              _type: "Process",
              GUID: "41a28420-3c0a-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Goods receipt for received goods is posted and paper documentation is created as required.",
              Outcome:
                "Goods receipt material document created, as required in addition goods receipt slip.",
              name: "Perform goods receipt  for customer-owned material",
              _id: 12,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In this process the shipment documents are prepared and the goods issue gets posted. In some cases shipment documents may have to be printed in advance to be included in the packaging.",
              _type: "Process",
              GUID: "41a28422-3c0a-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Goods issue posting and printing of transport and customs documents are involved in this process.",
              Outcome: "Goods issue posted and shipment ready for dispatch.",
              name: "Perform goods issue for customer-owned material",
              _id: 11,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The service employee calls up the outstanding notification. The service employee defines further actions that have to be taken e.g. creation of service order.  Optionally, the service order employee requests more information from the customer prior to deciding if the service notification is further processed. The customer can now be informed that his service request is further processed.",
              _type: "Process",
              GUID: "f56c6304-7e51-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Call up notification, call back customer and create service order.",
              Outcome: "Service order created.",
              name: "Process service notification and create service order",
              _id: 10,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the receipt of a service request of a customer and how to proceed with the request.",
              _type: "Process",
              GUID: "499e1b19-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Create and maintain the service notification based on the customers request for a service.",
              Outcome: "Service notification created.",
              name: "Create service notification",
              _id: 8,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of a customer invoice provides documentation of the financial obligation related to a customer order. The customer invoice is created from a sales order.",
              _type: "Process",
              GUID: "75ff0dfc-e8bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Circumstances such as required documents for customs clearance or advance payments might have an impact on the timing when an invoice needs to be created during the sales process.",
              Type: "Business Process",
              Scope:
                "After the customer order has been fulfilled, the invoice is created. It provides the customer with information required to settle the payment related to their order.",
              Outcome: "Invoice is created and sent to the customer.",
              name: "Create customer invoice",
              _id: 1363,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Employees working on projects or services have to record the hours spend for it. This can be done using Cross-Application Time Sheet (CATS). CATS is a tool for recording working times and tasks. ",
              _type: "Process",
              GUID: "1f40c4e3-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Maintenance of working hours, approval of working hours by the manager, transfer of working hours to controlling.",
              Outcome: "Working hours are recorded.",
              name: "Record and approve working hours",
              _id: 1261,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once all service order activities are complete and completion confirmations are posted, the status of the service order can be set to technically complete.",
              _type: "Process",
              GUID: "49b377d1-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The status of the service order is set to technically complete.",
              Outcome: "Service is technically complete.",
              name: "Technically complete service order",
              _id: 2,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Spare parts have been reserved from the service order in the stock for the repair. Spare part consumption takes place during the service process and must be recorded. Stock level in the system must be lowered accordingly.",
              _type: "Process",
              GUID: "499e1b3d-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Confirmation of material consumption, goods issue adjusts inventory and the spare parts are accounted to the service order as costs.",
              Outcome: "Material consumption captured and goods issue posted.",
              name: "Confirm consumption of spare parts",
              _id: 3,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "ASS Repair center services processing",
          _id: 9,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "95042a31-7e5b-11e5-0a66-001bc640cd9b",
          Description:
            "In a service contract management scenario a long-term contract for provision of services is negotiated with the customer. During the course of the contract, the customer places his service requests as call-offs against the contract (alternatively regular provision of e.g. maintenance services can take place, which does not require any trigger from customer). Such call-offs do not require processing of individual customer orders (price determination, credit management etc.), since all terms are set in contract.  When performing the service, additional costs such as travel activities and spare parts might occur. Those costs can be billed to the customer. The depicted scenario shows the typical process flow in case of a field service. ",
          _type: "Scenario",
          GUID: "7a69393a-ef3c-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the receipt of a service request of a customer and how to proceed with the request.",
              _type: "Process",
              GUID: "499e1b19-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Create and maintain the service notification based on the customers request for a service.",
              Outcome: "Service notification created.",
              name: "Create service notification",
              _id: 8,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the recording of travel activities that can occur when performing a service.       ",
              _type: "Process",
              GUID: "84843a3d-7e5b-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Creation of trips including start and end date of trip, travel expenses, location, finalization of travel activities recording by setting the status to approved and settled, posting travel activities to financial accounting.",
              Outcome: "Travel activities recorded and posted to accounting.",
              name: "Record travel activities",
              _id: 1265,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of a customer invoice provides documentation of the financial obligation related to a customer order. The customer invoice is created from a sales order.",
              _type: "Process",
              GUID: "75ff0dfc-e8bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Circumstances such as required documents for customs clearance or advance payments might have an impact on the timing when an invoice needs to be created during the sales process.",
              Type: "Business Process",
              Scope:
                "After the customer order has been fulfilled, the invoice is created. It provides the customer with information required to settle the payment related to their order.",
              Outcome: "Invoice is created and sent to the customer.",
              name: "Create customer invoice",
              _id: 1363,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Employees working on projects or services have to record the hours spend for it. This can be done using Cross-Application Time Sheet (CATS). CATS is a tool for recording working times and tasks. ",
              _type: "Process",
              GUID: "1f40c4e3-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Maintenance of working hours, approval of working hours by the manager, transfer of working hours to controlling.",
              Outcome: "Working hours are recorded.",
              name: "Record and approve working hours",
              _id: 1261,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Spare parts that were required for executing the service will be added to the customer invoice.       ",
              _type: "Process",
              GUID: "4260a7b9-e8db-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Price capturing of spare part/material, invoice will be linked to the customer invoice.",
              Outcome: "Invoice added to final customer invoice.",
              name: "Maintain spare parts for invoicing",
              _id: 7,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "It is sometimes required to maintain additional information to the customer notification based on new input internally, or from the customer.",
              _type: "Process",
              GUID: "84843a2b-7e5b-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Maintain additional information and update service notification.",
              Outcome: "Service notification updated.",
              name: "Change service notification",
              _id: 6,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After noting down the customers problem in a service notification, the service manager creates a service order with reference to the notification. A service order is required prior to service execution. The service order can include the requirement of spare parts.",
              _type: "Process",
              GUID: "81351d3c-e9bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Creation of service order, reservation of required spare parts, release of service order.",
              Outcome: "Service order created and released.",
              name: "Create service order",
              _id: 5,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The service must be executed according to the specifications provided in the service order. ",
              _type: "Process",
              GUID: "49b377d4-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the service has been dispatched, required activities are carried out to perform the service. After service execution, it is required to document the provided service.",
              Outcome: "Service operations are fulfilled.",
              name: "Perform service",
              _id: 1366,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the creation of a service contract.",
              _type: "Process",
              GUID: "84843a40-7e5b-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Creation of customer contract based on the contract data.",
              Outcome: "Service contract has been created.",
              name: "Create service contract",
              _id: 4,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Spare parts have been reserved from the service order in the stock for the repair. Spare part consumption takes place during the service process and must be recorded. Stock level in the system must be lowered accordingly.",
              _type: "Process",
              GUID: "499e1b3d-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Confirmation of material consumption, goods issue adjusts inventory and the spare parts are accounted to the service order as costs.",
              Outcome: "Material consumption captured and goods issue posted.",
              name: "Confirm consumption of spare parts",
              _id: 3,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once all service order activities are complete and completion confirmations are posted, the status of the service order can be set to technically complete.",
              _type: "Process",
              GUID: "49b377d1-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The status of the service order is set to technically complete.",
              Outcome: "Service is technically complete.",
              name: "Technically complete service order",
              _id: 2,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "ASS Service contract management and call-off",
          _id: 1,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "04694ea1-7e4d-11e5-0a66-001bc640cd9b",
          Description:
            "Customer complaints with returns scenario describes the handling of sales related disputes with customers in case of deliveries that are not compliant with the agreed product specification, volume, or in some cases even time. Another reason for a justified complaint that requires taking back products is damage that happened during the transport to the customer.  The complaint handling in this scenario involves physical return of the products by the customer. Further processing of returned products depends on a usage decision made by quality management. This decision also influences the terms on which customer complaint is closed.",
          _type: "Scenario",
          GUID: "8c942b30-ef45-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The inspection lot is created, completed and the underlying inspection plan are defined.",
              _type: "Process",
              GUID: "b27a547f-90b2-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "All necessary information for an inspection is stored in the inspection lot. When creating the inspection lot, information from the corresponding material master, inspection plan and sampling procedure is evaluated.",
              Outcome:
                "Outcome of the completed inspection lot is documentation which enables making usage decision about specific material.",
              name: "Complete inspection lot",
              _id: 0,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "It is necessary to determine the validity of each complaint received and the decision made regarding the settlement of the customer dispute.",
              _type: "Process",
              GUID: "1f6c4931-7e4d-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Guidelines must be established regarding the categorization and prioritization of complaints and how this information should be used in steering the handling (response time) of the customer dispute.   It is required to set-up the information flow and monitoring of received customer complaints between all involved parties involved in complaint handling (e.g. Quality Management).",
              Type: "Business Process",
              Scope:
                "The information regarding the customer complaint is assessed to determine the validity of the claims made. The decision is made on the steps necessary to resolve the customer dispute. The required steps must then be initiated.",
              Outcome:
                "The decision is made on:   ***Whether to take the goods back from the customer   ***If possible/appropriate, how to compensate the customer.",
              name: "Create return sales order",
              _id: 1375,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A created credit memo can either be used to partly or fully clear an existing customer invoice or forms a base for making a payment to customer.    ",
              _type: "Process",
              GUID: "aa8c61b7-7e48-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once credit memo is created and approved, it must be checked if there are any open customer invoices, which can be cleared with it. If no open customer invoices exist, a direct payment to customer must be made to close the credit memo. Latter option is rarely used.",
              Outcome:
                "Credit memo is cleared and payment to customer made if required.",
              name: "Manage credit memo payment",
              _id: 1374,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Quality inspections are processes on the basis of inspection lots. If a specific quantity of a material is inspected, an inspection lot must be created in the system. ",
              _type: "Process",
              GUID: "17fae614-e864-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "1",
              Type: "Business Process",
              Scope:
                "Triggered by the event that an inspection is required an inspection plan has to be assigned. Inspection plan together with information derived from the triggering business object (production order, purchase order) and material master basically specify the content of the inspection lot: ***what shall be inspected?   ***by whom?   ***when?    ***in what way?   ***how often?     Once the inspection lot is defined, the source of the lot needs to be noted within the quality system.   All necessary information for an inspection is stored in the inspection lot. When creating the inspection lot, information from the corresponding material master, inspection plan and sampling procedure is evaluated.",
              Outcome:
                "The inspection lot is created and the underlying inspection plan is defined.",
              name: "Create inspection lot",
              _id: 1373,
              Business_Rules:
                "Whenever an inspection has to be carried out, an Inspection lot must be created.   The specific LIMS integration needs to be checked. It is possible to transmit created inspection lots from SAP to LIMS, to perform the sampling calculation there.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Closing customer complaint is the final step in the customer dispute management process and occurs when all matters related to the dispute have been settled.         .",
              _type: "Process",
              GUID: "a3824c8c-e992-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the issuing of a credit memo or replacement, or a return by the customer has occurred, all information related to the dispute settlement is recorded, stored and sent to the customer. This marks the end of the customer dispute.",
              Outcome: "Customer complaint is closed",
              name: "Close customer complaint",
              _id: 1372,
              Business_Rules:
                "It is important to decide:   ***Who is responsible for closing what customer complaint   ***Whether and how confirmation of the closure needs to be confirmed by the customer?    ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A delivery is the central object of the goods receipt process containing all the data required for triggering and monitoring it, starting from goods receipt in the yard and ending with transferral of the goods to the final putaway. In a customer return (as well as consignment pick-up) process, a return delivery document is used for this purpose.",
              _type: "Process",
              GUID: "3712628c-e9bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the return order (consignment pick-up order for consignment process) is created, a return delivery is created with reference to it.",
              Outcome:
                "Return delivery is created and goods receipt process can be initiated. ",
              name: "Create return delivery",
              _id: 1371,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Receiving the customer complaint and capturing it in a format necessary for further processing helps to ensure the effective and efficient handling of customer disputes.",
              _type: "Process",
              GUID: "1f6c491c-7e4d-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the customer places a complaint, the data is recorded, stored and forwarded for further processing.",
              Outcome:
                "All relevant information regarding the customers complaint is documented.",
              name: "Document and assess customer complaint",
              _id: 1370,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Based on the documented results of the quality inspection, a decision on usage and final quality is made by an authorized and qualified person. It specifies whether the goods in the inspection lot have been accepted for use or rejected.",
              _type: "Process",
              GUID: "f072b296-7e45-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The usage decision for an inspection lot confirms that all physical samples have been evaluated and the inspection has been completed.  Usage decisions:    ***unrestricted usage sale/production   ***destruction of goods   ***recycling     ***re-work   ***return   ***restricted usage   (sale/production under certain circumstances - lower quality)   Approval requirements for usage decisions must be defined. The matrix between quality properties and actions should be defined to always ensure the same usage of goods.   Even in case of purchased goods, a new quality certificate might be generated if the goods are intended for sale.   If Laboratory Information Management System (LIMS) is used, the basis of the usage decision can be the recommendation transferred from the LIMS to the ERP.",
              Type: "Business Process",
              Scope:
                "The results of the quality inspection get reviewed and the completeness of the quality report is checked. Usage decisions can be made with the help of a predefined catalogue which includes all allowed codes for usage decisions. After the usage decision is made, the stock posting of material for stock-relevant inspection lots is carried out. The usage decision is communicated and documented, as well as a certificate of quality is generated and signed.",
              Outcome:
                "The decision on usage of goods is evaluated, documented and communicated. A quality certificate is generated if required.",
              name: "Make usage decision",
              _id: 1369,
              Business_Rules:
                "In order to make usage decision, the following conditions must be met: ***The Inspection Lot is released ***Expiration date has been assigned (if required ) ***Inspection results have been recorded for required characteristics, they are valuated and closed.    In case that an interface from SAP to LIMS and from LIMS to SAP (results transferring) are in place, this process takes place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A credit memo is issued by the seller of goods to the customer, reducing the amount that is owed to the seller under the terms of an earlier invoice. A credit memo may be issued because the goods were returned to the seller, or there may have been a pricing dispute or other reasons for which the customer will not pay the seller the full amount of the invoice.       ",
              _type: "Process",
              GUID: "e83072e4-e98c-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "The appropriate sales tax is also calculated along with any shipping charges that are being credited to the customer. ",
              Type: "Business Process",
              Scope:
                "Once the decision is made to compensate a customer with a credit memo, the document is created with details regarding reduction in the previous amount owed. The appropriate sales tax is also calculated along with any shipping charges that are being credited to the customer.",
              Outcome: "Credit memo is created and sent to the customer.",
              name: "Create credit memo",
              _id: 1368,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "ASS Customer complaints with returns",
          _id: 1367,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "3cdad251-82c5-11e5-0a66-001bc640cd9b",
          Description:
            "Sales of services scenario describes provision of services to a customer, which are not directly dependent on sales of products. The service is an independent part of the companys portfolio.  This scenario describes the service request being processed in a common sales order. The SAP solution CS is not used in this case",
          _type: "Scenario",
          GUID: "7a693944-ef3c-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of a customer invoice provides documentation of the financial obligation related to a customer order. The customer invoice is created from a sales order.",
              _type: "Process",
              GUID: "75ff0dfc-e8bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Circumstances such as required documents for customs clearance or advance payments might have an impact on the timing when an invoice needs to be created during the sales process.",
              Type: "Business Process",
              Scope:
                "After the customer order has been fulfilled, the invoice is created. It provides the customer with information required to settle the payment related to their order.",
              Outcome: "Invoice is created and sent to the customer.",
              name: "Create customer invoice",
              _id: 1363,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The service must be executed according to the specifications provided in the service order. ",
              _type: "Process",
              GUID: "49b377d4-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the service has been dispatched, required activities are carried out to perform the service. After service execution, it is required to document the provided service.",
              Outcome: "Service operations are fulfilled.",
              name: "Perform service",
              _id: 1366,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the receipt of a customer request for services.",
              _type: "Process",
              GUID: "4f887808-82c5-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Services can be represented by a material number with service type and/or service item category. The service item category controls whether a delivery is required or not.",
              Type: "Business Process",
              Scope:
                "Create sales order and maintain basic order data for service and the performance of a credit check.",
              Outcome: "Sales order for services is created.",
              name: "Receive service request and create sales order",
              _id: 1331,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Credit management helps to control the companys exposure to credit risk. Credit management must be aligned taking into account the customers liquidity and payment history (credit limit/insurance) and outstanding receivables.",
              _type: "Process",
              GUID: "5aa42fcb-e8e2-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Many corporations start looking at credit management from a group perspective. This requires some collaboration across companies and business units, which might not be established. Hierarchical credit limits might help to hinder a single business unit from already consuming the entire credit limit of a customer.  Any kind of guarantees such as letter of credit or bank guarantees and advanced payments need to be considered in this process.  Credit management for consignment fill-ups - despite goods remaining in sellers property, it is common to perform credit check, since control over goods is lost and the goods issue is typically retrospective.",
              Type: "Business Process",
              Scope:
                "The customers ability to pay for the product or service is evaluated based on their liquidity and payment history and a decision is made on whether the sale is allowed or not.",
              Outcome:
                "The decision is made on whether to proceed with sale or not.",
              name: "Execute credit management",
              _id: 1334,
              Business_Rules:
                "It is necessary to define the information necessary to execute the credit management process.  A framework must be put in place for:   ***Calculating the rating value of customers    ***Determining Credit Limit   ***Setting rules for Credit Check    ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of the sales order is given through the confirmation and represents a commitment to fulfil the order.",
              _type: "Process",
              GUID: "a98a286c-7e52-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The effectiveness of the approval-workflows often is overestimated. Sales managers will receive many approval requests daily. The data to be checked should be limited to the essentials. Everything that can be checked automatically by rules should be implemented in the system. The result of the automatic checks should be obvious to the reviewer.",
              Type: "Business Process",
              Scope:
                "After all checks related to the order have been performed the final decision is made regarding execution of the order. A commitment to the customer is made. This triggers the outbound logistics, production process or service process. ",
              Outcome:
                "A decision is made to fulfil the customers order. This triggers the outbound logistics/production process. The customer is informed about the decision.",
              name: "Save and approve sales order",
              _id: 1332,
              Business_Rules:
                "Rules must be established for allocating authorization for sales order approval to users. The format of the confirmation (electronic, paper) and communication channel must be defined.",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "This scenario explains and focuses on how to sell services via standard SD and does not include the usage of spare parts and the billing of those to the customer. Nevertheless, the spare part usage can be included to this scenario Sales of services. Service technicians might have them on their own stock (car) and will report consumption together with service confirmation. The materials will be added as additional item lines in the sales order or a second sales order will be issued.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "ASS Sales of services",
          _id: 1365,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "2cbbb251-7e50-11e5-0a66-001bc640cd9b",
          Description:
            "The service department receives a service request from a customer. Due to a valid warranty the customer is not charged for the service. The service department creates a sales order free of charge with returns delivery to get the item back for repair. After the service execution working times are maintained and approved within a time recording system (e.g.CATS) and spare parts consumption maintained.The items are sent back to the customer.",
          _type: "Scenario",
          GUID: "7a69393e-ef3c-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Once all service order activities are complete and completion confirmations are posted, the status of the service order can be set to technically complete.",
              _type: "Process",
              GUID: "49b377d1-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The status of the service order is set to technically complete.",
              Outcome: "Service is technically complete.",
              name: "Technically complete service order",
              _id: 2,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Prior to the service execution the planned working hours have to be maintained and if required also spare parts.",
              _type: "Process",
              GUID: "019b08e2-83f2-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Prior to the repair process the planned working hours and required spare parts are maintained in the system.",
              Outcome: "Working hours maintained, spare parts maintained.",
              name: "Maintain planned working hours",
              _id: 487,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Spare parts have been reserved from the service order in the stock for the repair. Spare part consumption takes place during the service process and must be recorded. Stock level in the system must be lowered accordingly.",
              _type: "Process",
              GUID: "499e1b3d-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Confirmation of material consumption, goods issue adjusts inventory and the spare parts are accounted to the service order as costs.",
              Outcome: "Material consumption captured and goods issue posted.",
              name: "Confirm consumption of spare parts",
              _id: 3,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The customers equipment is delivered for repair to the companys premises. The equipment delivered for repair needs to be posted into the companys stock with reference to the repair order.",
              _type: "Process",
              GUID: "499e1b1f-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once a repair order has been placed, a return delivery is initiated with all relevant shipping information. On arrival of the equipment, the goods receipt is posted.",
              Outcome: "Goods receipt of equipment to be repaired posted",
              name: "Create return delivery w. ref. to repair order",
              _id: 481,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Based on the equipment number, the service employee can perform a warranty check. If the  equipment has a valid warranty which covers the kind of damage a sales order free of charge (potentially with returns delivery) is created. If the warranty does not apply, the customer is invoiced for the repair.",
              _type: "Process",
              GUID: "499e1b34-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Check customer warranty.",
              Outcome: "Warranty status determined.",
              name: "Determine warranty status",
              _id: 14,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Employees working on projects or services have to record the hours spend for it. This can be done using Cross-Application Time Sheet (CATS). CATS is a tool for recording working times and tasks. ",
              _type: "Process",
              GUID: "1f40c4e3-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Maintenance of working hours, approval of working hours by the manager, transfer of working hours to controlling.",
              Outcome: "Working hours are recorded.",
              name: "Record and approve working hours",
              _id: 1261,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The service notification is reopened for adding more details to it. Additional details can be added by calling  back the customer. Based on the information of the customer, the service employee decides if the service request is further processed. If the service notification can be further processed, the service employee captures what material and quantity is requested for the repair of the equipment. The repair order is generated from the service notification.",
              _type: "Process",
              GUID: "a9cc68f6-7e4f-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Service products (material master record) are used to represent a service and to manage inventory of the customers returned equipment/product (unit of measure is piece)",
              Type: "Business Process",
              Scope:
                "Add details to service notification, create repair order.",
              Outcome: "Repair order created.",
              name: "Process service notification and create repair order",
              _id: 495,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the receipt of a service request of a customer and how to proceed with the request.",
              _type: "Process",
              GUID: "499e1b19-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Create and maintain the service notification based on the customers request for a service.",
              Outcome: "Service notification created.",
              name: "Create service notification",
              _id: 8,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The service must be executed according to the specifications provided in the service order. ",
              _type: "Process",
              GUID: "49b377d4-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the service has been dispatched, required activities are carried out to perform the service. After service execution, it is required to document the provided service.",
              Outcome: "Service operations are fulfilled.",
              name: "Perform service",
              _id: 1366,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A service order is required prior to service execution. In this case the service order is automatically created once the repair order is confirmed for repair execution.",
              _type: "Process",
              GUID: "499e1b22-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Select repair order and confirm repair order.",
              Outcome:
                "Repair order confirmed and service order automatically created.",
              name: "Process repair order and create service order",
              _id: 493,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "With the commercial completion of the service, no more costs can be allocated to the service. The service order is completed from an accounting/controlling perspective. This process describes the settling of the service order, which is the posting of all costs and revenues related to the service order and its transfer to the profitability analysis.",
              _type: "Process",
              GUID: "499e1b10-7e50-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Post costs and revenues related to the service order and transfer to the profitability analysis via settlement, complete service order.",
              Outcome:
                "All costs and revenues settled to service order and service order is closed from a business perspective.",
              name: "Settle and complete service order",
              _id: 484,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "ASS Maintenance and warranty processing",
          _id: 1364,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "c9fc7d11-7eeb-11e5-0a66-001bc640cd9b",
          Description:
            "The service department receives a customer request for a spare part for an equipment with a service contract. The service department creates a spare part order and triggers both the delivery process and the invoice to the customer.   Depending on characteristics, this scenario includes the classic checks such as dangerous goods, global trade and ATP.",
          _type: "Scenario",
          GUID: "7a693940-ef3c-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of a customer invoice provides documentation of the financial obligation related to a customer order. The customer invoice is created from a sales order.",
              _type: "Process",
              GUID: "75ff0dfc-e8bd-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Circumstances such as required documents for customs clearance or advance payments might have an impact on the timing when an invoice needs to be created during the sales process.",
              Type: "Business Process",
              Scope:
                "After the customer order has been fulfilled, the invoice is created. It provides the customer with information required to settle the payment related to their order.",
              Outcome: "Invoice is created and sent to the customer.",
              name: "Create customer invoice",
              _id: 1363,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The customer requests a spare part. A spare part order is created.",
              _type: "Process",
              GUID: "d46a2a9b-7eeb-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Create notification and spare part order.",
              Outcome: "Spare part order created.",
              name: "Enter service notification and create spare parts order",
              _id: 1362,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "ASS Spare parts delivery with a service contract",
          _id: 1361,
          Business_Rules: "",
          Prerequisite: "",
        },
      ],
      Description:
        "The After Sales and Services (ASS) domain describes the process of receiving and processing customer service requests including spare parts. It includes the initial trigger for initiating a service request and the process of checking the type of service, and linkage to service/maintenance contracts, calculating prices and checking and confirming service delivery as well as the processing and shipping of spare parts.",
      _type: "Domain",
      GUID: "58927692-ecef-11e4-0a66-001bc640cd9b",
      Advisory_Notes: "",
      Type: "E2E-Domain",
      Scope: "",
      Outcome: "",
      name: "After Sales and Services",
      _id: 1360,
      Business_Rules: "",
      Prerequisite: "",
    },
    {
      BPMN_GUID: "297d32a1-ef15-11e4-0a66-001bc640cd9b",
      scenario_of: [
        {
          BPMN_GUID: "a6ec9d31-7f1a-11e5-0a66-001bc640cd9b",
          Description:
            "In assemble-to-order production, the standardized product components are planned and held on stock and after the customer order is placed, the final assembly takes place according to customer requirements.  Typically, the final assembly operations are not complicated, therefore assemble-to-order manufacturing does not involve complex planning and scheduling. Individual assembly orders are scheduled and released after respective customer orders have been placed. However, the availability of components is fundamental for this approach and must be ensured.",
          _type: "Scenario",
          GUID: "22a31398-ef12-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Once an assembly order is created, the system copies the routing and BOM into the production order and performs the calculation of capacity and cost, and schedules the order.",
              _type: "Process",
              GUID: "b5e81079-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Master data get copied into the order and timelines, requirements, and costs are calculated. Finally, the production order has to be released.",
              Outcome:
                "Production order for assembly scheduled, costs and requirements (material and capacity) generated and order released.",
              name: "Schedule and release assembly order",
              _id: 349,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production or after the process order is released shop-floor papers (alternative via electronic files) are generated and the supply of necessary materials to the production initiated. ",
              _type: "Process",
              GUID: "712673e8-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "There are three options for production preparation:   ***using PI Sheet (production instructions in electronic form)   ***using shop floor papers (paper based solution)   ***transfer production instructions to an external manufacturing control system.     PI sheets (including electronic signatures) are often used in the pharmaceutical industry in order to comply with regulatory requirements concerning batch records.",
              Type: "Business Process",
              Scope:
                "The production preparation process covers all activities required to start manufacturing based on the released process order or production order. Information about the actual manufacturing process and control parameters and instructions for the production operators must be transferred to the production control to be carried out (for this purpose control recipes are used). Shop-floor papers for the coordination of manufacturing tasks must be created and material supply to production initiated. ",
              Outcome:
                "All preparation steps for production are performed, physical manufacturing can start.",
              name: "Prepare production (Paper-based)",
              _id: 1322,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production is finished, the process order related to it must be confirmed. This represents the technical closure of the production.",
              _type: "Process",
              GUID: "baf08401-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Capturing of working times and posting on the production order can be done automatically in case of electronic work sheets.",
              Type: "Business Process",
              Scope:
                "The production or process order confirmation takes place after the manufacturing process is finished. Confirmation can be performed for an order, for a completed manufacturing phase (milestone) or a single production step and is used to finally record and confirm produced quantity of goods, used resources and performed activities as well as actual order completion dates. Depending on set-up this process can have impact on production planning by reducing planned production quantities, reducing capacity load, making adjustments to dependent requirements for components etc.",
              Outcome:
                "The confirmed production steps or the complete order is considered as technically closed. No further activities can be performed on it. However, commercial closure will be done later - typically in a month end procedure in controlling.",
              name: "Confirm production",
              _id: 1329,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Goods issue for materials and components used within the production process have to be posted after delivery and when they are moved from the warehouse for further processing. ",
              _type: "Process",
              GUID: "baf08434-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The segregation of staging for production and actual posting of the GI of the components can differ depending on the physical and organizational set-up as well as on the required transparency on the material flow.",
              Type: "Business Process",
              Scope:
                "Goods issues are performed for materials and components retrieved from stock used in the respective production step. Some stock materials might be exempt and later be posted in the cause of a backflushing process.",
              Outcome: "Goods issue is posted.",
              name: "Perform goods issue of components for production",
              _id: 1328,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Assembly orders are used for highly standardized make to order products which typically have a short delivery time. In order to expedite the process an assembly order is automatically created after saving the sales order based on master data settings for BOM and routing.",
              _type: "Process",
              GUID: "baf08422-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Use a Sales BOM where there is a fixed combination of components and the customer needs confirmation of each item. The component items cannot be altered or removed from a sales order. Other items cannot be inserted between the parent and component items in the sales order. However, the quantities of the component items can be modified.  Use the Assembly BOM when you would not expect the customer to check each component in the order.",
              Type: "Business Process",
              Scope:
                "Based on master data, a production order for assembly is generated.",
              Outcome: "Assembly order created.",
              name: "Convert sales order demand to assembly order",
              _id: 348,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "To reflect the actual stock situation, component consumption, which takes place during the manufacturing process must be recorded and stock level in the shop-floor papers lowered accordingly. In manufacturing this is often done via backflushing for components, which are not explicitly counted or weighed. Component consumption is recorded only after finishing the actual manufacturing operation calculated using the BOM or recipe and the actual recorded quantity of produced goods. Additionally or alternatively the consumption of material can be entered via scanner or manually in advance.",
              _type: "Process",
              GUID: "baf083fe-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Within the material master and BOM it must be defined whether back flushing or any other specific type of GI (e.g. pipeline) can and will be performed.",
              Type: "Business Process",
              Scope:
                "The recording of material consumption for manufacturing process is carried out before, during, or after finishing manufacturing operation. The goods issue adjusts inventory and the value of the components is accounted to the order as actual costs.",
              Outcome: "Goods issues are posted",
              name: "Perform consumption for production",
              _id: 1320,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After all preparations are carried out, the actually assembly work can be performed place. Besides the assembly of the products the process usually includes also labeling and packing.",
              _type: "Process",
              GUID: "baf08428-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The work tasks for the assembly are performed. This includes setting-up and dismantling of machines and tools if necessary.",
              Outcome:
                "The product is assembled, packaged, labelled and ready to be putaway.",
              name: "Assemble products",
              _id: 354,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "Components are planned and held on stock (main value adding production process) based on sales order the final assembly takes place. Following strategies are available for integration with sales: Assemble-to-order with Planned Orders Assemble-to-order with Production Orders",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "Pl2P Assemble-to-order",
          _id: 1359,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "6eca1b31-90a6-11e8-2ddf-001bc640cd9b",
          Description:
            "Recycling refers to processing of materials, which in their current form cannot be sold or otherwise used, with the aim to transform them to materials ready for further use in production or for selling. Typical processing options are: 1) cleaning of contaminated material to its initial condition (extraction of components from a final product) or 2) using recyclable materials in the production of a new product.  Specifics of both options are: 1) Quantity of recyclable material is known, certain expectation for the extraction of useful material exists and the process required for extraction of components is known. The exact quantity of extracted material can be evaluated only after the end of the recycling process 2) Recycling aims at reaching a pre-defined result, and the process is managed by combining recyclable components and standard components. Therefore the quantity of required recyclable material cannot be previously evaluated. Exact consumption of material is known only after manufacturing is complete. In many cases, recyclable components cannot be previously assessed, therefore the second option is more widely applied.  Recycling scenario in a manufacturing organization is typically initiated by quality management inspection. Materials, which are processed in the recycling scenario can be products directly from the manufacturing process and for products returned by customers. Some companies use recycling as an own business model. Either products to be recycled are specially procured or collected, or the recycling is done as a service and the extracted materials are handed over to the customer after the process.",
          _type: "Scenario",
          GUID: "22a313aa-ef12-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Goods issue for materials and components used within the production process have to be posted after delivery and when they are moved from the warehouse for further processing. ",
              _type: "Process",
              GUID: "f9a05553-7f25-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "If weighing systems are used, they might be directly connected to the system and integrated in the user dialog.",
              Type: "Business Process",
              Scope:
                "Goods issues are performed for materials and components retrieved from stock used in the respective production step. Prior to the goods issue it is possible that weighing of components required for the production needs to be executed first.Goods issues are performed for materials and components retrieved from stock used in the respective production step. Prior to the goods issue it is possible that weighing of components required for the production needs to be executed first.",
              Outcome: "Goods issues are posted.",
              name: "Perform goods issue of components for process order",
              _id: 1338,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After all preparations are carried out, the physical production can take place. Besides the manufacturing of products the process usually includes also their labeling and packing. ",
              _type: "Process",
              GUID: "c3fb9c10-94b8-11e8-2ddf-001bc640cd9b",
              Advisory_Notes:
                "Set-up of manufacturing quality inspection must be defined-when it should be carried out (during production, based on first manufactured products, at end of production) and how it is initiated (information flow from production).   Production monitoring setup, exchange of production relevant information with external systems (e.g. process messages), production and downtime reporting requirements must be defined.   Label use (manufacturing, shipping, receiving, scanning, customer specific, general in-house label use) must be defined and considered for product labeling.",
              Type: "Business Process",
              Scope:
                "Physical recycling of products is carried out and monitored by production control. ",
              Outcome: "Goods have been recycled. ",
              name: "Perform recycling",
              _id: 1358,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Material requirements planning (MRP) helps to ensure the availability of all materials (raw materials, semifinished goods) required for production or other use in the right quantity and on time.",
              _type: "Process",
              GUID: "817029ee-7eff-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Material requirements planning (MRP) requires bills of materials and material lead times to be defined and correctly maintained. The MRP schedule must be defined regularly.   There are many different MRP strategies available for planning driven and consumption driven material approaches.   The identified materials requirement can be the triggering event for this process. Other triggering events can be: ***Production order created ***Independent demand revised and updated ***Rework production order created ***Refilling/Re-packaging process order created ***Campaign scheduling completed ***Dependent demand revised and updated",
              Type: "Business Process",
              Scope:
                "In stepwise production scheduling procedure after defining finished product demand for the planning period, material requirements planning must be performed to compare demand with current stocks and planned manufacturing, identify final products to be manufactured, analyze, what materials, in what quantity and when are required for the manufacturing and propose production and purchasing schedule (material requirements planning assumes infinite production capacity).",
              Outcome:
                "As a result of material requirements planning, the recommended production schedule is created together with planned orders. In parallel, a recommended purchasing schedule for materials required for production but not available on stock is needed.",
              name: "Perform and evaluate material requirements planning",
              _id: 1228,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production is finished, the process order related to it must be confirmed. This represents the technical closure of the production.",
              _type: "Process",
              GUID: "baf08401-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Capturing of working times and posting on the production order can be done automatically in case of electronic work sheets.",
              Type: "Business Process",
              Scope:
                "The production or process order confirmation takes place after the manufacturing process is finished. Confirmation can be performed for an order, for a completed manufacturing phase (milestone) or a single production step and is used to finally record and confirm produced quantity of goods, used resources and performed activities as well as actual order completion dates. Depending on set-up this process can have impact on production planning by reducing planned production quantities, reducing capacity load, making adjustments to dependent requirements for components etc.",
              Outcome:
                "The confirmed production steps or the complete order is considered as technically closed. No further activities can be performed on it. However, commercial closure will be done later - typically in a month end procedure in controlling.",
              name: "Confirm production",
              _id: 1329,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Material requirements planning assumes infinite production capacity, therefore its outcome - recommended production schedule - is often unrealistic. Actual production capacity must be evaluated, to identify if the required capacity does not exceed work centers defined capacity limits in a given time period. ",
              _type: "Process",
              GUID: "712673d6-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Production capacity is often checked for bottleneck work centers or key work centers only.   It should also be defined on which granularity capacity should be leveled.  In less time sensitive environments, it might be sufficient to look at the weekly load not considering individual days of overload.",
              Type: "Business Process",
              Scope:
                "Recommended production schedule from MRP must be combined with information from routing sheets about work centers and working hours required to meet production plan, by taking into account also setup times. This allows to accurately determine the required capacity at each work center during each time period and to identify problem areas - overcommitment of resources.",
              Outcome:
                "Recommended production schedule revised by taking into account actual capacity constraints, bottlenecks and overcommitment of resources identified.  ",
              name: "Evaluate and align capacity",
              _id: 1347,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Although requirements planning will initially have planned the availability of raw materials and components it is important to check and re-check the availability for production to avoid that any change in the actual stock situation may cause an interruption of the scheduled production. This can be a undelivered raw material or a missing component due to a break-down",
              _type: "Process",
              GUID: "88c21250-7f1c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Availability of the required components will be checked.",
              Outcome:
                "Availability confirmed or missing parts component list is generated.",
              name: "Check component availability",
              _id: 1323,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "To reflect the actual stock situation, component consumption, which takes place during the manufacturing process must be recorded and stock level in the shop-floor papers lowered accordingly. In manufacturing this is often done via backflushing for components, which are not explicitly counted or weighed. Component consumption is recorded only after finishing the actual manufacturing operation calculated using the BOM or recipe and the actual recorded quantity of produced goods. Additionally or alternatively the consumption of material can be entered via scanner or manually in advance.",
              _type: "Process",
              GUID: "baf083fe-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Within the material master and BOM it must be defined whether back flushing or any other specific type of GI (e.g. pipeline) can and will be performed.",
              Type: "Business Process",
              Scope:
                "The recording of material consumption for manufacturing process is carried out before, during, or after finishing manufacturing operation. The goods issue adjusts inventory and the value of the components is accounted to the order as actual costs.",
              Outcome: "Goods issues are posted",
              name: "Perform consumption for production",
              _id: 1320,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the goods receipt process for products and by-products manufactured in production. After goods receipt, the system increases the stock of the goods at the relevant storage location.      ",
              _type: "Process",
              GUID: "1c4d66cd-7ca9-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Goods or semi-finished goods that have been produced have to be posted on stock with a goods receipt.",
              Outcome:
                "Goods receipt posted (in many cases in a special stock as long as quality inspection is still ongoing).",
              name: "Perform goods receipt from production",
              _id: 1357,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process orders can be created in advance to the planned manufacturing start date and are not bound to the availability of required materials or capacity. The release process represents the final step to initiate the manufacturing process. Unless the order is released, no further processing is possible.",
              _type: "Process",
              GUID: "cf57b45a-e9c8-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "The release will also impact the status of the material reservations of the components. Latest at this point in time, the reservations should be treated as firm and no other planning or logistics process should no longer have access to the reserved quantities.",
              Type: "Business Process",
              Scope:
                "Created process orders must be released, before they can be processed by production. The release is done, when the release date has been reached and when the required materials and capacity are available. The availability of materials and capacity should be checked within the release process. The process order release may also include batch determination and assignments. ",
              Outcome: "Process order is released.",
              name: "Release process order",
              _id: 1337,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production or after the process order is released shop-floor papers (alternative via electronic files) are generated and the supply of necessary materials to the production initiated. ",
              _type: "Process",
              GUID: "712673e8-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "There are three options for production preparation:   ***using PI Sheet (production instructions in electronic form)   ***using shop floor papers (paper based solution)   ***transfer production instructions to an external manufacturing control system.     PI sheets (including electronic signatures) are often used in the pharmaceutical industry in order to comply with regulatory requirements concerning batch records.",
              Type: "Business Process",
              Scope:
                "The production preparation process covers all activities required to start manufacturing based on the released process order or production order. Information about the actual manufacturing process and control parameters and instructions for the production operators must be transferred to the production control to be carried out (for this purpose control recipes are used). Shop-floor papers for the coordination of manufacturing tasks must be created and material supply to production initiated. ",
              Outcome:
                "All preparation steps for production are performed, physical manufacturing can start.",
              name: "Prepare production (Paper-based)",
              _id: 1322,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A production order for recycling needs to be created for the breakdown and recycling of components. The nature of recycling processes require the selection of required operations and components either selected from standard routings and standard BOMs or captured manually. ",
              _type: "Process",
              GUID: "c3fb9beb-94b8-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "A recycling order is created with its own product as component. Within the order the required operations and additionally required components are defined and batches will be assigned if applicable.",
              Outcome:
                "The rework order with the required operations and components is created.",
              name: "Create production order for recycling",
              _id: 1356,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "Pl2P Recycling",
          _id: 1355,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "e2dd8101-7f1b-11e5-0a66-001bc640cd9b",
          Description:
            "Campaign production refers to the manufacturing approach where products from one family, which share a common production process and can be produced together or in a sequence are produced in a common production run. This avoids major switch-over costs associated with changing the family of products being produced.  Typically, the campaigns are pre-defined in the planning process and actual confirmed demands are then scheduled within campaigns. Lead times for these demands are determined by the campaign. Campaign production is most frequently applied when an overall discrete production capacity available greatly exceeds the demand for any specific product but the production of a number of different products fills the production capacity.  Since the production capacity is pre-defined, the main scheduling objective in this scenario is to ensure availability of all components. Adjustments to the campaign might be still done to match actual demands if technically possible.  This scenario depicts the use of a Manufacturing execution system (MES) for steering the manufacturing process, whereby the production scheduling is carried out in ERP. For the use of an MES system the information flow between ERP and MES is essential and the integration of both systems must be ensured.",
          _type: "Scenario",
          GUID: "22a3139a-ef12-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Planned orders created in material requirement planning or detailed scheduling are only planning elements, in order to trigger actual manufacturing in process industry they must be converted to process orders.",
              _type: "Process",
              GUID: "88c21232-7f1c-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Regardless whether a process order gets created directly or via converting a planned order material, recipe and BOM related data get retrieved again from respective master data.   Possible conversion options must be defined:   ***one planned order to one process order,   ***several planned orders to one process order,   ***partial conversion of planned orders.  ",
              Type: "Business Process",
              Scope:
                "Within a defined horizon, planned orders get converted in process orders to become executable. The conversion typically includes the adding of production specific information.   A process order describes the production of batches (materials) in a production run or the rendering of services. It is generated from the master recipe and contains all the information specified during process planning. You use a process order to plan the quantities, dates, and resources of the manufacturing process, to control process order execution, and to define rules for the account assignment and settlement of the costs incurred.    A recipe version is selected, its operations and sequences are transferred to the process order. The bill of materials (BOM) is exploded and the items in the BOM are transferred to the order. Reservations are generated for bill of material items held in stock. The planned costs for the order are generated. The capacity requirements are generated for the work centers. Purchase requisitions are generated for non-stock items and externally-processed operations.",
              Outcome:
                "Planned order is partly or completely converted to a process order.",
              name: "Convert planned order to process order",
              _id: 1336,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production is finished, the process order related to it must be confirmed. This represents the technical closure of the production.",
              _type: "Process",
              GUID: "baf08401-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Capturing of working times and posting on the production order can be done automatically in case of electronic work sheets.",
              Type: "Business Process",
              Scope:
                "The production or process order confirmation takes place after the manufacturing process is finished. Confirmation can be performed for an order, for a completed manufacturing phase (milestone) or a single production step and is used to finally record and confirm produced quantity of goods, used resources and performed activities as well as actual order completion dates. Depending on set-up this process can have impact on production planning by reducing planned production quantities, reducing capacity load, making adjustments to dependent requirements for components etc.",
              Outcome:
                "The confirmed production steps or the complete order is considered as technically closed. No further activities can be performed on it. However, commercial closure will be done later - typically in a month end procedure in controlling.",
              name: "Confirm production",
              _id: 1329,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process orders can be created in advance to the planned manufacturing start date and are not bound to the availability of required materials or capacity. The release process represents the final step to initiate the manufacturing process. Unless the order is released, no further processing is possible.",
              _type: "Process",
              GUID: "cf57b45a-e9c8-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "The release will also impact the status of the material reservations of the components. Latest at this point in time, the reservations should be treated as firm and no other planning or logistics process should no longer have access to the reserved quantities.",
              Type: "Business Process",
              Scope:
                "Created process orders must be released, before they can be processed by production. The release is done, when the release date has been reached and when the required materials and capacity are available. The availability of materials and capacity should be checked within the release process. The process order release may also include batch determination and assignments. ",
              Outcome: "Process order is released.",
              name: "Release process order",
              _id: 1337,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process explains the collection of a family of demands and scheduling them for serial production. ",
              _type: "Process",
              GUID: "88c21247-7f1c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "For serial production, demands are placed for products to be produced within the same family. It must be planned that production lines are efficiently planned to maximize production lots. ",
              Outcome: "Campaign production scheduled.",
              name: "Schedule confirmed demands within campaign",
              _id: 346,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "The actual production progress is monitored.",
              _type: "Process",
              GUID: "0f289faf-974c-11e9-0cfc-001bc641ce4f",
              Advisory_Notes:
                " ***it needs to be defined which events will trigger the adjustment of schedule or even feedback to production planning.",
              Type: "Business Process",
              Scope:
                "After orders have been released to production the actual progress needs to be monitored. In case of any special events or deviations follow-up activities as well as counter-measures need to be triggered.  Most important is the update of the production schedule and information/feedback to production planning in case of need.",
              Outcome:
                "Actual production progress is monitored and appropriate reactions are triggered.",
              name: "Monitor production progress",
              _id: 1326,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "To reflect the actual stock situation, component consumption, which takes place during the manufacturing process must be recorded and stock level in the shop-floor papers lowered accordingly. In manufacturing this is often done via backflushing for components, which are not explicitly counted or weighed. Component consumption is recorded only after finishing the actual manufacturing operation calculated using the BOM or recipe and the actual recorded quantity of produced goods. Additionally or alternatively the consumption of material can be entered via scanner or manually in advance.",
              _type: "Process",
              GUID: "baf083fe-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Within the material master and BOM it must be defined whether back flushing or any other specific type of GI (e.g. pipeline) can and will be performed.",
              Type: "Business Process",
              Scope:
                "The recording of material consumption for manufacturing process is carried out before, during, or after finishing manufacturing operation. The goods issue adjusts inventory and the value of the components is accounted to the order as actual costs.",
              Outcome: "Goods issues are posted",
              name: "Perform consumption for production",
              _id: 1320,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Although requirements planning will initially have planned the availability of raw materials and components it is important to check and re-check the availability for production to avoid that any change in the actual stock situation may cause an interruption of the scheduled production. This can be a undelivered raw material or a missing component due to a break-down",
              _type: "Process",
              GUID: "88c21250-7f1c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Availability of the required components will be checked.",
              Outcome:
                "Availability confirmed or missing parts component list is generated.",
              name: "Check component availability",
              _id: 1323,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After all preparations are carried out, the physical production can take place. Besides the manufacturing of products the process usually includes also their labeling and packing. ",
              _type: "Process",
              GUID: "8a5dc0c7-7f1c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Physical manufacturing of products is carried out and monitored by production control. After goods are produced, they must be packed and labeled. ",
              Outcome:
                "Products are manufactured using MES and deviations are recorded in MES.",
              name: "Manufacture products using manufacturing execution system",
              _id: 355,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Goods issue for materials and components used within the production process have to be posted after delivery and when they are moved from the warehouse for further processing. ",
              _type: "Process",
              GUID: "baf08434-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The segregation of staging for production and actual posting of the GI of the components can differ depending on the physical and organizational set-up as well as on the required transparency on the material flow.",
              Type: "Business Process",
              Scope:
                "Goods issues are performed for materials and components retrieved from stock used in the respective production step. Some stock materials might be exempt and later be posted in the cause of a backflushing process.",
              Outcome: "Goods issue is posted.",
              name: "Perform goods issue of components for production",
              _id: 1328,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production or process order is released shop-floor papers (or electronic files) are generated and the supply of necessary materials to the production initiated. ",
              _type: "Process",
              GUID: "ed92ae3d-9724-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The production preparation process covers all activities required to start manufacturing based on the released process order or production order. Information about the actual manufacturing process and control parameters and instructions for the production operators must be transferred to the production control to be carried out (for this purpose control recipes are used). Shop-floor papers for the coordination of manufacturing tasks must be created and material supply to production initiated. ",
              Outcome:
                "All preparation steps for production are performed, physical manufacturing can start.",
              name: "Prepare production with manufacturing execution system",
              _id: 352,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "In case there are certain minimum quantities necessary or the optimization of the lot-size of a campaign suggests to produce more than actual demands are given, the remaining capacity is often filled with some standard products likely to be requested by customers anyway soon.  Campaigns are very common in the process and steel industry: - Chemical processes (e.g. Cracker) produce different products throughout the process. Certain parameters (heat, pressure, ..) can influence the output to some extend. - Ice cream is produced in a certain sequence for example with plain vanilla at the beginning and chocolate at the end. This is done to avoid that small amounts of the previous type of ice cream adversely affect the next one. - Melting of steel has to be done based on the capacity of the melting pot - A chemical process used in many industries is galvanic. You might combine many different products for this production step to be galvanized with the same metal",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "Pl2P Campaign production with manufacturing execution system",
          _id: 1354,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "0dbacac1-7f1e-11e5-0a66-001bc640cd9b",
          Description:
            "In the make-to-order production approach, manufacturing of the product starts only after receiving a customer order. Customer orders drive the activities for component manufacturing, their assembly into products, and the delivery of products.  Typically, make-to-order is used for highly configured products, which are built according to specific customers requests and cannot be easily resold to a different one, or for products, where holding inventories is very expensive.  Due to the necessity to balance complex products and differently organized manufacturing tasks, the scheduling of make-to-order production is usually performed by using advanced production scheduling approach. The scheduling objective is ensuring that all customer orders can be fulfilled in the required quantity and on the desired dates, therefore it must be performed on an individual order basis.",
          _type: "Scenario",
          GUID: "22a31396-ef12-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description: "The actual production progress is monitored.",
              _type: "Process",
              GUID: "0f289faf-974c-11e9-0cfc-001bc641ce4f",
              Advisory_Notes:
                " ***it needs to be defined which events will trigger the adjustment of schedule or even feedback to production planning.",
              Type: "Business Process",
              Scope:
                "After orders have been released to production the actual progress needs to be monitored. In case of any special events or deviations follow-up activities as well as counter-measures need to be triggered.  Most important is the update of the production schedule and information/feedback to production planning in case of need.",
              Outcome:
                "Actual production progress is monitored and appropriate reactions are triggered.",
              name: "Monitor production progress",
              _id: 1326,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "As a result of a planning procedure planned orders are created. Those need to be converted to production orders.",
              _type: "Process",
              GUID: "712673f1-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Regardless whether a production order gets created directly or via converting a planned order material, routing and BOM related data get retrieved again from respective master data.   Possible conversion options must be defined:   ***one planned order to one production order,   ***several planned orders to one production order,   ***partial conversion of planned orders.  ",
              Type: "Business Process",
              Scope:
                "Within a defined horizon, planned production orders get converted in order to become executable production orders. The conversion typically includes the adding of production specific information.   A production order describes the production of the specified product following the selected production version (combination of BOM alternative and version or routing). The production order is used to plan the quantities, dates, and resources of the manufacturing process, to control order execution, and to define rules for the account assignment and settlement of the costs incurred.    A routing version is selected, its operations and sequences are transferred to the production order. The bill of materials (BOM) is exploded and the items in the BOM are transferred to the order. Reservations are generated for bill of material items held in stock. The planned costs for the order are generated. The capacity requirements are generated for the work centers. Purchase requisitions are generated for non-stock items and externally-processed operations.",
              Outcome:
                "Planned order is partly or completely converted to a production order.",
              name: "Convert planned order to production order",
              _id: 1325,
              Business_Rules:
                "It must be defined, how production orders can be created - either by converting a planned order to a production order only, or also by creating it manually. Latter bypasses planning violating best practices principals, though.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "To reflect the actual stock situation, component consumption, which takes place during the manufacturing process must be recorded and stock level in the shop-floor papers lowered accordingly. In manufacturing this is often done via backflushing for components, which are not explicitly counted or weighed. Component consumption is recorded only after finishing the actual manufacturing operation calculated using the BOM or recipe and the actual recorded quantity of produced goods. Additionally or alternatively the consumption of material can be entered via scanner or manually in advance.",
              _type: "Process",
              GUID: "baf083fe-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Within the material master and BOM it must be defined whether back flushing or any other specific type of GI (e.g. pipeline) can and will be performed.",
              Type: "Business Process",
              Scope:
                "The recording of material consumption for manufacturing process is carried out before, during, or after finishing manufacturing operation. The goods issue adjusts inventory and the value of the components is accounted to the order as actual costs.",
              Outcome: "Goods issues are posted",
              name: "Perform consumption for production",
              _id: 1320,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production or after the process order is released shop-floor papers (alternative via electronic files) are generated and the supply of necessary materials to the production initiated. ",
              _type: "Process",
              GUID: "712673e8-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "There are three options for production preparation:   ***using PI Sheet (production instructions in electronic form)   ***using shop floor papers (paper based solution)   ***transfer production instructions to an external manufacturing control system.     PI sheets (including electronic signatures) are often used in the pharmaceutical industry in order to comply with regulatory requirements concerning batch records.",
              Type: "Business Process",
              Scope:
                "The production preparation process covers all activities required to start manufacturing based on the released process order or production order. Information about the actual manufacturing process and control parameters and instructions for the production operators must be transferred to the production control to be carried out (for this purpose control recipes are used). Shop-floor papers for the coordination of manufacturing tasks must be created and material supply to production initiated. ",
              Outcome:
                "All preparation steps for production are performed, physical manufacturing can start.",
              name: "Prepare production (Paper-based)",
              _id: 1322,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After all preparations are carried out, the physical production can take place. Besides the manufacturing of products the process usually includes also their labeling and packing.",
              _type: "Process",
              GUID: "712673e2-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Set-up of manufacturing quality inspection must be defined-when it should be carried out (during production, based on first manufactured products, at end of production) and how it is initiated (information flow from production).   Production monitoring setup, exchange of production relevant information with external systems (e.g. process messages), production and downtime reporting requirements must be defined.   Label use (manufacturing, shipping, receiving, scanning, customer specific, general in-house label use) must be defined and considered for product labeling.",
              Type: "Business Process",
              Scope:
                "Physical manufacturing of products is carried out and monitored by production control.  Prior to the actual production of goods it is possible that machines need to be set up and after goods are produced, they must be packed and labeled. After labeling and packing production tools need to be dismantled.",
              Outcome: "Goods have been produced.",
              name: "Manufacture products",
              _id: 1324,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production is finished, the process order related to it must be confirmed. This represents the technical closure of the production.",
              _type: "Process",
              GUID: "baf08401-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Capturing of working times and posting on the production order can be done automatically in case of electronic work sheets.",
              Type: "Business Process",
              Scope:
                "The production or process order confirmation takes place after the manufacturing process is finished. Confirmation can be performed for an order, for a completed manufacturing phase (milestone) or a single production step and is used to finally record and confirm produced quantity of goods, used resources and performed activities as well as actual order completion dates. Depending on set-up this process can have impact on production planning by reducing planned production quantities, reducing capacity load, making adjustments to dependent requirements for components etc.",
              Outcome:
                "The confirmed production steps or the complete order is considered as technically closed. No further activities can be performed on it. However, commercial closure will be done later - typically in a month end procedure in controlling.",
              name: "Confirm production",
              _id: 1329,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Goods issue for materials and components used within the production process have to be posted after delivery and when they are moved from the warehouse for further processing. ",
              _type: "Process",
              GUID: "baf08434-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The segregation of staging for production and actual posting of the GI of the components can differ depending on the physical and organizational set-up as well as on the required transparency on the material flow.",
              Type: "Business Process",
              Scope:
                "Goods issues are performed for materials and components retrieved from stock used in the respective production step. Some stock materials might be exempt and later be posted in the cause of a backflushing process.",
              Outcome: "Goods issue is posted.",
              name: "Perform goods issue of components for production",
              _id: 1328,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Although requirements planning will initially have planned the availability of raw materials and components it is important to check and re-check the availability for production to avoid that any change in the actual stock situation may cause an interruption of the scheduled production. This can be a undelivered raw material or a missing component due to a break-down",
              _type: "Process",
              GUID: "88c21250-7f1c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Availability of the required components will be checked.",
              Outcome:
                "Availability confirmed or missing parts component list is generated.",
              name: "Check component availability",
              _id: 1323,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Manufacturing orders can be created in advance to the planned manufacturing start date and are not bound to the availability of required materials or capacity. The release process represents the final step to initiate the manufacturing process. Unless the order is released, no further processing is possible.",
              _type: "Process",
              GUID: "024d6439-e8f7-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "The release will also impact the status of the material reservations of the components. Latest at this point in time, the reservations should be treated as firm and no other planning or logistics process should have access to the reserved quantities anymore.",
              Type: "Business Process",
              Scope:
                "Created manufacturing orders must be released, before they can be processed by production. The release is done, when the release date has been reached and when the required materials and capacity are available. The availability of materials and capacity should be checked within the release process.",
              Outcome: "Production order is released.",
              name: "Release production order",
              _id: 1321,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Planned orders are scheduled in order to determine the actual production sequence per machine/workplace.",
              _type: "Process",
              GUID: "0f289faa-974c-11e9-0cfc-001bc641ce4f",
              Advisory_Notes:
                "***It needs to be decided how the schedule is going to be fixed. Often fixation of planned orders or the conversion to process orders is used to show, that scheduling has been conducted.In addition it is useful to discuss frozen horizons in order to keep production schedule stable.    ***Typically in scheduling the following aspects are taken into consideration: detailed capacities, change-over cost, alternative production versions/recipes, lot size optimization, component availability for JIT components. *** Real-time status information from shop floor integration systems might be used in order to keep schedule up to date.",
              Type: "Business Process",
              Scope:
                "After receiving planned orders from production planning these need to be brought into sequence for actual production. During this scheduling detailed restrictions of the different needed machines/workplaces are considered. Furthermore change-over optimization is conducted in order to achieve a cost efficient production sequence.",
              Outcome: "",
              name: "Schedule planned orders",
              _id: 1327,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "Pl2P Make-to-order (Discrete industry manufacturing)",
          _id: 1353,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "8e5e6b01-7f28-11e5-0a66-001bc640cd9b",
          Description:
            "Re-work refers to the manufacturing situation where a fully or partly manufactured product needs to be re-processed and adjusted. The re-work scenario describes the process flow required in such cases.  Due to the nature of re-work, it is not possible to plan material and equipment requirements beforehand. The production order is created without material assignment.  Typical application of the re-work scenario is correction of identified product quality problems. It is initiated by a quality management inspection, and can be used for handling products coming directly from a manufacturing process as well as those returned by customers.",
          _type: "Scenario",
          GUID: "22a313a0-ef12-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "To reflect the actual stock situation, component consumption, which takes place during the manufacturing process must be recorded and stock level in the shop-floor papers lowered accordingly. In manufacturing this is often done via backflushing for components, which are not explicitly counted or weighed. Component consumption is recorded only after finishing the actual manufacturing operation calculated using the BOM or recipe and the actual recorded quantity of produced goods. Additionally or alternatively the consumption of material can be entered via scanner or manually in advance.",
              _type: "Process",
              GUID: "baf083fe-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Within the material master and BOM it must be defined whether back flushing or any other specific type of GI (e.g. pipeline) can and will be performed.",
              Type: "Business Process",
              Scope:
                "The recording of material consumption for manufacturing process is carried out before, during, or after finishing manufacturing operation. The goods issue adjusts inventory and the value of the components is accounted to the order as actual costs.",
              Outcome: "Goods issues are posted",
              name: "Perform consumption for production",
              _id: 1320,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Manufacturing orders can be created in advance to the planned manufacturing start date and are not bound to the availability of required materials or capacity. The release process represents the final step to initiate the manufacturing process. Unless the order is released, no further processing is possible.",
              _type: "Process",
              GUID: "024d6439-e8f7-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "The release will also impact the status of the material reservations of the components. Latest at this point in time, the reservations should be treated as firm and no other planning or logistics process should have access to the reserved quantities anymore.",
              Type: "Business Process",
              Scope:
                "Created manufacturing orders must be released, before they can be processed by production. The release is done, when the release date has been reached and when the required materials and capacity are available. The availability of materials and capacity should be checked within the release process.",
              Outcome: "Production order is released.",
              name: "Release production order",
              _id: 1321,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the goods receipt process for products and by-products manufactured in production via re-working of a product normally due to quality issues.    ",
              _type: "Process",
              GUID: "45c3aeb7-9c7c-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Re-worked goods that have been produced have to be posted on stock with a goods receipt.",
              Outcome:
                "Goods receipt posted (in many cases in a special stock as long as quality inspection is still ongoing).",
              name: "Perform goods receipt from re-work",
              _id: 1352,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production or after the process order is released shop-floor papers (alternative via electronic files) are generated and the supply of necessary materials to the production initiated. ",
              _type: "Process",
              GUID: "712673e8-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "There are three options for production preparation:   ***using PI Sheet (production instructions in electronic form)   ***using shop floor papers (paper based solution)   ***transfer production instructions to an external manufacturing control system.     PI sheets (including electronic signatures) are often used in the pharmaceutical industry in order to comply with regulatory requirements concerning batch records.",
              Type: "Business Process",
              Scope:
                "The production preparation process covers all activities required to start manufacturing based on the released process order or production order. Information about the actual manufacturing process and control parameters and instructions for the production operators must be transferred to the production control to be carried out (for this purpose control recipes are used). Shop-floor papers for the coordination of manufacturing tasks must be created and material supply to production initiated. ",
              Outcome:
                "All preparation steps for production are performed, physical manufacturing can start.",
              name: "Prepare production (Paper-based)",
              _id: 1322,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Although requirements planning will initially have planned the availability of raw materials and components it is important to check and re-check the availability for production to avoid that any change in the actual stock situation may cause an interruption of the scheduled production. This can be a undelivered raw material or a missing component due to a break-down",
              _type: "Process",
              GUID: "88c21250-7f1c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Availability of the required components will be checked.",
              Outcome:
                "Availability confirmed or missing parts component list is generated.",
              name: "Check component availability",
              _id: 1323,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After all preparations are carried out, the physical production can take place. Besides the manufacturing of products the process usually includes also their labeling and packing.",
              _type: "Process",
              GUID: "712673e2-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Set-up of manufacturing quality inspection must be defined-when it should be carried out (during production, based on first manufactured products, at end of production) and how it is initiated (information flow from production).   Production monitoring setup, exchange of production relevant information with external systems (e.g. process messages), production and downtime reporting requirements must be defined.   Label use (manufacturing, shipping, receiving, scanning, customer specific, general in-house label use) must be defined and considered for product labeling.",
              Type: "Business Process",
              Scope:
                "Physical manufacturing of products is carried out and monitored by production control.  Prior to the actual production of goods it is possible that machines need to be set up and after goods are produced, they must be packed and labeled. After labeling and packing production tools need to be dismantled.",
              Outcome: "Goods have been produced.",
              name: "Manufacture products",
              _id: 1324,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Material requirements planning (MRP) helps to ensure the availability of all materials (raw materials, semifinished goods) required for production or other use in the right quantity and on time.",
              _type: "Process",
              GUID: "817029ee-7eff-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Material requirements planning (MRP) requires bills of materials and material lead times to be defined and correctly maintained. The MRP schedule must be defined regularly.   There are many different MRP strategies available for planning driven and consumption driven material approaches.   The identified materials requirement can be the triggering event for this process. Other triggering events can be: ***Production order created ***Independent demand revised and updated ***Rework production order created ***Refilling/Re-packaging process order created ***Campaign scheduling completed ***Dependent demand revised and updated",
              Type: "Business Process",
              Scope:
                "In stepwise production scheduling procedure after defining finished product demand for the planning period, material requirements planning must be performed to compare demand with current stocks and planned manufacturing, identify final products to be manufactured, analyze, what materials, in what quantity and when are required for the manufacturing and propose production and purchasing schedule (material requirements planning assumes infinite production capacity).",
              Outcome:
                "As a result of material requirements planning, the recommended production schedule is created together with planned orders. In parallel, a recommended purchasing schedule for materials required for production but not available on stock is needed.",
              name: "Perform and evaluate material requirements planning",
              _id: 1228,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Material requirements planning assumes infinite production capacity, therefore its outcome - recommended production schedule - is often unrealistic. Actual production capacity must be evaluated, to identify if the required capacity does not exceed work centers defined capacity limits in a given time period. ",
              _type: "Process",
              GUID: "712673d6-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Production capacity is often checked for bottleneck work centers or key work centers only.   It should also be defined on which granularity capacity should be leveled.  In less time sensitive environments, it might be sufficient to look at the weekly load not considering individual days of overload.",
              Type: "Business Process",
              Scope:
                "Recommended production schedule from MRP must be combined with information from routing sheets about work centers and working hours required to meet production plan, by taking into account also setup times. This allows to accurately determine the required capacity at each work center during each time period and to identify problem areas - overcommitment of resources.",
              Outcome:
                "Recommended production schedule revised by taking into account actual capacity constraints, bottlenecks and overcommitment of resources identified.  ",
              name: "Evaluate and align capacity",
              _id: 1347,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Goods issue for materials and components used within the production process have to be posted after delivery and when they are moved from the warehouse for further processing. ",
              _type: "Process",
              GUID: "f9a05553-7f25-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "If weighing systems are used, they might be directly connected to the system and integrated in the user dialog.",
              Type: "Business Process",
              Scope:
                "Goods issues are performed for materials and components retrieved from stock used in the respective production step. Prior to the goods issue it is possible that weighing of components required for the production needs to be executed first.Goods issues are performed for materials and components retrieved from stock used in the respective production step. Prior to the goods issue it is possible that weighing of components required for the production needs to be executed first.",
              Outcome: "Goods issues are posted.",
              name: "Perform goods issue of components for process order",
              _id: 1338,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production is finished, the process order related to it must be confirmed. This represents the technical closure of the production.",
              _type: "Process",
              GUID: "baf08401-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Capturing of working times and posting on the production order can be done automatically in case of electronic work sheets.",
              Type: "Business Process",
              Scope:
                "The production or process order confirmation takes place after the manufacturing process is finished. Confirmation can be performed for an order, for a completed manufacturing phase (milestone) or a single production step and is used to finally record and confirm produced quantity of goods, used resources and performed activities as well as actual order completion dates. Depending on set-up this process can have impact on production planning by reducing planned production quantities, reducing capacity load, making adjustments to dependent requirements for components etc.",
              Outcome:
                "The confirmed production steps or the complete order is considered as technically closed. No further activities can be performed on it. However, commercial closure will be done later - typically in a month end procedure in controlling.",
              name: "Confirm production",
              _id: 1329,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When rework is to be done a production order for rework needs to be created. The nature of reworking processes require the selection of required operations and components either selected from standard routings and standard BOMs or captured manually.  A process order can also be used in the process industry.",
              _type: "Process",
              GUID: "5a5e62f7-7f29-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "A rework order is created with its own product as component. Within the order the required operations and additionally required components are defined and batches will be assigned if applicable.",
              Outcome:
                "The rework order with the required operations and components is created.",
              name: "Create production order for rework",
              _id: 1351,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            " ***The specific about a re-work order is that it typically has the same input and output material. Production steps and any other needed component for the re-work are either added manually, or are selected from standard routings and BOMs.    ***An adjustment order is used when the product input and output differs. Typical use cases for adjustment orders are software upgrades for technical products, re-labeling, and re-washing, or conversions involving the exchange of some components.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "Pl2P Re-work",
          _id: 1350,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "f4516d11-7f26-11e5-0a66-001bc640cd9b",
          Description:
            "Re-filling / re-packaging describes the manufacturing approach, whereby packaging of previously manufactured products is replaced. The products themselves are not amended.  The scenario is typically applied when the demand for the initially planned packaging units is low and change of packaging (increase/decrease of units per package) is necessary. The scenario can also be applied when external requirements in regards to packaging have changed, which do not influence the product itself.",
          _type: "Scenario",
          GUID: "22a313a2-ef12-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Manually create a process order in order to cater for the special circumstances of refilling or repacking. The situation that requires refilling or repacking of products can vary i.e. damaged packaging or just wrong labels. Depending on the necessary steps the process order requires manual selection and creation.",
              _type: "Process",
              GUID: "26d1217a-7f27-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "A process order needs to be created to trigger the refilling/repackaging process.",
              Outcome: "A process order is created.",
              name: "Create process order for re-filling/re-packaging",
              _id: 1349,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production is finished, the process order related to it must be confirmed. This represents the technical closure of the production.",
              _type: "Process",
              GUID: "baf08401-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Capturing of working times and posting on the production order can be done automatically in case of electronic work sheets.",
              Type: "Business Process",
              Scope:
                "The production or process order confirmation takes place after the manufacturing process is finished. Confirmation can be performed for an order, for a completed manufacturing phase (milestone) or a single production step and is used to finally record and confirm produced quantity of goods, used resources and performed activities as well as actual order completion dates. Depending on set-up this process can have impact on production planning by reducing planned production quantities, reducing capacity load, making adjustments to dependent requirements for components etc.",
              Outcome:
                "The confirmed production steps or the complete order is considered as technically closed. No further activities can be performed on it. However, commercial closure will be done later - typically in a month end procedure in controlling.",
              name: "Confirm production",
              _id: 1329,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Although requirements planning will initially have planned the availability of raw materials and components it is important to check and re-check the availability for production to avoid that any change in the actual stock situation may cause an interruption of the scheduled production. This can be a undelivered raw material or a missing component due to a break-down",
              _type: "Process",
              GUID: "88c21250-7f1c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Availability of the required components will be checked.",
              Outcome:
                "Availability confirmed or missing parts component list is generated.",
              name: "Check component availability",
              _id: 1323,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After all preparations are carried out, the physical production can take place. Besides the manufacturing of products the process usually includes also their labeling and packing.  ",
              _type: "Process",
              GUID: "26d12177-7f27-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                " *** Re-labelling is often conducted in the warehouse whereas re-filling often needs to be done in production due to safety and environmental compliance (e.g. EX protection).  ***Set-up of manufacturing quality inspection must be defined-when it should be carried out (during production, based on first manufactured products, at end of production) and how it is initiated (information flow from production).    ***Production monitoring setup, exchange of production relevant information with external systems (e.g. process messages), production and downtime reporting requirements must be defined.    ***Label use (manufacturing, shipping, receiving, scanning, customer specific, general in-house label use) must be defined and considered for product labeling.  ***If products are serialized and new serial numbers are required, then the existing ones must be marked/written off as internal consumption for tracking purposes ",
              Type: "Business Process",
              Scope:
                "Physical re-filling and re-labeling of products is carried out and monitored by production control. ",
              Outcome: "Product is refilled/relabelled and packed.",
              name: "Process re-filling/re-labelling",
              _id: 1348,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process orders can be created in advance to the planned manufacturing start date and are not bound to the availability of required materials or capacity. The release process represents the final step to initiate the manufacturing process. Unless the order is released, no further processing is possible.",
              _type: "Process",
              GUID: "cf57b45a-e9c8-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "The release will also impact the status of the material reservations of the components. Latest at this point in time, the reservations should be treated as firm and no other planning or logistics process should no longer have access to the reserved quantities.",
              Type: "Business Process",
              Scope:
                "Created process orders must be released, before they can be processed by production. The release is done, when the release date has been reached and when the required materials and capacity are available. The availability of materials and capacity should be checked within the release process. The process order release may also include batch determination and assignments. ",
              Outcome: "Process order is released.",
              name: "Release process order",
              _id: 1337,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Material requirements planning (MRP) helps to ensure the availability of all materials (raw materials, semifinished goods) required for production or other use in the right quantity and on time.",
              _type: "Process",
              GUID: "817029ee-7eff-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Material requirements planning (MRP) requires bills of materials and material lead times to be defined and correctly maintained. The MRP schedule must be defined regularly.   There are many different MRP strategies available for planning driven and consumption driven material approaches.   The identified materials requirement can be the triggering event for this process. Other triggering events can be: ***Production order created ***Independent demand revised and updated ***Rework production order created ***Refilling/Re-packaging process order created ***Campaign scheduling completed ***Dependent demand revised and updated",
              Type: "Business Process",
              Scope:
                "In stepwise production scheduling procedure after defining finished product demand for the planning period, material requirements planning must be performed to compare demand with current stocks and planned manufacturing, identify final products to be manufactured, analyze, what materials, in what quantity and when are required for the manufacturing and propose production and purchasing schedule (material requirements planning assumes infinite production capacity).",
              Outcome:
                "As a result of material requirements planning, the recommended production schedule is created together with planned orders. In parallel, a recommended purchasing schedule for materials required for production but not available on stock is needed.",
              name: "Perform and evaluate material requirements planning",
              _id: 1228,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Goods issue for materials and components used within the production process have to be posted after delivery and when they are moved from the warehouse for further processing. ",
              _type: "Process",
              GUID: "f9a05553-7f25-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "If weighing systems are used, they might be directly connected to the system and integrated in the user dialog.",
              Type: "Business Process",
              Scope:
                "Goods issues are performed for materials and components retrieved from stock used in the respective production step. Prior to the goods issue it is possible that weighing of components required for the production needs to be executed first.Goods issues are performed for materials and components retrieved from stock used in the respective production step. Prior to the goods issue it is possible that weighing of components required for the production needs to be executed first.",
              Outcome: "Goods issues are posted.",
              name: "Perform goods issue of components for process order",
              _id: 1338,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production or after the process order is released shop-floor papers (alternative via electronic files) are generated and the supply of necessary materials to the production initiated. ",
              _type: "Process",
              GUID: "712673e8-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "There are three options for production preparation:   ***using PI Sheet (production instructions in electronic form)   ***using shop floor papers (paper based solution)   ***transfer production instructions to an external manufacturing control system.     PI sheets (including electronic signatures) are often used in the pharmaceutical industry in order to comply with regulatory requirements concerning batch records.",
              Type: "Business Process",
              Scope:
                "The production preparation process covers all activities required to start manufacturing based on the released process order or production order. Information about the actual manufacturing process and control parameters and instructions for the production operators must be transferred to the production control to be carried out (for this purpose control recipes are used). Shop-floor papers for the coordination of manufacturing tasks must be created and material supply to production initiated. ",
              Outcome:
                "All preparation steps for production are performed, physical manufacturing can start.",
              name: "Prepare production (Paper-based)",
              _id: 1322,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Material requirements planning assumes infinite production capacity, therefore its outcome - recommended production schedule - is often unrealistic. Actual production capacity must be evaluated, to identify if the required capacity does not exceed work centers defined capacity limits in a given time period. ",
              _type: "Process",
              GUID: "712673d6-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Production capacity is often checked for bottleneck work centers or key work centers only.   It should also be defined on which granularity capacity should be leveled.  In less time sensitive environments, it might be sufficient to look at the weekly load not considering individual days of overload.",
              Type: "Business Process",
              Scope:
                "Recommended production schedule from MRP must be combined with information from routing sheets about work centers and working hours required to meet production plan, by taking into account also setup times. This allows to accurately determine the required capacity at each work center during each time period and to identify problem areas - overcommitment of resources.",
              Outcome:
                "Recommended production schedule revised by taking into account actual capacity constraints, bottlenecks and overcommitment of resources identified.  ",
              name: "Evaluate and align capacity",
              _id: 1347,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "To reflect the actual stock situation, component consumption, which takes place during the manufacturing process must be recorded and stock level in the shop-floor papers lowered accordingly. In manufacturing this is often done via backflushing for components, which are not explicitly counted or weighed. Component consumption is recorded only after finishing the actual manufacturing operation calculated using the BOM or recipe and the actual recorded quantity of produced goods. Additionally or alternatively the consumption of material can be entered via scanner or manually in advance.",
              _type: "Process",
              GUID: "baf083fe-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Within the material master and BOM it must be defined whether back flushing or any other specific type of GI (e.g. pipeline) can and will be performed.",
              Type: "Business Process",
              Scope:
                "The recording of material consumption for manufacturing process is carried out before, during, or after finishing manufacturing operation. The goods issue adjusts inventory and the value of the components is accounted to the order as actual costs.",
              Outcome: "Goods issues are posted",
              name: "Perform consumption for production",
              _id: 1320,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "Typical use cases: ***Re-packing from country specific packaging or customer specific packaging (e.g. private labels) ***Re-filling the same product from one SKU (stock keeping unit) to another SKU with a different unit capacity (e.g. from 3l drums to 10l drums) ***Filling of bags, jumbo bags, drums etc. from a silo (bulk SKU) emptying remaining quantities from a silo to make the silo available for another product [may also be done via a standard filling order]",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "Pl2P Re-filling / re-packaging",
          _id: 1346,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "6af62501-7f22-11e5-0a66-001bc640cd9b",
          Description:
            "Make-to-stock production model describes the manufacturing of large quantities of standardized products. In the process industry production is carried out in a continuous linear flow process. The manufactured products are placed in inventory and sold to customers from there.  In comparison to the discrete manufacturing industries, the number of production steps and the variety to combine them is limited. Products are rather defined by a distinct combination of components used in the same chemical process or by a very specific control of a chemical process to achieve the intended result.  Typically a make-to-stock production model is applied where the output of a production order fulfills the demand from many customers or the production process takes too long to meet expected lead times on the market. Especially on an intermediate level, volumes might depend on the capacity of a production unit, that determines the output and forces a make-to-stock production on that level.  Production scheduling in this scenario is performed in a stepwise procedure - first performing material requirement planning and then evaluating and leveling the production capacity.",
          _type: "Scenario",
          GUID: "22a31390-ef12-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production is finished, the process order related to it must be confirmed. This represents the technical closure of the production.",
              _type: "Process",
              GUID: "baf08401-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Capturing of working times and posting on the production order can be done automatically in case of electronic work sheets.",
              Type: "Business Process",
              Scope:
                "The production or process order confirmation takes place after the manufacturing process is finished. Confirmation can be performed for an order, for a completed manufacturing phase (milestone) or a single production step and is used to finally record and confirm produced quantity of goods, used resources and performed activities as well as actual order completion dates. Depending on set-up this process can have impact on production planning by reducing planned production quantities, reducing capacity load, making adjustments to dependent requirements for components etc.",
              Outcome:
                "The confirmed production steps or the complete order is considered as technically closed. No further activities can be performed on it. However, commercial closure will be done later - typically in a month end procedure in controlling.",
              name: "Confirm production",
              _id: 1329,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production or after the process order is released shop-floor papers (alternative via electronic files) are generated and the supply of necessary materials to the production initiated. ",
              _type: "Process",
              GUID: "712673e8-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "There are three options for production preparation:   ***using PI Sheet (production instructions in electronic form)   ***using shop floor papers (paper based solution)   ***transfer production instructions to an external manufacturing control system.     PI sheets (including electronic signatures) are often used in the pharmaceutical industry in order to comply with regulatory requirements concerning batch records.",
              Type: "Business Process",
              Scope:
                "The production preparation process covers all activities required to start manufacturing based on the released process order or production order. Information about the actual manufacturing process and control parameters and instructions for the production operators must be transferred to the production control to be carried out (for this purpose control recipes are used). Shop-floor papers for the coordination of manufacturing tasks must be created and material supply to production initiated. ",
              Outcome:
                "All preparation steps for production are performed, physical manufacturing can start.",
              name: "Prepare production (Paper-based)",
              _id: 1322,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "To reflect the actual stock situation, component consumption, which takes place during the manufacturing process must be recorded and stock level in the shop-floor papers lowered accordingly. In manufacturing this is often done via backflushing for components, which are not explicitly counted or weighed. Component consumption is recorded only after finishing the actual manufacturing operation calculated using the BOM or recipe and the actual recorded quantity of produced goods. Additionally or alternatively the consumption of material can be entered via scanner or manually in advance.",
              _type: "Process",
              GUID: "baf083fe-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Within the material master and BOM it must be defined whether back flushing or any other specific type of GI (e.g. pipeline) can and will be performed.",
              Type: "Business Process",
              Scope:
                "The recording of material consumption for manufacturing process is carried out before, during, or after finishing manufacturing operation. The goods issue adjusts inventory and the value of the components is accounted to the order as actual costs.",
              Outcome: "Goods issues are posted",
              name: "Perform consumption for production",
              _id: 1320,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "The actual production progress is monitored.",
              _type: "Process",
              GUID: "0f289faf-974c-11e9-0cfc-001bc641ce4f",
              Advisory_Notes:
                " ***it needs to be defined which events will trigger the adjustment of schedule or even feedback to production planning.",
              Type: "Business Process",
              Scope:
                "After orders have been released to production the actual progress needs to be monitored. In case of any special events or deviations follow-up activities as well as counter-measures need to be triggered.  Most important is the update of the production schedule and information/feedback to production planning in case of need.",
              Outcome:
                "Actual production progress is monitored and appropriate reactions are triggered.",
              name: "Monitor production progress",
              _id: 1326,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Although requirements planning will initially have planned the availability of raw materials and components it is important to check and re-check the availability for production to avoid that any change in the actual stock situation may cause an interruption of the scheduled production. This can be a undelivered raw material or a missing component due to a break-down",
              _type: "Process",
              GUID: "88c21250-7f1c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Availability of the required components will be checked.",
              Outcome:
                "Availability confirmed or missing parts component list is generated.",
              name: "Check component availability",
              _id: 1323,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Planned orders are scheduled in order to determine the actual production sequence per machine/workplace.",
              _type: "Process",
              GUID: "0f289faa-974c-11e9-0cfc-001bc641ce4f",
              Advisory_Notes:
                "***It needs to be decided how the schedule is going to be fixed. Often fixation of planned orders or the conversion to process orders is used to show, that scheduling has been conducted.In addition it is useful to discuss frozen horizons in order to keep production schedule stable.    ***Typically in scheduling the following aspects are taken into consideration: detailed capacities, change-over cost, alternative production versions/recipes, lot size optimization, component availability for JIT components. *** Real-time status information from shop floor integration systems might be used in order to keep schedule up to date.",
              Type: "Business Process",
              Scope:
                "After receiving planned orders from production planning these need to be brought into sequence for actual production. During this scheduling detailed restrictions of the different needed machines/workplaces are considered. Furthermore change-over optimization is conducted in order to achieve a cost efficient production sequence.",
              Outcome: "",
              name: "Schedule planned orders",
              _id: 1327,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After all preparations are carried out, the physical production can take place. Besides the manufacturing of products the process usually includes also their labeling and packing.",
              _type: "Process",
              GUID: "712673e2-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Set-up of manufacturing quality inspection must be defined-when it should be carried out (during production, based on first manufactured products, at end of production) and how it is initiated (information flow from production).   Production monitoring setup, exchange of production relevant information with external systems (e.g. process messages), production and downtime reporting requirements must be defined.   Label use (manufacturing, shipping, receiving, scanning, customer specific, general in-house label use) must be defined and considered for product labeling.",
              Type: "Business Process",
              Scope:
                "Physical manufacturing of products is carried out and monitored by production control.  Prior to the actual production of goods it is possible that machines need to be set up and after goods are produced, they must be packed and labeled. After labeling and packing production tools need to be dismantled.",
              Outcome: "Goods have been produced.",
              name: "Manufacture products",
              _id: 1324,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Goods issue for materials and components used within the production process have to be posted after delivery and when they are moved from the warehouse for further processing. ",
              _type: "Process",
              GUID: "f9a05553-7f25-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "If weighing systems are used, they might be directly connected to the system and integrated in the user dialog.",
              Type: "Business Process",
              Scope:
                "Goods issues are performed for materials and components retrieved from stock used in the respective production step. Prior to the goods issue it is possible that weighing of components required for the production needs to be executed first.Goods issues are performed for materials and components retrieved from stock used in the respective production step. Prior to the goods issue it is possible that weighing of components required for the production needs to be executed first.",
              Outcome: "Goods issues are posted.",
              name: "Perform goods issue of components for process order",
              _id: 1338,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process orders can be created in advance to the planned manufacturing start date and are not bound to the availability of required materials or capacity. The release process represents the final step to initiate the manufacturing process. Unless the order is released, no further processing is possible.",
              _type: "Process",
              GUID: "cf57b45a-e9c8-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "The release will also impact the status of the material reservations of the components. Latest at this point in time, the reservations should be treated as firm and no other planning or logistics process should no longer have access to the reserved quantities.",
              Type: "Business Process",
              Scope:
                "Created process orders must be released, before they can be processed by production. The release is done, when the release date has been reached and when the required materials and capacity are available. The availability of materials and capacity should be checked within the release process. The process order release may also include batch determination and assignments. ",
              Outcome: "Process order is released.",
              name: "Release process order",
              _id: 1337,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Planned orders created in material requirement planning or detailed scheduling are only planning elements, in order to trigger actual manufacturing in process industry they must be converted to process orders.",
              _type: "Process",
              GUID: "88c21232-7f1c-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Regardless whether a process order gets created directly or via converting a planned order material, recipe and BOM related data get retrieved again from respective master data.   Possible conversion options must be defined:   ***one planned order to one process order,   ***several planned orders to one process order,   ***partial conversion of planned orders.  ",
              Type: "Business Process",
              Scope:
                "Within a defined horizon, planned orders get converted in process orders to become executable. The conversion typically includes the adding of production specific information.   A process order describes the production of batches (materials) in a production run or the rendering of services. It is generated from the master recipe and contains all the information specified during process planning. You use a process order to plan the quantities, dates, and resources of the manufacturing process, to control process order execution, and to define rules for the account assignment and settlement of the costs incurred.    A recipe version is selected, its operations and sequences are transferred to the process order. The bill of materials (BOM) is exploded and the items in the BOM are transferred to the order. Reservations are generated for bill of material items held in stock. The planned costs for the order are generated. The capacity requirements are generated for the work centers. Purchase requisitions are generated for non-stock items and externally-processed operations.",
              Outcome:
                "Planned order is partly or completely converted to a process order.",
              name: "Convert planned order to process order",
              _id: 1336,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "Pl2P Make-to-stock (Process industry manufacturing with shop-floor papers)",
          _id: 1345,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "8a1b83c1-94c4-11e8-2ddf-001bc640cd9b",
          Description:
            "External processing involves the processes required when a specific production step is subcontracted to an external manufacturer. In comparison to the subcontracting scenarios covered by P2P the External processing scenario does not require material masters.    If external operation is done onsite, then the service is purchased.    If external service is done off-site and logistics is managed by the buyer, then a material number (unvalued) is required.    The described process flow focusses on the actual manufacturing and does not consider planning and scheduling activities.",
          _type: "Scenario",
          GUID: "7cb39ca0-f877-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production is finished, the process order related to it must be confirmed. This represents the technical closure of the production.",
              _type: "Process",
              GUID: "baf08401-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Capturing of working times and posting on the production order can be done automatically in case of electronic work sheets.",
              Type: "Business Process",
              Scope:
                "The production or process order confirmation takes place after the manufacturing process is finished. Confirmation can be performed for an order, for a completed manufacturing phase (milestone) or a single production step and is used to finally record and confirm produced quantity of goods, used resources and performed activities as well as actual order completion dates. Depending on set-up this process can have impact on production planning by reducing planned production quantities, reducing capacity load, making adjustments to dependent requirements for components etc.",
              Outcome:
                "The confirmed production steps or the complete order is considered as technically closed. No further activities can be performed on it. However, commercial closure will be done later - typically in a month end procedure in controlling.",
              name: "Confirm production",
              _id: 1329,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production or after the process order is released shop-floor papers (alternative via electronic files) are generated and the supply of necessary materials to the production initiated. ",
              _type: "Process",
              GUID: "712673e8-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "There are three options for production preparation:   ***using PI Sheet (production instructions in electronic form)   ***using shop floor papers (paper based solution)   ***transfer production instructions to an external manufacturing control system.     PI sheets (including electronic signatures) are often used in the pharmaceutical industry in order to comply with regulatory requirements concerning batch records.",
              Type: "Business Process",
              Scope:
                "The production preparation process covers all activities required to start manufacturing based on the released process order or production order. Information about the actual manufacturing process and control parameters and instructions for the production operators must be transferred to the production control to be carried out (for this purpose control recipes are used). Shop-floor papers for the coordination of manufacturing tasks must be created and material supply to production initiated. ",
              Outcome:
                "All preparation steps for production are performed, physical manufacturing can start.",
              name: "Prepare production (Paper-based)",
              _id: 1322,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After external subcontracting is complete, a goods issue of the externally subcontracted material is posted to the internal production order. The inventory of the components at the relevant storage location will be decreased.",
              _type: "Process",
              GUID: "693c7fe4-94c9-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Before resuming production internally, a goods issue must be posted for the externally subcontracted materials. ",
              Outcome:
                "Goods issue posting of externally subcontracted material to internal production order. ",
              name: "Perform goods issue of processed materials to subsequent internal production step",
              _id: 1344,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "To reflect the actual stock situation, component consumption, which takes place during the manufacturing process must be recorded and stock level in the shop-floor papers lowered accordingly. In manufacturing this is often done via backflushing for components, which are not explicitly counted or weighed. Component consumption is recorded only after finishing the actual manufacturing operation calculated using the BOM or recipe and the actual recorded quantity of produced goods. Additionally or alternatively the consumption of material can be entered via scanner or manually in advance.",
              _type: "Process",
              GUID: "baf083fe-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Within the material master and BOM it must be defined whether back flushing or any other specific type of GI (e.g. pipeline) can and will be performed.",
              Type: "Business Process",
              Scope:
                "The recording of material consumption for manufacturing process is carried out before, during, or after finishing manufacturing operation. The goods issue adjusts inventory and the value of the components is accounted to the order as actual costs.",
              Outcome: "Goods issues are posted",
              name: "Perform consumption for production",
              _id: 1320,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes subcontracting production. When a co-product is manufactured for sub-contracting, the semi-finished good is put onto stock as a co-product. Once the co-product is on stock, the subcontracting can be triggered. ",
              _type: "Process",
              GUID: "693c7fcf-94c9-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Semi-finished product produced internally and ready for subcontracting are staged for further processing. ",
              Outcome: "Co-products are checked and ready for subcontracting. ",
              name: "Perform goods receipt of co-product for subcontracting",
              _id: 1343,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Goods issue for materials and components used within the production process have to be posted after delivery and when they are moved from the warehouse for further processing. ",
              _type: "Process",
              GUID: "baf08434-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The segregation of staging for production and actual posting of the GI of the components can differ depending on the physical and organizational set-up as well as on the required transparency on the material flow.",
              Type: "Business Process",
              Scope:
                "Goods issues are performed for materials and components retrieved from stock used in the respective production step. Some stock materials might be exempt and later be posted in the cause of a backflushing process.",
              Outcome: "Goods issue is posted.",
              name: "Perform goods issue of components for production",
              _id: 1328,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After all preparations are carried out, the physical production can take place. Besides the manufacturing of products the process usually includes also their labeling and packing.",
              _type: "Process",
              GUID: "712673e2-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Set-up of manufacturing quality inspection must be defined-when it should be carried out (during production, based on first manufactured products, at end of production) and how it is initiated (information flow from production).   Production monitoring setup, exchange of production relevant information with external systems (e.g. process messages), production and downtime reporting requirements must be defined.   Label use (manufacturing, shipping, receiving, scanning, customer specific, general in-house label use) must be defined and considered for product labeling.",
              Type: "Business Process",
              Scope:
                "Physical manufacturing of products is carried out and monitored by production control.  Prior to the actual production of goods it is possible that machines need to be set up and after goods are produced, they must be packed and labeled. After labeling and packing production tools need to be dismantled.",
              Outcome: "Goods have been produced.",
              name: "Manufacture products",
              _id: 1324,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "Pl2P External processing",
          _id: 1342,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "24978921-7f20-11e5-0a66-001bc640cd9b",
          Description:
            "Make-to-stock production model describes the manufacturing of large quantities of standardized products. In the process industry production is carried out in a continuous linear flow process. The manufactured products are placed in inventory and sold to customers from there.  In comparison to the discrete manufacturing industries, the number of production steps and the variety to combine them is limited. Products are rather defined by a distinct combination of components used in the same chemical process or by a very specific control of a chemical process to achieve the intended result.  Typically a make-to-stock production model is applied where the output of a production order fulfills the demand from many customers or the production process takes too long to meet expected lead times on the market. Especially on an intermediate level, volumes might depend on the capacity of a production unit, that determines the output and forces a make-to-stock production on that level.  Production scheduling in this scenario is performed in a stepwise procedure - first performing material requirement planning and then evaluating and leveling the production capacity.  In this scenario, the production is controlled via an electronic version of the shop floor papers. The instructions as well as any documentation are captured electronically including electronic signatures and represent at the end the electronic batch record. Typically applied in the pharmaceutical industry, the PI-sheet (electronic process instruction) and the electronic batch record allow to comply with regulatory requirements more efficiently.   In addition this scenario shows the integration with quality inspection using inspection points. The process data needed for different inspection points is captured in the PI-sheet in the course of the production process in order to be available for later analyses. This kind of quality control has no immediate impact on stock availability of the produced batch. ",
          _type: "Scenario",
          GUID: "22a31392-ef12-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Planned orders are scheduled in order to determine the actual production sequence per machine/workplace.",
              _type: "Process",
              GUID: "0f289faa-974c-11e9-0cfc-001bc641ce4f",
              Advisory_Notes:
                "***It needs to be decided how the schedule is going to be fixed. Often fixation of planned orders or the conversion to process orders is used to show, that scheduling has been conducted.In addition it is useful to discuss frozen horizons in order to keep production schedule stable.    ***Typically in scheduling the following aspects are taken into consideration: detailed capacities, change-over cost, alternative production versions/recipes, lot size optimization, component availability for JIT components. *** Real-time status information from shop floor integration systems might be used in order to keep schedule up to date.",
              Type: "Business Process",
              Scope:
                "After receiving planned orders from production planning these need to be brought into sequence for actual production. During this scheduling detailed restrictions of the different needed machines/workplaces are considered. Furthermore change-over optimization is conducted in order to achieve a cost efficient production sequence.",
              Outcome: "",
              name: "Schedule planned orders",
              _id: 1327,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production is finished, the process order related to it must be confirmed. This represents the technical closure of the production.",
              _type: "Process",
              GUID: "baf08401-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Capturing of working times and posting on the production order can be done automatically in case of electronic work sheets.",
              Type: "Business Process",
              Scope:
                "The production or process order confirmation takes place after the manufacturing process is finished. Confirmation can be performed for an order, for a completed manufacturing phase (milestone) or a single production step and is used to finally record and confirm produced quantity of goods, used resources and performed activities as well as actual order completion dates. Depending on set-up this process can have impact on production planning by reducing planned production quantities, reducing capacity load, making adjustments to dependent requirements for components etc.",
              Outcome:
                "The confirmed production steps or the complete order is considered as technically closed. No further activities can be performed on it. However, commercial closure will be done later - typically in a month end procedure in controlling.",
              name: "Confirm production",
              _id: 1329,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Although requirements planning will initially have planned the availability of raw materials and components it is important to check and re-check the availability for production to avoid that any change in the actual stock situation may cause an interruption of the scheduled production. This can be a undelivered raw material or a missing component due to a break-down",
              _type: "Process",
              GUID: "88c21250-7f1c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Availability of the required components will be checked.",
              Outcome:
                "Availability confirmed or missing parts component list is generated.",
              name: "Check component availability",
              _id: 1323,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the process order is released, production set-up and control needs to be prepared-process instructions transferred from process order, shop-floor papers generated and supply of necessary materials to the production initiated.",
              _type: "Process",
              GUID: "70fa5e73-e8f7-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "There are three options for production preparation:   ***using PI Sheet (production instructions in electronic form)   ***using shop floor papers (paper based solution)   ***transfer production instructions to an external manufacturing control system.    In process industry PI sheet is the typical solution.",
              Type: "Business Process",
              Scope:
                "The production preparation process covers all activities required to start manufacturing based on the released process order. Information about the actual manufacturing process and control parameters and instructions for the process operators must be transferred to the production control to be carried out (for this purpose control recipes are used). Shop-floor papers for the coordination of manufacturing tasks must be created and material supply to production initiated.",
              Outcome:
                "All preparation steps for production are performed, physical manufacturing can start.",
              name: "Prepare production (PI sheet)",
              _id: 1341,
              Business_Rules:
                "It must be defined:   ***Which shop-floor papers are required (e.g. process order operations, goods issue slip),   ***What information must be included into control recipe, to what destinations they must be sent as well as communication channels   ***What checks are required before the release of control recipes and how they are set-up  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After all preparations are carried out, the physical production can take place. Besides the manufacturing of products the process usually includes also their labeling and packing.",
              _type: "Process",
              GUID: "712673e2-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Set-up of manufacturing quality inspection must be defined-when it should be carried out (during production, based on first manufactured products, at end of production) and how it is initiated (information flow from production).   Production monitoring setup, exchange of production relevant information with external systems (e.g. process messages), production and downtime reporting requirements must be defined.   Label use (manufacturing, shipping, receiving, scanning, customer specific, general in-house label use) must be defined and considered for product labeling.",
              Type: "Business Process",
              Scope:
                "Physical manufacturing of products is carried out and monitored by production control.  Prior to the actual production of goods it is possible that machines need to be set up and after goods are produced, they must be packed and labeled. After labeling and packing production tools need to be dismantled.",
              Outcome: "Goods have been produced.",
              name: "Manufacture products",
              _id: 1324,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "During production process data is documented in the PI sheet.",
              _type: "Process",
              GUID: "0e8d9651-7559-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                " ***With a higher degree of shopfloor integration it is possible to automate the capturing of data directly from the interfaces of available machine execution systems (MES).  ***captured data in PI sheet can directly be used for postings (e.g. consumption postings) or gathered for later processing after completion of process order.  ***Milestone confirmation data can be used for process analyses (e.g. throughput times or interruptions). But it is essential to keep in mind that this needs to be heavily supported by master data design (esp. structure of recipes) as well as the discipline on the shopfloor in case of manual capturing.",
              Type: "Business Process",
              Scope:
                "During production the shop floor operator receives step-by-step process instructions for the related process order. For some process steps the capturing of data is required (e.g. actually dosed quantities, process data as specified in inspection points, milestone confirmation).  This process shows manual data entry and confirmation as well as milestone confirmation.",
              Outcome:
                "Process data has been captured and confirmed and is available in the PI sheet for further processing.",
              name: "Capture process data in PI sheet",
              _id: 1340,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "To reflect the actual stock situation, component consumption, which takes place during the manufacturing process must be recorded and stock level in the process instruction sheet lowered accordingly. In manufacturing this is often done via backflushing for components, which are not explicitly counted or weighed. Component consumption is recorded only after finishing the actual manufacturing operation calculated using the BOM or recipe and the actual recorded quantity of produced goods. Additionally or alternatively the consumption of material can be entered via scanner or manually in advance.",
              _type: "Process",
              GUID: "d5ab3667-689a-11e8-2ddf-001bc640cd9b",
              Advisory_Notes:
                "Within the material master and BOM it must be defined whether back flushing or any other specific type of GI (e.g. pipeline) can and will be performed.",
              Type: "Business Process",
              Scope:
                "The recording of material consumption for manufacturing process is carried out before, during, or after finishing manufacturing operation. The goods issue adjusts inventory and the value of the components is accounted to the order as actual costs.",
              Outcome: "Consumption postings have been conducted.",
              name: "Perform consumption for production in PI sheet",
              _id: 1339,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Goods issue for materials and components used within the production process have to be posted after delivery and when they are moved from the warehouse for further processing. ",
              _type: "Process",
              GUID: "f9a05553-7f25-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "If weighing systems are used, they might be directly connected to the system and integrated in the user dialog.",
              Type: "Business Process",
              Scope:
                "Goods issues are performed for materials and components retrieved from stock used in the respective production step. Prior to the goods issue it is possible that weighing of components required for the production needs to be executed first.Goods issues are performed for materials and components retrieved from stock used in the respective production step. Prior to the goods issue it is possible that weighing of components required for the production needs to be executed first.",
              Outcome: "Goods issues are posted.",
              name: "Perform goods issue of components for process order",
              _id: 1338,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Process orders can be created in advance to the planned manufacturing start date and are not bound to the availability of required materials or capacity. The release process represents the final step to initiate the manufacturing process. Unless the order is released, no further processing is possible.",
              _type: "Process",
              GUID: "cf57b45a-e9c8-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "The release will also impact the status of the material reservations of the components. Latest at this point in time, the reservations should be treated as firm and no other planning or logistics process should no longer have access to the reserved quantities.",
              Type: "Business Process",
              Scope:
                "Created process orders must be released, before they can be processed by production. The release is done, when the release date has been reached and when the required materials and capacity are available. The availability of materials and capacity should be checked within the release process. The process order release may also include batch determination and assignments. ",
              Outcome: "Process order is released.",
              name: "Release process order",
              _id: 1337,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "The actual production progress is monitored.",
              _type: "Process",
              GUID: "0f289faf-974c-11e9-0cfc-001bc641ce4f",
              Advisory_Notes:
                " ***it needs to be defined which events will trigger the adjustment of schedule or even feedback to production planning.",
              Type: "Business Process",
              Scope:
                "After orders have been released to production the actual progress needs to be monitored. In case of any special events or deviations follow-up activities as well as counter-measures need to be triggered.  Most important is the update of the production schedule and information/feedback to production planning in case of need.",
              Outcome:
                "Actual production progress is monitored and appropriate reactions are triggered.",
              name: "Monitor production progress",
              _id: 1326,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Planned orders created in material requirement planning or detailed scheduling are only planning elements, in order to trigger actual manufacturing in process industry they must be converted to process orders.",
              _type: "Process",
              GUID: "88c21232-7f1c-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Regardless whether a process order gets created directly or via converting a planned order material, recipe and BOM related data get retrieved again from respective master data.   Possible conversion options must be defined:   ***one planned order to one process order,   ***several planned orders to one process order,   ***partial conversion of planned orders.  ",
              Type: "Business Process",
              Scope:
                "Within a defined horizon, planned orders get converted in process orders to become executable. The conversion typically includes the adding of production specific information.   A process order describes the production of batches (materials) in a production run or the rendering of services. It is generated from the master recipe and contains all the information specified during process planning. You use a process order to plan the quantities, dates, and resources of the manufacturing process, to control process order execution, and to define rules for the account assignment and settlement of the costs incurred.    A recipe version is selected, its operations and sequences are transferred to the process order. The bill of materials (BOM) is exploded and the items in the BOM are transferred to the order. Reservations are generated for bill of material items held in stock. The planned costs for the order are generated. The capacity requirements are generated for the work centers. Purchase requisitions are generated for non-stock items and externally-processed operations.",
              Outcome:
                "Planned order is partly or completely converted to a process order.",
              name: "Convert planned order to process order",
              _id: 1336,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "Pl2P Make-to-stock (Process industry manufacturing with PI sheet)",
          _id: 1335,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "e5e9d621-900a-11e8-2ddf-001bc640cd9b",
          Description:
            "Active subcontracting scenario describes an organization acting as a subcontractor (active toll manufacturer) and providing manufacturing services to their customers. Typically, in this scenario a customer who is purchasing the subcontracting service also provides material components required for production and the subcontractor only carries out the production itself.  The production process itself does not differ from any other production. However, as the handled materials do belong to the customer, there are differences.",
          _type: "Scenario",
          GUID: "22a313a6-ef12-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "To reflect the actual stock situation, component consumption, which takes place during the manufacturing process must be recorded and stock level in the shop-floor papers lowered accordingly. In manufacturing this is often done via backflushing for components, which are not explicitly counted or weighed. Component consumption is recorded only after finishing the actual manufacturing operation calculated using the BOM or recipe and the actual recorded quantity of produced goods. Additionally or alternatively the consumption of material can be entered via scanner or manually in advance.",
              _type: "Process",
              GUID: "baf083fe-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Within the material master and BOM it must be defined whether back flushing or any other specific type of GI (e.g. pipeline) can and will be performed.",
              Type: "Business Process",
              Scope:
                "The recording of material consumption for manufacturing process is carried out before, during, or after finishing manufacturing operation. The goods issue adjusts inventory and the value of the components is accounted to the order as actual costs.",
              Outcome: "Goods issues are posted",
              name: "Perform consumption for production",
              _id: 1320,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Although requirements planning will initially have planned the availability of raw materials and components it is important to check and re-check the availability for production to avoid that any change in the actual stock situation may cause an interruption of the scheduled production. This can be a undelivered raw material or a missing component due to a break-down",
              _type: "Process",
              GUID: "88c21250-7f1c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Availability of the required components will be checked.",
              Outcome:
                "Availability confirmed or missing parts component list is generated.",
              name: "Check component availability",
              _id: 1323,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Planned orders are scheduled in order to determine the actual production sequence per machine/workplace.",
              _type: "Process",
              GUID: "0f289faa-974c-11e9-0cfc-001bc641ce4f",
              Advisory_Notes:
                "***It needs to be decided how the schedule is going to be fixed. Often fixation of planned orders or the conversion to process orders is used to show, that scheduling has been conducted.In addition it is useful to discuss frozen horizons in order to keep production schedule stable.    ***Typically in scheduling the following aspects are taken into consideration: detailed capacities, change-over cost, alternative production versions/recipes, lot size optimization, component availability for JIT components. *** Real-time status information from shop floor integration systems might be used in order to keep schedule up to date.",
              Type: "Business Process",
              Scope:
                "After receiving planned orders from production planning these need to be brought into sequence for actual production. During this scheduling detailed restrictions of the different needed machines/workplaces are considered. Furthermore change-over optimization is conducted in order to achieve a cost efficient production sequence.",
              Outcome: "",
              name: "Schedule planned orders",
              _id: 1327,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Credit management helps to control the companys exposure to credit risk. Credit management must be aligned taking into account the customers liquidity and payment history (credit limit/insurance) and outstanding receivables.",
              _type: "Process",
              GUID: "5aa42fcb-e8e2-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Many corporations start looking at credit management from a group perspective. This requires some collaboration across companies and business units, which might not be established. Hierarchical credit limits might help to hinder a single business unit from already consuming the entire credit limit of a customer.  Any kind of guarantees such as letter of credit or bank guarantees and advanced payments need to be considered in this process.  Credit management for consignment fill-ups - despite goods remaining in sellers property, it is common to perform credit check, since control over goods is lost and the goods issue is typically retrospective.",
              Type: "Business Process",
              Scope:
                "The customers ability to pay for the product or service is evaluated based on their liquidity and payment history and a decision is made on whether the sale is allowed or not.",
              Outcome:
                "The decision is made on whether to proceed with sale or not.",
              name: "Execute credit management",
              _id: 1334,
              Business_Rules:
                "It is necessary to define the information necessary to execute the credit management process.  A framework must be put in place for:   ***Calculating the rating value of customers    ***Determining Credit Limit   ***Setting rules for Credit Check    ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Goods issue for materials and components used within the production process have to be posted after delivery and when they are moved from the warehouse for further processing. ",
              _type: "Process",
              GUID: "baf08434-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The segregation of staging for production and actual posting of the GI of the components can differ depending on the physical and organizational set-up as well as on the required transparency on the material flow.",
              Type: "Business Process",
              Scope:
                "Goods issues are performed for materials and components retrieved from stock used in the respective production step. Some stock materials might be exempt and later be posted in the cause of a backflushing process.",
              Outcome: "Goods issue is posted.",
              name: "Perform goods issue of components for production",
              _id: 1328,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "The actual production progress is monitored.",
              _type: "Process",
              GUID: "0f289faf-974c-11e9-0cfc-001bc641ce4f",
              Advisory_Notes:
                " ***it needs to be defined which events will trigger the adjustment of schedule or even feedback to production planning.",
              Type: "Business Process",
              Scope:
                "After orders have been released to production the actual progress needs to be monitored. In case of any special events or deviations follow-up activities as well as counter-measures need to be triggered.  Most important is the update of the production schedule and information/feedback to production planning in case of need.",
              Outcome:
                "Actual production progress is monitored and appropriate reactions are triggered.",
              name: "Monitor production progress",
              _id: 1326,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Manufacturing orders can be created in advance to the planned manufacturing start date and are not bound to the availability of required materials or capacity. The release process represents the final step to initiate the manufacturing process. Unless the order is released, no further processing is possible.",
              _type: "Process",
              GUID: "024d6439-e8f7-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "The release will also impact the status of the material reservations of the components. Latest at this point in time, the reservations should be treated as firm and no other planning or logistics process should have access to the reserved quantities anymore.",
              Type: "Business Process",
              Scope:
                "Created manufacturing orders must be released, before they can be processed by production. The release is done, when the release date has been reached and when the required materials and capacity are available. The availability of materials and capacity should be checked within the release process.",
              Outcome: "Production order is released.",
              name: "Release production order",
              _id: 1321,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "As a result of a planning procedure planned orders are created. Those need to be converted to production orders.",
              _type: "Process",
              GUID: "712673f1-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Regardless whether a production order gets created directly or via converting a planned order material, routing and BOM related data get retrieved again from respective master data.   Possible conversion options must be defined:   ***one planned order to one production order,   ***several planned orders to one production order,   ***partial conversion of planned orders.  ",
              Type: "Business Process",
              Scope:
                "Within a defined horizon, planned production orders get converted in order to become executable production orders. The conversion typically includes the adding of production specific information.   A production order describes the production of the specified product following the selected production version (combination of BOM alternative and version or routing). The production order is used to plan the quantities, dates, and resources of the manufacturing process, to control order execution, and to define rules for the account assignment and settlement of the costs incurred.    A routing version is selected, its operations and sequences are transferred to the production order. The bill of materials (BOM) is exploded and the items in the BOM are transferred to the order. Reservations are generated for bill of material items held in stock. The planned costs for the order are generated. The capacity requirements are generated for the work centers. Purchase requisitions are generated for non-stock items and externally-processed operations.",
              Outcome:
                "Planned order is partly or completely converted to a production order.",
              name: "Convert planned order to production order",
              _id: 1325,
              Business_Rules:
                "It must be defined, how production orders can be created - either by converting a planned order to a production order only, or also by creating it manually. Latter bypasses planning violating best practices principals, though.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In an active subcontracting process, the company must receive the components before providing the subcontracting services. ",
              _type: "Process",
              GUID: "1923a0ad-900d-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "In this process, the goods are received, which triggers production. ",
              Outcome: "Components received from sub-contractor.",
              name: "Initiate and confirm components from subcontractor",
              _id: 1333,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of the sales order is given through the confirmation and represents a commitment to fulfil the order.",
              _type: "Process",
              GUID: "a98a286c-7e52-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The effectiveness of the approval-workflows often is overestimated. Sales managers will receive many approval requests daily. The data to be checked should be limited to the essentials. Everything that can be checked automatically by rules should be implemented in the system. The result of the automatic checks should be obvious to the reviewer.",
              Type: "Business Process",
              Scope:
                "After all checks related to the order have been performed the final decision is made regarding execution of the order. A commitment to the customer is made. This triggers the outbound logistics, production process or service process. ",
              Outcome:
                "A decision is made to fulfil the customers order. This triggers the outbound logistics/production process. The customer is informed about the decision.",
              name: "Save and approve sales order",
              _id: 1332,
              Business_Rules:
                "Rules must be established for allocating authorization for sales order approval to users. The format of the confirmation (electronic, paper) and communication channel must be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production or after the process order is released shop-floor papers (alternative via electronic files) are generated and the supply of necessary materials to the production initiated. ",
              _type: "Process",
              GUID: "712673e8-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "There are three options for production preparation:   ***using PI Sheet (production instructions in electronic form)   ***using shop floor papers (paper based solution)   ***transfer production instructions to an external manufacturing control system.     PI sheets (including electronic signatures) are often used in the pharmaceutical industry in order to comply with regulatory requirements concerning batch records.",
              Type: "Business Process",
              Scope:
                "The production preparation process covers all activities required to start manufacturing based on the released process order or production order. Information about the actual manufacturing process and control parameters and instructions for the production operators must be transferred to the production control to be carried out (for this purpose control recipes are used). Shop-floor papers for the coordination of manufacturing tasks must be created and material supply to production initiated. ",
              Outcome:
                "All preparation steps for production are performed, physical manufacturing can start.",
              name: "Prepare production (Paper-based)",
              _id: 1322,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production is finished, the process order related to it must be confirmed. This represents the technical closure of the production.",
              _type: "Process",
              GUID: "baf08401-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Capturing of working times and posting on the production order can be done automatically in case of electronic work sheets.",
              Type: "Business Process",
              Scope:
                "The production or process order confirmation takes place after the manufacturing process is finished. Confirmation can be performed for an order, for a completed manufacturing phase (milestone) or a single production step and is used to finally record and confirm produced quantity of goods, used resources and performed activities as well as actual order completion dates. Depending on set-up this process can have impact on production planning by reducing planned production quantities, reducing capacity load, making adjustments to dependent requirements for components etc.",
              Outcome:
                "The confirmed production steps or the complete order is considered as technically closed. No further activities can be performed on it. However, commercial closure will be done later - typically in a month end procedure in controlling.",
              name: "Confirm production",
              _id: 1329,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the receipt of a customer request for services.",
              _type: "Process",
              GUID: "4f887808-82c5-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Services can be represented by a material number with service type and/or service item category. The service item category controls whether a delivery is required or not.",
              Type: "Business Process",
              Scope:
                "Create sales order and maintain basic order data for service and the performance of a credit check.",
              Outcome: "Sales order for services is created.",
              name: "Receive service request and create sales order",
              _id: 1331,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After all preparations are carried out, the physical production can take place. Besides the manufacturing of products the process usually includes also their labeling and packing.",
              _type: "Process",
              GUID: "712673e2-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Set-up of manufacturing quality inspection must be defined-when it should be carried out (during production, based on first manufactured products, at end of production) and how it is initiated (information flow from production).   Production monitoring setup, exchange of production relevant information with external systems (e.g. process messages), production and downtime reporting requirements must be defined.   Label use (manufacturing, shipping, receiving, scanning, customer specific, general in-house label use) must be defined and considered for product labeling.",
              Type: "Business Process",
              Scope:
                "Physical manufacturing of products is carried out and monitored by production control.  Prior to the actual production of goods it is possible that machines need to be set up and after goods are produced, they must be packed and labeled. After labeling and packing production tools need to be dismantled.",
              Outcome: "Goods have been produced.",
              name: "Manufacture products",
              _id: 1324,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "Pl2P Active subcontracting",
          _id: 1330,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "c7f39011-7f1f-11e5-0a66-001bc640cd9b",
          Description:
            "Make-to-stock production model describes manufacturing of large quantities of standardized products, which are then placed on stock and subsequently sold to customers. Typically, the make-to-stock production model is used when there are a few product lines and long costly changeover times between products. The make-to-stock scheduling objective ensures constant equipment utilization and allows optimization of lot sizes, which leads to a maximization of output.  The production processes deployed in discrete manufacturing are not continuous in nature. Each process can be individually started or stopped and can be run at varying production rates. Products in discrete manufacturing industries require often to perform many production steps in an order distinct to the specific product. Sometimes combined with quite complex structures of a product specific bill of material, defining which components and materials are required to assemble the final product. Very likely, the production is done in several stages with intermediates, for which individual production orders are generated. In some industries such as automotive, the hierarchical structure of a products bill of material can be as deep as 23 levels with intermediate products on each level. Those are rarely produced with on enterprise but rather in a highly complex supply chain of many levels of suppliers contributing to the final product.  In this scenario the material requirements planning (MRP) is applied, which only evaluates material requirements. The actual resolving of possible capacity or resource constraints take place in a manual leveling process.",
          _type: "Scenario",
          GUID: "22a31394-ef12-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production is finished, the process order related to it must be confirmed. This represents the technical closure of the production.",
              _type: "Process",
              GUID: "baf08401-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Capturing of working times and posting on the production order can be done automatically in case of electronic work sheets.",
              Type: "Business Process",
              Scope:
                "The production or process order confirmation takes place after the manufacturing process is finished. Confirmation can be performed for an order, for a completed manufacturing phase (milestone) or a single production step and is used to finally record and confirm produced quantity of goods, used resources and performed activities as well as actual order completion dates. Depending on set-up this process can have impact on production planning by reducing planned production quantities, reducing capacity load, making adjustments to dependent requirements for components etc.",
              Outcome:
                "The confirmed production steps or the complete order is considered as technically closed. No further activities can be performed on it. However, commercial closure will be done later - typically in a month end procedure in controlling.",
              name: "Confirm production",
              _id: 1329,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Goods issue for materials and components used within the production process have to be posted after delivery and when they are moved from the warehouse for further processing. ",
              _type: "Process",
              GUID: "baf08434-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The segregation of staging for production and actual posting of the GI of the components can differ depending on the physical and organizational set-up as well as on the required transparency on the material flow.",
              Type: "Business Process",
              Scope:
                "Goods issues are performed for materials and components retrieved from stock used in the respective production step. Some stock materials might be exempt and later be posted in the cause of a backflushing process.",
              Outcome: "Goods issue is posted.",
              name: "Perform goods issue of components for production",
              _id: 1328,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Planned orders are scheduled in order to determine the actual production sequence per machine/workplace.",
              _type: "Process",
              GUID: "0f289faa-974c-11e9-0cfc-001bc641ce4f",
              Advisory_Notes:
                "***It needs to be decided how the schedule is going to be fixed. Often fixation of planned orders or the conversion to process orders is used to show, that scheduling has been conducted.In addition it is useful to discuss frozen horizons in order to keep production schedule stable.    ***Typically in scheduling the following aspects are taken into consideration: detailed capacities, change-over cost, alternative production versions/recipes, lot size optimization, component availability for JIT components. *** Real-time status information from shop floor integration systems might be used in order to keep schedule up to date.",
              Type: "Business Process",
              Scope:
                "After receiving planned orders from production planning these need to be brought into sequence for actual production. During this scheduling detailed restrictions of the different needed machines/workplaces are considered. Furthermore change-over optimization is conducted in order to achieve a cost efficient production sequence.",
              Outcome: "",
              name: "Schedule planned orders",
              _id: 1327,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "The actual production progress is monitored.",
              _type: "Process",
              GUID: "0f289faf-974c-11e9-0cfc-001bc641ce4f",
              Advisory_Notes:
                " ***it needs to be defined which events will trigger the adjustment of schedule or even feedback to production planning.",
              Type: "Business Process",
              Scope:
                "After orders have been released to production the actual progress needs to be monitored. In case of any special events or deviations follow-up activities as well as counter-measures need to be triggered.  Most important is the update of the production schedule and information/feedback to production planning in case of need.",
              Outcome:
                "Actual production progress is monitored and appropriate reactions are triggered.",
              name: "Monitor production progress",
              _id: 1326,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "As a result of a planning procedure planned orders are created. Those need to be converted to production orders.",
              _type: "Process",
              GUID: "712673f1-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Regardless whether a production order gets created directly or via converting a planned order material, routing and BOM related data get retrieved again from respective master data.   Possible conversion options must be defined:   ***one planned order to one production order,   ***several planned orders to one production order,   ***partial conversion of planned orders.  ",
              Type: "Business Process",
              Scope:
                "Within a defined horizon, planned production orders get converted in order to become executable production orders. The conversion typically includes the adding of production specific information.   A production order describes the production of the specified product following the selected production version (combination of BOM alternative and version or routing). The production order is used to plan the quantities, dates, and resources of the manufacturing process, to control order execution, and to define rules for the account assignment and settlement of the costs incurred.    A routing version is selected, its operations and sequences are transferred to the production order. The bill of materials (BOM) is exploded and the items in the BOM are transferred to the order. Reservations are generated for bill of material items held in stock. The planned costs for the order are generated. The capacity requirements are generated for the work centers. Purchase requisitions are generated for non-stock items and externally-processed operations.",
              Outcome:
                "Planned order is partly or completely converted to a production order.",
              name: "Convert planned order to production order",
              _id: 1325,
              Business_Rules:
                "It must be defined, how production orders can be created - either by converting a planned order to a production order only, or also by creating it manually. Latter bypasses planning violating best practices principals, though.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After all preparations are carried out, the physical production can take place. Besides the manufacturing of products the process usually includes also their labeling and packing.",
              _type: "Process",
              GUID: "712673e2-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Set-up of manufacturing quality inspection must be defined-when it should be carried out (during production, based on first manufactured products, at end of production) and how it is initiated (information flow from production).   Production monitoring setup, exchange of production relevant information with external systems (e.g. process messages), production and downtime reporting requirements must be defined.   Label use (manufacturing, shipping, receiving, scanning, customer specific, general in-house label use) must be defined and considered for product labeling.",
              Type: "Business Process",
              Scope:
                "Physical manufacturing of products is carried out and monitored by production control.  Prior to the actual production of goods it is possible that machines need to be set up and after goods are produced, they must be packed and labeled. After labeling and packing production tools need to be dismantled.",
              Outcome: "Goods have been produced.",
              name: "Manufacture products",
              _id: 1324,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Although requirements planning will initially have planned the availability of raw materials and components it is important to check and re-check the availability for production to avoid that any change in the actual stock situation may cause an interruption of the scheduled production. This can be a undelivered raw material or a missing component due to a break-down",
              _type: "Process",
              GUID: "88c21250-7f1c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "Availability of the required components will be checked.",
              Outcome:
                "Availability confirmed or missing parts component list is generated.",
              name: "Check component availability",
              _id: 1323,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the production or after the process order is released shop-floor papers (alternative via electronic files) are generated and the supply of necessary materials to the production initiated. ",
              _type: "Process",
              GUID: "712673e8-7f1e-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "There are three options for production preparation:   ***using PI Sheet (production instructions in electronic form)   ***using shop floor papers (paper based solution)   ***transfer production instructions to an external manufacturing control system.     PI sheets (including electronic signatures) are often used in the pharmaceutical industry in order to comply with regulatory requirements concerning batch records.",
              Type: "Business Process",
              Scope:
                "The production preparation process covers all activities required to start manufacturing based on the released process order or production order. Information about the actual manufacturing process and control parameters and instructions for the production operators must be transferred to the production control to be carried out (for this purpose control recipes are used). Shop-floor papers for the coordination of manufacturing tasks must be created and material supply to production initiated. ",
              Outcome:
                "All preparation steps for production are performed, physical manufacturing can start.",
              name: "Prepare production (Paper-based)",
              _id: 1322,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Manufacturing orders can be created in advance to the planned manufacturing start date and are not bound to the availability of required materials or capacity. The release process represents the final step to initiate the manufacturing process. Unless the order is released, no further processing is possible.",
              _type: "Process",
              GUID: "024d6439-e8f7-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "The release will also impact the status of the material reservations of the components. Latest at this point in time, the reservations should be treated as firm and no other planning or logistics process should have access to the reserved quantities anymore.",
              Type: "Business Process",
              Scope:
                "Created manufacturing orders must be released, before they can be processed by production. The release is done, when the release date has been reached and when the required materials and capacity are available. The availability of materials and capacity should be checked within the release process.",
              Outcome: "Production order is released.",
              name: "Release production order",
              _id: 1321,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "To reflect the actual stock situation, component consumption, which takes place during the manufacturing process must be recorded and stock level in the shop-floor papers lowered accordingly. In manufacturing this is often done via backflushing for components, which are not explicitly counted or weighed. Component consumption is recorded only after finishing the actual manufacturing operation calculated using the BOM or recipe and the actual recorded quantity of produced goods. Additionally or alternatively the consumption of material can be entered via scanner or manually in advance.",
              _type: "Process",
              GUID: "baf083fe-7f1a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Within the material master and BOM it must be defined whether back flushing or any other specific type of GI (e.g. pipeline) can and will be performed.",
              Type: "Business Process",
              Scope:
                "The recording of material consumption for manufacturing process is carried out before, during, or after finishing manufacturing operation. The goods issue adjusts inventory and the value of the components is accounted to the order as actual costs.",
              Outcome: "Goods issues are posted",
              name: "Perform consumption for production",
              _id: 1320,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "Pl2P Make-to-stock (Discrete industry manufacturing)",
          _id: 1319,
          Business_Rules: "",
          Prerequisite: "",
        },
      ],
      Description:
        "The Plan to Produce (Pl2P) domain encompasses the process of producing goods which includes the initial production planning, the process of preparing the production, producing the goods, and the transaction made for  placement of the produced goods in the storage location.",
      _type: "Domain",
      GUID: "964b5c32-642b-11e4-55cc-001bc640cd9b",
      Advisory_Notes: "",
      Type: "E2E-Domain",
      Scope: "",
      Outcome: "",
      name: "Plan to Produce",
      _id: 1318,
      Business_Rules: "",
      Prerequisite: "",
    },
    {
      BPMN_GUID: "81c70811-ef0f-11e4-0a66-001bc640cd9b",
      scenario_of: [
        {
          BPMN_GUID: "4762db61-7ef0-11e5-0a66-001bc640cd9b",
          Description:
            "Decommissioning of assets scenario covers processes for shutting down a plant/equipment, sale or storage of reusable parts, disposal of waste, and the related accounting activities. In the scope of this scenario, the decision must be made on whether to sell, reuse or dispose an asset. The analysis of assets condition after dismantling forms the basis for determining further usage for the parts (components).",
          _type: "Scenario",
          GUID: "22a3138e-ef12-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "This reflects the sale of an asset which has been approved by management or the cost center responsible for scrapping and/ or sale.  ",
              _type: "Process",
              GUID: "feff4098-7ef0-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The asset is sold upon negotiation of the selling price. There will be no sales order connected to this process and a manual invoice will be required. ",
              Outcome: "Asset sale is complete.",
              name: "Sell asset",
              _id: 567,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures receipt of the return copies of disposal documents within the set periods.",
              _type: "Process",
              GUID: "12bafa91-7ef1-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Generate list of the disposal documents whose return within period is soon to expire. For example, as soon as the disposer has sent the return copies and informed of the waste quantity disposed.   Adjust the waste quantity that can still be disposed of with the corresponding waste approval. Lock waste approvals which have reached their permitted quantity.",
              Outcome: "Waste disposal documents returned and up to date.",
              name: "Monitor disposal and document return",
              _id: 594,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In handing over of physical possession of the asset to the buyer, it is necessary to define the means of transportation and who will cover the transportation cost, as well as record the sale.",
              _type: "Process",
              GUID: "feff4074-7ef0-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once sale consideration or the down payment (as per negotiated terms of payment approved has been received, the possession of the asset is handed over to the buyer. If a portion of sale consideration is deferred, i.e. payable over a span of time, the rightful title of the assets can not be transferred to the purchaser. However, the buyer will take possession of the asset on depositing down payment and may be required to pay interest on the deferred part of sale.",
              Outcome: "Asset is in possession of the buyer.",
              name: "Hand over asset to buyer",
              _id: 334,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After the decision has been taken to sell an asset, it is necessary to find a buyer and negotiate the terms of the sale.",
              _type: "Process",
              GUID: "feff4071-7ef0-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The remaining value of the asset is defined and based on that, negotiations are conducted with several potential buyers. The sale agreement is made with the buyer offering the best terms and conditions.",
              Outcome: "Buyer found and sale terms and conditions defined.",
              name: "Negotiate and determine buyer of asset",
              _id: 359,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures the allocation of resources required to perform plant maintenance.",
              _type: "Process",
              GUID: "e46f703c-e800-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "It is necessary to determine the individual internal resources needed for specific maintenance activities, and when they are needed. Planning enables the availability of the resources at the time they are required.",
              Outcome: "Resources are assigned to the maintenance order",
              name: "Assign resources to maintenance order",
              _id: 1277,
              Business_Rules: "",
              Prerequisite: "Internal resources allocated to maintenance order",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Before the  maintenance order can be released, it is necessary to check whether materials needed to conduct the maintenance are available. ",
              _type: "Process",
              GUID: "7d178dc7-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Pre-requisites: each material, whose availability is checked, must be assigned a checking group on the MRP detail screen in its material master. The checking group combines materials whose availability is checked at the same time. You can, for instance, group materials according to the material type or the MRP type.",
              Type: "Business Process",
              Scope:
                "The system checks whether material components in networks are available on the required date. If the requirements are not covered, the system determines the date on which they can be covered.",
              Outcome: "Availability of required material is determined.",
              name: "Check material availability",
              _id: 1270,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "If a technical asset is no longer fit to be used and it no longer makes sense, for economic or technical reasons, to continue using that asset as a resource, it must be removed from productive use.",
              _type: "Process",
              GUID: "feff406b-7ef0-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The following activities are performed:   ***Determine technical weak points   ***Determine assets that generate very high costs   ***Determine which assets no longer meets the required technical, business, safety, and environmental standards",
              Outcome: "Asset phased out and no longer available for use",
              name: "Phase out asset",
              _id: 609,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Disposal is executed according to legal guidelines and waste management requirements.",
              _type: "Process",
              GUID: "ff0fe25a-7ef0-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Record the necessary external disposal operations and put together the legally required waste disposal documents such as waste manifests, dock receipts on the basis of the internal disposal documents. Execute the disposal and confirm completion.",
              Outcome: "Disposal of waste is confirmed.",
              name: "Execute waste disposal",
              _id: 592,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process covers the creation of the master data required for waste management, including waste generators, points of generation, waste disposers, disposal facilities, waste transporters, authorities and waste.    In cases where waste disposal is to be executed by a service provided, preparation of waste disposal will trigger the procurement process for disposal services.",
              _type: "Process",
              GUID: "12bafa9a-7ef1-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "To describe the waste, waste materials can be created in the system with the logistic properties of the waste and waste specifications with the properties of ingredients, catalog numbers and process codes. The waste may be assigned to plant, cost centers, storage locations or the vendor.",
              Outcome:
                "Waste master data is created and the waste execution is triggered.",
              name: "Prepare waste disposal",
              _id: 593,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Plant maintenance must be executed as specified in the maintenance plan, with tracking of time and task completion.   For dismantling, asset accounting is informed and EH&S is informed about harmful substances have to be transported when the asset is dismantled.",
              _type: "Process",
              GUID: "73e0f9e8-e802-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Having collected the required materials, the maintenance technician conducts the planned maintenance as described in the shop papers. All activities performed are tracked and documented accordingly. ",
              Outcome:
                "All activities related to the plant maintenance are performed",
              name: "Perform plant maintenance",
              _id: 1268,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In waste management, it is necessary to comply with and implement numerous national and international laws and regulations. This business process makes the classification of waste possible and the evaluation of waste management requirements.",
              _type: "Process",
              GUID: "12bafa97-7ef1-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Including the waste specifications, the requirements for handling, disposal, approval and documentation of waste is specified. This includes physical-chemical properties, safety and transport information and legal data for waste. ",
              Outcome:
                "Waste classification and requirements evaluation are complete.",
              name: "Classify waste and evaluate waste management requirements",
              _id: 591,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process covers the scrapping of a fixed asset within asset accounting.",
              _type: "Process",
              GUID: "feff4065-7ef0-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "When an asset is scrapped, the following activities must be performed:   ***Post the net book value to expenses   ***Set date of deactivation in asset master   ***Return information to scrapping requestor",
              Outcome: "Asset scrapping posted and requestor informed.",
              name: "Scrap asset",
              _id: 571,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Manage incoming payment process ensures that the payment from a customer is captured and documented appropriately.",
              _type: "Process",
              GUID: "f5f29ea1-e8f4-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Especially in global template projects different variants of payments have to be considered but their use should often be limited to a group of countries rather than being made available to all.",
              Type: "Business Process",
              Scope:
                "Manage incoming payment involves receiving a payment from a customer and entering the information in accounting. The incoming payment is mapped to the customer invoice and customer account.",
              Outcome:
                "Incoming payment is recorded and the customer account is credited.",
              name: "Manage incoming payment",
              _id: 1264,
              Business_Rules:
                "The methods of payment must be established taking into account country specific factors related to the business and customer. For instance: The bill of exchange (BoE) payment method is used in some countries only.   Typical methods of payment are:   ***Check   ***Direct debits   ***Credit cards   ***Bank transfers",
              Prerequisite:
                "Prerequisite: currency exchange and hedging processes",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The maintenance plan demonstrates that tasks will be done on time, that the technical objects are available and that all required resources, such as internal and external resources and materials, are on hand. The maintenance tasks that are to be performed require detailed planning, in order to minimize the time that the object is not productive. ",
              _type: "Process",
              GUID: "7bbc6a9c-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "For preventative maintenance, the maintenance order is created based on planned tasks that are required when specific predefined circumstances are given. Those can be described by specific parameters , which are verified regularly, by measuring usage (discrete counter or running time), or by a period after which refurbishment is due. Subsequently the maintenance plan is compiled.   For corrective maintenance (including refurbishment), planning is done after  a maintenance request is approved (or planned order converted) and the maintenance order is created.    In both cases, the maintenance plan provides a clear definition of tasks to be performed, roles and responsibilities, and dates.",
              Outcome: "Maintenance plan is created.",
              name: "Plan maintenance order",
              _id: 1271,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of planned activities is given with the release of the  maintenance order. This initiates execution of all activities related to the maintenance order. ",
              _type: "Process",
              GUID: "7bbc6ad8-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Release of a maintenance order represents the approval of the planned activities, such as purchasing of services and materials, as well as the usage of planned materials from stock. After the maintenance order is released shop papers are printed. These are the maintenance instructions for the maintenance technician.",
              Outcome:
                "Maintenance order is released and maintenance activities can be executed.",
              name: "Release maintenance order",
              _id: 1274,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Additional resources may be required to perform plant maintenance. In such cases it is necessary determine the individual resources needed for specific maintenance activities, and when they are needed.  Planning enables the availability of the resources at the time they are required.",
              _type: "Process",
              GUID: "7bbc6aba-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "External resources are planned against the maintenance order. If an additional external service is required immediately, the maintenance planner will change the settings on the maintenance order so that a purchase requisition for the external service is generated immediately.",
              Outcome:
                "Additional external resources are incorporated into the maintenance plan.",
              name: "Plan additional external resources",
              _id: 1275,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approvals are used to define certain rules or requirements that must be observed in Work Clearance Management. ",
              _type: "Process",
              GUID: "7bbc6abd-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The Maintenance Approver evaluates whether work clearance approval is required or not. In case work clearance approval is required, the maintenance planner requests work clearance approval and the maintenance approver either accepts or rejects the request.",
              Outcome:
                "Decision is made whether work clearance is required or not.",
              name: "Evaluate work clearance approval",
              _id: 1278,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Parts designated for refurbishment must be taken from the plant to the area where the refurbishment is performed. This must be accompanied by the relevant goods issue posting.   ",
              _type: "Process",
              GUID: "2348f377-7efc-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "For refurbishment orders, goods issue posting is performed using transaction MB1A (not MIGO).",
              Type: "Business Process",
              Scope:
                "Goods issue is posted with reference to the maintenance order to inform the responsible that parts can be moved to the refurbishment site.",
              Outcome:
                "Goods issue with reference to maintenance order posted. ",
              name: "Perform goods issue for maintenance order",
              _id: 1276,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When an asset can no longer be used, it is necessary to define further steps to finalize its phasing out.",
              _type: "Process",
              GUID: "21fda555-7ef0-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The maintenance manager evaluates the asset to get a view of the asset condition. In doing this, a decision is made on whether to sell, scrap or dispose the asset.",
              Outcome:
                "Decision is made whether to sell, scrap or dispose the asset.",
              name: "Analyze asset condition",
              _id: 589,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process is used to record and store any reusable material derived from scrapping. ",
              _type: "Process",
              GUID: "feff4062-7ef0-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After scrapping of asset is complete, components that can be reused are placed in a storage location with recording of the receipt into the warehouse.",
              Outcome: "Goods receipt of material from strapping posted.",
              name: "Store reusable materials",
              _id: 322,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2D Decommissioning of assets",
          _id: 1317,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "77f555f1-9bd0-11e8-2ddf-001bc640cd9b",
          Description:
            "P2D Raw material/ component introduction or replacement describes technical changes to products which are produced internally, as well as its documentation in the system. Following the definition of the change, its scope and timeline an approval workflow starts, after which the implementation of the change is executed.",
          _type: "Scenario",
          GUID: "d9b00d34-ee77-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "A project is technically closed if work is completed but costs are still expected to accrue.   ",
              _type: "Process",
              GUID: "1f40c4ed-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "For Capital Investment Projects (CAPEX) the Asset master has to be maintained and the relevant asset related information updated on the settlement rule for the project. This is to enable costs to be settled to the asset when settlement is run after technical completion.",
              Type: "Business Process",
              Scope:
                "Once all project related activities have been performed and confirmed, the project is completed by setting the project status to technically complete. This prevents further changes to the project.",
              Outcome: "The project is technically complete.",
              name: "Complete project technically",
              _id: 1263,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "With the commercial completion of the project, no more costs can be allocated to the project. This marks the completion of the project from an accounting/ controlling perspective.",
              _type: "Process",
              GUID: "54e6bc6c-e7fc-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After all the project activities have been completed, actual costs settled and commitments removed, the project is completed commercially and the project portfolio item is closed. Completion of a project will usually be linked to a quality control gate.",
              Outcome:
                "All actual costs are settled to the project and commitments removed.",
              name: "Complete project commercially",
              _id: 1259,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When all requirements are met, the change request is approved, released and communicated to the stakeholders.",
              _type: "Process",
              GUID: "c5c21af5-9bd2-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once all the tasks in a change request are approved, it is released. At this point, there are records of all items that should be changed and the parties involved. ",
              Outcome: "Change request is approved.",
              name: "Release change request",
              _id: 1304,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Based on the engineering change order, the development process is initiated.",
              _type: "Process",
              GUID: "c5c21b0b-9bd2-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Initiate development process sets out a series of stages that new or change products typically go through, including creation of a prototype and the implementation of the change.",
              Outcome: "Prototyping can start.",
              name: "Initiate development",
              _id: 1316,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Implement changes according to prototype so that all changes are executed as specified in the change order.",
              _type: "Process",
              GUID: "c5c21b0f-9bd2-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Based on the change specifications, the responsible parties are engaged to manufacture a specific quantity of the new product with the new raw material/components. The production order is assigned to the project. ",
              Outcome: "Changes implemented.",
              name: "Implement change",
              _id: 1315,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The product master data offers a single point of reference for information regarding a product. Maintaining the data ensures that all relevant information is available and up-to-date.      ",
              _type: "Process",
              GUID: "1cdd80a5-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once designing and prototyping is complete, the new material master and material BOM are created in the backend system. Later, the production scheduling department creates routing as a basis for production and calculation of the product price. To check the price level specified by the marketing department, the product cost controller calculates material costs using the BOM and routing. In case, the estimated price exceeds the specified price limit, a component of the new product BOM is exchanged for a less expensive component using change management. The design department issues an engineering change master to collect and document all changes according the specification document. Following a second costing run (cost estimate), the price meets the budget and the development status of the new product can be fixed by assigning a revision level.",
              Outcome:
                "Cost calculation is complete and product master data updated.",
              name: "Maintain product master data",
              _id: 1285,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Designing and creating a prototype of the product are essential early steps in product development that provide the blueprint from which the final product is derived.     ",
              _type: "Process",
              GUID: "1f40c4c4-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The design process is carried out in a CAD system which can be fully integrated into the SAP system. SAP CAD Desktop is used as the central user interface by the design engineer. By linking the CAD system and the CAD Desktop in the SAP system all components designed in the CAD system can be managed. With full CAD integration, the CAD drawings are checked into the document management system (DMS). A document BOM is available in the system. CAD Desktop allows the easy creation of the necessary material masters and material BOM.",
              Outcome: "Product is design complete and documented.",
              name: "Design and prototype product",
              _id: 1286,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "9c41f070-09d2-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Roll out changed product version",
              _id: 1314,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A change order is work that is added to or deleted from the original scope of product development.",
              _type: "Process",
              GUID: "c5c21af8-9bd2-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Issuing of a change order initiate the development process, and can result in a a new project to handle significant changes to the current project.",
              Outcome: "Change order forwarded to relevant parties.",
              name: "Issue change order",
              _id: 1313,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When the internal marketing department sends a request for a new product, the information is recorded and stored. This forms the basis for defining product specifications.       ",
              _type: "Process",
              GUID: "1cdd8081-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the marketing department sends the request for a new product, the data is documented, stored and forwarded to the product development department. ",
              Outcome:
                "All relevant details regarding the requested product are documented.",
              name: "Receive and process product request",
              _id: 1281,
              Business_Rules:
                "It is necessary to define how the information will be recorded and forwarded for further evaluation by the product development department.",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2D Raw material/component introduction or replacement",
          _id: 1312,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "56840531-7ef8-11e5-0a66-001bc640cd9b",
          Description:
            "The Overhead Cost Projects (OPEX) scenario covers internal projects for which costs are not capitalized (non-investment related). Overhead cost projects allow the management and allocation of overhead costs to the responsible cost object such as a cost center.  Within this scenario the project is planned and scheduled with adequate allocation of resources, as well as tracking of project progress and final closure of the project upon completion.  Typical applications of overhead cost projects include:  -Management consulting, IT and service projects where costs are reallocated to the requesting department  -General events such as trade fairs where costs are reallocated to the marketing department or respective profit center",
          _type: "Scenario",
          GUID: "9622a15d-ef0e-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "In order to ensure execution of the project in a timely manner and the controlling of costs, planning and scheduling of the project must be performed.      ",
              _type: "Process",
              GUID: "1cdd8084-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Scheduling is carried out according to project timelines, milestones and deliverables.  The cost of materials and planned labour comes from the project template. This information is incorporated into the project plan. ",
              Outcome:
                "Project plan is created and project activities are scheduled.",
              name: "Plan and schedule project",
              _id: 1280,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Project execution phase involves fulfilment of planned activities, collecting and reporting on project progress, as well as tracking of time, cost, and deliverables.       ",
              _type: "Process",
              GUID: "44b6ae91-7eed-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the project has been released, it is executed in accordance with the project plan. Depending on the project status, it is possible to assign purchase requisitions and purchase orders, perform goods receipt / issue and book of invoices, time confirmations and other allocations to project elements. During project execution, all actual costs are considered during the individual month end closing activities (e.g. settlement).",
              Outcome: "Project related activities are executed and tracked.",
              name: "Execute project",
              _id: 1300,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "With the commercial completion of the project, no more costs can be allocated to the project. This marks the completion of the project from an accounting/ controlling perspective.",
              _type: "Process",
              GUID: "54e6bc6c-e7fc-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After all the project activities have been completed, actual costs settled and commitments removed, the project is completed commercially and the project portfolio item is closed. Completion of a project will usually be linked to a quality control gate.",
              Outcome:
                "All actual costs are settled to the project and commitments removed.",
              name: "Complete project commercially",
              _id: 1259,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When all requirements are met, the project is approved, released and communicated to the stakeholders.      ",
              _type: "Process",
              GUID: "1cdd808a-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Project deliverables, plan and resources assignments are reviewed. If all requirements are fulfilled the project is released for execution. It is possible to release the whole project or only a phase of the project.",
              Outcome:
                "The entire project or a project phase is released for execution.",
              name: "Approve and release project",
              _id: 1266,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The project maps the work structure and is the object for collecting costs incurred for the internal work.This allows the capturing of times and expenses incurred on project tasks.",
              _type: "Process",
              GUID: "400b3f50-9627-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The project is created from a standard template. The settlement rule is generated, forming the basis for capturing project related costs.",
              Outcome: "Project is created and related costs can be allocated.",
              name: "Create internal project",
              _id: 1282,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A project is technically closed if work is completed but costs are still expected to accrue.   ",
              _type: "Process",
              GUID: "1f40c4ed-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "For Capital Investment Projects (CAPEX) the Asset master has to be maintained and the relevant asset related information updated on the settlement rule for the project. This is to enable costs to be settled to the asset when settlement is run after technical completion.",
              Type: "Business Process",
              Scope:
                "Once all project related activities have been performed and confirmed, the project is completed by setting the project status to technically complete. This prevents further changes to the project.",
              Outcome: "The project is technically complete.",
              name: "Complete project technically",
              _id: 1263,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In a project environment, several personnel resources may be assigned to a work center. In case capacity planning is performed on work center level, and not assigned to a single person a detailed and meaningful reporting will not be possible. Therefore, assigning personnel resources enables capacity planning on personnel level to avoid overwork or to assign personnel with relevant qualification. ",
              _type: "Process",
              GUID: "ebe8c58f-e753-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the customer order is created, activities are assigned to personnel resources. To ensure the advanced procurement, the status of a Work Breakdown Structure (WBS) element has to have the status Released.",
              Outcome:
                "Required personnel resources are assigned to project activities.",
              name: "Assign personnel resources to project",
              _id: 1262,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2D Overhead cost projects (OPEX)",
          _id: 1311,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "003ad351-09d5-11e9-2ddf-001bc640cd9b",
          Description:
            "Scenario covering changes to products based on customer complaints. Product amendments are based on careful analysis of complaints to ensure that product improvements are in line with customer requirements.",
          _type: "Scenario",
          GUID: "9c41f075-09d2-11e9-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "7d9d5ff9-c016-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Evaluate change impact of product change",
              _id: 1310,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "7d9d600d-c016-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Inform production about amendment",
              _id: 1309,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "51963d95-09d7-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Maintain material master data",
              _id: 1308,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "7d9d5ff6-c016-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Classify product change",
              _id: 1307,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "7d9d5ffc-c016-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Approve product change",
              _id: 1306,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "7d9d5ff0-c016-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Process product change problem notification",
              _id: 1305,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When all requirements are met, the change request is approved, released and communicated to the stakeholders.",
              _type: "Process",
              GUID: "c5c21af5-9bd2-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once all the tasks in a change request are approved, it is released. At this point, there are records of all items that should be changed and the parties involved. ",
              Outcome: "Change request is approved.",
              name: "Release change request",
              _id: 1304,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "7d9d6004-c016-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Inform sales about product amendment",
              _id: 1303,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "7d9d600a-c016-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Inform customers about product amendment",
              _id: 1302,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2D Product amend and complaint processing",
          _id: 1301,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "7343b9d1-7eef-11e5-0a66-001bc640cd9b",
          Description:
            "The Customer service projects scenario depicts processes for external projects where resources are used to provide consulting advice or technical services to customers. This scenario is initiated by the creation of a sales order with reference to the quotation sent to the customer, and requires milestone billing to control the progressive payment procedure and track back the status of the project.",
          _type: "Scenario",
          GUID: "22a31384-ef12-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "When all requirements are met, the project is approved, released and communicated to the stakeholders.      ",
              _type: "Process",
              GUID: "1cdd808a-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Project deliverables, plan and resources assignments are reviewed. If all requirements are fulfilled the project is released for execution. It is possible to release the whole project or only a phase of the project.",
              Outcome:
                "The entire project or a project phase is released for execution.",
              name: "Approve and release project",
              _id: 1266,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "With the commercial completion of the project, no more costs can be allocated to the project. This marks the completion of the project from an accounting/ controlling perspective.",
              _type: "Process",
              GUID: "54e6bc6c-e7fc-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After all the project activities have been completed, actual costs settled and commitments removed, the project is completed commercially and the project portfolio item is closed. Completion of a project will usually be linked to a quality control gate.",
              Outcome:
                "All actual costs are settled to the project and commitments removed.",
              name: "Complete project commercially",
              _id: 1259,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A project is technically closed if work is completed but costs are still expected to accrue.   ",
              _type: "Process",
              GUID: "1f40c4ed-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "For Capital Investment Projects (CAPEX) the Asset master has to be maintained and the relevant asset related information updated on the settlement rule for the project. This is to enable costs to be settled to the asset when settlement is run after technical completion.",
              Type: "Business Process",
              Scope:
                "Once all project related activities have been performed and confirmed, the project is completed by setting the project status to technically complete. This prevents further changes to the project.",
              Outcome: "The project is technically complete.",
              name: "Complete project technically",
              _id: 1263,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Project execution phase involves fulfilment of planned activities, collecting and reporting on project progress, as well as tracking of time, cost, and deliverables.       ",
              _type: "Process",
              GUID: "44b6ae91-7eed-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the project has been released, it is executed in accordance with the project plan. Depending on the project status, it is possible to assign purchase requisitions and purchase orders, perform goods receipt / issue and book of invoices, time confirmations and other allocations to project elements. During project execution, all actual costs are considered during the individual month end closing activities (e.g. settlement).",
              Outcome: "Project related activities are executed and tracked.",
              name: "Execute project",
              _id: 1300,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process involves activities required to create a billing document that is sent to the customer for payment.  ",
              _type: "Process",
              GUID: "ca0ea8e9-7eef-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The milestones set in the project are transferred to the sales order and a billing document is created.",
              Outcome:
                "Billing document is created and can be sent to the customer. ",
              name: "Perform milestone billing",
              _id: 1257,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "For customer projects, a sales order must be created with reference to the quotation sent to the customer.     ",
              _type: "Process",
              GUID: "ca0ea8e0-7eef-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After sending the customer quotation, a customer order is created with reference to the quotation. The project baseline is adjusted based on sales order and technical documents are assigned to project related activities.",
              Outcome: "Customer order is created with reference to quotation.",
              name: "Create sales order with ref. to quotation",
              _id: 1258,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Manage incoming payment process ensures that the payment from a customer is captured and documented appropriately.",
              _type: "Process",
              GUID: "f5f29ea1-e8f4-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Especially in global template projects different variants of payments have to be considered but their use should often be limited to a group of countries rather than being made available to all.",
              Type: "Business Process",
              Scope:
                "Manage incoming payment involves receiving a payment from a customer and entering the information in accounting. The incoming payment is mapped to the customer invoice and customer account.",
              Outcome:
                "Incoming payment is recorded and the customer account is credited.",
              name: "Manage incoming payment",
              _id: 1264,
              Business_Rules:
                "The methods of payment must be established taking into account country specific factors related to the business and customer. For instance: The bill of exchange (BoE) payment method is used in some countries only.   Typical methods of payment are:   ***Check   ***Direct debits   ***Credit cards   ***Bank transfers",
              Prerequisite:
                "Prerequisite: currency exchange and hedging processes",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In a project environment, several personnel resources may be assigned to a work center. In case capacity planning is performed on work center level, and not assigned to a single person a detailed and meaningful reporting will not be possible. Therefore, assigning personnel resources enables capacity planning on personnel level to avoid overwork or to assign personnel with relevant qualification. ",
              _type: "Process",
              GUID: "ebe8c58f-e753-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the customer order is created, activities are assigned to personnel resources. To ensure the advanced procurement, the status of a Work Breakdown Structure (WBS) element has to have the status Released.",
              Outcome:
                "Required personnel resources are assigned to project activities.",
              name: "Assign personnel resources to project",
              _id: 1262,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2D Customer service projects",
          _id: 1299,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "55c459d1-9293-11e9-0cfc-001bc641ce4f",
          Description:
            "This scenario covers the processes for the systemic removal of a material that is no longer allowed for production. In a phase out planning, adjustments to parameters need to be made. This ensures proper consideration in supply chain planning, inventory planning, production (lot sizes) and purchasing.",
          _type: "Scenario",
          GUID: "1c4f0c16-928c-11e9-0cfc-001bc641ce4f",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "de706d8a-9408-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Approve phase out",
              _id: 277,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When an request for phase out is sent, the information is recorded and stored. From todays point of view there are manual processes only.",
              _type: "Process",
              GUID: "7d9d6019-c016-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the request for phase out for a material is sent, the data is documented, stored and forwarded.",
              Outcome: "Phase out information stored.",
              name: "Receive phase out request and conduct impact analysis",
              _id: 612,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "de706d8d-9408-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Inform production about phase out",
              _id: 614,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The validity of a material must be updated in the system by setting the appropriate phase out status.",
              _type: "Process",
              GUID: "686d861b-94c0-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The time at which the material will no longer be valid for use in production is maintained in the system.",
              Outcome:
                "Data regarding the product phase out are maintained in the system.",
              name: "Update phase out status of master data",
              _id: 613,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2D Material phase out",
          _id: 1298,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "e7cd9621-7eec-11e5-0a66-001bc640cd9b",
          Description:
            "The Capital Investment Projects (CAPEX) scenario covers how investments in own equipment and facilities are handled. The basis for this scenario is a project that offers the possibility to have an appropriate structure in place which supports the necessary capitalization in an adequate way.  Within the Capital Investment Projects (CAPEX) scenario the project is planned and scheduled with adequate allocation of resources. As well as tracking of project progress, closing of project phases and final closure of the project upon completion are performed.",
          _type: "Scenario",
          GUID: "9622a15b-ef0e-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The project maps the work structure and is the object for collecting costs incurred for the internal work.This allows the capturing of times and expenses incurred on project tasks.",
              _type: "Process",
              GUID: "400b3f50-9627-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The project is created from a standard template. The settlement rule is generated, forming the basis for capturing project related costs.",
              Outcome: "Project is created and related costs can be allocated.",
              name: "Create internal project",
              _id: 1282,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Project execution phase involves fulfilment of planned activities, collecting and reporting on project progress, as well as tracking of time, cost, and deliverables.       ",
              _type: "Process",
              GUID: "44b6ae91-7eed-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the project has been released, it is executed in accordance with the project plan. Depending on the project status, it is possible to assign purchase requisitions and purchase orders, perform goods receipt / issue and book of invoices, time confirmations and other allocations to project elements. During project execution, all actual costs are considered during the individual month end closing activities (e.g. settlement).",
              Outcome: "Project related activities are executed and tracked.",
              name: "Execute project",
              _id: 1300,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "During the month end closing process, costs incurred from the project phase of a capital investment project must be capitalized according to accounting rules.        ",
              _type: "Process",
              GUID: "44b6ae88-7eed-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "For project costs to be capitalized, all necessary information relevant for the posting and depreciation of an asset is provided, e.g. cost center, useful life, asset class, location / plant, etc. With this information, the settlement rule for the project is maintained.",
              Outcome:
                "Project costs are capitalized and can be incorporated in month end closing figures.",
              name: "Capitalize asset from project phase",
              _id: 565,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In order to ensure execution of the project in a timely manner and the controlling of costs, planning and scheduling of the project must be performed.      ",
              _type: "Process",
              GUID: "1cdd8084-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Scheduling is carried out according to project timelines, milestones and deliverables.  The cost of materials and planned labour comes from the project template. This information is incorporated into the project plan. ",
              Outcome:
                "Project plan is created and project activities are scheduled.",
              name: "Plan and schedule project",
              _id: 1280,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When all requirements are met, the project is approved, released and communicated to the stakeholders.      ",
              _type: "Process",
              GUID: "1cdd808a-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Project deliverables, plan and resources assignments are reviewed. If all requirements are fulfilled the project is released for execution. It is possible to release the whole project or only a phase of the project.",
              Outcome:
                "The entire project or a project phase is released for execution.",
              name: "Approve and release project",
              _id: 1266,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "With the commercial completion of the project, no more costs can be allocated to the project. This marks the completion of the project from an accounting/ controlling perspective.",
              _type: "Process",
              GUID: "54e6bc6c-e7fc-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After all the project activities have been completed, actual costs settled and commitments removed, the project is completed commercially and the project portfolio item is closed. Completion of a project will usually be linked to a quality control gate.",
              Outcome:
                "All actual costs are settled to the project and commitments removed.",
              name: "Complete project commercially",
              _id: 1259,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When an asset is aquired or a CAPEX project is released, it is necessary to create the relevant asset in the system. This is used for managing and supervising assets in Financial Accounting.",
              _type: "Process",
              GUID: "44a5e5bf-7eed-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "It is possible to create an entirely new asset or add the asset to an already existing one. When creating a new asset, the correct asset class must be determined and then entered into the initial screen of the master data transaction along with the company code. When adding an asset to an already existing one, the asset main number of the existing asset must first be identified. This is followed by the creation of a new asset sub-number for the asset being added.  Once the asset number is assigned, relevant master record information is maintained along with depreciation and valuation information for each depreciation area.",
              Outcome: "Asset is created/added and saved in the system.",
              name: "Create asset",
              _id: 566,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In a project environment, several personnel resources may be assigned to a work center. In case capacity planning is performed on work center level, and not assigned to a single person a detailed and meaningful reporting will not be possible. Therefore, assigning personnel resources enables capacity planning on personnel level to avoid overwork or to assign personnel with relevant qualification. ",
              _type: "Process",
              GUID: "ebe8c58f-e753-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the customer order is created, activities are assigned to personnel resources. To ensure the advanced procurement, the status of a Work Breakdown Structure (WBS) element has to have the status Released.",
              Outcome:
                "Required personnel resources are assigned to project activities.",
              name: "Assign personnel resources to project",
              _id: 1262,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A project is technically closed if work is completed but costs are still expected to accrue.   ",
              _type: "Process",
              GUID: "1f40c4ed-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "For Capital Investment Projects (CAPEX) the Asset master has to be maintained and the relevant asset related information updated on the settlement rule for the project. This is to enable costs to be settled to the asset when settlement is run after technical completion.",
              Type: "Business Process",
              Scope:
                "Once all project related activities have been performed and confirmed, the project is completed by setting the project status to technically complete. This prevents further changes to the project.",
              Outcome: "The project is technically complete.",
              name: "Complete project technically",
              _id: 1263,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2D Capital investment projects (CAPEX)",
          _id: 1297,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "b0045e51-94c3-11e8-2ddf-001bc640cd9b",
          Description:
            "Product phase out scenario describes processes for the systemic removal of a product or a product version that is no longer marketed. Product phase out is founded on comprehensive portfolio review and product life cycle consideration.  In a phase out planning, adjustments to parameters of the product itself and its components need to be made long before the actual removal of the product from the market takes place. This ensures proper consideration in supply chain planning, inventory planning, production (lot sizes) and purchasing.",
          _type: "Scenario",
          GUID: "d9b00d36-ee77-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "When an request for phase out is sent, the information is recorded and stored. From todays point of view there are manual processes only.",
              _type: "Process",
              GUID: "686d860e-94c0-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the request for phase out for a product is sent, the data is documented, stored and forwarded.",
              Outcome: "Phase out information stored.",
              name: "Receive request for phase out",
              _id: 611,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Within a reasonable time before a planned product phase out the customers have to be informed. This is necessary to give customers the chance to place replacement orders or to fill their stocks. In case a follow-up-product will be set up, this information has to be given to the customers too.",
              _type: "Process",
              GUID: "686d8612-94c0-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Customers need to be informed in case products are being discontinued as follows:   ***date of phase-out (last production date at vendor     ***last acceptance date for PO from customers   ***successor material     ***timeline of availability of spare parts if applicable     ***timeline of service being provided All information given is prior to availability!",
              Outcome:
                "Customer informed and prepped for upcoming product phase out",
              name: "Inform customer about last option to buy",
              _id: 363,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Observe the reason for phase out and decide which following steps are needed. From todays point of view these are manual processes only.",
              _type: "Process",
              GUID: "686d8610-94c0-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Sold units and warehouse stock has to be considered to calculate follow-up costs. ",
              Outcome: "Classified request for product phase out.",
              name: "Classify request for phase out",
              _id: 608,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "If the good cannot be sold, re-worked or recycled, it needs to be scrapped.",
              _type: "Process",
              GUID: "f4e1fe2a-7e46-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the decision was made to scrap the good, it has to be depreciated and scrapped as defined for this specific good. The batch needs to be flagged as not active for sales.",
              Outcome: "The good is ready for scrapping. ",
              name: "Initiate scrapping",
              _id: 472,
              Business_Rules:
                "Decisions are needed for:   ***internal vs. external scrapping    ***good specific scrapping regulations to be determined   ***official specifications/laws to be determined   ***special health and/or environmental protection needs  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The validity of a material must be updated in the system by setting the appropriate phase out status.",
              _type: "Process",
              GUID: "686d861b-94c0-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The time at which the material will no longer be valid for use in production is maintained in the system.",
              Outcome:
                "Data regarding the product phase out are maintained in the system.",
              name: "Update phase out status of master data",
              _id: 613,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When rework is to be done a production order for rework needs to be created. The nature of reworking processes require the selection of required operations and components either selected from standard routings and standard BOMs or captured manually.  A process order can also be used in the process industry.",
              _type: "Process",
              GUID: "5a5e62f7-7f29-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "A rework order is created with its own product as component. Within the order the required operations and additionally required components are defined and batches will be assigned if applicable.",
              Outcome:
                "The rework order with the required operations and components is created.",
              name: "Create production order for rework",
              _id: 1351,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "During phase out, the continued time for service needs to be defined and communicated to the customer. This includes not only repair, service onsite but also stockholding of spare parts. Purchasing or production of spare parts must be ensured until end of repair/service time.",
              _type: "Process",
              GUID: "686d8614-94c0-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Consider sold units, warranty times, service quota and used spare parts.",
              Outcome:
                "End of service defined with all relevant details. Communicated to all relevant parties.",
              name: "Define end of service time",
              _id: 488,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2D Product phase out",
          _id: 1296,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "9bb480a1-09d6-11e9-2ddf-001bc640cd9b",
          Description:
            "Covers introduction of an alternative production version for manufacturing. Typically, new manufacturing process introduction is triggered by quality control activities and customer feedback.",
          _type: "Scenario",
          GUID: "9c41f077-09d2-11e9-2ddf-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The request must be evaluated to determine whether a process change is actually required. ",
              _type: "Process",
              GUID: "51963d8b-09d7-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Evaluate change impact of manufacturing process",
              _id: 597,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The development result and the specifications are to be compared. If the result and the the specifications do not match, the product development process restarts.",
              _type: "Process",
              GUID: "35a36f71-09d8-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Implement manufacturing process change",
              _id: 353,
              Business_Rules:
                "Test are done by R&D, AE (application engineering) and customer. Approved by project manager and gate review by EPSC. Documentation mainly done in QSYS.  Follow up concerning time line driven by EPSC and project manager.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description: "",
              _type: "Process",
              GUID: "51963d95-09d7-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Maintain material master data",
              _id: 1308,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of the request initiates the planning of required tasks to fulfil process change procedures. ",
              _type: "Process",
              GUID: "8c36f737-9414-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Approve manufacturing process request",
              _id: 601,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When an request for process change is sent, the information is recorded and stored.",
              _type: "Process",
              GUID: "0cb0b781-09d6-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the request for a process change for a product is sent, the data is documented, stored and forwarded.",
              Outcome: "",
              name: "Receive manufacturing process change request",
              _id: 598,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of planned activities is given with the release of the process change request. This initiates execution of all activities related to the process change request. ",
              _type: "Process",
              GUID: "0cb0b796-09d6-11e9-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope: "",
              Outcome: "",
              name: "Release process change request",
              _id: 599,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2D New manufacturing process introduction",
          _id: 1295,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "71a2d081-7eee-11e5-0a66-001bc640cd9b",
          Description:
            "Corrective maintenance scenario describes how maintenance is carried out after fault recognition and is intended to put an equipment into a state in which it can again perform as required. This scenario is triggered by a corrective maintenance request, which must be evaluated and approved before creation of the corrective maintenance order.  The following types of corrective maintenance can be managed:   ***Deferred corrective maintenance which is not immediately carried out after a fault detection but is delayed in accordance with given rules   ***Immediate corrective maintenance that is carried out without delay after a fault has been detected to avoid unacceptable consequences.  ",
          _type: "Scenario",
          GUID: "22a3138a-ef12-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Parts designated for refurbishment must be taken from the plant to the area where the refurbishment is performed. This must be accompanied by the relevant goods issue posting.   ",
              _type: "Process",
              GUID: "2348f377-7efc-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "For refurbishment orders, goods issue posting is performed using transaction MB1A (not MIGO).",
              Type: "Business Process",
              Scope:
                "Goods issue is posted with reference to the maintenance order to inform the responsible that parts can be moved to the refurbishment site.",
              Outcome:
                "Goods issue with reference to maintenance order posted. ",
              name: "Perform goods issue for maintenance order",
              _id: 1276,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The request must be evaluated to determine whether corrective maintenance is actually required. Approval of the request initiates the planning of required tasks to fulfil corrective maintenance procedures. ",
              _type: "Process",
              GUID: "7bbc6acc-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Requests for maintenance are evaluated by the maintenance approver, who may either approve or reject the request. After the approval of a corrective maintenance request, a corrective maintenance order is created.",
              Outcome: "A corrective maintenance order is created.",
              name: "Evaluate and approve maintenance request",
              _id: 587,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Completion of plant maintenance activities must be followed by confirmation and verification of results. ",
              _type: "Process",
              GUID: "7d178dc1-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once all planned activities have been performed, the Maintenance coordinator checks whether maintenance has been executed and documented as required. The Maintenance coordinator either:  1. Accepts the maintenance as successfully completed 2. Requests follow up maintenance and accepts the maintenance as having been completed 3. Rejects the completion of the maintenance, and asks for the maintenance to be completed.",
              Outcome:
                "Completion of plant maintenance activities is verified.",
              name: "Confirm plant maintenance order and verify results",
              _id: 1273,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The maintenance plan demonstrates that tasks will be done on time, that the technical objects are available and that all required resources, such as internal and external resources and materials, are on hand. The maintenance tasks that are to be performed require detailed planning, in order to minimize the time that the object is not productive. ",
              _type: "Process",
              GUID: "7bbc6a9c-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "For preventative maintenance, the maintenance order is created based on planned tasks that are required when specific predefined circumstances are given. Those can be described by specific parameters , which are verified regularly, by measuring usage (discrete counter or running time), or by a period after which refurbishment is due. Subsequently the maintenance plan is compiled.   For corrective maintenance (including refurbishment), planning is done after  a maintenance request is approved (or planned order converted) and the maintenance order is created.    In both cases, the maintenance plan provides a clear definition of tasks to be performed, roles and responsibilities, and dates.",
              Outcome: "Maintenance plan is created.",
              name: "Plan maintenance order",
              _id: 1271,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Before the  maintenance order can be released, it is necessary to check whether materials needed to conduct the maintenance are available. ",
              _type: "Process",
              GUID: "7d178dc7-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Pre-requisites: each material, whose availability is checked, must be assigned a checking group on the MRP detail screen in its material master. The checking group combines materials whose availability is checked at the same time. You can, for instance, group materials according to the material type or the MRP type.",
              Type: "Business Process",
              Scope:
                "The system checks whether material components in networks are available on the required date. If the requirements are not covered, the system determines the date on which they can be covered.",
              Outcome: "Availability of required material is determined.",
              name: "Check material availability",
              _id: 1270,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Commercial completion of the plant maintenance order indicates that all costs related to the order have been settled. This process pertains to the business completion of an order when no further costs are expected to be posted to the order. ",
              _type: "Process",
              GUID: "7bbc6aae-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Typically, maintenance orders are set to commercially complete by a batch process after a defined period of time.",
              Outcome:
                "The order obtains the status Completed, which indicates full completion. ",
              name: "Complete maintenance order commercially",
              _id: 1269,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approvals are used to define certain rules or requirements that must be observed in Work Clearance Management. ",
              _type: "Process",
              GUID: "7bbc6abd-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The Maintenance Approver evaluates whether work clearance approval is required or not. In case work clearance approval is required, the maintenance planner requests work clearance approval and the maintenance approver either accepts or rejects the request.",
              Outcome:
                "Decision is made whether work clearance is required or not.",
              name: "Evaluate work clearance approval",
              _id: 1278,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Technical completion of plant maintenance indicates that all planned activities of the order have been performed. This activity demonstrates that all existing reservations, open commitments and planned capacities are no longer needed. ",
              _type: "Process",
              GUID: "7bbc6aa8-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the maintenance work planned in the order has been performed, results verified and accepted, the order is marked as complete for plant maintenance.",
              Outcome:
                "The plant maintenance order obtains the status Technically completed.",
              name: "Complete maintenance order technically",
              _id: 1272,
              Business_Rules:
                "A business rule should enforce timely setting of the status to release unused resources and avoid faulty recording of working hours or material consumptions.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of planned activities is given with the release of the  maintenance order. This initiates execution of all activities related to the maintenance order. ",
              _type: "Process",
              GUID: "7bbc6ad8-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Release of a maintenance order represents the approval of the planned activities, such as purchasing of services and materials, as well as the usage of planned materials from stock. After the maintenance order is released shop papers are printed. These are the maintenance instructions for the maintenance technician.",
              Outcome:
                "Maintenance order is released and maintenance activities can be executed.",
              name: "Release maintenance order",
              _id: 1274,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Plant maintenance must be executed as specified in the maintenance plan, with tracking of time and task completion.   For dismantling, asset accounting is informed and EH&S is informed about harmful substances have to be transported when the asset is dismantled.",
              _type: "Process",
              GUID: "73e0f9e8-e802-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Having collected the required materials, the maintenance technician conducts the planned maintenance as described in the shop papers. All activities performed are tracked and documented accordingly. ",
              Outcome:
                "All activities related to the plant maintenance are performed",
              name: "Perform plant maintenance",
              _id: 1268,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When the need for corrective maintenance arises, the details must be recorded and made available for evaluation and approval. A corrective maintenance request is a targeted instruction to perform an activity in the manner described.",
              _type: "Process",
              GUID: "dd4a5383-e7ff-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "A corrective maintenance request is entered in the system by a maintenance requestor. The requestor maybe a maintenance technician who can create a corrective maintenance request from a mobile device whilst conducting preventive maintenance.",
              Outcome:
                "Details regarding required corrective maintenance are recorded.",
              name: "Maintain corrective maintenance request",
              _id: 588,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Additional resources may be required to perform plant maintenance. In such cases it is necessary determine the individual resources needed for specific maintenance activities, and when they are needed.  Planning enables the availability of the resources at the time they are required.",
              _type: "Process",
              GUID: "7bbc6aba-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "External resources are planned against the maintenance order. If an additional external service is required immediately, the maintenance planner will change the settings on the maintenance order so that a purchase requisition for the external service is generated immediately.",
              Outcome:
                "Additional external resources are incorporated into the maintenance plan.",
              name: "Plan additional external resources",
              _id: 1275,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures the allocation of resources required to perform plant maintenance.",
              _type: "Process",
              GUID: "e46f703c-e800-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "It is necessary to determine the individual internal resources needed for specific maintenance activities, and when they are needed. Planning enables the availability of the resources at the time they are required.",
              Outcome: "Resources are assigned to the maintenance order",
              name: "Assign resources to maintenance order",
              _id: 1277,
              Business_Rules: "",
              Prerequisite: "Internal resources allocated to maintenance order",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2D Corrective maintenance",
          _id: 1294,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "ab163ac1-7efb-11e5-0a66-001bc640cd9b",
          Description:
            "Repair and refurbishment scenario describes processes for the refurbishment of faulty repairable equipment that are in a damaged state and cannot be used. In this scenario, planning is necessary to determine what must be done before the damaged equipment can be used again. During the execution of the repair/refurbishment, the purpose for which the object is used can change.   The Repair and refurbishment scenario is initiated by either a refurbishment request or a planned order. In the latter case, specific refurbishment are planned by creating planned orders in material requirements planning (MRP). When required, the planned order is converted into a refurbishment order to start the refurbishment process. The planned order provides the quantity and dates for the refurbishment order.",
          _type: "Scenario",
          GUID: "22a3138c-ef12-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Employees working on projects or services have to record the hours spend for it. This can be done using Cross-Application Time Sheet (CATS). CATS is a tool for recording working times and tasks. ",
              _type: "Process",
              GUID: "1f40c4e3-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Maintenance of working hours, approval of working hours by the manager, transfer of working hours to controlling.",
              Outcome: "Working hours are recorded.",
              name: "Record and approve working hours",
              _id: 1261,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Before the  maintenance order can be released, it is necessary to check whether materials needed to conduct the maintenance are available. ",
              _type: "Process",
              GUID: "7d178dc7-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Pre-requisites: each material, whose availability is checked, must be assigned a checking group on the MRP detail screen in its material master. The checking group combines materials whose availability is checked at the same time. You can, for instance, group materials according to the material type or the MRP type.",
              Type: "Business Process",
              Scope:
                "The system checks whether material components in networks are available on the required date. If the requirements are not covered, the system determines the date on which they can be covered.",
              Outcome: "Availability of required material is determined.",
              name: "Check material availability",
              _id: 1270,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Specific refurbishment are planned by creating planned orders in material requirements planning (MRP). When required, the planned order is converted into a refurbishment order to start the refurbishment process.",
              _type: "Process",
              GUID: "2359bc58-7efc-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "MRP can be used to generate planned orders for refurbishment for rotable or repairable material types. Special settings in the material master are required to activate this process.",
              Type: "Business Process",
              Scope:
                "Refurbishment process is started by converting the planned order into a refurbishment order. The planned order provides the quantity and dates for the refurbishment order.",
              Outcome: "Planned order converted into refurbishment order.",
              name: "Convert planned order into refurbishment  order",
              _id: 1293,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Completion of Refurbishment activities must be followed by confirmation and verification of results, as well as entry of costs and settlement.",
              _type: "Process",
              GUID: "233ac2a3-7efc-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once all refurbishment activities have been performed, the maintenance technician confirms work performed. The maintenance coordinator then checks whether refurbishment has been successful, whether follow-up work is required or  whether a part needs to be scrapped.    After this, related costs are either capitalized or expense according to accounting rules. Generally, If the refurbishment/repair is of a material nature i.e. a major overhaul or the repair of a major component of a machine, the amount is capitalized because the benefit is for more than the current period.",
              Outcome: "Completion of Refurbishment is verified.",
              name: "Confirm refurbishment and verify results",
              _id: 1292,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of planned activities is given with the release of the  maintenance order. This initiates execution of all activities related to the maintenance order. ",
              _type: "Process",
              GUID: "7bbc6ad8-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Release of a maintenance order represents the approval of the planned activities, such as purchasing of services and materials, as well as the usage of planned materials from stock. After the maintenance order is released shop papers are printed. These are the maintenance instructions for the maintenance technician.",
              Outcome:
                "Maintenance order is released and maintenance activities can be executed.",
              name: "Release maintenance order",
              _id: 1274,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Repair/refurbishment can be triggered by an approved refurbishment maintenance request. In such cases, a refurbishment order is created from the request notification. A Refurbishment order is a special order, which is used  for the refurbishment of repairable spares, and for which the order type must be specially selected in the system.",
              _type: "Process",
              GUID: "233ac2c4-7efc-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "A refurbishment order is maintained in the system, which defines how many repairable spares managed in stock (if necessary, these can be identified uniquely by serial number) are to be refurbished for a particular material. The planner determines the time frame for the refurbishment and plans all the necessary operations, materials, utilities and so on.",
              Outcome: "Refurbishment order is created",
              name: "Create refurbishment maintenance order",
              _id: 1291,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Parts designated for refurbishment must be taken from the plant to the area where the refurbishment is performed. This must be accompanied by the relevant goods issue posting.   ",
              _type: "Process",
              GUID: "2348f377-7efc-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "For refurbishment orders, goods issue posting is performed using transaction MB1A (not MIGO).",
              Type: "Business Process",
              Scope:
                "Goods issue is posted with reference to the maintenance order to inform the responsible that parts can be moved to the refurbishment site.",
              Outcome:
                "Goods issue with reference to maintenance order posted. ",
              name: "Perform goods issue for maintenance order",
              _id: 1276,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The costs that arise from processing an order (for example, costs for material, personnel, or external services) must be allocated to the correct cost object. ",
              _type: "Process",
              GUID: "18d52036-51b1-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The costs are initially collected on the order, and when the order is technically completed, the costs are transferred to the settlement receiver specified in the settlement rule. ",
              Outcome:
                "All costs related to the maintenance order are settled.",
              name: "Settle maintenance order",
              _id: 1290,
              Business_Rules: "",
              Prerequisite:
                "An order can be settled if:    It is released    It has the status settlement rule created    Costs collected for it have not yet been settled    A business completion has not yet been performed for it",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Technical completion of plant maintenance indicates that all planned activities of the order have been performed. This activity demonstrates that all existing reservations, open commitments and planned capacities are no longer needed. ",
              _type: "Process",
              GUID: "7bbc6aa8-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the maintenance work planned in the order has been performed, results verified and accepted, the order is marked as complete for plant maintenance.",
              Outcome:
                "The plant maintenance order obtains the status Technically completed.",
              name: "Complete maintenance order technically",
              _id: 1272,
              Business_Rules:
                "A business rule should enforce timely setting of the status to release unused resources and avoid faulty recording of working hours or material consumptions.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The maintenance plan demonstrates that tasks will be done on time, that the technical objects are available and that all required resources, such as internal and external resources and materials, are on hand. The maintenance tasks that are to be performed require detailed planning, in order to minimize the time that the object is not productive. ",
              _type: "Process",
              GUID: "7bbc6a9c-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "For preventative maintenance, the maintenance order is created based on planned tasks that are required when specific predefined circumstances are given. Those can be described by specific parameters , which are verified regularly, by measuring usage (discrete counter or running time), or by a period after which refurbishment is due. Subsequently the maintenance plan is compiled.   For corrective maintenance (including refurbishment), planning is done after  a maintenance request is approved (or planned order converted) and the maintenance order is created.    In both cases, the maintenance plan provides a clear definition of tasks to be performed, roles and responsibilities, and dates.",
              Outcome: "Maintenance plan is created.",
              name: "Plan maintenance order",
              _id: 1271,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures the allocation of resources required to perform plant maintenance.",
              _type: "Process",
              GUID: "e46f703c-e800-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "It is necessary to determine the individual internal resources needed for specific maintenance activities, and when they are needed. Planning enables the availability of the resources at the time they are required.",
              Outcome: "Resources are assigned to the maintenance order",
              name: "Assign resources to maintenance order",
              _id: 1277,
              Business_Rules: "",
              Prerequisite: "Internal resources allocated to maintenance order",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Commercial completion of the plant maintenance order indicates that all costs related to the order have been settled. This process pertains to the business completion of an order when no further costs are expected to be posted to the order. ",
              _type: "Process",
              GUID: "7bbc6aae-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Typically, maintenance orders are set to commercially complete by a batch process after a defined period of time.",
              Outcome:
                "The order obtains the status Completed, which indicates full completion. ",
              name: "Complete maintenance order commercially",
              _id: 1269,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Refurbishment involves the restoration of faulty repairable equipment. Related activities must be executed as specified in the maintenance plan, with tracking of time and task completion.",
              _type: "Process",
              GUID: "1d89eb24-51b0-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The repairable equipment is brought from an initial damaged condition to an end condition at which  it can be used again. The maintenance technician performs the refurbishment of the equipment as described in the shop papers and provides confirmation upon completion.",
              Outcome: "All activities related to refurbishment are performed.",
              name: "Perform refurbishment",
              _id: 1289,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When a request for refurbishment is sent, all relevant details must be documented and then evaluated in order to determine whether to proceeded with creation of a refurbishment order.",
              _type: "Process",
              GUID: "233ac2a9-7efc-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "A refurbishment maintenance request is maintained in the system. It is then evaluated by the maintenance approver who may either approve or reject the request. If approved, the request notification forms the basis for creating the refurbishment order.",
              Outcome: "Decision made whether to accept or reject the request.",
              name: "Receive and process refurbishment request",
              _id: 1288,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2D Repair and refurbishment",
          _id: 1287,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "08626dd1-7ca3-11e5-0a66-001bc640cd9b",
          Description:
            "The Internal product development scenario describes the process of designing a new product requested by the internal marketing department in the form of a product specification. The project provides a central structure for cost collection and documentation management.    This scenario concludes with the development of a new product and recording of all activities executed during the project by the design department, as well as a creation of a standard cost estimate for the new product.",
          _type: "Scenario",
          GUID: "d9b00d30-ee77-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Designing and creating a prototype of the product are essential early steps in product development that provide the blueprint from which the final product is derived.     ",
              _type: "Process",
              GUID: "1f40c4c4-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The design process is carried out in a CAD system which can be fully integrated into the SAP system. SAP CAD Desktop is used as the central user interface by the design engineer. By linking the CAD system and the CAD Desktop in the SAP system all components designed in the CAD system can be managed. With full CAD integration, the CAD drawings are checked into the document management system (DMS). A document BOM is available in the system. CAD Desktop allows the easy creation of the necessary material masters and material BOM.",
              Outcome: "Product is design complete and documented.",
              name: "Design and prototype product",
              _id: 1286,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The product master data offers a single point of reference for information regarding a product. Maintaining the data ensures that all relevant information is available and up-to-date.      ",
              _type: "Process",
              GUID: "1cdd80a5-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once designing and prototyping is complete, the new material master and material BOM are created in the backend system. Later, the production scheduling department creates routing as a basis for production and calculation of the product price. To check the price level specified by the marketing department, the product cost controller calculates material costs using the BOM and routing. In case, the estimated price exceeds the specified price limit, a component of the new product BOM is exchanged for a less expensive component using change management. The design department issues an engineering change master to collect and document all changes according the specification document. Following a second costing run (cost estimate), the price meets the budget and the development status of the new product can be fixed by assigning a revision level.",
              Outcome:
                "Cost calculation is complete and product master data updated.",
              name: "Maintain product master data",
              _id: 1285,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "For internal product development, it is necessary to carry out test production based on the product prototype. Information must be passed on to the manufacturing department regarding what needs to be produced and in what quantity.       ",
              _type: "Process",
              GUID: "1cdd807b-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Based on the product specifications, the production department is engaged to manufacture a specific quantity of the new product.  The production order is assigned to the project. ",
              Outcome: "Test production of new product can begin.",
              name: "Initiate small scale test production",
              _id: 1284,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After a new product has been successfully developed, it needs to be handed over to the regular operations units.",
              _type: "Process",
              GUID: "70914ab0-09c8-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "Further implications of a new product introduction should be considered especially from a planning perspective. Cannibalism might reduce demand for similar existing products and demand on component level might change.",
              Type: "Business Process",
              Scope:
                "The scope of the handover typically includes the knowledge transfer and provision of master data and documentation materials for production and sales. Depending on the type of product it might also include EHS, logistics and warehousing, service and other technical departments.",
              Outcome: "Hand-over of responsibility to operational departments",
              name: "Roll out new product",
              _id: 1283,
              Business_Rules:
                "Clear guidelines and sometimes system supported status schema should be defined when various actions such as planning and forecasting, purchasing, price lists, quotations and sales orders, production for new products should be allowed.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The project maps the work structure and is the object for collecting costs incurred for the internal work.This allows the capturing of times and expenses incurred on project tasks.",
              _type: "Process",
              GUID: "400b3f50-9627-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The project is created from a standard template. The settlement rule is generated, forming the basis for capturing project related costs.",
              Outcome: "Project is created and related costs can be allocated.",
              name: "Create internal project",
              _id: 1282,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "With the commercial completion of the project, no more costs can be allocated to the project. This marks the completion of the project from an accounting/ controlling perspective.",
              _type: "Process",
              GUID: "54e6bc6c-e7fc-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After all the project activities have been completed, actual costs settled and commitments removed, the project is completed commercially and the project portfolio item is closed. Completion of a project will usually be linked to a quality control gate.",
              Outcome:
                "All actual costs are settled to the project and commitments removed.",
              name: "Complete project commercially",
              _id: 1259,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A project is technically closed if work is completed but costs are still expected to accrue.   ",
              _type: "Process",
              GUID: "1f40c4ed-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "For Capital Investment Projects (CAPEX) the Asset master has to be maintained and the relevant asset related information updated on the settlement rule for the project. This is to enable costs to be settled to the asset when settlement is run after technical completion.",
              Type: "Business Process",
              Scope:
                "Once all project related activities have been performed and confirmed, the project is completed by setting the project status to technically complete. This prevents further changes to the project.",
              Outcome: "The project is technically complete.",
              name: "Complete project technically",
              _id: 1263,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When the internal marketing department sends a request for a new product, the information is recorded and stored. This forms the basis for defining product specifications.       ",
              _type: "Process",
              GUID: "1cdd8081-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the marketing department sends the request for a new product, the data is documented, stored and forwarded to the product development department. ",
              Outcome:
                "All relevant details regarding the requested product are documented.",
              name: "Receive and process product request",
              _id: 1281,
              Business_Rules:
                "It is necessary to define how the information will be recorded and forwarded for further evaluation by the product development department.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In order to ensure execution of the project in a timely manner and the controlling of costs, planning and scheduling of the project must be performed.      ",
              _type: "Process",
              GUID: "1cdd8084-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Scheduling is carried out according to project timelines, milestones and deliverables.  The cost of materials and planned labour comes from the project template. This information is incorporated into the project plan. ",
              Outcome:
                "Project plan is created and project activities are scheduled.",
              name: "Plan and schedule project",
              _id: 1280,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In a project environment, several personnel resources may be assigned to a work center. In case capacity planning is performed on work center level, and not assigned to a single person a detailed and meaningful reporting will not be possible. Therefore, assigning personnel resources enables capacity planning on personnel level to avoid overwork or to assign personnel with relevant qualification. ",
              _type: "Process",
              GUID: "ebe8c58f-e753-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the customer order is created, activities are assigned to personnel resources. To ensure the advanced procurement, the status of a Work Breakdown Structure (WBS) element has to have the status Released.",
              Outcome:
                "Required personnel resources are assigned to project activities.",
              name: "Assign personnel resources to project",
              _id: 1262,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When all requirements are met, the project is approved, released and communicated to the stakeholders.      ",
              _type: "Process",
              GUID: "1cdd808a-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Project deliverables, plan and resources assignments are reviewed. If all requirements are fulfilled the project is released for execution. It is possible to release the whole project or only a phase of the project.",
              Outcome:
                "The entire project or a project phase is released for execution.",
              name: "Approve and release project",
              _id: 1266,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2D Internal product development",
          _id: 1279,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "df33c7d0-7ef8-11e5-0a66-001bc640cd9b",
          Description:
            "The Preventive maintenance scenarios describes processes for maintaining equipment and facilities in satisfactory operating condition by providing for systematic inspection, detection, and correction of incipient failures before they occur. In this scenario, a notification and order are created by the maintenance scheduling.  Unlike corrective maintenance, preventative maintenance puts more emphasis on a coordinated planning of the maintenance schedule. The planning ensures that any required resources are available as well as that the negative impact of the maintenance work on the production schedules is limited.",
          _type: "Scenario",
          GUID: "22a31388-ef12-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Approvals are used to define certain rules or requirements that must be observed in Work Clearance Management. ",
              _type: "Process",
              GUID: "7bbc6abd-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The Maintenance Approver evaluates whether work clearance approval is required or not. In case work clearance approval is required, the maintenance planner requests work clearance approval and the maintenance approver either accepts or rejects the request.",
              Outcome:
                "Decision is made whether work clearance is required or not.",
              name: "Evaluate work clearance approval",
              _id: 1278,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures the allocation of resources required to perform plant maintenance.",
              _type: "Process",
              GUID: "e46f703c-e800-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "It is necessary to determine the individual internal resources needed for specific maintenance activities, and when they are needed. Planning enables the availability of the resources at the time they are required.",
              Outcome: "Resources are assigned to the maintenance order",
              name: "Assign resources to maintenance order",
              _id: 1277,
              Business_Rules: "",
              Prerequisite: "Internal resources allocated to maintenance order",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Parts designated for refurbishment must be taken from the plant to the area where the refurbishment is performed. This must be accompanied by the relevant goods issue posting.   ",
              _type: "Process",
              GUID: "2348f377-7efc-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "For refurbishment orders, goods issue posting is performed using transaction MB1A (not MIGO).",
              Type: "Business Process",
              Scope:
                "Goods issue is posted with reference to the maintenance order to inform the responsible that parts can be moved to the refurbishment site.",
              Outcome:
                "Goods issue with reference to maintenance order posted. ",
              name: "Perform goods issue for maintenance order",
              _id: 1276,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Additional resources may be required to perform plant maintenance. In such cases it is necessary determine the individual resources needed for specific maintenance activities, and when they are needed.  Planning enables the availability of the resources at the time they are required.",
              _type: "Process",
              GUID: "7bbc6aba-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "External resources are planned against the maintenance order. If an additional external service is required immediately, the maintenance planner will change the settings on the maintenance order so that a purchase requisition for the external service is generated immediately.",
              Outcome:
                "Additional external resources are incorporated into the maintenance plan.",
              name: "Plan additional external resources",
              _id: 1275,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Approval of planned activities is given with the release of the  maintenance order. This initiates execution of all activities related to the maintenance order. ",
              _type: "Process",
              GUID: "7bbc6ad8-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Release of a maintenance order represents the approval of the planned activities, such as purchasing of services and materials, as well as the usage of planned materials from stock. After the maintenance order is released shop papers are printed. These are the maintenance instructions for the maintenance technician.",
              Outcome:
                "Maintenance order is released and maintenance activities can be executed.",
              name: "Release maintenance order",
              _id: 1274,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Completion of plant maintenance activities must be followed by confirmation and verification of results. ",
              _type: "Process",
              GUID: "7d178dc1-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once all planned activities have been performed, the Maintenance coordinator checks whether maintenance has been executed and documented as required. The Maintenance coordinator either:  1. Accepts the maintenance as successfully completed 2. Requests follow up maintenance and accepts the maintenance as having been completed 3. Rejects the completion of the maintenance, and asks for the maintenance to be completed.",
              Outcome:
                "Completion of plant maintenance activities is verified.",
              name: "Confirm plant maintenance order and verify results",
              _id: 1273,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Technical completion of plant maintenance indicates that all planned activities of the order have been performed. This activity demonstrates that all existing reservations, open commitments and planned capacities are no longer needed. ",
              _type: "Process",
              GUID: "7bbc6aa8-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the maintenance work planned in the order has been performed, results verified and accepted, the order is marked as complete for plant maintenance.",
              Outcome:
                "The plant maintenance order obtains the status Technically completed.",
              name: "Complete maintenance order technically",
              _id: 1272,
              Business_Rules:
                "A business rule should enforce timely setting of the status to release unused resources and avoid faulty recording of working hours or material consumptions.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The maintenance plan demonstrates that tasks will be done on time, that the technical objects are available and that all required resources, such as internal and external resources and materials, are on hand. The maintenance tasks that are to be performed require detailed planning, in order to minimize the time that the object is not productive. ",
              _type: "Process",
              GUID: "7bbc6a9c-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "For preventative maintenance, the maintenance order is created based on planned tasks that are required when specific predefined circumstances are given. Those can be described by specific parameters , which are verified regularly, by measuring usage (discrete counter or running time), or by a period after which refurbishment is due. Subsequently the maintenance plan is compiled.   For corrective maintenance (including refurbishment), planning is done after  a maintenance request is approved (or planned order converted) and the maintenance order is created.    In both cases, the maintenance plan provides a clear definition of tasks to be performed, roles and responsibilities, and dates.",
              Outcome: "Maintenance plan is created.",
              name: "Plan maintenance order",
              _id: 1271,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Before the  maintenance order can be released, it is necessary to check whether materials needed to conduct the maintenance are available. ",
              _type: "Process",
              GUID: "7d178dc7-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Pre-requisites: each material, whose availability is checked, must be assigned a checking group on the MRP detail screen in its material master. The checking group combines materials whose availability is checked at the same time. You can, for instance, group materials according to the material type or the MRP type.",
              Type: "Business Process",
              Scope:
                "The system checks whether material components in networks are available on the required date. If the requirements are not covered, the system determines the date on which they can be covered.",
              Outcome: "Availability of required material is determined.",
              name: "Check material availability",
              _id: 1270,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Commercial completion of the plant maintenance order indicates that all costs related to the order have been settled. This process pertains to the business completion of an order when no further costs are expected to be posted to the order. ",
              _type: "Process",
              GUID: "7bbc6aae-7eee-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Typically, maintenance orders are set to commercially complete by a batch process after a defined period of time.",
              Outcome:
                "The order obtains the status Completed, which indicates full completion. ",
              name: "Complete maintenance order commercially",
              _id: 1269,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Plant maintenance must be executed as specified in the maintenance plan, with tracking of time and task completion.   For dismantling, asset accounting is informed and EH&S is informed about harmful substances have to be transported when the asset is dismantled.",
              _type: "Process",
              GUID: "73e0f9e8-e802-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Having collected the required materials, the maintenance technician conducts the planned maintenance as described in the shop papers. All activities performed are tracked and documented accordingly. ",
              Outcome:
                "All activities related to the plant maintenance are performed",
              name: "Perform plant maintenance",
              _id: 1268,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2D Preventive maintenance",
          _id: 1267,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "250ab9f1-7ef7-11e5-0a66-001bc640cd9b",
          Description:
            "The Engineer-to-order (Project Assembly) scenario describes processes in a project situation whereby products are developed and subsequently assembled at the customers location. The scenario comprises the procedure from planning and scheduling of the project, the recording of working hours and the delivery of the final work.  Key aspects of Engineer-to-order (Project Assembly) are:   ***Project structuring/execution via project system to control the collaboration between the different departments involved   ***Milestone billing to control the progressive payment procedure, and track back the status of the project   ***Delivery of the semi-finished goods via the project   ***Handling the final assembly on customer site using network activity in the project ",
          _type: "Scenario",
          GUID: "22a31382-ef12-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "When all requirements are met, the project is approved, released and communicated to the stakeholders.      ",
              _type: "Process",
              GUID: "1cdd808a-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Project deliverables, plan and resources assignments are reviewed. If all requirements are fulfilled the project is released for execution. It is possible to release the whole project or only a phase of the project.",
              Outcome:
                "The entire project or a project phase is released for execution.",
              name: "Approve and release project",
              _id: 1266,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process describes the recording of travel activities that can occur when performing a service.       ",
              _type: "Process",
              GUID: "84843a3d-7e5b-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Creation of trips including start and end date of trip, travel expenses, location, finalization of travel activities recording by setting the status to approved and settled, posting travel activities to financial accounting.",
              Outcome: "Travel activities recorded and posted to accounting.",
              name: "Record travel activities",
              _id: 1265,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Manage incoming payment process ensures that the payment from a customer is captured and documented appropriately.",
              _type: "Process",
              GUID: "f5f29ea1-e8f4-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Especially in global template projects different variants of payments have to be considered but their use should often be limited to a group of countries rather than being made available to all.",
              Type: "Business Process",
              Scope:
                "Manage incoming payment involves receiving a payment from a customer and entering the information in accounting. The incoming payment is mapped to the customer invoice and customer account.",
              Outcome:
                "Incoming payment is recorded and the customer account is credited.",
              name: "Manage incoming payment",
              _id: 1264,
              Business_Rules:
                "The methods of payment must be established taking into account country specific factors related to the business and customer. For instance: The bill of exchange (BoE) payment method is used in some countries only.   Typical methods of payment are:   ***Check   ***Direct debits   ***Credit cards   ***Bank transfers",
              Prerequisite:
                "Prerequisite: currency exchange and hedging processes",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A project is technically closed if work is completed but costs are still expected to accrue.   ",
              _type: "Process",
              GUID: "1f40c4ed-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "For Capital Investment Projects (CAPEX) the Asset master has to be maintained and the relevant asset related information updated on the settlement rule for the project. This is to enable costs to be settled to the asset when settlement is run after technical completion.",
              Type: "Business Process",
              Scope:
                "Once all project related activities have been performed and confirmed, the project is completed by setting the project status to technically complete. This prevents further changes to the project.",
              Outcome: "The project is technically complete.",
              name: "Complete project technically",
              _id: 1263,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In a project environment, several personnel resources may be assigned to a work center. In case capacity planning is performed on work center level, and not assigned to a single person a detailed and meaningful reporting will not be possible. Therefore, assigning personnel resources enables capacity planning on personnel level to avoid overwork or to assign personnel with relevant qualification. ",
              _type: "Process",
              GUID: "ebe8c58f-e753-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the customer order is created, activities are assigned to personnel resources. To ensure the advanced procurement, the status of a Work Breakdown Structure (WBS) element has to have the status Released.",
              Outcome:
                "Required personnel resources are assigned to project activities.",
              name: "Assign personnel resources to project",
              _id: 1262,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Employees working on projects or services have to record the hours spend for it. This can be done using Cross-Application Time Sheet (CATS). CATS is a tool for recording working times and tasks. ",
              _type: "Process",
              GUID: "1f40c4e3-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Maintenance of working hours, approval of working hours by the manager, transfer of working hours to controlling.",
              Outcome: "Working hours are recorded.",
              name: "Record and approve working hours",
              _id: 1261,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In a project environment, it is necessary to perform required R&D work, track the process and confirm upon completion.   ",
              _type: "Process",
              GUID: "19efab1a-7ef6-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Required  R&D work is performed as specified in the project plan.  Milestones are tracked, and the status of the project is reported.       ",
              Outcome: "Completion of R&D work is confirmed",
              name: "Execute R&D work",
              _id: 1260,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "With the commercial completion of the project, no more costs can be allocated to the project. This marks the completion of the project from an accounting/ controlling perspective.",
              _type: "Process",
              GUID: "54e6bc6c-e7fc-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After all the project activities have been completed, actual costs settled and commitments removed, the project is completed commercially and the project portfolio item is closed. Completion of a project will usually be linked to a quality control gate.",
              Outcome:
                "All actual costs are settled to the project and commitments removed.",
              name: "Complete project commercially",
              _id: 1259,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "For customer projects, a sales order must be created with reference to the quotation sent to the customer.     ",
              _type: "Process",
              GUID: "ca0ea8e0-7eef-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After sending the customer quotation, a customer order is created with reference to the quotation. The project baseline is adjusted based on sales order and technical documents are assigned to project related activities.",
              Outcome: "Customer order is created with reference to quotation.",
              name: "Create sales order with ref. to quotation",
              _id: 1258,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process involves activities required to create a billing document that is sent to the customer for payment.  ",
              _type: "Process",
              GUID: "ca0ea8e9-7eef-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The milestones set in the project are transferred to the sales order and a billing document is created.",
              Outcome:
                "Billing document is created and can be sent to the customer. ",
              name: "Perform milestone billing",
              _id: 1257,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In a project assembly situation it is necessary to perform assembly work at the customers location. For this purpose, work performed must be tracked and confirmed upon completion. ",
              _type: "Process",
              GUID: "8172e291-7ef7-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the WBS element is released, assembly work can begin with execution of all the required tasks. At each stage of the assembly, completion of activities is followed by confirmation and reporting to the responsible project lead on-site at the customer location.",
              Outcome: "Assembly work is complete and confirmed",
              name: "Execute assembly work",
              _id: 1256,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2D Engineer-to-order (Project assembly)",
          _id: 1255,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "76a0c021-7ef2-11e5-0a66-001bc640cd9b",
          Description:
            "The Engineer-to-order (Production) scenario describes processes in a project situation whereby products are designed, manufactured and delivered to the customer. The scenario comprises the procedure from planning and scheduling of the project, the recording of working hours and the delivery of the final product to the customer.  Key aspects of Engineer-to-order (Production) are:    ***Project structuring/execution via project system to control the collaboration between the different departments involved    ***Milestone billing to control the progressive payment procedure, and track back the status of the project    ***Delivery of the final product via the project  ",
          _type: "Scenario",
          GUID: "22a31380-ef12-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "In a project environment, several personnel resources may be assigned to a work center. In case capacity planning is performed on work center level, and not assigned to a single person a detailed and meaningful reporting will not be possible. Therefore, assigning personnel resources enables capacity planning on personnel level to avoid overwork or to assign personnel with relevant qualification. ",
              _type: "Process",
              GUID: "ebe8c58f-e753-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the customer order is created, activities are assigned to personnel resources. To ensure the advanced procurement, the status of a Work Breakdown Structure (WBS) element has to have the status Released.",
              Outcome:
                "Required personnel resources are assigned to project activities.",
              name: "Assign personnel resources to project",
              _id: 1262,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Manage incoming payment process ensures that the payment from a customer is captured and documented appropriately.",
              _type: "Process",
              GUID: "f5f29ea1-e8f4-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Especially in global template projects different variants of payments have to be considered but their use should often be limited to a group of countries rather than being made available to all.",
              Type: "Business Process",
              Scope:
                "Manage incoming payment involves receiving a payment from a customer and entering the information in accounting. The incoming payment is mapped to the customer invoice and customer account.",
              Outcome:
                "Incoming payment is recorded and the customer account is credited.",
              name: "Manage incoming payment",
              _id: 1264,
              Business_Rules:
                "The methods of payment must be established taking into account country specific factors related to the business and customer. For instance: The bill of exchange (BoE) payment method is used in some countries only.   Typical methods of payment are:   ***Check   ***Direct debits   ***Credit cards   ***Bank transfers",
              Prerequisite:
                "Prerequisite: currency exchange and hedging processes",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When all requirements are met, the project is approved, released and communicated to the stakeholders.      ",
              _type: "Process",
              GUID: "1cdd808a-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Project deliverables, plan and resources assignments are reviewed. If all requirements are fulfilled the project is released for execution. It is possible to release the whole project or only a phase of the project.",
              Outcome:
                "The entire project or a project phase is released for execution.",
              name: "Approve and release project",
              _id: 1266,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "With the commercial completion of the project, no more costs can be allocated to the project. This marks the completion of the project from an accounting/ controlling perspective.",
              _type: "Process",
              GUID: "54e6bc6c-e7fc-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After all the project activities have been completed, actual costs settled and commitments removed, the project is completed commercially and the project portfolio item is closed. Completion of a project will usually be linked to a quality control gate.",
              Outcome:
                "All actual costs are settled to the project and commitments removed.",
              name: "Complete project commercially",
              _id: 1259,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Employees working on projects or services have to record the hours spend for it. This can be done using Cross-Application Time Sheet (CATS). CATS is a tool for recording working times and tasks. ",
              _type: "Process",
              GUID: "1f40c4e3-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Maintenance of working hours, approval of working hours by the manager, transfer of working hours to controlling.",
              Outcome: "Working hours are recorded.",
              name: "Record and approve working hours",
              _id: 1261,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In a project environment, it is necessary to perform required R&D work, track the process and confirm upon completion.   ",
              _type: "Process",
              GUID: "19efab1a-7ef6-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Required  R&D work is performed as specified in the project plan.  Milestones are tracked, and the status of the project is reported.       ",
              Outcome: "Completion of R&D work is confirmed",
              name: "Execute R&D work",
              _id: 1260,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A project is technically closed if work is completed but costs are still expected to accrue.   ",
              _type: "Process",
              GUID: "1f40c4ed-7ca3-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "For Capital Investment Projects (CAPEX) the Asset master has to be maintained and the relevant asset related information updated on the settlement rule for the project. This is to enable costs to be settled to the asset when settlement is run after technical completion.",
              Type: "Business Process",
              Scope:
                "Once all project related activities have been performed and confirmed, the project is completed by setting the project status to technically complete. This prevents further changes to the project.",
              Outcome: "The project is technically complete.",
              name: "Complete project technically",
              _id: 1263,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process involves activities required to create a billing document that is sent to the customer for payment.  ",
              _type: "Process",
              GUID: "ca0ea8e9-7eef-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The milestones set in the project are transferred to the sales order and a billing document is created.",
              Outcome:
                "Billing document is created and can be sent to the customer. ",
              name: "Perform milestone billing",
              _id: 1257,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "For customer projects, a sales order must be created with reference to the quotation sent to the customer.     ",
              _type: "Process",
              GUID: "ca0ea8e0-7eef-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After sending the customer quotation, a customer order is created with reference to the quotation. The project baseline is adjusted based on sales order and technical documents are assigned to project related activities.",
              Outcome: "Customer order is created with reference to quotation.",
              name: "Create sales order with ref. to quotation",
              _id: 1258,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2D Engineer-to-order (Production)",
          _id: 1254,
          Business_Rules: "",
          Prerequisite: "",
        },
      ],
      Description:
        "The Project to Decommission (P2D) domain covers the planning and execution of projects as well as the implementation, operation and decommissioning of assets (Plant maintenance).",
      _type: "Domain",
      GUID: "dff028f0-b5d4-11e4-0a66-001bc640cd9b",
      Advisory_Notes: "",
      Type: "E2E-Domain",
      Scope: "",
      Outcome: "",
      name: "Project to Decommission",
      _id: 1253,
      Business_Rules: "",
      Prerequisite: "",
    },
    {
      BPMN_GUID: "58dbc951-ef18-11e4-0a66-001bc640cd9b",
      scenario_of: [
        {
          BPMN_GUID: "6eef4da1-7f0c-11e5-0a66-001bc640cd9b",
          Description:
            "This scenario describes the process of returning procured goods back to the vendor due to quality issues or due to the delivery of wrong goods.  In this scenario the company receives a full refund from the vendor in terms of a credit memo.",
          _type: "Scenario",
          GUID: "7278f24a-ef18-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "A delivery is the central object of the goods issue process - all shipping activities including picking, packing, transportation and goods issue are initiated based on the delivery. For the return to vendor scenario creation of a return delivery is required (similar to an outbound delivery in sales scenarios).      .",
              _type: "Process",
              GUID: "7b1559a0-7f0c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "A return delivery is created with reference to the return purchase order. A delivery can be created only for purchase orders, which are due to delivery (material availability date or the transportation scheduling date is reached). ",
              Outcome:
                "Return delivery document is created and shipping activities can be initiated.",
              name: "Create return delivery for vendor returns",
              _id: 1252,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once a credit memo is received, the details must be captured and documented accordingly. Relevant details include the vendor that sent the credit memo and the reason for issuing the credit memo.   ",
              _type: "Process",
              GUID: "7b15599d-7f0c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After products or packaging have been returned to the vendor, a credit memo can be issued. When this occurs the credit memo is checked regarding whether it is formally compliant and it is checked against the original invoice. ",
              Outcome: "The credit memo is posted and processed in accounting.",
              name: "Manage incoming credit memo",
              _id: 1251,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once issued to vendor the purchase order represents a firm commitment. Therefore, it must be approved before the issue and then transferred to vendor.       ",
              _type: "Process",
              GUID: "de59c972-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Before committing to the actual purchase of materials or services, an authorised person does a final check if the purchase order is correct and approves it. The PO will then be sent to the vendor.",
              Outcome: "The purchase order is issued.",
              name: "Approve and issue purchase order",
              _id: 1189,
              Business_Rules: "Approval rules and limits have to be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Receiving notification from the relevant department about a product related complaint to a vendor and processing the information initiates the return-to-vendor process.        ",
              _type: "Process",
              GUID: "7b15599a-7f0c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "This process includes receiving the complaint from a relevant department, assessing and updating it with the necessary information (e.g. PO number, warranty terms), identifying the responsible vendor and requesting a return material authorization (RMA). After the vendor has confirmed the complaint, the return purchase order can be created.",
              Outcome:
                "The complaint contains all necessary information. The vendor has approved the return and the product can be returned to the vendor.",
              name: "Process complaint to vendor",
              _id: 1250,
              Business_Rules:
                "It must be defined:   ***How the validity of the complaint will be assessed and what parties (departments) will be involved.   ***Who will have authorization to approve which type of complaints.   ***What information is required to ensure that the vendor accepts the complaint.   ***What the timeframe for processing of complaints is.  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The purchase department checks the status of the goods return delivery.",
              _type: "Process",
              GUID: "01d98350-a15e-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Status of return delivery is verify, and all relevant details are recorded. ",
              Outcome: "Status of vendor return is available and up to date.",
              name: "Monitor vendor return",
              _id: 1249,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of a return purchase order is required to initiate the return of products to the vendor. The return can result from a valid complaint or the over-delivery of products, part of which needs to be returned to vendor.       ",
              _type: "Process",
              GUID: "17bfd3bc-5171-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the notification is given that products must be sent back to the vendor, a return purchase order is created and forwarded for further processing. ",
              Outcome:
                "All relevant information regarding the return is documented in the return purchase order.",
              name: "Create return purchase order",
              _id: 1248,
              Business_Rules:
                "***The format of the order (electronic, paper) and communication channel must be defined.    ***It is necessary to  define who covers the transportation and other related costs.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade checks ensure compliance with trade regulatory programs and cross-border customs requirements. Compliance must be ensured in all international business operations.     ",
              _type: "Process",
              GUID: "fb9de07b-7f05-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The GTS check itself is in most cases just an automated check against tables.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both the vendor and products being purchased are subject to checks.",
              Outcome:
                "The purchase order complies with the applicable trade regulations and the goods can be purchased and imported.",
              name: "Perform global trade checks for purchasing",
              _id: 1198,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists) used for screening is comprehensive and up to date.   Vendor data must be up to date.   Rules and procedures how to handle purchase orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "Return to vendor scenario describes the process flow required to return previously purchased products to the vendor. This scenario covers only the option of physical goods return to vendor.  An alternative scenario is scrapping on site, whereby the vendor compensates the value of non-consumed products and the costs for scrapping, but products themselves are not sent back to the vendor.  Return to vendor scenario can be initiated from all scenarios, which involve procurement of external materials, as well as from customer return scenarios (if material received from customer has been procured from vendor). In some cases the goods may be returned to the vendor due to late deliveries.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2P Return to vendor",
          _id: 1247,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "20ade571-94bc-11e8-2ddf-001bc640cd9b",
          Description:
            "Procurement of asset scenario covers the purchasing of products treated as assets in account, due to their long-term usage. The value of the procured asset is capitalized and depreciation debited to the respective cost object.",
          _type: "Scenario",
          GUID: "7278f224-ef18-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The asset is created and its value is derived from the cost objects collecting any costs for acquiring the asset or related services. Activation is a manual process in Finance by Asset Management role (locally based on laws and regulations).   Criteria for classification of assets: If the value is <2.000 treated as an expense charged against the P&L account. If the value is >2.000 it has to be activated with a depreciation schedule If it is unclear, it can be maintained in an internal order to collect costs and decide on activation later.",
              _type: "Process",
              GUID: "22f823a4-94bc-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "A new financial asset is created in the system. The initial value of the asset is derived from the object used for collecting costs for acquiring the asset.",
              Outcome: "Financial asset created",
              name: "Activate asset",
              _id: 1246,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Processing of a Purchase Order based invoice from a vendor, in order to trigger the outgoing payment process.",
              _type: "Process",
              GUID: "981573d4-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes:
                "As one of the most prominent examples of Segregation of Duty (SoD), invoice verification has to be done from a department independent from the department responsible for the purchasing. Typically, invoice verification is a department reporting to finance. Needs to be implemented.   ***In addition tolerances need to be defined in order to avoid clearing efforts for small deviations.   ***Further more rules need to be defined on how to handle invoices for partial deliveries. These rules could either effect internal procedures or external ones (e.g. allow supplier to increase quantity of next delivery to compensate for missing quantities).   ***The sequence of processing invoices compared to the goods receipt might differ from case to case. Especially for purchasing of services both sequences are common (e.g. service entry sheet). ",
              Type: "Business Process",
              Scope:
                "After the invoice has been transferred (from a scanning tool), invoice verification supports the checking for formal compliance, and whether it is consistent with the purchase order and the actually provided goods or services.",
              Outcome:
                "The invoice is posted, triggering the outgoing payment process.",
              name: "Process incoming invoice (with PO)",
              _id: 1190,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once issued to vendor the purchase order represents a firm commitment. Therefore, it must be approved before the issue and then transferred to vendor.       ",
              _type: "Process",
              GUID: "de59c972-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Before committing to the actual purchase of materials or services, an authorised person does a final check if the purchase order is correct and approves it. The PO will then be sent to the vendor.",
              Outcome: "The purchase order is issued.",
              name: "Approve and issue purchase order",
              _id: 1189,
              Business_Rules: "Approval rules and limits have to be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Before the created purchase requisition (PR) can be processed further, it needs to pass an approval workflow to ensure, that no un-necessary purchases are made.  ",
              _type: "Process",
              GUID: "564ad663-7f04-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Typically approval of a purchase requisiton involves two stages - budget approval and content approval. Budget approval confirms, that there are sufficient funds for the intended purchase and lies within responsibility of the budget owner for the requesting department. Content approval confirms the necessity of the purchase and is performed by subject matter expert (e.g. IT manager for IT related spending).",
              Outcome:
                "Purchase requisition has been approved and can be further processed by purchasing department.",
              name: "Approve purchase requisition",
              _id: 1245,
              Business_Rules:
                "To eliminate possibility of maverick spending, rules must be established regulating approvals requirements (e.g. spending exceeding set amount require a higher instance approval). To reduce unnecessary approval workload rules must be established on when which approvals are required (e.g. only spending exceeding predefined amounts require extra approval).",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A purchase requisition (PR) has to be created with detailed information about the asset to be purchased.",
              _type: "Process",
              GUID: "22f82391-94bc-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The PR can be derived from an individual demand and includes basic information of the type of asset and which quantity is needed. This could be:   ***material   ***quantity   ***delivery date   ***estimated price   ***vendor (if known)   ***procurement type (e.g. K for cost center) ***information about the related cost object.",
              Outcome:
                "PR has been created for an asset and can be handed over for approval.",
              name: "Create purchase requisition for asset",
              _id: 1244,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "An official purchase order (PO) has to be created from a purchase requisition (PR) to be able to order materials and services.       ",
              _type: "Process",
              GUID: "de59c987-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                " ***set-up of possible conversions must be defined. Conversion options are single, multiple or partial ***purchasing strategies for vendors need to be considered (e.g. fair share, contingents)  ***special agreements with vendors need to be considered (e.g. FTL/FCL only, min/max quantities, multiple products to be bundled) ",
              Type: "Business Process",
              Scope:
                "The PO is created with reference to a specific PR. Additional data not provided within the PR has to be maintained.",
              Outcome: "A PO is generated.",
              name: "Convert purchase requisition to purchase order",
              _id: 1193,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process covers the scanning of a Purchase Order based invoice or an Expense Invoice (no PO reference).",
              _type: "Process",
              GUID: "981573d2-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the invoice is received, it is scanned and the data is captured. The data is then stored in a database for digital use and then transfered to for verification.",
              Outcome:
                "Received invoice information is transferred for verification.",
              name: "Scan incoming invoice with OCR software",
              _id: 1192,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Monitoring purchase order (PO) process ensures - through communication with the vendor - that the correct material is sent and can be/is delivered on time, and in full quantity.     ",
              _type: "Process",
              GUID: "dfa9a1e2-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The monitoring scope and necessary details must be defined depending on material market availability and importance for the supply chain (e.g. monitoring for deficit components might be stricter then for widely available materials). Rules for sending reminders to vendor (timing etc.) must be defined",
              Type: "Business Process",
              Scope:
                "After the PO has been sent to the vendor, it needs to be tracked. The vendor hereby sends an order acknowledgement to confirm the receipt of the PO. Furthermore, the delivery date is tracked and, in case of imported material, the estimated time of arrival (ETA) as well as the estimated time of sailing is provided by the vendor. In addition, the timely provision of quality certificate is monitored. In case of delays or missing information on the vendors side, reminders and dunning letters can be issued.",
              Outcome:
                "Purchase order status and delivery of goods, documents and additional information has been monitored.",
              name: "Monitor purchase order",
              _id: 1191,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade checks ensure compliance with trade regulatory programs and cross-border customs requirements. Compliance must be ensured in all international business operations.     ",
              _type: "Process",
              GUID: "fb9de07b-7f05-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The GTS check itself is in most cases just an automated check against tables.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both the vendor and products being purchased are subject to checks.",
              Outcome:
                "The purchase order complies with the applicable trade regulations and the goods can be purchased and imported.",
              name: "Perform global trade checks for purchasing",
              _id: 1198,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists) used for screening is comprehensive and up to date.   Vendor data must be up to date.   Rules and procedures how to handle purchase orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2P Procurement of assets",
          _id: 1243,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "8c730a01-7f0d-11e5-0a66-001bc640cd9b",
          Description:
            "To ensure uninterrupted operations, possible sources for purchasing important materials and services need to be identified and relationships with main suppliers established. The supplier sourcing and contracting scenario covers relevant processes from gathering product information till capturing supplier contracts in the system.  Execution of supplier sourcing scenario is resource demanding and time consuming, therefore its application requires clear prioritization based on criticality for the operations, competitive factors (strategic), dependency on market conditions (shortages, high price fluctuation etc.), and costs.  Widely available components not crucial for manufacturing can be acquired by using standard procurement scenarios without intense sourcing activities.",
          _type: "Scenario",
          GUID: "7278f250-ef18-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Evaluating the market enables the purchasing department to know what products and services are currently offered in relation to the defined products and services requested by the various departments within the organization.    ",
              _type: "Process",
              GUID: "915d6e75-7f0d-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the requested products or services have been clearly defined, the purchasing department performs market research in order to get a clear picture of the products and services being offered by various suppliers on the market.    The evaluation can include:   ***profiling of suppliers   ***profiling of products and services   ***analysis of market trends   ***assessment of cost structures   ***gaining insight on distribution channels   ***assessment of key success factors and review of success details",
              Outcome:
                "All relevant information on the market is available for further processing.",
              name: "Evaluate market",
              _id: 305,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Receiving information about a supplier contract and capturing it for further processing are key first steps in purchasing processes which are based on the contractual agreement with a supplier.        ",
              _type: "Process",
              GUID: "ec357bcb-7e11-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Not all vendor contracts need to be captured in SAP. Often, only details such as prices or rebates will be reflected in the purchasing master data.   Only if special treatment of contracts within SAP is required, the contracts have to be captured as such in SAP. This is basically the case for scheduling agreements and for more complex rebate agreements.",
              Type: "Business Process",
              Scope:
                "Details regarding contracts with a supplier are  recorded, stored and forwarded for further processing. The information can include the type of products, the quantity and the agreed price, as well as other terms and condition related the purchase. ",
              Outcome:
                "All relevant information regarding the contract with the supplier is stored.",
              name: "Capture vendor contract",
              _id: 1203,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The final decision regarding which supplier will provide the organization with the requested products or services has to be made in order to initiate collaboration with the supplier and confirm the new source of products or services.   ",
              _type: "Process",
              GUID: "915d6eb7-7f0d-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Based upon the negotiations with potential suppliers, an assessment is carried out to determine which one is most suitable to fulfill the requests for products or services. A supplier is selected and informed about the decision. ",
              Outcome:
                "The supplier that will provide a specified product or service is chosen and the contracting process can begin.",
              name: "Evaluate vendors and make final decision",
              _id: 311,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In this process supplier and customer negotiate and agree the terms and conditions of their anticipated relationship.  The negotiation can be based on the previous exchange of RFP/RFQ and the related responses.",
              _type: "Process",
              GUID: "ec357bad-7e11-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Align and agree scope of services, negotiate and agree contract terms.",
              Outcome: "Agreement ready for contracting.",
              name: "Perform vendor negotiations",
              _id: 1205,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Information on products or services requested by the various departments must be amended in order to ensure that all the necessary details are available to begin the search for suppliers.   ",
              _type: "Process",
              GUID: "915d6ea8-7f0d-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "Material master data might be already captured.",
              Type: "Business Process",
              Scope:
                "The purchasing department uses the initial information gathered concerning products and services needed by the various departments as the basis for documenting the specifics of the requests. Additional information is sourced in order to complete the definition of requested product or services.   ",
              Outcome: "Requested product or service is defined.",
              name: "Complete definition of requested product or services",
              _id: 310,
              Business_Rules:
                "It must be defined:   ***Where additional information will be taken from e.g. asking the various departments to provide the missing details   ***Whether approval is required once the products or services have been defined and if yes, through whom it will be defined    ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Through evaluation, the organization can qualify suppliers to ensure that their capabilities have been verified. The result of the evaluation forms the basis for the negotiation process with the supplier.    It is possible to assign different weights to the individual criterias. The vendors overall score is calculated taking into account the weighted scores awarded for each of the main criteria. ",
              _type: "Process",
              GUID: "915d6e93-7f0d-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The data, statements, records, operations and performances of a supplier are maintained in the system and examined in order to verify the suppliers validity and support the decision on whether or not to enter into a business relation with the supplier.    The audit can include criteria such as:   ***checking that the supplier is capable of producing the product or providing the service with adequate quality standards   ***verifying that the supplier is conforming to required environmental regulations and international standards   ***checking if the information available about the supplier is comprehensive enough to begin the negotiation process    ",
              Outcome: " Negotiations with identified supplier can begin.",
              name: "Evaluate vendor responses",
              _id: 301,
              Business_Rules:
                "It is necessary to establish a framework for the audit i.e.    ***What information will be used?   ***How will the audit be operationalised?   ***Who will perform the audit?   ***How will the results be communicated and used in the selection of suppliers?  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Before purchasing goods under a contractual agreement with the supplier, it is necessary to define the conditions and set the terms under which the goods will be provided. The purchasing department must understand exactly what products (e.g. goods or services) need to be purchased and in what quantity, as well as select the supplier and prepare the contracting details with the supplier.      ",
              _type: "Process",
              GUID: "ec357bb3-7e11-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Typically at the end of the negotiations the  vendor master data and other master data is initiated if  required.",
              Type: "Business Process",
              Scope:
                "Based on the products and quantity that needs to be purchased, a suitable supplier is selected. Specific terms and conditions related to the purchase are negotiated and a contract document prepared.",
              Outcome: "The contract with the supplier is approved.",
              name: "Perform contracting",
              _id: 1206,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Possible suppliers are evaluated regarding aspects that are important for a well-set and cordial working co-operation. These can include:   ***company profile   ***management   ***quality   ***compliance   ***reputation   ***location   ",
              _type: "Process",
              GUID: "9d60b014-7f0d-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Depending on the purchasing requirements, possible suppliers are sorted and evaluated in order to determine who is most suited. Based on the assessment, a quotation or proposal is requested from the selected suppliers.",
              Outcome:
                "Suppliers, who will be involved in further sourcing process, are selected.",
              name: "Evaluate source of supply",
              _id: 303,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After identification of suitable vendors it is possible to maintain the vendor in a source list to determine through which vendor a certain material/service is to be purchased at one specific time. ",
              _type: "Process",
              GUID: "feb3c726-514b-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The supplier is identified as a source.  It is captured and that the supplier delivers certain materials/services for the organization within a pre-defined period. ",
              Outcome: "Source list created.",
              name: "Create source list",
              _id: 304,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Gathering information regarding products and services required by the organization is a key first step of the purchasing process. Through this, details on the specific product and service needs of the various department within the organization are communicated and documented accordingly.     ",
              _type: "Process",
              GUID: "915d6e8a-7f0d-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Before a potential supplier can be identified, details regarding the specific products or services needed are collected and recorded. The purchasing department ensures that all departments communicate their requirements accurately and comprehensively. The information is captured in a reliant format for further processing. ",
              Outcome:
                "Comprehensive information on products and services required by the various departments is available.",
              name: "Gather product/service information",
              _id: 308,
              Business_Rules:
                "It is necessary to define:   ***What information is required on the products and services   ***How the information is collected and stored  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Requests For Quotation (RFQ) are suited for goods or services that are as standardized as possible.   A formal request for proposal (RFQ) is sent to potential suppliers. It contains a description of all relevant parameters of the intended purchase, such as:   ***Part or service descriptions/specifications   ***Quantities/Volumes   ***Description or drawings   ***Quality levels or personnel skills, training level or competencies   ***Delivery requirements   ***Term of contract   ***Terms and conditions   ***Other value added requirements or terms   ***Draft contract   As the request is centered around a standard offering the most important dimension for ranking suppliers will be the price per item or per unit of service, with other dimensions playing a secondary role.  ",
              _type: "Process",
              GUID: "915d6e90-7f0d-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "RFQs are typically used as supporting documentation for sealed bids (either single-round or multi-round) and may be a logical pre-cursor to an electronic reverse auction.",
              Type: "Business Process",
              Scope:
                "An RfQ is created and issued to potential vendors. The vendor responses to the RfQ are collected.  ",
              Outcome: "Vendor responses to RfQ is available.",
              name: "Request quotation from vendors",
              _id: 309,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2P Supplier sourcing and contracting",
          _id: 1242,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "ed9626c1-7f06-11e5-0a66-001bc640cd9b",
          Description:
            "Procurement of direct materials scenario covers the process flow required to obtain materials (raw materials or (semi-)finished goods) from a vendor and receive them in inventory either for further use in production or for sale. The received materials are tracked and valuated in stock.  Procurement of direct materials is typically initiated by planning to ensure availability of materials. Since requested materials are used in manufacturing or sales, no specific approval of purchase requisition is performed.",
          _type: "Scenario",
          GUID: "22a313ae-ef12-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Processing of a Purchase Order based invoice from a vendor, in order to trigger the outgoing payment process.",
              _type: "Process",
              GUID: "981573d4-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes:
                "As one of the most prominent examples of Segregation of Duty (SoD), invoice verification has to be done from a department independent from the department responsible for the purchasing. Typically, invoice verification is a department reporting to finance. Needs to be implemented.   ***In addition tolerances need to be defined in order to avoid clearing efforts for small deviations.   ***Further more rules need to be defined on how to handle invoices for partial deliveries. These rules could either effect internal procedures or external ones (e.g. allow supplier to increase quantity of next delivery to compensate for missing quantities).   ***The sequence of processing invoices compared to the goods receipt might differ from case to case. Especially for purchasing of services both sequences are common (e.g. service entry sheet). ",
              Type: "Business Process",
              Scope:
                "After the invoice has been transferred (from a scanning tool), invoice verification supports the checking for formal compliance, and whether it is consistent with the purchase order and the actually provided goods or services.",
              Outcome:
                "The invoice is posted, triggering the outgoing payment process.",
              name: "Process incoming invoice (with PO)",
              _id: 1190,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "An official purchase order (PO) has to be created from a purchase requisition (PR) to be able to order materials and services.       ",
              _type: "Process",
              GUID: "de59c987-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                " ***set-up of possible conversions must be defined. Conversion options are single, multiple or partial ***purchasing strategies for vendors need to be considered (e.g. fair share, contingents)  ***special agreements with vendors need to be considered (e.g. FTL/FCL only, min/max quantities, multiple products to be bundled) ",
              Type: "Business Process",
              Scope:
                "The PO is created with reference to a specific PR. Additional data not provided within the PR has to be maintained.",
              Outcome: "A PO is generated.",
              name: "Convert purchase requisition to purchase order",
              _id: 1193,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process covers the scanning of a Purchase Order based invoice or an Expense Invoice (no PO reference).",
              _type: "Process",
              GUID: "981573d2-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the invoice is received, it is scanned and the data is captured. The data is then stored in a database for digital use and then transfered to for verification.",
              Outcome:
                "Received invoice information is transferred for verification.",
              name: "Scan incoming invoice with OCR software",
              _id: 1192,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade checks ensure compliance with trade regulatory programs and cross-border customs requirements. Compliance must be ensured in all international business operations.     ",
              _type: "Process",
              GUID: "fb9de07b-7f05-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The GTS check itself is in most cases just an automated check against tables.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both the vendor and products being purchased are subject to checks.",
              Outcome:
                "The purchase order complies with the applicable trade regulations and the goods can be purchased and imported.",
              name: "Perform global trade checks for purchasing",
              _id: 1198,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists) used for screening is comprehensive and up to date.   Vendor data must be up to date.   Rules and procedures how to handle purchase orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Requirements for externally source materials are evaluated considering all relevant demand elements.",
              _type: "Process",
              GUID: "279a79cf-99bb-11e9-0cfc-001bc641ce4f",
              Advisory_Notes:
                " *** In SAP environments typically the MRP run is used as functionality to calculate the final requirements per material and create the corresponding purchase requisitions.  ***Often (not always!) you will find separate MRP calculation setups for externally sourced materials compared to the own produced materials. Difference can be found for example in frequency of the calculation and also in the scope of demand elements taken into account.  ***If requirements for externally source materials are calculated with a different logic it is still absolutely essential to consider the overall sequence of MRP calculations in combination with calculations of own-produced materials and those of across other plants in the supply network.",
              Type: "Business Process",
              Scope:
                "In order to evaluate the material requirements the demands from production (esp. components), from customer orders or intercompany replenishments (esp. trading goods), as well as stock replenishments and planned procurment quantities need to be considered and combined. Based on this comprehensive information the purchase requisitions are created.",
              Outcome:
                "Purchase requisitions for externally sourced materials have been created according to the overall demand situation.",
              name: "Evaluate material requirements for procurement",
              _id: 1204,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once issued to vendor the purchase order represents a firm commitment. Therefore, it must be approved before the issue and then transferred to vendor.       ",
              _type: "Process",
              GUID: "de59c972-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Before committing to the actual purchase of materials or services, an authorised person does a final check if the purchase order is correct and approves it. The PO will then be sent to the vendor.",
              Outcome: "The purchase order is issued.",
              name: "Approve and issue purchase order",
              _id: 1189,
              Business_Rules: "Approval rules and limits have to be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A purchase requisition (PR) acts as the trigger for the purchasing department to perform the required purchase of direct materials. Therefore, the purchasing department needs to check who can deliver the material and if the supplier can meet the necessary purchasing conditions. Often the supply network for continuously required direct materials is defined and already considered by the planning tool. Thus, the processing can be automated.              ",
              _type: "Process",
              GUID: "26aa6cf5-7f07-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Even if APO is used for supply chain planning, quite often the ERP MRP run will finally generate the PRs on a local (=plant) level. However, PRs can also be generated and transferred to the ERP by the APO.",
              Type: "Business Process",
              Scope:
                "Processing the PR checks if the purchase order can be fulfilled. Delivery conditions, payment methods, and potential suppliers who can deliver the material, are checked. Once the purchasing department has all relevant information, the conversion of the PR into a purchase order (PO) can be triggered.",
              Outcome: "The PR is ready to be converted to a PO.",
              name: "Process purchase requisition for direct materials",
              _id: 1210,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Monitoring purchase order (PO) process ensures - through communication with the vendor - that the correct material is sent and can be/is delivered on time, and in full quantity.     ",
              _type: "Process",
              GUID: "dfa9a1e2-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The monitoring scope and necessary details must be defined depending on material market availability and importance for the supply chain (e.g. monitoring for deficit components might be stricter then for widely available materials). Rules for sending reminders to vendor (timing etc.) must be defined",
              Type: "Business Process",
              Scope:
                "After the PO has been sent to the vendor, it needs to be tracked. The vendor hereby sends an order acknowledgement to confirm the receipt of the PO. Furthermore, the delivery date is tracked and, in case of imported material, the estimated time of arrival (ETA) as well as the estimated time of sailing is provided by the vendor. In addition, the timely provision of quality certificate is monitored. In case of delays or missing information on the vendors side, reminders and dunning letters can be issued.",
              Outcome:
                "Purchase order status and delivery of goods, documents and additional information has been monitored.",
              name: "Monitor purchase order",
              _id: 1191,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2P Procurement of direct materials",
          _id: 1241,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "245b1801-7f02-11e5-0a66-001bc640cd9b",
          Description:
            "The intracompany replenishment scenario describes a collaborative relationship between a receiving and supplying plants, which aims at ensuring consistent supply of materials required for production or sale to customers. In this scenario after evaluating material requirements the receiving plant creates a stock transport order. Basing on this order the supplying plant creates an outbound delivery and performs goods issue.  In the intracompany replenishment scenario both plants belong to the same organization and are operating within the same ERP system, therefore no invoicing and payment flow takes place.",
          _type: "Scenario",
          GUID: "7278f244-ef18-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The Available-to-Promise (ATP) check verifies, whether the required quantity of material will be available at the required date. ",
              _type: "Process",
              GUID: "817029f4-7eff-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "In order to verify the material availability for replenishments across plants, a global availability check has to be established.",
              Type: "Business Process",
              Scope:
                "After the stock transport order is created, it must be checked if the order can be fulfilled (requested material is available in the requested quantity and on the desired date).  ",
              Outcome: "ATP check is performed.",
              name: "Check availability to promise for stock transfer",
              _id: 1227,
              Business_Rules:
                "Rules how to manage and distribute available materials to different requesting plants and legal entities have to be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Material requirements planning (MRP) helps to ensure the availability of all materials (raw materials, semifinished goods) required for production or other use in the right quantity and on time.",
              _type: "Process",
              GUID: "817029ee-7eff-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Material requirements planning (MRP) requires bills of materials and material lead times to be defined and correctly maintained. The MRP schedule must be defined regularly.   There are many different MRP strategies available for planning driven and consumption driven material approaches.   The identified materials requirement can be the triggering event for this process. Other triggering events can be: ***Production order created ***Independent demand revised and updated ***Rework production order created ***Refilling/Re-packaging process order created ***Campaign scheduling completed ***Dependent demand revised and updated",
              Type: "Business Process",
              Scope:
                "In stepwise production scheduling procedure after defining finished product demand for the planning period, material requirements planning must be performed to compare demand with current stocks and planned manufacturing, identify final products to be manufactured, analyze, what materials, in what quantity and when are required for the manufacturing and propose production and purchasing schedule (material requirements planning assumes infinite production capacity).",
              Outcome:
                "As a result of material requirements planning, the recommended production schedule is created together with planned orders. In parallel, a recommended purchasing schedule for materials required for production but not available on stock is needed.",
              name: "Perform and evaluate material requirements planning",
              _id: 1228,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Replenishment scenarios are based on a set of agreements between the individual legal entities of a group, which are reflected in the supply chain set-up and related master data. The processing of the stock requisition (STR) for replenishment involves taking information on material requirements and mapping them to a predefined supplying entity. This forms the basis for delivery scheduling.",
              _type: "Process",
              GUID: "81702a09-7eff-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "When the PR is received, the purchasing department records the required amount of materials based on planning data and records which predefined group vendor will supply the materials. The STR is then reviewed and approved accordingly. ",
              Outcome:
                "The STR is approved and forwarded for further processing. ",
              name: "Process stock transport requisition",
              _id: 1226,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In a cross-company replenishment scenario, no purchase orders are used. Instead a stock transport order (STO) is used to depict the fact that goods delivery is expected from another legal entity of the group.     ",
              _type: "Process",
              GUID: "fbef921c-e8d4-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "An STO is created (converted from an STR), which documents the fact that materials will be received from a cross-company vendor. The kind and quantity of materials to be transferred and received are specified in the transport order, as well as the specified storage location and the point in time for planned goods receipt. Pricing follows the same logic as for purchasing from external vendors.",
              Outcome:
                "An STO is created triggering and documenting the expected inventory transfer.",
              name: "Create stock transport order",
              _id: 1230,
              Business_Rules:
                "Approval requirements for stock transfer orders need to be defined.",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "SAP provides several scenarios for transfer of material from one plant to another: - Stock Transfer Between Plants in One Step, - Stock Transfer Between Plants in Two Steps, - Stock Transport Order Without Delivery, - Stock Transport Order with Delivery via Shipping, - Stock Transport Order with Delivery and Billing Document/Invoice Choice between the scenarios depends on physical distance between receiving and supplying plants, transparency requirements for goods in transit, supporting documentation requirements, legal structure of the organization.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2P Intracompany replenishment",
          _id: 1240,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "db4b9681-7f0b-11e5-0a66-001bc640cd9b",
          Description:
            "Procurement via vendor managed inventory scenario covers outsourcing of the material management function to the vendor. In this scenario the responsibility to monitor inventory, consumption of a material and the triggering of replenishment is assumed by the vendor of the material.  The realization of this scenario requires a high degree of integration with the vendors information systems as well as regular and consistent information exchange. It is typically practiced only in long term relationships with major suppliers.",
          _type: "Scenario",
          GUID: "7278f234-ef18-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Monitoring purchase order (PO) process ensures - through communication with the vendor - that the correct material is sent and can be/is delivered on time, and in full quantity.     ",
              _type: "Process",
              GUID: "dfa9a1e2-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The monitoring scope and necessary details must be defined depending on material market availability and importance for the supply chain (e.g. monitoring for deficit components might be stricter then for widely available materials). Rules for sending reminders to vendor (timing etc.) must be defined",
              Type: "Business Process",
              Scope:
                "After the PO has been sent to the vendor, it needs to be tracked. The vendor hereby sends an order acknowledgement to confirm the receipt of the PO. Furthermore, the delivery date is tracked and, in case of imported material, the estimated time of arrival (ETA) as well as the estimated time of sailing is provided by the vendor. In addition, the timely provision of quality certificate is monitored. In case of delays or missing information on the vendors side, reminders and dunning letters can be issued.",
              Outcome:
                "Purchase order status and delivery of goods, documents and additional information has been monitored.",
              name: "Monitor purchase order",
              _id: 1191,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Processing of a Purchase Order based invoice from a vendor, in order to trigger the outgoing payment process.",
              _type: "Process",
              GUID: "981573d4-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes:
                "As one of the most prominent examples of Segregation of Duty (SoD), invoice verification has to be done from a department independent from the department responsible for the purchasing. Typically, invoice verification is a department reporting to finance. Needs to be implemented.   ***In addition tolerances need to be defined in order to avoid clearing efforts for small deviations.   ***Further more rules need to be defined on how to handle invoices for partial deliveries. These rules could either effect internal procedures or external ones (e.g. allow supplier to increase quantity of next delivery to compensate for missing quantities).   ***The sequence of processing invoices compared to the goods receipt might differ from case to case. Especially for purchasing of services both sequences are common (e.g. service entry sheet). ",
              Type: "Business Process",
              Scope:
                "After the invoice has been transferred (from a scanning tool), invoice verification supports the checking for formal compliance, and whether it is consistent with the purchase order and the actually provided goods or services.",
              Outcome:
                "The invoice is posted, triggering the outgoing payment process.",
              name: "Process incoming invoice (with PO)",
              _id: 1190,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade checks ensure compliance with trade regulatory programs and cross-border customs requirements. Compliance must be ensured in all international business operations.     ",
              _type: "Process",
              GUID: "fb9de07b-7f05-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The GTS check itself is in most cases just an automated check against tables.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both the vendor and products being purchased are subject to checks.",
              Outcome:
                "The purchase order complies with the applicable trade regulations and the goods can be purchased and imported.",
              name: "Perform global trade checks for purchasing",
              _id: 1198,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists) used for screening is comprehensive and up to date.   Vendor data must be up to date.   Rules and procedures how to handle purchase orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process covers the scanning of a Purchase Order based invoice or an Expense Invoice (no PO reference).",
              _type: "Process",
              GUID: "981573d2-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the invoice is received, it is scanned and the data is captured. The data is then stored in a database for digital use and then transfered to for verification.",
              Outcome:
                "Received invoice information is transferred for verification.",
              name: "Scan incoming invoice with OCR software",
              _id: 1192,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "With procurement via vendor-managed inventory, the vendor is responsible for creating and maintaining the inventory plan, as well as monitoring stock levels and making replenishment decisions for products owned by the organization which purchases the goods. Extensive information sharing is required so that the vendor can maintain a high degree of visibility. This must be ensured either by giving the vendor access to the organizations system or providing consistent and regular information sharing with the vendor about stock levels and planned consumption.      ",
              _type: "Process",
              GUID: "fcf412ed-7f0b-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Based on information regarding stock levels and planned consumption, the vendor plans and initiates replenishment by scheduling its production/distribution. The creation of the purchase order is triggered by notification of future replenishment from the vendor.",
              Outcome:
                "Replenishment of stock is initiated and the purchasing process is triggered",
              name: "Exchange, monitor stock levels and plan replenishment",
              _id: 299,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The purchase order (PO) for VMI stock is created with information received from the vendor regarding replenishment. This PO is a formal request to the vendor for the products and initiates the official purchasing process. Information from the vendor notification is incorporated into the PO.    ",
              _type: "Process",
              GUID: "fcf412ef-7f0b-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the vendor notifies that a specified quantity of stock is needed, the PO is created based on the information provided. The PO is issued to the vendor, who then ships out the goods.",
              Outcome: "The PO for VMI stock is sent to the vendor.",
              name: "Create and issue purchase order for VMI stock",
              _id: 284,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "Examples where a VMI scenario is typically applied are: - Replenishment of tank or silo stocked inventory often triggered by automatic signals directly transmitted to the supplier - In the consumer goods industry where manufacturers maintain a strong brand and plan their own marketing campaigns - For packaging material",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2P Procurement via vendor managed inventory",
          _id: 1239,
          Business_Rules:
            "Define what information forecasts and planned marketing campaigns, production plans and production campaigns etc. should be provided to the vendor.",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "b1fea961-7f0c-11e5-0a66-001bc640cd9b",
          Description:
            "Returnable vendor packaging scenario covers the handling of returnable packaging, which was received from a vendor.  The scenario describes the returnable packaging handling option with deposit. In this case the vendor charges a deposit for the packaging units, which will be returned, when the packaging has been made available for the supplier again. The packaging still belongs to the vendor. Based on the agreement with the supplier, packaging material is sent back or the supplier gets informed that the packaging material can be picked up.",
          _type: "Scenario",
          GUID: "7278f248-ef18-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Before packaging materials can be sent back to the vendor, it is necessary to provide the vendor with information regarding the return. This includes the specific packaging units and quantity being returned as well as other conditions related to the delivery of the packaging materials.     ",
              _type: "Process",
              GUID: "ba511800-7f0c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "A document to initiate the return of packing units is compiled, specifying the quantity being returned and the proposed delivery date. The information is then sent to the vendor.",
              Outcome:
                "The vendor receives information about the return of the packaging units.",
              name: "Provide information on return of packaging units to vendor",
              _id: 279,
              Business_Rules:
                "It is necessary to define:   ***What information will be documented and sent to the vendor.   ***How the information will be communicated to the vendor.  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Processing the purchase order with returnable packaging information ensures that the cost, quantity and other conditions related to the returnable packaging material are recorded in the purchase order (PO).     ",
              _type: "Process",
              GUID: "ba511803-7f0c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "When returnable packaging is received from a vendor along with products, information about the quantity and value of the returnable packaging, as well as return conditions and the vendor to which the packaging is to be returned must be captured in the PO and forwarded for further processing.",
              Outcome:
                "Returnable packaging information is recorded in the PO.",
              name: "Process purchase order with returnable packaging",
              _id: 283,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Processing of a Purchase Order based invoice from a vendor, in order to trigger the outgoing payment process.",
              _type: "Process",
              GUID: "981573d4-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes:
                "As one of the most prominent examples of Segregation of Duty (SoD), invoice verification has to be done from a department independent from the department responsible for the purchasing. Typically, invoice verification is a department reporting to finance. Needs to be implemented.   ***In addition tolerances need to be defined in order to avoid clearing efforts for small deviations.   ***Further more rules need to be defined on how to handle invoices for partial deliveries. These rules could either effect internal procedures or external ones (e.g. allow supplier to increase quantity of next delivery to compensate for missing quantities).   ***The sequence of processing invoices compared to the goods receipt might differ from case to case. Especially for purchasing of services both sequences are common (e.g. service entry sheet). ",
              Type: "Business Process",
              Scope:
                "After the invoice has been transferred (from a scanning tool), invoice verification supports the checking for formal compliance, and whether it is consistent with the purchase order and the actually provided goods or services.",
              Outcome:
                "The invoice is posted, triggering the outgoing payment process.",
              name: "Process incoming invoice (with PO)",
              _id: 1190,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once a credit memo is received, the details must be captured and documented accordingly. Relevant details include the vendor that sent the credit memo and the reason for issuing the credit memo.   ",
              _type: "Process",
              GUID: "7b15599d-7f0c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After products or packaging have been returned to the vendor, a credit memo can be issued. When this occurs the credit memo is checked regarding whether it is formally compliant and it is checked against the original invoice. ",
              Outcome: "The credit memo is posted and processed in accounting.",
              name: "Manage incoming credit memo",
              _id: 1251,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process covers the scanning of a Purchase Order based invoice or an Expense Invoice (no PO reference).",
              _type: "Process",
              GUID: "981573d2-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the invoice is received, it is scanned and the data is captured. The data is then stored in a database for digital use and then transfered to for verification.",
              Outcome:
                "Received invoice information is transferred for verification.",
              name: "Scan incoming invoice with OCR software",
              _id: 1192,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Regarding the receipt of returnable packaging materials, it is necessary to capture the fact that the packaging units received come from a specific vendor and are now at a specific storage location of the purchasing entity.",
              _type: "Process",
              GUID: "ba511821-7f0c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the packaging material is received along with the products, details regarding what packaging has been received and where it is, is kept documented. Furthermore the packaging material is stored in an unvalued special stock. The information is forwarded for further processing.",
              Outcome:
                "Details regarding returnable packaging at the storage location is recorded. ",
              name: "Capture receipt of packaging units",
              _id: 278,
              Business_Rules:
                "It is necessary to define how and which data will be captured and stored.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When returnable packaging material sent by a vendor is at the storage location of the purchasing entity, it is necessary to track the packaging units in order to:   ***know when the packaging must be sent back to the vendor,   ***know what units are at which storage location,   ***record when packaging was received and when it was sent out.      ",
              _type: "Process",
              GUID: "95956860-7f0c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the receipt of packaging units has been captured, all relevant information concerning the packaging is collected and recorded. With this information the movement of the packaging is tracked until it is sent back to the vendor. ",
              Outcome:
                "Returnable distribution packaging is being tracked and can be located if needed.",
              name: "Track packaging units",
              _id: 295,
              Business_Rules:
                "***The decision must be made regarding what information is required for tracking.   ***It is necessary to define what movements of the packaging will be tracked e.g. only movement to/from vendor, movement between storage locations owned by the purchasing entity.   ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Before returnable packaging can be sent back to the vendor, the vendor must provide confirmation that the materials will be picked-up upon delivery on a specified date. The information is captured and processed to update the existing data pertaining to the return.   ",
              _type: "Process",
              GUID: "9595686f-7f0c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After information has been sent to the vendor regarding the return of the packaging units, the vendor acknowledges the return and confirms when and where the packaging materials will be picked-up. The information from the vendor updates the existing data on the return of the specified packaging units. This triggers the logistics process.",
              Outcome:
                "All relevant information regarding the pick-up is available and the returnable packaging can be sent to the vendor",
              name: "Receive and process returnable packaging pick-up information",
              _id: 287,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "Either the individual unit is tracked or it is just the lump sum of all units of the same packaging material type from one supplier.   Further returnable vendor packaging scenarios are rental and sales. In the rental scenario the vendor charges a periodical fee for the use of packaging units. In sales scenarios, the value of packaging units is invoiced at their receipt. However, if the units are later returned to the vendor, the charged amount may be returned.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2P Returnable vendor packaging",
          _id: 1238,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "cff07ff1-7f04-11e5-0a66-001bc640cd9b",
          Description:
            "Procurement of indirect materials refer to the purchase of items, which are not intended for direct use in manufacturing or as trading goods (direct materials), but instead will be consumed by the organization. The costs are allocated immediately to the related cost object such as a cost center, an internal order, or a project.  Procurement of inventory managed indirect materials describe the case, where a higher quantity of consumables are purchased and not immediately transferred to the requestor, but are placed into a warehouse and consumed over a period of time.  This scenario can be applied for purchases of office supplies, IT equipment (if not an asset), or for maintenance materials and spare parts.",
          _type: "Scenario",
          GUID: "22a313b0-ef12-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "This process covers the scanning of a Purchase Order based invoice or an Expense Invoice (no PO reference).",
              _type: "Process",
              GUID: "981573d2-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the invoice is received, it is scanned and the data is captured. The data is then stored in a database for digital use and then transfered to for verification.",
              Outcome:
                "Received invoice information is transferred for verification.",
              name: "Scan incoming invoice with OCR software",
              _id: 1192,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In inventory managed consumables procurement scenario, the procurement process is triggered by planning instead of acting on an actual, individual request. Parameters used in the material requirement planning (MRP) and resulting in purchase requisitions must be reviewed regularly to ensure their relevance to current situation and avoid unnecessary purchases.",
              _type: "Process",
              GUID: "dac2e2bc-7f04-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Parameters used in MRP for calculating purchasing requirements are reviewed and updated. Such parameters could include minimal stock levels, replenishment time, minimal order size. Review should also answer the question if consumables under question are still required and their planned purchasing should be continued.",
              Outcome: "Parameters used in MRP are up-to-date.",
              name: "Review material requirement parameters",
              _id: 406,
              Business_Rules:
                "In order to ensure consistency of all relevant planning parameters and logistics data, it is recommended to define standardized types of materials/products and to set rules how to classify and periodically verify those.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "An official purchase order (PO) has to be created from a purchase requisition (PR) to be able to order materials and services.       ",
              _type: "Process",
              GUID: "de59c987-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                " ***set-up of possible conversions must be defined. Conversion options are single, multiple or partial ***purchasing strategies for vendors need to be considered (e.g. fair share, contingents)  ***special agreements with vendors need to be considered (e.g. FTL/FCL only, min/max quantities, multiple products to be bundled) ",
              Type: "Business Process",
              Scope:
                "The PO is created with reference to a specific PR. Additional data not provided within the PR has to be maintained.",
              Outcome: "A PO is generated.",
              name: "Convert purchase requisition to purchase order",
              _id: 1193,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Monitoring purchase order (PO) for indirect materials ensures - through communication with the vendor - that the correct material is sent and can be/is delivered on time, and in full quantity.   ",
              _type: "Process",
              GUID: "bdc1eaff-7f03-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the PO has been sent to the vendor, it needs to be tracked. The vendor hereby sends an order acknowledgement to confirm the receipt of the PO. Furthermore, the delivery date is tracked and, in case of imported material, the estimated time of arrival (ETA) as well as the estimated time of sailing is provided by the vendor. In comparison to monitoring PO for direct materials the timely receipt of purchased materials by consumable procurement is less strictly monitored by the purchasing department, therefore overdue deliveries are possible. In this case information regarding the delays needs to be received from vendor and delivery information updated.",
              Outcome:
                "Order acknowledgement and details on import status, delivery date and confirmed quantity.",
              name: "Monitor purchase order for indirect materials",
              _id: 1220,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Material requirements planning (MRP) helps to ensure the availability of all materials (raw materials, semifinished goods) required for production or other use in the right quantity and on time.",
              _type: "Process",
              GUID: "817029ee-7eff-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Material requirements planning (MRP) requires bills of materials and material lead times to be defined and correctly maintained. The MRP schedule must be defined regularly.   There are many different MRP strategies available for planning driven and consumption driven material approaches.   The identified materials requirement can be the triggering event for this process. Other triggering events can be: ***Production order created ***Independent demand revised and updated ***Rework production order created ***Refilling/Re-packaging process order created ***Campaign scheduling completed ***Dependent demand revised and updated",
              Type: "Business Process",
              Scope:
                "In stepwise production scheduling procedure after defining finished product demand for the planning period, material requirements planning must be performed to compare demand with current stocks and planned manufacturing, identify final products to be manufactured, analyze, what materials, in what quantity and when are required for the manufacturing and propose production and purchasing schedule (material requirements planning assumes infinite production capacity).",
              Outcome:
                "As a result of material requirements planning, the recommended production schedule is created together with planned orders. In parallel, a recommended purchasing schedule for materials required for production but not available on stock is needed.",
              name: "Perform and evaluate material requirements planning",
              _id: 1228,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Processing of a Purchase Order based invoice from a vendor, in order to trigger the outgoing payment process.",
              _type: "Process",
              GUID: "981573d4-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes:
                "As one of the most prominent examples of Segregation of Duty (SoD), invoice verification has to be done from a department independent from the department responsible for the purchasing. Typically, invoice verification is a department reporting to finance. Needs to be implemented.   ***In addition tolerances need to be defined in order to avoid clearing efforts for small deviations.   ***Further more rules need to be defined on how to handle invoices for partial deliveries. These rules could either effect internal procedures or external ones (e.g. allow supplier to increase quantity of next delivery to compensate for missing quantities).   ***The sequence of processing invoices compared to the goods receipt might differ from case to case. Especially for purchasing of services both sequences are common (e.g. service entry sheet). ",
              Type: "Business Process",
              Scope:
                "After the invoice has been transferred (from a scanning tool), invoice verification supports the checking for formal compliance, and whether it is consistent with the purchase order and the actually provided goods or services.",
              Outcome:
                "The invoice is posted, triggering the outgoing payment process.",
              name: "Process incoming invoice (with PO)",
              _id: 1190,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once issued to vendor the purchase order represents a firm commitment. Therefore, it must be approved before the issue and then transferred to vendor.       ",
              _type: "Process",
              GUID: "de59c972-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Before committing to the actual purchase of materials or services, an authorised person does a final check if the purchase order is correct and approves it. The PO will then be sent to the vendor.",
              Outcome: "The purchase order is issued.",
              name: "Approve and issue purchase order",
              _id: 1189,
              Business_Rules: "Approval rules and limits have to be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade checks ensure compliance with trade regulatory programs and cross-border customs requirements. Compliance must be ensured in all international business operations.     ",
              _type: "Process",
              GUID: "fb9de07b-7f05-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The GTS check itself is in most cases just an automated check against tables.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both the vendor and products being purchased are subject to checks.",
              Outcome:
                "The purchase order complies with the applicable trade regulations and the goods can be purchased and imported.",
              name: "Perform global trade checks for purchasing",
              _id: 1198,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists) used for screening is comprehensive and up to date.   Vendor data must be up to date.   Rules and procedures how to handle purchase orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2P Procurement of indirect materials (inventory managed)",
          _id: 1237,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "70e38b41-7f06-11e5-0a66-001bc640cd9b",
          Description:
            "Procurement of standard services scenario covers the process flow required to obtain services provided by an external party.  The services and their suppliers are pre-defined and typically repeatedly performed. Therefore no specific approval of purchase requisitions is foreseen in this model.  This scenario is applied for procurement of repetitive external services necessary for the companys operations. Business process outsourcing is not in the scope of this scenario.",
          _type: "Scenario",
          GUID: "7278f228-ef18-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "This process covers the scanning of a Purchase Order based invoice or an Expense Invoice (no PO reference).",
              _type: "Process",
              GUID: "981573d2-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the invoice is received, it is scanned and the data is captured. The data is then stored in a database for digital use and then transfered to for verification.",
              Outcome:
                "Received invoice information is transferred for verification.",
              name: "Scan incoming invoice with OCR software",
              _id: 1192,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Receipt confirmation takes place after service has been performed and is used to record the service performance fact and initiate billing process on vendor side and payment process on service recipient side. ",
              _type: "Process",
              GUID: "529c6284-7f06-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Depending on the nature of the service and the organizational set-up different variations who actually captures the service delivery via the service entry sheet and who confirms it finally can be established.",
              Type: "Business Process",
              Scope:
                "Vendor provides a confirmation once the service has been performed. This serves as a trigger for recording the service fulfillment, which is done via service entry sheet. Once service fulfillment is recorded, it must be confirmed by the requestor, if the service has actually been performed, as well as if it complies with agreed requirements on time, cost and quality. If requestor confirms the service, billing and payment process can be initiated. ",
              Outcome:
                "Service is confirmed, billing and payment can be initiated.",
              name: "Confirm service receipt",
              _id: 1236,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "An official purchase order (PO) has to be created from a purchase requisition (PR) to be able to order materials and services.       ",
              _type: "Process",
              GUID: "de59c987-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                " ***set-up of possible conversions must be defined. Conversion options are single, multiple or partial ***purchasing strategies for vendors need to be considered (e.g. fair share, contingents)  ***special agreements with vendors need to be considered (e.g. FTL/FCL only, min/max quantities, multiple products to be bundled) ",
              Type: "Business Process",
              Scope:
                "The PO is created with reference to a specific PR. Additional data not provided within the PR has to be maintained.",
              Outcome: "A PO is generated.",
              name: "Convert purchase requisition to purchase order",
              _id: 1193,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The purchase requisition (PR) for services is a notification that informs the purchasing department that additional services, e.g. for a specific project, are required.",
              _type: "Process",
              GUID: "529c6282-7f06-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "It must be determined where external resources are needed and what availability is required to perform the service. The requisition is triggered by the user department. The PR for services can contain a set of service specifications with details of the necessary service or group of services. It can also be very basic with a superficial provision for unplanned services. This can be the case for hiring external employees. In this case, the extent and the precise nature of the service are not fully determined yet.",
              Outcome:
                "The PR includes all required information:   ***specific value (max. price)   ***services with certain skills   ***time frame   ***reason, stating why a service needs to be purchased  ",
              name: "Create purchase requisition for standard services",
              _id: 1235,
              Business_Rules:
                "The reasons, stating why purchasing a service is necessary to achieve a certain task, must be clearly defined.   ***How are the services purchased e.g. via a bidders platform?   ***What if the price of the service exceeds the budget e.g. of a project?   ***How is the internal hiring process started?   ***How is the bid procedure performed?   ***How were the quotations compared?  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade checks ensure compliance with trade regulatory programs and cross-border customs requirements. Compliance must be ensured in all international business operations.     ",
              _type: "Process",
              GUID: "fb9de07b-7f05-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The GTS check itself is in most cases just an automated check against tables.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both the vendor and products being purchased are subject to checks.",
              Outcome:
                "The purchase order complies with the applicable trade regulations and the goods can be purchased and imported.",
              name: "Perform global trade checks for purchasing",
              _id: 1198,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists) used for screening is comprehensive and up to date.   Vendor data must be up to date.   Rules and procedures how to handle purchase orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Processing of a Purchase Order based invoice from a vendor, in order to trigger the outgoing payment process.",
              _type: "Process",
              GUID: "981573d4-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes:
                "As one of the most prominent examples of Segregation of Duty (SoD), invoice verification has to be done from a department independent from the department responsible for the purchasing. Typically, invoice verification is a department reporting to finance. Needs to be implemented.   ***In addition tolerances need to be defined in order to avoid clearing efforts for small deviations.   ***Further more rules need to be defined on how to handle invoices for partial deliveries. These rules could either effect internal procedures or external ones (e.g. allow supplier to increase quantity of next delivery to compensate for missing quantities).   ***The sequence of processing invoices compared to the goods receipt might differ from case to case. Especially for purchasing of services both sequences are common (e.g. service entry sheet). ",
              Type: "Business Process",
              Scope:
                "After the invoice has been transferred (from a scanning tool), invoice verification supports the checking for formal compliance, and whether it is consistent with the purchase order and the actually provided goods or services.",
              Outcome:
                "The invoice is posted, triggering the outgoing payment process.",
              name: "Process incoming invoice (with PO)",
              _id: 1190,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Monitoring purchase order (PO) for services ensures - through communication with the vendor - that the correct service will be performed on time.        ",
              _type: "Process",
              GUID: "94eda4a0-83f0-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the PO has been sent to the vendor, it needs to be tracked. The vendor hereby sends an order acknowledgement to confirm the receipt of the PO. The service provider may provide additional data or inform about changes at any time. ",
              Outcome: "Order acknowledgement received.",
              name: "Monitor purchase order for services",
              _id: 1234,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once issued to vendor the purchase order represents a firm commitment. Therefore, it must be approved before the issue and then transferred to vendor.       ",
              _type: "Process",
              GUID: "de59c972-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Before committing to the actual purchase of materials or services, an authorised person does a final check if the purchase order is correct and approves it. The PO will then be sent to the vendor.",
              Outcome: "The purchase order is issued.",
              name: "Approve and issue purchase order",
              _id: 1189,
              Business_Rules: "Approval rules and limits have to be defined.",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2P Procurement of standard services",
          _id: 1233,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "79e06ee1-7eff-11e5-0a66-001bc640cd9b",
          Description:
            "The intercompany replenishment scenario describes a collaborative relationship between a receiving and supplying entities of the same organization, which aims at ensuring consistent supply of materials required for production or sale to customers. In this scenario after evaluating material requirements the receiving entity creates a stock transport order. Based on this order the supplying entity creates an outbound delivery and performs goods issue.  In the intercompany replenishment scenario both entities belong to the same organization but to different legal entities, therefore creation of invoices and settlement intercompany balances is required.",
          _type: "Scenario",
          GUID: "7278f242-ef18-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "For intercompany transactions, this process ensures that billing information is received by the delivering entity and the financial obligation related to the transaction is settled.      ",
              _type: "Process",
              GUID: "6166270a-7e56-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the goods have been delivered and invoice received, payment is made to the delivering entity and recording in accounting.",
              Outcome:
                "Amount in the intercompany invoice is paid and documented accordingly.",
              name: "Receive intercompany invoice",
              _id: 1232,
              Business_Rules:
                "It is necessary to define: - General payment terms and condition for intercompany invoicing, - Relations between the selling and shipping operating units in view of intercompany transaction flows.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When entities from the same corporate group are involved in a business transaction (e.g. intercompany purchasing), intercompany billing is required.  ",
              _type: "Process",
              GUID: "837a78be-7eff-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The intercompany invoice must be captured and documented accordingly in the accounting system. The invoice is mapped to business transactions performed in purchasing.",
              Outcome:
                "Incoming intercompany invoice is recorded and forwarded for payment.",
              name: "Manage incoming intercompany invoice",
              _id: 1231,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In a cross-company replenishment scenario, no purchase orders are used. Instead a stock transport order (STO) is used to depict the fact that goods delivery is expected from another legal entity of the group.     ",
              _type: "Process",
              GUID: "fbef921c-e8d4-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "An STO is created (converted from an STR), which documents the fact that materials will be received from a cross-company vendor. The kind and quantity of materials to be transferred and received are specified in the transport order, as well as the specified storage location and the point in time for planned goods receipt. Pricing follows the same logic as for purchasing from external vendors.",
              Outcome:
                "An STO is created triggering and documenting the expected inventory transfer.",
              name: "Create stock transport order",
              _id: 1230,
              Business_Rules:
                "Approval requirements for stock transfer orders need to be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The creation of an intercompany invoice initiates the payment process for a transaction between two entities from the same corporate group.       ",
              _type: "Process",
              GUID: "53da3f54-e8c9-11e4-0a66-001bc640cd9b",
              Advisory_Notes:
                "Typically there are special calculation rules to determine the profit margin in intercompany transactions.",
              Type: "Business Process",
              Scope:
                "The intercompany invoice, with which the supplier entity bills the selling or receiving entity, is created. In the case of a direct delivery to a customer, this happens automatically at the same time when the customer invoice is created. The required accounting entries are created using information from this invoice.",
              Outcome: "Intercompany invoice is created and issued. ",
              name: "Create intercompany invoice",
              _id: 1229,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Material requirements planning (MRP) helps to ensure the availability of all materials (raw materials, semifinished goods) required for production or other use in the right quantity and on time.",
              _type: "Process",
              GUID: "817029ee-7eff-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Material requirements planning (MRP) requires bills of materials and material lead times to be defined and correctly maintained. The MRP schedule must be defined regularly.   There are many different MRP strategies available for planning driven and consumption driven material approaches.   The identified materials requirement can be the triggering event for this process. Other triggering events can be: ***Production order created ***Independent demand revised and updated ***Rework production order created ***Refilling/Re-packaging process order created ***Campaign scheduling completed ***Dependent demand revised and updated",
              Type: "Business Process",
              Scope:
                "In stepwise production scheduling procedure after defining finished product demand for the planning period, material requirements planning must be performed to compare demand with current stocks and planned manufacturing, identify final products to be manufactured, analyze, what materials, in what quantity and when are required for the manufacturing and propose production and purchasing schedule (material requirements planning assumes infinite production capacity).",
              Outcome:
                "As a result of material requirements planning, the recommended production schedule is created together with planned orders. In parallel, a recommended purchasing schedule for materials required for production but not available on stock is needed.",
              name: "Perform and evaluate material requirements planning",
              _id: 1228,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The Available-to-Promise (ATP) check verifies, whether the required quantity of material will be available at the required date. ",
              _type: "Process",
              GUID: "817029f4-7eff-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "In order to verify the material availability for replenishments across plants, a global availability check has to be established.",
              Type: "Business Process",
              Scope:
                "After the stock transport order is created, it must be checked if the order can be fulfilled (requested material is available in the requested quantity and on the desired date).  ",
              Outcome: "ATP check is performed.",
              name: "Check availability to promise for stock transfer",
              _id: 1227,
              Business_Rules:
                "Rules how to manage and distribute available materials to different requesting plants and legal entities have to be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Replenishment scenarios are based on a set of agreements between the individual legal entities of a group, which are reflected in the supply chain set-up and related master data. The processing of the stock requisition (STR) for replenishment involves taking information on material requirements and mapping them to a predefined supplying entity. This forms the basis for delivery scheduling.",
              _type: "Process",
              GUID: "81702a09-7eff-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "When the PR is received, the purchasing department records the required amount of materials based on planning data and records which predefined group vendor will supply the materials. The STR is then reviewed and approved accordingly. ",
              Outcome:
                "The STR is approved and forwarded for further processing. ",
              name: "Process stock transport requisition",
              _id: 1226,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "SAP provides several scenarios for transfer of material from one plant to another: - Stock Transfer Between Plants in One Step, - Stock Transfer Between Plants in Two Steps, - Stock Transport Order Without Delivery, - Stock Transport Order with Delivery via Shipping, - Stock Transport Order with Delivery and Billing Document/Invoice Choice between the scenarios depends on physical distance between receiving and supplying plants, transparency requirements for goods in transit, supporting documentation requirements, legal structure of the organization.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2P Intercompany replenishment",
          _id: 1225,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "4fd4efe1-7f04-11e5-0a66-001bc640cd9b",
          Description:
            "This scenario describes the flow in case the purchased indirect materials are directly transferred to the requestor after receipt and consumption is posted.  Typically this scenario is applied for purchasing of any product that is either for a specific purpose (e.g. for a project) or for office supplies and equipment that is not intended to be kept on stock.",
          _type: "Scenario",
          GUID: "7278f220-ef18-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade checks ensure compliance with trade regulatory programs and cross-border customs requirements. Compliance must be ensured in all international business operations.     ",
              _type: "Process",
              GUID: "fb9de07b-7f05-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The GTS check itself is in most cases just an automated check against tables.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both the vendor and products being purchased are subject to checks.",
              Outcome:
                "The purchase order complies with the applicable trade regulations and the goods can be purchased and imported.",
              name: "Perform global trade checks for purchasing",
              _id: 1198,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists) used for screening is comprehensive and up to date.   Vendor data must be up to date.   Rules and procedures how to handle purchase orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A purchase order is an external document and issued by a procuring organization to a supplier indicating types, quantities, and agreed prices for products or services.    In procurement via catalogue scenario all items available for purchasing and included into catalogue are controlled by procurement. Therefore no separate approval of purchase order at a later stage is required. Nevertheless purchase order must be checked before the issue on absence of trade compliance blocks.",
              _type: "Process",
              GUID: "7d8dc859-e8c6-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After global trade checks have been performed for a particular purchase order, it is checked if any blocks have been set and the purchase order is issued to vendor.",
              Outcome: "Purchase order is issued.",
              name: "Issue purchase order",
              _id: 1217,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Processing of a Purchase Order based invoice from a vendor, in order to trigger the outgoing payment process.",
              _type: "Process",
              GUID: "981573d4-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes:
                "As one of the most prominent examples of Segregation of Duty (SoD), invoice verification has to be done from a department independent from the department responsible for the purchasing. Typically, invoice verification is a department reporting to finance. Needs to be implemented.   ***In addition tolerances need to be defined in order to avoid clearing efforts for small deviations.   ***Further more rules need to be defined on how to handle invoices for partial deliveries. These rules could either effect internal procedures or external ones (e.g. allow supplier to increase quantity of next delivery to compensate for missing quantities).   ***The sequence of processing invoices compared to the goods receipt might differ from case to case. Especially for purchasing of services both sequences are common (e.g. service entry sheet). ",
              Type: "Business Process",
              Scope:
                "After the invoice has been transferred (from a scanning tool), invoice verification supports the checking for formal compliance, and whether it is consistent with the purchase order and the actually provided goods or services.",
              Outcome:
                "The invoice is posted, triggering the outgoing payment process.",
              name: "Process incoming invoice (with PO)",
              _id: 1190,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process covers the scanning of a Purchase Order based invoice or an Expense Invoice (no PO reference).",
              _type: "Process",
              GUID: "981573d2-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the invoice is received, it is scanned and the data is captured. The data is then stored in a database for digital use and then transfered to for verification.",
              Outcome:
                "Received invoice information is transferred for verification.",
              name: "Scan incoming invoice with OCR software",
              _id: 1192,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Since directly consumable materials are not stock-managed, upon receipt they are forwarded to the cost center or receiver which is responsible for the original request.      ",
              _type: "Process",
              GUID: "bdcb60d1-7f03-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the directly consumable materials are delivered to the requesting department, the goods are verified and confirmed regarding correct product, correct quantity, and correct cost allocation. They are then posted to consumption accounts.",
              Outcome: "GR posted to cost object.",
              name: "Manage goods receipt for directly consumable materials",
              _id: 1221,
              Business_Rules:
                "Rules and procedures should be established in order to avoid unnecessary delays which might affect timely payment and the entitlement of cash discounts.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A purchase requisition (PR) has to be created from the purchase request with additional information of the purchase. ",
              _type: "Process",
              GUID: "564ad661-7f04-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The PR can be derived from an individual demand and includes basic information of the type of indirect materials and which quantity is needed.    This could be:   ***material   ***quantity    ***delivery date   ***estimated price   ***vendor (if known)   ***procurement type (e.g. K for cost center)  ",
              Outcome:
                "A PR with the necessary details is created and ready for the approval workflow through the purchasing department.",
              name: "Create purchase requisition for indirect materials",
              _id: 292,
              Business_Rules:
                "It needs to be ensured that the information on the PR is complete and up to date. This includes for example:   ***When the PR was created   ***Why the PR is required   ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Monitoring purchase order (PO) for indirect materials ensures - through communication with the vendor - that the correct material is sent and can be/is delivered on time, and in full quantity.   ",
              _type: "Process",
              GUID: "bdc1eaff-7f03-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the PO has been sent to the vendor, it needs to be tracked. The vendor hereby sends an order acknowledgement to confirm the receipt of the PO. Furthermore, the delivery date is tracked and, in case of imported material, the estimated time of arrival (ETA) as well as the estimated time of sailing is provided by the vendor. In comparison to monitoring PO for direct materials the timely receipt of purchased materials by consumable procurement is less strictly monitored by the purchasing department, therefore overdue deliveries are possible. In this case information regarding the delays needs to be received from vendor and delivery information updated.",
              Outcome:
                "Order acknowledgement and details on import status, delivery date and confirmed quantity.",
              name: "Monitor purchase order for indirect materials",
              _id: 1220,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Before the created purchase requisition (PR) can be processed further, it needs to pass an approval workflow to ensure, that no un-necessary purchases are made.  ",
              _type: "Process",
              GUID: "564ad663-7f04-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Typically approval of a purchase requisiton involves two stages - budget approval and content approval. Budget approval confirms, that there are sufficient funds for the intended purchase and lies within responsibility of the budget owner for the requesting department. Content approval confirms the necessity of the purchase and is performed by subject matter expert (e.g. IT manager for IT related spending).",
              Outcome:
                "Purchase requisition has been approved and can be further processed by purchasing department.",
              name: "Approve purchase requisition",
              _id: 1245,
              Business_Rules:
                "To eliminate possibility of maverick spending, rules must be established regulating approvals requirements (e.g. spending exceeding set amount require a higher instance approval). To reduce unnecessary approval workload rules must be established on when which approvals are required (e.g. only spending exceeding predefined amounts require extra approval).",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "An official purchase order (PO) has to be created from a purchase requisition (PR) to be able to order materials and services.       ",
              _type: "Process",
              GUID: "de59c987-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                " ***set-up of possible conversions must be defined. Conversion options are single, multiple or partial ***purchasing strategies for vendors need to be considered (e.g. fair share, contingents)  ***special agreements with vendors need to be considered (e.g. FTL/FCL only, min/max quantities, multiple products to be bundled) ",
              Type: "Business Process",
              Scope:
                "The PO is created with reference to a specific PR. Additional data not provided within the PR has to be maintained.",
              Outcome: "A PO is generated.",
              name: "Convert purchase requisition to purchase order",
              _id: 1193,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2P Procurement of indirect materials (non-inventory managed)",
          _id: 1224,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "0ae157f1-9f15-11e8-2ddf-001bc640cd9b",
          Description:
            "The scenario of procurement via vendor owned inventory describes the process flow for handling goods, which are procured from a vendor on consignment terms (vendor consignment).  In this scenario the vendor provides materials and stocks them at the purchasers premises. The goods are owned by the vendor until they are consumed by purchaser. Consumption of materials as well as the need for a further fill-up of the stock or relevant planning data have to be communicated to the supplier. In case of latter, the scenario represents a variation of vendor managed inventory (VMI).",
          _type: "Scenario",
          GUID: "7278f232-ef18-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "The purchase order (PO) for VOI stock is created with information received from the vendor regarding replenishment. This PO is a formal request to the vendor for the products and initiates the official purchasing process. Information from the vendor notification is incorporated into the PO.",
              _type: "Process",
              GUID: "1b7433ce-9fd9-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the purchaser notifies that a specified quantity of stock is needed, the PO is created based on the information provided. The PO is issued to the vendor, who then ships out the goods.",
              Outcome:
                "The purchase order complies with the applicable trade regulations and the goods can be purchased and imported.",
              name: "Create and issue purchase order for VOI",
              _id: 289,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once a credit memo is received, the details must be captured and documented accordingly. Relevant details include the vendor that sent the credit memo and the reason for issuing the credit memo.   ",
              _type: "Process",
              GUID: "7b15599d-7f0c-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After products or packaging have been returned to the vendor, a credit memo can be issued. When this occurs the credit memo is checked regarding whether it is formally compliant and it is checked against the original invoice. ",
              Outcome: "The credit memo is posted and processed in accounting.",
              name: "Manage incoming credit memo",
              _id: 1251,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Material requirements planning (MRP) helps to ensure the availability of all materials (raw materials, semifinished goods) required for production or other use in the right quantity and on time.",
              _type: "Process",
              GUID: "817029ee-7eff-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Material requirements planning (MRP) requires bills of materials and material lead times to be defined and correctly maintained. The MRP schedule must be defined regularly.   There are many different MRP strategies available for planning driven and consumption driven material approaches.   The identified materials requirement can be the triggering event for this process. Other triggering events can be: ***Production order created ***Independent demand revised and updated ***Rework production order created ***Refilling/Re-packaging process order created ***Campaign scheduling completed ***Dependent demand revised and updated",
              Type: "Business Process",
              Scope:
                "In stepwise production scheduling procedure after defining finished product demand for the planning period, material requirements planning must be performed to compare demand with current stocks and planned manufacturing, identify final products to be manufactured, analyze, what materials, in what quantity and when are required for the manufacturing and propose production and purchasing schedule (material requirements planning assumes infinite production capacity).",
              Outcome:
                "As a result of material requirements planning, the recommended production schedule is created together with planned orders. In parallel, a recommended purchasing schedule for materials required for production but not available on stock is needed.",
              name: "Perform and evaluate material requirements planning",
              _id: 1228,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Consumption of vendor consigned inventory is recorded triggering reporting to the vendor.",
              _type: "Process",
              GUID: "1b7433e8-9fd9-11e8-2ddf-001bc640cd9b",
              Advisory_Notes:
                " ***the allocation of actually consumed qty to the different existing PO needs to be considered. It needs to be defined if vendor is defining the split or receives it as part of the consumption information.   *** the invoicing scheme needs to be aligned with the vendor (e.g. per consumption, weekly, monthly).",
              Type: "Business Process",
              Scope:
                "After the vendor owned inventory is used up, the vendor will be informed.",
              Outcome: "Vendor informed about goods consumption",
              name: "Notify supplier about goods consumption",
              _id: 298,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures that a payment to a vendor is captured, executed, and documented accordingly.       ",
              _type: "Process",
              GUID: "fb9de08d-7f05-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The methods of payment must be established taking into account country specific factors.",
              Type: "Business Process",
              Scope:
                "Manage outgoing payment involves making a payment to a vendor and posting the payment to the relevant vendor account. ",
              Outcome:
                "The outgoing payment is executed and the account vendor debited.",
              name: "Manage outgoing payment",
              _id: 1218,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade compliance ensures due diligence with trade regulatory programs and cross-border customs requirements. Global trade checks are required for all business operations.",
              _type: "Process",
              GUID: "1b684ec4-44de-11e9-2ddf-001bc640cd9b",
              Advisory_Notes:
                "The check itself is typically done automatically by the ERP system. The actual process discussion should focus on the maintenance of the relevant GTS data (including the integration of external data sources) and the handling of sales orders failing to pass the checks.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both involved business partners and products being sold or related services are subject to checks.",
              Outcome:
                "The sales order complies with the applicable trade regulations and the product can be shipped.",
              name: "Perform global trade check",
              _id: 57,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists, dual use products) used for screening is comprehensive and up to date.   Customer data must be up to date.   Rules and procedures how to handle sales orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2P Procurement via vendor owned inventory",
          _id: 1223,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "b8a26cb1-7f03-11e5-0a66-001bc640cd9b",
          Description:
            "Procurement of indirect materials via catalogue/vendor portal is an extension to the scenario procurement of directly consumable materials. In order to streamline the process, an internal catalogue system/external vendor portal is set up, which is used by the requester to select the required products and initiate the approval workflow.  The catalogue/vendor portal lists items from various suppliers. Products, prices and conditions are already negotiated and fixed.",
          _type: "Scenario",
          GUID: "7278f222-ef18-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "In this process the requestor uses an electronic catalogue system/vendor portal for placing purchasing requests. The same tool is used also for approving the placed requests.    ",
              _type: "Process",
              GUID: "bdc1eaf3-7f03-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Requestor places purchase request in an electronic catalogue system/vendor portal, which is not part of ERP. The materials included into the catalogue/vendor portal are previously defined by procurement, their terms agreed with vendors and rules control, which items are available for choice for a particular requestor. Required approval workflow is also managed through the catalogue system/vendor portal.",
              Outcome:
                "Purchase request is placed in the catalogue/vendor portal and approved.",
              name: "Create and approve purchase request via catalogue/vendor portal",
              _id: 1222,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Since directly consumable materials are not stock-managed, upon receipt they are forwarded to the cost center or receiver which is responsible for the original request.      ",
              _type: "Process",
              GUID: "bdcb60d1-7f03-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the directly consumable materials are delivered to the requesting department, the goods are verified and confirmed regarding correct product, correct quantity, and correct cost allocation. They are then posted to consumption accounts.",
              Outcome: "GR posted to cost object.",
              name: "Manage goods receipt for directly consumable materials",
              _id: 1221,
              Business_Rules:
                "Rules and procedures should be established in order to avoid unnecessary delays which might affect timely payment and the entitlement of cash discounts.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Monitoring purchase order (PO) for indirect materials ensures - through communication with the vendor - that the correct material is sent and can be/is delivered on time, and in full quantity.   ",
              _type: "Process",
              GUID: "bdc1eaff-7f03-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the PO has been sent to the vendor, it needs to be tracked. The vendor hereby sends an order acknowledgement to confirm the receipt of the PO. Furthermore, the delivery date is tracked and, in case of imported material, the estimated time of arrival (ETA) as well as the estimated time of sailing is provided by the vendor. In comparison to monitoring PO for direct materials the timely receipt of purchased materials by consumable procurement is less strictly monitored by the purchasing department, therefore overdue deliveries are possible. In this case information regarding the delays needs to be received from vendor and delivery information updated.",
              Outcome:
                "Order acknowledgement and details on import status, delivery date and confirmed quantity.",
              name: "Monitor purchase order for indirect materials",
              _id: 1220,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Purchase requisition (PR) is created in the ERP based on data from the purchase request within the catalogue system or vendor portal.",
              _type: "Process",
              GUID: "af3b5880-514a-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "***Items need to be included into catalogue and controlled by procurement, which means, they contain all information necessary to make the purchase (vendor information, product information etc.).   ***Purchase request can be directly converted to a purchase requisition in the ERP system without any manual intervention only if catalogue content is maintained correctly.",
              Type: "Business Process",
              Scope:
                "Information from the purchase request in the catalogue system or vendor portal is transferred to the ERP system in order to create a corresponding purchase requisition (PR) there. During this process the existence of the requested materials within the ERP is checked.",
              Outcome:
                "Purchase requisition is created and can be processed in ERP.",
              name: "Convert purchase request to purchase requisition",
              _id: 1219,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade checks ensure compliance with trade regulatory programs and cross-border customs requirements. Compliance must be ensured in all international business operations.     ",
              _type: "Process",
              GUID: "fb9de07b-7f05-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The GTS check itself is in most cases just an automated check against tables.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both the vendor and products being purchased are subject to checks.",
              Outcome:
                "The purchase order complies with the applicable trade regulations and the goods can be purchased and imported.",
              name: "Perform global trade checks for purchasing",
              _id: 1198,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists) used for screening is comprehensive and up to date.   Vendor data must be up to date.   Rules and procedures how to handle purchase orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures that a payment to a vendor is captured, executed, and documented accordingly.       ",
              _type: "Process",
              GUID: "fb9de08d-7f05-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The methods of payment must be established taking into account country specific factors.",
              Type: "Business Process",
              Scope:
                "Manage outgoing payment involves making a payment to a vendor and posting the payment to the relevant vendor account. ",
              Outcome:
                "The outgoing payment is executed and the account vendor debited.",
              name: "Manage outgoing payment",
              _id: 1218,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A purchase order is an external document and issued by a procuring organization to a supplier indicating types, quantities, and agreed prices for products or services.    In procurement via catalogue scenario all items available for purchasing and included into catalogue are controlled by procurement. Therefore no separate approval of purchase order at a later stage is required. Nevertheless purchase order must be checked before the issue on absence of trade compliance blocks.",
              _type: "Process",
              GUID: "7d8dc859-e8c6-11e4-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After global trade checks have been performed for a particular purchase order, it is checked if any blocks have been set and the purchase order is issued to vendor.",
              Outcome: "Purchase order is issued.",
              name: "Issue purchase order",
              _id: 1217,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "An official purchase order (PO) has to be created from a purchase requisition (PR) to be able to order materials and services.       ",
              _type: "Process",
              GUID: "de59c987-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                " ***set-up of possible conversions must be defined. Conversion options are single, multiple or partial ***purchasing strategies for vendors need to be considered (e.g. fair share, contingents)  ***special agreements with vendors need to be considered (e.g. FTL/FCL only, min/max quantities, multiple products to be bundled) ",
              Type: "Business Process",
              Scope:
                "The PO is created with reference to a specific PR. Additional data not provided within the PR has to be maintained.",
              Outcome: "A PO is generated.",
              name: "Convert purchase requisition to purchase order",
              _id: 1193,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "With self invoicing an agreement is reached with a supplier, that he does not create invoices for delivered goods/provided services. Instead the customer himself creates an invoice for the received goods and provides it to vendor.   ",
              _type: "Process",
              GUID: "bdcb60c8-7f03-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Self-billing agreements usually last for 12 months. At the end of this period it is necessary to review the agreement to ensure existence of a proof that the agreement is still in force. It is important not to self-bill a supplier without their written agreement to do so. It is necessary to enter into a separate agreement with each vendor.",
              Type: "Business Process",
              Scope:
                "After receiving ordered goods, a self invoice is automatically created in customers system based on data in the purchase orders and goods receipts. The self invoice is posted  and sent to vendor. This allows closer control over correctness of the invoices and speeds the recognition of the liability.",
              Outcome:
                "Self invoice is created, posted and issued, liability for received goods is recorded.",
              name: "Manage self invoice",
              _id: 1216,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "Procurement catalogues/vendor portals do not just increase efficiency but also mitigate maverick buying. The streamlined process may go as far as suppliers deliver directly to the desk or at least an optimized internal distribution (fixed schedules for deliveries from a small number of suppliers) reduces effort and time. Central and also decentral (desk) stock can be avoided.  Beside the standard use for requesing specified products that have been defined by the purchasing department and category managers upfront, the workflow of the catalogue system/vendor portal is often used also for one-time requests. In this case, a text item is used. Typically, the supplier and the price are already known by the requester and are mentioned in the text of the request.   ",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2P Procurement of indirect materials via catalogue/vendor portal (self-invoicing)",
          _id: 1215,
          Business_Rules:
            "Via a proper structure of the catalogue/vendor portal tailored to different user groups (requester), it is possible to avoid unintended purchasing behavior. For example only employees working in labs will have access to the category lab materials.  By introducing category managers and integrating them into the approval workflow, additional control can be achieved. Typically this is used where some expert knowledge is required to verify the request (e.g. ICT equipment will be checked for compatibility).  Rules for the cost allocation and the respective approval have to be defined.",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "c86f9cb1-7f05-11e5-0a66-001bc640cd9b",
          Description:
            "Procurement of one-time services scenario describes obtaining external services that are not pre-defined.  The scenario is initiated by a purchase request and involves open market sourcing for possible suppliers, their evaluation and request-for-proposal process.  Typically this scenario is used for ad-hoc procurement of services or if complex services need to be procured.",
          _type: "Scenario",
          GUID: "7278f22a-ef18-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "This process covers the scanning of a Purchase Order based invoice or an Expense Invoice (no PO reference).",
              _type: "Process",
              GUID: "981573d2-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the invoice is received, it is scanned and the data is captured. The data is then stored in a database for digital use and then transfered to for verification.",
              Outcome:
                "Received invoice information is transferred for verification.",
              name: "Scan incoming invoice with OCR software",
              _id: 1192,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade checks ensure compliance with trade regulatory programs and cross-border customs requirements. Compliance must be ensured in all international business operations.     ",
              _type: "Process",
              GUID: "fb9de07b-7f05-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The GTS check itself is in most cases just an automated check against tables.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both the vendor and products being purchased are subject to checks.",
              Outcome:
                "The purchase order complies with the applicable trade regulations and the goods can be purchased and imported.",
              name: "Perform global trade checks for purchasing",
              _id: 1198,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists) used for screening is comprehensive and up to date.   Vendor data must be up to date.   Rules and procedures how to handle purchase orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Receipt confirmation takes place after service has been performed and is used to record the service performance fact and initiate billing process on vendor side and payment process on service recipient side.    ",
              _type: "Process",
              GUID: "fbfd3e97-7f05-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Vendor provides a confirmation, once the service has been performed. This serves as trigger for recording the service fulfillment by procurement. For one-time services the recording typically is done by using the goods receipt functionality of ERP system. Once service fulfillment is recorded, it must be confirmed by the requestor, if the service has actually been performed, as well as if it complies with agreed requirements on time, cost and quality. If requestor confirms the service, billing and payment process can be initiated.",
              Outcome:
                "Service is confirmed, billing and payment can be initiated.",
              name: "Confirm one-time service receipt",
              _id: 281,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Monitoring purchase order (PO) for services ensures - through communication with the vendor - that the correct service will be performed on time.        ",
              _type: "Process",
              GUID: "94eda4a0-83f0-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the PO has been sent to the vendor, it needs to be tracked. The vendor hereby sends an order acknowledgement to confirm the receipt of the PO. The service provider may provide additional data or inform about changes at any time. ",
              Outcome: "Order acknowledgement received.",
              name: "Monitor purchase order for services",
              _id: 1234,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The approval process for purchase requisition (PR) for one-time services confirms that the specific service can be purchased by the requester and performed by the identified service provider. Moreover, the duration of the service to be performed and other related terms and conditions are verified.  ",
              _type: "Process",
              GUID: "fbfd3e95-7f05-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The purchasing department verifies that the service can be purchased by the requester and that all necessary information regarding the service is recorded, including type and duration of service as well as vendor.   ",
              Outcome:
                "The PR for one-time services is ready to be converted into a purchase order (PO).",
              name: "Approve purchase requisition for one-time services",
              _id: 296,
              Business_Rules:
                "It needs to be clarified what will happen if the PR is not converted into a PO because:   ***the price for the service exceeds the budget   ***the purchase of services is not required     It is necessary to define what services a department is allowed to purchase.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "An official purchase order (PO) has to be created from a purchase requisition (PR) to be able to order materials and services.       ",
              _type: "Process",
              GUID: "de59c987-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                " ***set-up of possible conversions must be defined. Conversion options are single, multiple or partial ***purchasing strategies for vendors need to be considered (e.g. fair share, contingents)  ***special agreements with vendors need to be considered (e.g. FTL/FCL only, min/max quantities, multiple products to be bundled) ",
              Type: "Business Process",
              Scope:
                "The PO is created with reference to a specific PR. Additional data not provided within the PR has to be maintained.",
              Outcome: "A PO is generated.",
              name: "Convert purchase requisition to purchase order",
              _id: 1193,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Processing of a Purchase Order based invoice from a vendor, in order to trigger the outgoing payment process.",
              _type: "Process",
              GUID: "981573d4-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes:
                "As one of the most prominent examples of Segregation of Duty (SoD), invoice verification has to be done from a department independent from the department responsible for the purchasing. Typically, invoice verification is a department reporting to finance. Needs to be implemented.   ***In addition tolerances need to be defined in order to avoid clearing efforts for small deviations.   ***Further more rules need to be defined on how to handle invoices for partial deliveries. These rules could either effect internal procedures or external ones (e.g. allow supplier to increase quantity of next delivery to compensate for missing quantities).   ***The sequence of processing invoices compared to the goods receipt might differ from case to case. Especially for purchasing of services both sequences are common (e.g. service entry sheet). ",
              Type: "Business Process",
              Scope:
                "After the invoice has been transferred (from a scanning tool), invoice verification supports the checking for formal compliance, and whether it is consistent with the purchase order and the actually provided goods or services.",
              Outcome:
                "The invoice is posted, triggering the outgoing payment process.",
              name: "Process incoming invoice (with PO)",
              _id: 1190,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once issued to vendor the purchase order represents a firm commitment. Therefore, it must be approved before the issue and then transferred to vendor.       ",
              _type: "Process",
              GUID: "de59c972-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Before committing to the actual purchase of materials or services, an authorised person does a final check if the purchase order is correct and approves it. The PO will then be sent to the vendor.",
              Outcome: "The purchase order is issued.",
              name: "Approve and issue purchase order",
              _id: 1189,
              Business_Rules: "Approval rules and limits have to be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once terms for purchasing of one-time service have been agreed, a purchase requisition (PR) must be created to capture information about the procured service in the ERP system.   ",
              _type: "Process",
              GUID: "fbfd3e93-7f05-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Since the purchased service is not regularly purchased, its details are not contained in the ERP system and cant be included into the PR. Therefore the purchase requisition must have reference to a statement of work, previously negotiated vendor proposal or other documents stating content and terms of the service.",
              Outcome:
                "PR for services with necessary details is created and ready for the approval workflow.",
              name: "Create purchase requisition for one-time services",
              _id: 293,
              Business_Rules: "",
              Prerequisite:
                "Pre-requisites: request for proposal process has been performed if required, vendor proposal has been received, its terms negotiated and approved by purchasing department.",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2P Procurement of one-time services",
          _id: 1214,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "155c5431-7f03-11e5-0a66-001bc640cd9b",
          Description:
            "The Procurement to order with drop-shipment scenario describes the procurement of finished goods for third party sales as a drop-shipment. In this scenario procured goods are directly delivered from vendor to a customer, bypassing the organizations warehouse.  This scenario is used in combination with the O2C Sales of third party items scenario. After the customer order is placed, the ordered products are procured from a vendor, who takes over the order fulfillment and delivers the products directly to the customer. The vendor usually manages transportation of goods as well, but this can also be carried out by the organizations transportation department.",
          _type: "Scenario",
          GUID: "7278f238-ef18-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Processing of a Purchase Order based invoice from a vendor, in order to trigger the outgoing payment process.",
              _type: "Process",
              GUID: "981573d4-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes:
                "As one of the most prominent examples of Segregation of Duty (SoD), invoice verification has to be done from a department independent from the department responsible for the purchasing. Typically, invoice verification is a department reporting to finance. Needs to be implemented.   ***In addition tolerances need to be defined in order to avoid clearing efforts for small deviations.   ***Further more rules need to be defined on how to handle invoices for partial deliveries. These rules could either effect internal procedures or external ones (e.g. allow supplier to increase quantity of next delivery to compensate for missing quantities).   ***The sequence of processing invoices compared to the goods receipt might differ from case to case. Especially for purchasing of services both sequences are common (e.g. service entry sheet). ",
              Type: "Business Process",
              Scope:
                "After the invoice has been transferred (from a scanning tool), invoice verification supports the checking for formal compliance, and whether it is consistent with the purchase order and the actually provided goods or services.",
              Outcome:
                "The invoice is posted, triggering the outgoing payment process.",
              name: "Process incoming invoice (with PO)",
              _id: 1190,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process covers the scanning of a Purchase Order based invoice or an Expense Invoice (no PO reference).",
              _type: "Process",
              GUID: "981573d2-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the invoice is received, it is scanned and the data is captured. The data is then stored in a database for digital use and then transfered to for verification.",
              Outcome:
                "Received invoice information is transferred for verification.",
              name: "Scan incoming invoice with OCR software",
              _id: 1192,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once issued to vendor the purchase order represents a firm commitment. Therefore, it must be approved before the issue and then transferred to vendor.       ",
              _type: "Process",
              GUID: "de59c972-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Before committing to the actual purchase of materials or services, an authorised person does a final check if the purchase order is correct and approves it. The PO will then be sent to the vendor.",
              Outcome: "The purchase order is issued.",
              name: "Approve and issue purchase order",
              _id: 1189,
              Business_Rules: "Approval rules and limits have to be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In a third party sales scenario there is no physical inbound movement of goods or materials. Nevertheless it is necessary to acknowledge change of ownership of goods from supplier to selling entity to be able to further record the sale to the customer.      ",
              _type: "Process",
              GUID: "2bb46437-7f03-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once advanced shipping notification is received, a non-physical goods receipt is recorded, documenting assumption of the title of ownership for the goods or materials by the selling entity. The non-physical goods receipt does not initiate any changes in inventory levels.",
              Outcome: "Change of goods ownership is recorded.",
              name: "Perform non-physical goods receipt",
              _id: 1213,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade checks ensure compliance with trade regulatory programs and cross-border customs requirements. Compliance must be ensured in all international business operations.     ",
              _type: "Process",
              GUID: "fb9de07b-7f05-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The GTS check itself is in most cases just an automated check against tables.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both the vendor and products being purchased are subject to checks.",
              Outcome:
                "The purchase order complies with the applicable trade regulations and the goods can be purchased and imported.",
              name: "Perform global trade checks for purchasing",
              _id: 1198,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists) used for screening is comprehensive and up to date.   Vendor data must be up to date.   Rules and procedures how to handle purchase orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The advanced shipping notification (ASN) issued by the vendor provides information about the carrier, the amount of material, the mode of transport, and the company which executes the shipping. It also provides information about the delivery date. Most importantly it allows better material availability planning and hence more reliable confirmation to customers.",
              _type: "Process",
              GUID: "871038f2-7caa-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The following questions need to be answered:  ***Who receives the shipping information?  ***How are the documents received (EDI, Email etc.)?  ***What information is required?  ***Who communicates with the vendor?  ***Who must be made aware of the processed ASN internally?",
              Type: "Business Process",
              Scope:
                "The shipping notification is received from the vendor and forwarded to all business units involved in goods receipt e.g. warehouse management and quality management.    The ASN includes information on shipment of goods and additional information related to the shipment, such as order information, product description, physical characteristics, type of packaging, markings, carrier information, and configuration of goods within the transportation equipment.",
              Outcome:
                "Advanced shipping notification is received and distributed to involved business units and inbound delivery has been created.",
              name: "Receive and process advanced shipping notification",
              _id: 1212,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A purchase requisition (PR)  is created after a sales order has been confirmed. The purchasing department must check which vendor can supply the goods. The goods are delivered directly to the customer, therefore it is necessary to clarify the terms of delivery with the vendor.        ",
              _type: "Process",
              GUID: "78ced096-7f02-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Purchasing products directly for a sales order is used in a variety of business models. It can be a one time opportunity, a frequently applied model, or even a type of outsourced inventory in a JIT-like set-up. Therefore, the interaction between the sales department, the purchasing department, and the vendor in order to clarify availability and delivery dates might differ. In a opportunity sale, it might even be required to identify a source of supply before any commitment to the customer is given.",
              Type: "Business Process",
              Scope:
                "If not already specified by master data, the purchasing department checks vendors to determine which one can supply the products required to fulfil the order.",
              Outcome: "The PR is created.",
              name: "Process purchase requisition for sales orders",
              _id: 1188,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "An official purchase order (PO) has to be created from a purchase requisition (PR) to be able to order materials and services.       ",
              _type: "Process",
              GUID: "de59c987-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                " ***set-up of possible conversions must be defined. Conversion options are single, multiple or partial ***purchasing strategies for vendors need to be considered (e.g. fair share, contingents)  ***special agreements with vendors need to be considered (e.g. FTL/FCL only, min/max quantities, multiple products to be bundled) ",
              Type: "Business Process",
              Scope:
                "The PO is created with reference to a specific PR. Additional data not provided within the PR has to be maintained.",
              Outcome: "A PO is generated.",
              name: "Convert purchase requisition to purchase order",
              _id: 1193,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Monitoring purchase order (PO) process ensures - through communication with the vendor - that the correct material is sent and can be/is delivered on time, and in full quantity.     ",
              _type: "Process",
              GUID: "dfa9a1e2-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The monitoring scope and necessary details must be defined depending on material market availability and importance for the supply chain (e.g. monitoring for deficit components might be stricter then for widely available materials). Rules for sending reminders to vendor (timing etc.) must be defined",
              Type: "Business Process",
              Scope:
                "After the PO has been sent to the vendor, it needs to be tracked. The vendor hereby sends an order acknowledgement to confirm the receipt of the PO. Furthermore, the delivery date is tracked and, in case of imported material, the estimated time of arrival (ETA) as well as the estimated time of sailing is provided by the vendor. In addition, the timely provision of quality certificate is monitored. In case of delays or missing information on the vendors side, reminders and dunning letters can be issued.",
              Outcome:
                "Purchase order status and delivery of goods, documents and additional information has been monitored.",
              name: "Monitor purchase order",
              _id: 1191,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2P Procurement to order (drop-shipment)",
          _id: 1211,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "046c1c71-7f0b-11e5-0a66-001bc640cd9b",
          Description:
            "Procurement via contract scenario covers the procurement of goods or services from an external vendor, based on system managed contracts and with reference to them. It as well includes the monitoring and enforcement of the contract. In this scenario, all procurement terms (product, price etc.) are stipulated in a contract. Further, when the product is required, no separate sourcing or negotiation process takes place. The purchase order is issued by performing a call-off for the contract based on its terms. Monitoring of the contract is required in this scenario to ensure that agreed value or quantity is procured and the contract is renewed when required.  The scenario can be applied in combination with other procurement scenarios and is typically used to ensure permanent availability of materials or services that are important for production or other essential operations.",
          _type: "Scenario",
          GUID: "7278f24e-ef18-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "A purchase requisition (PR) acts as the trigger for the purchasing department to perform the required purchase of direct materials. Therefore, the purchasing department needs to check who can deliver the material and if the supplier can meet the necessary purchasing conditions. Often the supply network for continuously required direct materials is defined and already considered by the planning tool. Thus, the processing can be automated.              ",
              _type: "Process",
              GUID: "26aa6cf5-7f07-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Even if APO is used for supply chain planning, quite often the ERP MRP run will finally generate the PRs on a local (=plant) level. However, PRs can also be generated and transferred to the ERP by the APO.",
              Type: "Business Process",
              Scope:
                "Processing the PR checks if the purchase order can be fulfilled. Delivery conditions, payment methods, and potential suppliers who can deliver the material, are checked. Once the purchasing department has all relevant information, the conversion of the PR into a purchase order (PO) can be triggered.",
              Outcome: "The PR is ready to be converted to a PO.",
              name: "Process purchase requisition for direct materials",
              _id: 1210,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade checks ensure compliance with trade regulatory programs and cross-border customs requirements. Compliance must be ensured in all international business operations.     ",
              _type: "Process",
              GUID: "fb9de07b-7f05-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The GTS check itself is in most cases just an automated check against tables.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both the vendor and products being purchased are subject to checks.",
              Outcome:
                "The purchase order complies with the applicable trade regulations and the goods can be purchased and imported.",
              name: "Perform global trade checks for purchasing",
              _id: 1198,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists) used for screening is comprehensive and up to date.   Vendor data must be up to date.   Rules and procedures how to handle purchase orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Monitoring the vendor contract ensures that the supplier is meeting the performance criteria stated in the contractual agreement. It involves measuring, analysing and managing the suppliers ability to comply with the contractual obligations as well as keeping track of own commitments. ",
              _type: "Process",
              GUID: "2164f38b-7f0b-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Consulting the order, it is checked whether the supplier is compliant with the contract. This includes confirming on timely delivery of goods that conform to specifications, as well as measuring performance against other contract requirements over time.",
              Outcome:
                "Up-to-date information regarding the suppliers performance is available.",
              name: "Monitor vendor contract",
              _id: 1209,
              Business_Rules:
                "It is necessary to define:   ***What will be measured   ***Criteria for measuring performance e.g. service levels and quality, written down in the contract ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process ensures that any obligation from both parties are met and financially settled. This is executed periodically or at expiration of the contract.",
              _type: "Process",
              GUID: "31d74f14-7f0b-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Settling the contract may lead to a debit or credit note. Follow-up contracts might be negotiated.",
              Type: "Business Process",
              Scope:
                "Actual business transactions are evaluated against the contractually agreed conditions. Financial obligations are documented and settled.",
              Outcome: "Contract settled.",
              name: "Settle contract",
              _id: 1208,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When creating the purchase order (PO) for purchases based on a contractual agreement with the supplier, the agreed terms, conditions and prices stated in the supplier contract are applied to the order.      ",
              _type: "Process",
              GUID: "2164f397-7f0b-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The PO is created with information from the purchase requisition as well as details regarding the terms and conditions specified in the supplier contract. The PO is then forwarded for approval.",
              Outcome:
                "A PO is generated. This is an official document that - once it has been approved - can be forwarded to the supplier.",
              name: "Convert purchase requisition for contract into purchase order",
              _id: 1207,
              Business_Rules:
                "The set-up of possible conversions must be defined.    Conversion options are:   ***single   ***multiple   ***partial  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Before purchasing goods under a contractual agreement with the supplier, it is necessary to define the conditions and set the terms under which the goods will be provided. The purchasing department must understand exactly what products (e.g. goods or services) need to be purchased and in what quantity, as well as select the supplier and prepare the contracting details with the supplier.      ",
              _type: "Process",
              GUID: "ec357bb3-7e11-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Typically at the end of the negotiations the  vendor master data and other master data is initiated if  required.",
              Type: "Business Process",
              Scope:
                "Based on the products and quantity that needs to be purchased, a suitable supplier is selected. Specific terms and conditions related to the purchase are negotiated and a contract document prepared.",
              Outcome: "The contract with the supplier is approved.",
              name: "Perform contracting",
              _id: 1206,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Processing of a Purchase Order based invoice from a vendor, in order to trigger the outgoing payment process.",
              _type: "Process",
              GUID: "981573d4-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes:
                "As one of the most prominent examples of Segregation of Duty (SoD), invoice verification has to be done from a department independent from the department responsible for the purchasing. Typically, invoice verification is a department reporting to finance. Needs to be implemented.   ***In addition tolerances need to be defined in order to avoid clearing efforts for small deviations.   ***Further more rules need to be defined on how to handle invoices for partial deliveries. These rules could either effect internal procedures or external ones (e.g. allow supplier to increase quantity of next delivery to compensate for missing quantities).   ***The sequence of processing invoices compared to the goods receipt might differ from case to case. Especially for purchasing of services both sequences are common (e.g. service entry sheet). ",
              Type: "Business Process",
              Scope:
                "After the invoice has been transferred (from a scanning tool), invoice verification supports the checking for formal compliance, and whether it is consistent with the purchase order and the actually provided goods or services.",
              Outcome:
                "The invoice is posted, triggering the outgoing payment process.",
              name: "Process incoming invoice (with PO)",
              _id: 1190,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In this process supplier and customer negotiate and agree the terms and conditions of their anticipated relationship.  The negotiation can be based on the previous exchange of RFP/RFQ and the related responses.",
              _type: "Process",
              GUID: "ec357bad-7e11-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Align and agree scope of services, negotiate and agree contract terms.",
              Outcome: "Agreement ready for contracting.",
              name: "Perform vendor negotiations",
              _id: 1205,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once issued to vendor the purchase order represents a firm commitment. Therefore, it must be approved before the issue and then transferred to vendor.       ",
              _type: "Process",
              GUID: "de59c972-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Before committing to the actual purchase of materials or services, an authorised person does a final check if the purchase order is correct and approves it. The PO will then be sent to the vendor.",
              Outcome: "The purchase order is issued.",
              name: "Approve and issue purchase order",
              _id: 1189,
              Business_Rules: "Approval rules and limits have to be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Requirements for externally source materials are evaluated considering all relevant demand elements.",
              _type: "Process",
              GUID: "279a79cf-99bb-11e9-0cfc-001bc641ce4f",
              Advisory_Notes:
                " *** In SAP environments typically the MRP run is used as functionality to calculate the final requirements per material and create the corresponding purchase requisitions.  ***Often (not always!) you will find separate MRP calculation setups for externally sourced materials compared to the own produced materials. Difference can be found for example in frequency of the calculation and also in the scope of demand elements taken into account.  ***If requirements for externally source materials are calculated with a different logic it is still absolutely essential to consider the overall sequence of MRP calculations in combination with calculations of own-produced materials and those of across other plants in the supply network.",
              Type: "Business Process",
              Scope:
                "In order to evaluate the material requirements the demands from production (esp. components), from customer orders or intercompany replenishments (esp. trading goods), as well as stock replenishments and planned procurment quantities need to be considered and combined. Based on this comprehensive information the purchase requisitions are created.",
              Outcome:
                "Purchase requisitions for externally sourced materials have been created according to the overall demand situation.",
              name: "Evaluate material requirements for procurement",
              _id: 1204,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process covers the scanning of a Purchase Order based invoice or an Expense Invoice (no PO reference).",
              _type: "Process",
              GUID: "981573d2-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the invoice is received, it is scanned and the data is captured. The data is then stored in a database for digital use and then transfered to for verification.",
              Outcome:
                "Received invoice information is transferred for verification.",
              name: "Scan incoming invoice with OCR software",
              _id: 1192,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Monitoring purchase order (PO) process ensures - through communication with the vendor - that the correct material is sent and can be/is delivered on time, and in full quantity.     ",
              _type: "Process",
              GUID: "dfa9a1e2-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The monitoring scope and necessary details must be defined depending on material market availability and importance for the supply chain (e.g. monitoring for deficit components might be stricter then for widely available materials). Rules for sending reminders to vendor (timing etc.) must be defined",
              Type: "Business Process",
              Scope:
                "After the PO has been sent to the vendor, it needs to be tracked. The vendor hereby sends an order acknowledgement to confirm the receipt of the PO. Furthermore, the delivery date is tracked and, in case of imported material, the estimated time of arrival (ETA) as well as the estimated time of sailing is provided by the vendor. In addition, the timely provision of quality certificate is monitored. In case of delays or missing information on the vendors side, reminders and dunning letters can be issued.",
              Outcome:
                "Purchase order status and delivery of goods, documents and additional information has been monitored.",
              name: "Monitor purchase order",
              _id: 1191,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Receiving information about a supplier contract and capturing it for further processing are key first steps in purchasing processes which are based on the contractual agreement with a supplier.        ",
              _type: "Process",
              GUID: "ec357bcb-7e11-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Not all vendor contracts need to be captured in SAP. Often, only details such as prices or rebates will be reflected in the purchasing master data.   Only if special treatment of contracts within SAP is required, the contracts have to be captured as such in SAP. This is basically the case for scheduling agreements and for more complex rebate agreements.",
              Type: "Business Process",
              Scope:
                "Details regarding contracts with a supplier are  recorded, stored and forwarded for further processing. The information can include the type of products, the quantity and the agreed price, as well as other terms and condition related the purchase. ",
              Outcome:
                "All relevant information regarding the contract with the supplier is stored.",
              name: "Capture vendor contract",
              _id: 1203,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2P Procurement via contract",
          _id: 1202,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "e73c6801-9f17-11e8-2ddf-001bc640cd9b",
          Description:
            "Procurement via SAP Ariba scenario describes procurement activities where the SAP Ariba network is used to purchase goods.  Use of the SAP Ariba network outsources the integration with the vendors system and facilitates all transactions and document exchanges. ",
          _type: "Scenario",
          GUID: "7278f22e-ef18-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "An official purchase order (PO) has to be created from a purchase requisition (PR) to be able to order materials. It is a formal request or instruction from a purchasing organization to a vendor to supply or provide a certain quantity of materials at or by a certain point in time",
              _type: "Process",
              GUID: "31aa9d59-b9cd-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Upon approval of a PR, a PO is created based on it. An automated notification on the creation of the PO in SAP Ariba is then sent to the S4/HANA system. Based on this message the PO is also created in the ERP system and a PO number is generated. This information is sent back to Ariba where the PO number is added to the document in Ariba. The updated PO is ready to be issued to the supplier via the Ariba network. ",
              Outcome: "The PO is issued. ",
              name: "Create purchase order (Ariba)",
              _id: 294,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A goods receipt (GR) is the physical inbound movement of goods or materials into the warehouse. It is a goods movement that is used to post goods received from external vendors or from in-plant production.",
              _type: "Process",
              GUID: "31aa9d5b-b9cd-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Once the purchased materials are delivered to the requesting department a GR is created in Ariba and a notification on it is sent to the supplier and also to the own ERP system. After verification and check of the materials for correct type/product, correct quantity, and correct cost allocation and triggering any necessary put-away actions, the GR is confirmed. The confirmation is then transferred back to Ariba. ",
              Outcome: "GR is confirmed. ",
              name: "Create goods receipt (Ariba)",
              _id: 337,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The invoice issued by the supplier gets processed and posted.   If goods-receipt-based invoice verification has been defined for a purchase order item, the system compares the supplier invoice data with the related goods receipt data. If the deviation is outside defined tolerances, the invoice is posted, but the invoice is automatically blocked for payment. Blocked invoices can be released and therefore enable the payment process.",
              _type: "Process",
              GUID: "4dc445b3-b9d2-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The supplier invoice is transferred via the Ariba network. The invoice includes the S4/HANA PO reference.  If required, a check of the invoice and release of blocked invoices can be performed. ",
              Outcome:
                "The invoice is posted, triggering the outgoing payment process.",
              name: "Process supplier invoice (Ariba)",
              _id: 515,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "After a demand for materials is identified, a purchase requisition (PR) is created to capture the details of the demand. The PR is an internal document and its details include e.g. the quantity and timeframe for the required material.  The approved PR then is the trigger for the procurement department to perform the purchase of the required goods.              ",
              _type: "Process",
              GUID: "31aa9d57-b9cd-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "The creation of a PR takes place in SAP Ariba. After submitting the the PR for approval, an automated transfer of the document will be send to SAP S4/HANA and therefore be created also in the ERP system with status In Release. Simultaneously, the approver can check if all relevant information is included in the PR and approve the document.  In S4/HANA, all information and progress of the PR can be monitored at any point in time.",
              Outcome: "The approved PR is ready to be converted into a PO. ",
              name: "Create and approve purchase requisition (Ariba)",
              _id: 288,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "By using the Ariba network all documents required are exchanged electronically. These documents can be: ***Purchase requisition  ***Purchase order ***Order confirmation ***Advanced shipping notification ***Goods receipt ***Invoice",
              _type: "Process",
              GUID: "a30b1b18-972c-11e9-0cfc-001bc641ce4f",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the supplier receives the PO via the Ariba network, the order confirmation can be created, if required. The confirmation data is transferred to the procuring organization and the PO is updated.  To inform the procuring organization about  a pending delivery and details on e.g. the schedule and physical characteristics of the shipment, the supplier creates an Advanced Shipping Notification (ASN). Also the ASN details are exchanged via the Ariba network and the the PO is updated accordingly.  At any time, the procuring company is able to monitor the suppliers updates via the the network. ",
              Outcome:
                "PO is enriched with order confirmation data and ASN details. ",
              name: "Exchange electronic documents via Ariba network",
              _id: 291,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Monitoring purchase order (PO) process ensures - through communication with the vendor - that the correct material is sent and can be/is delivered on time, and in full quantity.     ",
              _type: "Process",
              GUID: "dfa9a1e2-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The monitoring scope and necessary details must be defined depending on material market availability and importance for the supply chain (e.g. monitoring for deficit components might be stricter then for widely available materials). Rules for sending reminders to vendor (timing etc.) must be defined",
              Type: "Business Process",
              Scope:
                "After the PO has been sent to the vendor, it needs to be tracked. The vendor hereby sends an order acknowledgement to confirm the receipt of the PO. Furthermore, the delivery date is tracked and, in case of imported material, the estimated time of arrival (ETA) as well as the estimated time of sailing is provided by the vendor. In addition, the timely provision of quality certificate is monitored. In case of delays or missing information on the vendors side, reminders and dunning letters can be issued.",
              Outcome:
                "Purchase order status and delivery of goods, documents and additional information has been monitored.",
              name: "Monitor purchase order",
              _id: 1191,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes: "",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2P Procurement of direct materials via SAP Ariba",
          _id: 1201,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "49e099b0-7efd-11e5-0a66-001bc640cd9b",
          Description:
            "The external subcontracting with own components scenario describes procurement of an external subcontracting service. In this scenario a specific manufacturing process is outsourced to an external supplier (subcontractor). Only the manufacturing service is procured. Required material components are provided to the subcontractor by the organization.  External subcontracting scenario can be initiated from production planning, as a result of a MRP run, from a sales order or ad-hoc directly from production. Latter is less common but might be applicable in late make or buy decisions.  This scenario is used when some steps of a manufacturing process are outsourced to specialised external sub-contractors (extended workbench) or a whole production level will be performed externally (toll manufacturer). The manufactured products are then delivered to the organizations warehouse.",
          _type: "Scenario",
          GUID: "7278f23e-ef18-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "Once issued to vendor the purchase order represents a firm commitment. Therefore, it must be approved before the issue and then transferred to vendor.       ",
              _type: "Process",
              GUID: "de59c972-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Before committing to the actual purchase of materials or services, an authorised person does a final check if the purchase order is correct and approves it. The PO will then be sent to the vendor.",
              Outcome: "The purchase order is issued.",
              name: "Approve and issue purchase order",
              _id: 1189,
              Business_Rules: "Approval rules and limits have to be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Monitoring purchase order (PO) process ensures - through communication with the vendor - that the correct material is sent and can be/is delivered on time, and in full quantity.     ",
              _type: "Process",
              GUID: "dfa9a1e2-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The monitoring scope and necessary details must be defined depending on material market availability and importance for the supply chain (e.g. monitoring for deficit components might be stricter then for widely available materials). Rules for sending reminders to vendor (timing etc.) must be defined",
              Type: "Business Process",
              Scope:
                "After the PO has been sent to the vendor, it needs to be tracked. The vendor hereby sends an order acknowledgement to confirm the receipt of the PO. Furthermore, the delivery date is tracked and, in case of imported material, the estimated time of arrival (ETA) as well as the estimated time of sailing is provided by the vendor. In addition, the timely provision of quality certificate is monitored. In case of delays or missing information on the vendors side, reminders and dunning letters can be issued.",
              Outcome:
                "Purchase order status and delivery of goods, documents and additional information has been monitored.",
              name: "Monitor purchase order",
              _id: 1191,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Processing of a Purchase Order based invoice from a vendor, in order to trigger the outgoing payment process.",
              _type: "Process",
              GUID: "981573d4-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes:
                "As one of the most prominent examples of Segregation of Duty (SoD), invoice verification has to be done from a department independent from the department responsible for the purchasing. Typically, invoice verification is a department reporting to finance. Needs to be implemented.   ***In addition tolerances need to be defined in order to avoid clearing efforts for small deviations.   ***Further more rules need to be defined on how to handle invoices for partial deliveries. These rules could either effect internal procedures or external ones (e.g. allow supplier to increase quantity of next delivery to compensate for missing quantities).   ***The sequence of processing invoices compared to the goods receipt might differ from case to case. Especially for purchasing of services both sequences are common (e.g. service entry sheet). ",
              Type: "Business Process",
              Scope:
                "After the invoice has been transferred (from a scanning tool), invoice verification supports the checking for formal compliance, and whether it is consistent with the purchase order and the actually provided goods or services.",
              Outcome:
                "The invoice is posted, triggering the outgoing payment process.",
              name: "Process incoming invoice (with PO)",
              _id: 1190,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "When purchasing subcontracting services, a requisition must be sent to the purchasing department that checks to see which subcontractor can manufacture the required products under the corresponding purchasing conditions.        ",
              _type: "Process",
              GUID: "de59c96c-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Potential subcontractors that can manufacture the required products under desired conditions are checked. Once the purchasing department confirms that all relevant information is available for the fulfilment of the order, the purchase requisition (PR) is ready to be converted to a purchase order (PO). ",
              Outcome: "The PR is ready to be converted to a PO.",
              name: "Process subcontracting purchase requisition",
              _id: 1200,
              Business_Rules:
                "Rules must be defined regarding how materials can be provided to fulfil a specific order.",
              Prerequisite:
                "Pre-requisites:  - There must be predefined contracts with subcontractors. - A list of subcontractors and the specific services they provide must be available",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "In order to provide the subcontractor with the components required for manufacturing, it is necessary to determine where the components will be taken from and approve the components delivery. It is also essential to verify and confirm that the correct components are being sent to the correct subcontractor. ",
              _type: "Process",
              GUID: "de59c975-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The quantities of components delivered to a subcontractor do not have to match exactly the required quantities from the purchase order. It is possible to keep stock of components at the subcontractor. Before sending components to the subcontractor the availability of these for own production should be checked. Especially if own produced orders have already been confirmed towards customers this check avoids reliability breaches.",
              Type: "Business Process",
              Scope:
                "After the purchase order (PO) has been issued and acknowledgement is communicated by the subcontractor, the required components are located. The delivery of the stated quantity to the designated subcontractor, who will fulfil the order, is initiated. Releasing the components delivery triggers the outbound logistics process. ",
              Outcome:
                "Components are released and can be sent to the subcontractor.",
              name: "Initiate and release components delivery to subcontractor",
              _id: 1199,
              Business_Rules:
                "***Rules must be established for allocating authorization for components release.   ***It must be clarified how information regarding the release will be communicated across the organization (e.g. to storage locations, to outbound logistics).   ***It must be defined who has authorization to approve the delivery and to what amount.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Global trade checks ensure compliance with trade regulatory programs and cross-border customs requirements. Compliance must be ensured in all international business operations.     ",
              _type: "Process",
              GUID: "fb9de07b-7f05-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The GTS check itself is in most cases just an automated check against tables.",
              Type: "Business Process",
              Scope:
                "Global trade checks verify conformance with regulations of the countries from/to which the trade is being conducted. In this respect both the vendor and products being purchased are subject to checks.",
              Outcome:
                "The purchase order complies with the applicable trade regulations and the goods can be purchased and imported.",
              name: "Perform global trade checks for purchasing",
              _id: 1198,
              Business_Rules:
                "It needs to be ensured that information (sanctioned party lists, embargo lists) used for screening is comprehensive and up to date.   Vendor data must be up to date.   Rules and procedures how to handle purchase orders which failed the compliance checks have to be in place.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "The subcontractor must fulfil the order by manufacturing the products stated in the purchase order (PO) under the agreed conditions. After the manufacturing the products can be sent to the contractor. ",
              _type: "Process",
              GUID: "de59c969-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Upon reception of the components, the subcontractor manufactures the products with the specifications stipulated in the PO. Manufacturing is performed exclusively by the subcontractor, who provides notification and delivers the finished products.",
              Outcome:
                "Products are manufactured and ready to be sent out by the subcontractor.",
              name: "Perform subcontracting manufacturing",
              _id: 1197,
              Business_Rules:
                "It must be defined:   ***How/whether the manufacturing process will be monitored by the contracting organization.   ***How/whether manufacturing practices of the subcontractor will be aligned with the contracting organization.  ",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process covers the scanning of a Purchase Order based invoice or an Expense Invoice (no PO reference).",
              _type: "Process",
              GUID: "981573d2-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the invoice is received, it is scanned and the data is captured. The data is then stored in a database for digital use and then transfered to for verification.",
              Outcome:
                "Received invoice information is transferred for verification.",
              name: "Scan incoming invoice with OCR software",
              _id: 1192,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "An official purchase order (PO) has to be created from a purchase requisition (PR) to be able to order materials and services.       ",
              _type: "Process",
              GUID: "de59c987-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                " ***set-up of possible conversions must be defined. Conversion options are single, multiple or partial ***purchasing strategies for vendors need to be considered (e.g. fair share, contingents)  ***special agreements with vendors need to be considered (e.g. FTL/FCL only, min/max quantities, multiple products to be bundled) ",
              Type: "Business Process",
              Scope:
                "The PO is created with reference to a specific PR. Additional data not provided within the PR has to be maintained.",
              Outcome: "A PO is generated.",
              name: "Convert purchase requisition to purchase order",
              _id: 1193,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Subsequent adjustments of components is required in order to make corrections of goods receipt for a subcontracting order. With this, the actual quantity of components used to fulfill a subcontracting order is recorded. ",
              _type: "Process",
              GUID: "dfb588d2-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "When the subcontractor gives notice that a larger or smaller quantity of the subcontracting components was actually consumed than planned, a subsequent adjustment to correct the component consumption must to be done. ",
              Outcome: "The actual components consumption is recorded.",
              name: "Perform subsequent goods issue and adjustments of components",
              _id: 1196,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process is required in order to track components delivered to the subcontractor. The components still belong to the organization, but are held in storage at the subcontractor. That way the subcontractor is able to fulfill his service to manufacture a product with components from the requesting organization.",
              _type: "Process",
              GUID: "dfb588c6-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Subcontracting stock underlies the regular inventory procedures.",
              Type: "Business Process",
              Scope:
                "When components are delivered to the subcontractor, they must be recorded as stock that is stored at an external location (not at an internal storage location). ",
              Outcome:
                "Information regarding components consumption and subcontracting progress is available.",
              name: "Perform goods receipt in subcontracting stock and monitor stock",
              _id: 1195,
              Business_Rules:
                "The level of system integration with the subcontractor as well as external vendors of components must be defined. It is necessary to define how tracking and reporting will be done.",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "This scenario requires the usage of material masters for the provided products/materials and for the final product delivered by the toll manufacturer. Material movements and deliveries are managed via the system.   There is also the option to just order the service of a toll manufacturer as part of a production order without any material masters and consequently without material movements for the WIP-product, except additional components will be provided. This can be achieved by a special type of operation within the routing of a production order.   The contract with subcontractor needs to include rules on regular stock reports and physical inventory taking to ensure reliable component deliveries to the subcontractor. ",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2P External subcontracting with own components",
          _id: 1194,
          Business_Rules: "",
          Prerequisite: "",
        },
        {
          BPMN_GUID: "6952e2d1-7f02-11e5-0a66-001bc640cd9b",
          Description:
            "Procurement for sales (procure to order) scenario describes the procurement of finished third party products for their further delivery to a customer.  This scenario is used in combination with O2C Sales from procurement (Procure to order) scenario. After the customer order is placed, the ordered products are procured from the vendor and delivered to the organizations warehouse. After receipt of the goods, their transportation to customer based on customer order must be organized. This scenario is used in situations when direct delivery from vendor to customer is not possible or desired.",
          _type: "Scenario",
          GUID: "7278f23a-ef18-11e4-0a66-001bc640cd9b",
          process_of: [
            {
              BPMN_GUID: "NULL",
              Description:
                "An official purchase order (PO) has to be created from a purchase requisition (PR) to be able to order materials and services.       ",
              _type: "Process",
              GUID: "de59c987-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                " ***set-up of possible conversions must be defined. Conversion options are single, multiple or partial ***purchasing strategies for vendors need to be considered (e.g. fair share, contingents)  ***special agreements with vendors need to be considered (e.g. FTL/FCL only, min/max quantities, multiple products to be bundled) ",
              Type: "Business Process",
              Scope:
                "The PO is created with reference to a specific PR. Additional data not provided within the PR has to be maintained.",
              Outcome: "A PO is generated.",
              name: "Convert purchase requisition to purchase order",
              _id: 1193,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "This process covers the scanning of a Purchase Order based invoice or an Expense Invoice (no PO reference).",
              _type: "Process",
              GUID: "981573d2-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "After the invoice is received, it is scanned and the data is captured. The data is then stored in a database for digital use and then transfered to for verification.",
              Outcome:
                "Received invoice information is transferred for verification.",
              name: "Scan incoming invoice with OCR software",
              _id: 1192,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Monitoring purchase order (PO) process ensures - through communication with the vendor - that the correct material is sent and can be/is delivered on time, and in full quantity.     ",
              _type: "Process",
              GUID: "dfa9a1e2-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "The monitoring scope and necessary details must be defined depending on material market availability and importance for the supply chain (e.g. monitoring for deficit components might be stricter then for widely available materials). Rules for sending reminders to vendor (timing etc.) must be defined",
              Type: "Business Process",
              Scope:
                "After the PO has been sent to the vendor, it needs to be tracked. The vendor hereby sends an order acknowledgement to confirm the receipt of the PO. Furthermore, the delivery date is tracked and, in case of imported material, the estimated time of arrival (ETA) as well as the estimated time of sailing is provided by the vendor. In addition, the timely provision of quality certificate is monitored. In case of delays or missing information on the vendors side, reminders and dunning letters can be issued.",
              Outcome:
                "Purchase order status and delivery of goods, documents and additional information has been monitored.",
              name: "Monitor purchase order",
              _id: 1191,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Processing of a Purchase Order based invoice from a vendor, in order to trigger the outgoing payment process.",
              _type: "Process",
              GUID: "981573d4-9499-11e8-2ddf-001bc640cd9b",
              Advisory_Notes:
                "As one of the most prominent examples of Segregation of Duty (SoD), invoice verification has to be done from a department independent from the department responsible for the purchasing. Typically, invoice verification is a department reporting to finance. Needs to be implemented.   ***In addition tolerances need to be defined in order to avoid clearing efforts for small deviations.   ***Further more rules need to be defined on how to handle invoices for partial deliveries. These rules could either effect internal procedures or external ones (e.g. allow supplier to increase quantity of next delivery to compensate for missing quantities).   ***The sequence of processing invoices compared to the goods receipt might differ from case to case. Especially for purchasing of services both sequences are common (e.g. service entry sheet). ",
              Type: "Business Process",
              Scope:
                "After the invoice has been transferred (from a scanning tool), invoice verification supports the checking for formal compliance, and whether it is consistent with the purchase order and the actually provided goods or services.",
              Outcome:
                "The invoice is posted, triggering the outgoing payment process.",
              name: "Process incoming invoice (with PO)",
              _id: 1190,
              Business_Rules: "",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "Once issued to vendor the purchase order represents a firm commitment. Therefore, it must be approved before the issue and then transferred to vendor.       ",
              _type: "Process",
              GUID: "de59c972-7efd-11e5-0a66-001bc640cd9b",
              Advisory_Notes: "",
              Type: "Business Process",
              Scope:
                "Before committing to the actual purchase of materials or services, an authorised person does a final check if the purchase order is correct and approves it. The PO will then be sent to the vendor.",
              Outcome: "The purchase order is issued.",
              name: "Approve and issue purchase order",
              _id: 1189,
              Business_Rules: "Approval rules and limits have to be defined.",
              Prerequisite: "",
            },
            {
              BPMN_GUID: "NULL",
              Description:
                "A purchase requisition (PR)  is created after a sales order has been confirmed. The purchasing department must check which vendor can supply the goods. The goods are delivered directly to the customer, therefore it is necessary to clarify the terms of delivery with the vendor.        ",
              _type: "Process",
              GUID: "78ced096-7f02-11e5-0a66-001bc640cd9b",
              Advisory_Notes:
                "Purchasing products directly for a sales order is used in a variety of business models. It can be a one time opportunity, a frequently applied model, or even a type of outsourced inventory in a JIT-like set-up. Therefore, the interaction between the sales department, the purchasing department, and the vendor in order to clarify availability and delivery dates might differ. In a opportunity sale, it might even be required to identify a source of supply before any commitment to the customer is given.",
              Type: "Business Process",
              Scope:
                "If not already specified by master data, the purchasing department checks vendors to determine which one can supply the products required to fulfil the order.",
              Outcome: "The PR is created.",
              name: "Process purchase requisition for sales orders",
              _id: 1188,
              Business_Rules: "",
              Prerequisite: "",
            },
          ],
          Advisory_Notes:
            "Purchasing products directly for a sales order is used in a variety of business models. It can be a one time opportunity, a frequently applied model, or even a type of outsourced inventory in a JIT-like set-up. Therefore, the interaction between the sales department, the purchasing department, and the vendor in order to clarify availability and delivery dates might differ. In a opportunity sale, it might even be required to identify a source of supply before any commitment to the customer is given.",
          Type: "E2E-Scenario",
          Scope: "",
          Outcome: "",
          name: "P2P Procurement to order (trading goods)",
          _id: 1187,
          Business_Rules: "",
          Prerequisite: "",
        },
      ],
      Description:
        "The Procure to Pay (P2P) domain describes the process of buying goods and services which includes the initial decision to make the purchase, the process of selecting the vendor, and transaction made for purchasing and payment to the vendor. ",
      _type: "Domain",
      GUID: "964b5c30-642b-11e4-55cc-001bc640cd9b",
      Advisory_Notes: "",
      Type: "E2E-Domain",
      Scope: "",
      Outcome: "",
      name: "Procure to Pay",
      _id: 1186,
      Business_Rules: "",
      Prerequisite: "",
    },
  ],
  _type: "Map",
  GUID: "14d42810-eced-11e4-0a66-001bc640cd9b",
  name: "E2E-Map",
  _id: 1184,
};

export default e2eMapDump;
